
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequire2b58"];
var parcelRegister = parcelRequire.register;
parcelRegister("5ARW1", function(module, exports) {

$parcel$export(module.exports, "EthereumProvider", function () { return $412a26e585c69ca1$export$cdfbbad9b2980226; });

var $7hlqZ = parcelRequire("7hlqZ");

var $9jF5G = parcelRequire("9jF5G");

var $bzZjV = parcelRequire("bzZjV");
const $412a26e585c69ca1$var$T = "wc", $412a26e585c69ca1$var$$ = "ethereum_provider", $412a26e585c69ca1$var$j = `${$412a26e585c69ca1$var$T}@2:${$412a26e585c69ca1$var$$}:`, $412a26e585c69ca1$var$q = "https://rpc.walletconnect.org/v1/", $412a26e585c69ca1$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $412a26e585c69ca1$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "personal_sign",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode",
    "wallet_sendCalls",
    "wallet_getCapabilities",
    "wallet_getCallsStatus",
    "wallet_showCallsStatus"
], $412a26e585c69ca1$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $412a26e585c69ca1$export$1d352f96d67d51e6 = [
    "chainChanged",
    "accountsChanged",
    "message",
    "disconnect",
    "connect"
];
var $412a26e585c69ca1$var$N = Object.defineProperty, $412a26e585c69ca1$var$D = Object.defineProperties, $412a26e585c69ca1$var$U = Object.getOwnPropertyDescriptors, $412a26e585c69ca1$var$P = Object.getOwnPropertySymbols, $412a26e585c69ca1$var$Q = Object.prototype.hasOwnProperty, $412a26e585c69ca1$var$L = Object.prototype.propertyIsEnumerable, $412a26e585c69ca1$var$y = (a, t, s)=>t in a ? $412a26e585c69ca1$var$N(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s, $412a26e585c69ca1$var$g = (a, t)=>{
    for(var s in t || (t = {}))$412a26e585c69ca1$var$Q.call(t, s) && $412a26e585c69ca1$var$y(a, s, t[s]);
    if ($412a26e585c69ca1$var$P) for (var s of $412a26e585c69ca1$var$P(t))$412a26e585c69ca1$var$L.call(t, s) && $412a26e585c69ca1$var$y(a, s, t[s]);
    return a;
}, $412a26e585c69ca1$var$_ = (a, t)=>$412a26e585c69ca1$var$D(a, $412a26e585c69ca1$var$U(t)), $412a26e585c69ca1$var$o = (a, t, s)=>$412a26e585c69ca1$var$y(a, typeof t != "symbol" ? t + "" : t, s);
function $412a26e585c69ca1$var$v(a) {
    return Number(a[0].split(":")[1]);
}
function $412a26e585c69ca1$var$C(a) {
    return `0x${a.toString(16)}`;
}
function $412a26e585c69ca1$var$x(a) {
    const { chains: t, optionalChains: s, methods: i, optionalMethods: e, events: n, optionalEvents: h, rpcMap: l } = a;
    if (!(0, $9jF5G.isValidArray)(t)) throw new Error("Invalid chains");
    const r = {
        chains: t,
        methods: i || $412a26e585c69ca1$export$cfec112b6d27bf,
        events: n || $412a26e585c69ca1$export$2c607e5ce12221af,
        rpcMap: $412a26e585c69ca1$var$g({}, t.length ? {
            [$412a26e585c69ca1$var$v(t)]: l[$412a26e585c69ca1$var$v(t)]
        } : {})
    }, d = n?.filter((p)=>!$412a26e585c69ca1$export$2c607e5ce12221af.includes(p)), c = i?.filter((p)=>!$412a26e585c69ca1$export$cfec112b6d27bf.includes(p));
    if (!s && !h && !e && !(d != null && d.length) && !(c != null && c.length)) return {
        required: t.length ? r : void 0
    };
    const I = d?.length && c?.length || !s, f = {
        chains: [
            ...new Set(I ? r.chains.concat(s || []) : s)
        ],
        methods: [
            ...new Set(r.methods.concat(e != null && e.length ? e : $412a26e585c69ca1$export$bc85197675500780))
        ],
        events: [
            ...new Set(r.events.concat(h != null && h.length ? h : $412a26e585c69ca1$export$1d352f96d67d51e6))
        ],
        rpcMap: l
    };
    return {
        required: t.length ? r : void 0,
        optional: s.length ? f : void 0
    };
}

class $412a26e585c69ca1$export$2e2bcd8739ae039 {
    constructor(){
        $412a26e585c69ca1$var$o(this, "events", new (0, $7hlqZ.EventEmitter)), $412a26e585c69ca1$var$o(this, "namespace", "eip155"), $412a26e585c69ca1$var$o(this, "accounts", []), $412a26e585c69ca1$var$o(this, "signer"), $412a26e585c69ca1$var$o(this, "chainId", 1), $412a26e585c69ca1$var$o(this, "modal"), $412a26e585c69ca1$var$o(this, "rpc"), $412a26e585c69ca1$var$o(this, "STORAGE_KEY", $412a26e585c69ca1$var$j), $412a26e585c69ca1$var$o(this, "on", (t, s)=>(this.events.on(t, s), this)), $412a26e585c69ca1$var$o(this, "once", (t, s)=>(this.events.once(t, s), this)), $412a26e585c69ca1$var$o(this, "removeListener", (t, s)=>(this.events.removeListener(t, s), this)), $412a26e585c69ca1$var$o(this, "off", (t, s)=>(this.events.off(t, s), this)), $412a26e585c69ca1$var$o(this, "parseAccount", (t)=>this.isCompatibleChainId(t) ? this.parseAccountId(t).address : t), this.signer = {}, this.rpc = {};
    }
    static async init(t) {
        const s = new $412a26e585c69ca1$export$2e2bcd8739ae039;
        return await s.initialize(t), s;
    }
    async request(t, s) {
        return await this.signer.request(t, this.formatChainId(this.chainId), s);
    }
    sendAsync(t, s, i) {
        this.signer.sendAsync(t, s, this.formatChainId(this.chainId), i);
    }
    get connected() {
        return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
    get connecting() {
        return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
    async enable() {
        return this.session || await this.connect(), await this.request({
            method: "eth_requestAccounts"
        });
    }
    async connect(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts(t);
        const { required: s, optional: i } = $412a26e585c69ca1$var$x(this.rpc);
        try {
            const e = await new Promise(async (h, l)=>{
                var r;
                this.rpc.showQrModal && ((r = this.modal) == null || r.subscribeModal((c)=>{
                    !c.open && !this.signer.session && (this.signer.abortPairingAttempt(), l(new Error("Connection request reset. Please try again.")));
                }));
                const d = t != null && t.scopedProperties ? {
                    [this.namespace]: t.scopedProperties
                } : void 0;
                await this.signer.connect($412a26e585c69ca1$var$_($412a26e585c69ca1$var$g({
                    namespaces: $412a26e585c69ca1$var$g({}, s && {
                        [this.namespace]: s
                    })
                }, i && {
                    optionalNamespaces: {
                        [this.namespace]: i
                    }
                }), {
                    pairingTopic: t?.pairingTopic,
                    scopedProperties: d
                })).then((c)=>{
                    h(c);
                }).catch((c)=>{
                    l(new Error(c.message));
                });
            });
            if (!e) return;
            const n = (0, $9jF5G.getAccountsFromNamespaces)(e.namespaces, [
                this.namespace
            ]);
            this.setChainIds(this.rpc.chains.length ? this.rpc.chains : n), this.setAccounts(n), this.events.emit("connect", {
                chainId: $412a26e585c69ca1$var$C(this.chainId)
            });
        } catch (e) {
            throw this.signer.logger.error(e), e;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async authenticate(t, s) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts({
            chains: t?.chains
        });
        try {
            const i = await new Promise(async (n, h)=>{
                var l;
                this.rpc.showQrModal && ((l = this.modal) == null || l.subscribeModal((r)=>{
                    !r.open && !this.signer.session && (this.signer.abortPairingAttempt(), h(new Error("Connection request reset. Please try again.")));
                })), await this.signer.authenticate($412a26e585c69ca1$var$_($412a26e585c69ca1$var$g({}, t), {
                    chains: this.rpc.chains
                }), s).then((r)=>{
                    n(r);
                }).catch((r)=>{
                    h(new Error(r.message));
                });
            }), e = i.session;
            if (e) {
                const n = (0, $9jF5G.getAccountsFromNamespaces)(e.namespaces, [
                    this.namespace
                ]);
                this.setChainIds(this.rpc.chains.length ? this.rpc.chains : n), this.setAccounts(n), this.events.emit("connect", {
                    chainId: $412a26e585c69ca1$var$C(this.chainId)
                });
            }
            return i;
        } catch (i) {
            throw this.signer.logger.error(i), i;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async disconnect() {
        this.session && await this.signer.disconnect(), this.reset();
    }
    get isWalletConnect() {
        return !0;
    }
    get session() {
        return this.signer.session;
    }
    registerEventListeners() {
        this.signer.on("session_event", (t)=>{
            const { params: s } = t, { event: i } = s;
            i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", t);
        }), this.signer.on("accountsChanged", (t)=>{
            this.accounts = this.parseAccounts(t), this.events.emit("accountsChanged", this.accounts);
        }), this.signer.on("chainChanged", (t)=>{
            const s = parseInt(t);
            this.chainId = s, this.events.emit("chainChanged", $412a26e585c69ca1$var$C(this.chainId)), this.persist();
        }), this.signer.on("session_update", (t)=>{
            this.events.emit("session_update", t);
        }), this.signer.on("session_delete", (t)=>{
            this.reset(), this.events.emit("session_delete", t), this.events.emit("disconnect", $412a26e585c69ca1$var$_($412a26e585c69ca1$var$g({}, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), {
                data: t.topic,
                name: "USER_DISCONNECTED"
            }));
        }), this.signer.on("display_uri", (t)=>{
            var s, i;
            this.rpc.showQrModal && ((s = this.modal) == null || s.closeModal(), (i = this.modal) == null || i.openModal({
                uri: t
            })), this.events.emit("display_uri", t);
        });
    }
    switchEthereumChain(t) {
        this.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: t.toString(16)
                }
            ]
        });
    }
    isCompatibleChainId(t) {
        return typeof t == "string" ? t.startsWith(`${this.namespace}:`) : !1;
    }
    formatChainId(t) {
        return `${this.namespace}:${t}`;
    }
    parseChainId(t) {
        return Number(t.split(":")[1]);
    }
    setChainIds(t) {
        const s = t.filter((i)=>this.isCompatibleChainId(i)).map((i)=>this.parseChainId(i));
        s.length && (this.chainId = s[0], this.events.emit("chainChanged", $412a26e585c69ca1$var$C(this.chainId)), this.persist());
    }
    setChainId(t) {
        if (this.isCompatibleChainId(t)) {
            const s = this.parseChainId(t);
            this.chainId = s, this.switchEthereumChain(s);
        }
    }
    parseAccountId(t) {
        const [s, i, e] = t.split(":");
        return {
            chainId: `${s}:${i}`,
            address: e
        };
    }
    setAccounts(t) {
        this.accounts = t.filter((s)=>this.parseChainId(this.parseAccountId(s).chainId) === this.chainId).map((s)=>this.parseAccountId(s).address), this.events.emit("accountsChanged", this.accounts);
    }
    getRpcConfig(t) {
        var s, i;
        const e = (s = t?.chains) != null ? s : [], n = (i = t?.optionalChains) != null ? i : [], h = e.concat(n);
        if (!h.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
        const l = e.length ? t?.methods || $412a26e585c69ca1$export$cfec112b6d27bf : [], r = e.length ? t?.events || $412a26e585c69ca1$export$2c607e5ce12221af : [], d = t?.optionalMethods || [], c = t?.optionalEvents || [], I = t?.rpcMap || this.buildRpcMap(h, t.projectId), f = t?.qrModalOptions || void 0;
        return {
            chains: e?.map((p)=>this.formatChainId(p)),
            optionalChains: n.map((p)=>this.formatChainId(p)),
            methods: l,
            events: r,
            optionalMethods: d,
            optionalEvents: c,
            rpcMap: I,
            showQrModal: !!(t != null && t.showQrModal),
            qrModalOptions: f,
            projectId: t.projectId,
            metadata: t.metadata
        };
    }
    buildRpcMap(t, s) {
        const i = {};
        return t.forEach((e)=>{
            i[e] = this.getRpcUrl(e, s);
        }), i;
    }
    async initialize(t) {
        if (this.rpc = this.getRpcConfig(t), this.chainId = this.rpc.chains.length ? $412a26e585c69ca1$var$v(this.rpc.chains) : $412a26e585c69ca1$var$v(this.rpc.optionalChains), this.signer = await (0, $bzZjV.UniversalProvider).init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: t.disableProviderPing,
            relayUrl: t.relayUrl,
            storage: t.storage,
            storageOptions: t.storageOptions,
            customStoragePrefix: t.customStoragePrefix,
            telemetryEnabled: t.telemetryEnabled,
            logger: t.logger
        }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
            let s;
            try {
                const { WalletConnectModal: i } = await (parcelRequire("19vcb"));
                s = i;
            } catch  {
                throw new Error("To use QR modal, please install @walletconnect/modal package");
            }
            if (s) try {
                this.modal = new s($412a26e585c69ca1$var$g({
                    projectId: this.rpc.projectId
                }, this.rpc.qrModalOptions));
            } catch (i) {
                throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
            }
        }
    }
    loadConnectOpts(t) {
        if (!t) return;
        const { chains: s, optionalChains: i, rpcMap: e } = t;
        s && (0, $9jF5G.isValidArray)(s) && (this.rpc.chains = s.map((n)=>this.formatChainId(n)), s.forEach((n)=>{
            this.rpc.rpcMap[n] = e?.[n] || this.getRpcUrl(n);
        })), i && (0, $9jF5G.isValidArray)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i?.map((n)=>this.formatChainId(n)), i.forEach((n)=>{
            this.rpc.rpcMap[n] = e?.[n] || this.getRpcUrl(n);
        }));
    }
    getRpcUrl(t, s) {
        var i;
        return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || `${$412a26e585c69ca1$var$q}?chainId=eip155:${t}&projectId=${s || this.rpc.projectId}`;
    }
    async loadPersistedSession() {
        if (this.session) try {
            const t = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), s = this.session.namespaces[`${this.namespace}:${t}`] ? this.session.namespaces[`${this.namespace}:${t}`] : this.session.namespaces[this.namespace];
            this.setChainIds(t ? [
                this.formatChainId(t)
            ] : s?.accounts), this.setAccounts(s?.accounts);
        } catch (t) {
            this.signer.logger.error("Failed to load persisted session, clearing state..."), this.signer.logger.error(t), await this.disconnect().catch((s)=>this.signer.logger.warn(s));
        }
    }
    reset() {
        this.chainId = 1, this.accounts = [];
    }
    persist() {
        this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
    }
    parseAccounts(t) {
        return typeof t == "string" || t instanceof String ? [
            this.parseAccount(t)
        ] : t.map((s)=>this.parseAccount(s));
    }
}
const $412a26e585c69ca1$export$cdfbbad9b2980226 = $412a26e585c69ca1$export$2e2bcd8739ae039;

});
parcelRegister("7hlqZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $54cabf57d810dd2b$var$R = typeof Reflect === "object" ? Reflect : null;
var $54cabf57d810dd2b$var$ReflectApply = $54cabf57d810dd2b$var$R && typeof $54cabf57d810dd2b$var$R.apply === "function" ? $54cabf57d810dd2b$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $54cabf57d810dd2b$var$ReflectOwnKeys;
if ($54cabf57d810dd2b$var$R && typeof $54cabf57d810dd2b$var$R.ownKeys === "function") $54cabf57d810dd2b$var$ReflectOwnKeys = $54cabf57d810dd2b$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $54cabf57d810dd2b$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $54cabf57d810dd2b$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $54cabf57d810dd2b$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $54cabf57d810dd2b$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $54cabf57d810dd2b$var$EventEmitter() {
    $54cabf57d810dd2b$var$EventEmitter.init.call(this);
}
module.exports = $54cabf57d810dd2b$var$EventEmitter;
module.exports.once = $54cabf57d810dd2b$var$once;
// Backwards-compat with node 0.10.x
$54cabf57d810dd2b$var$EventEmitter.EventEmitter = $54cabf57d810dd2b$var$EventEmitter;
$54cabf57d810dd2b$var$EventEmitter.prototype._events = undefined;
$54cabf57d810dd2b$var$EventEmitter.prototype._eventsCount = 0;
$54cabf57d810dd2b$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $54cabf57d810dd2b$var$defaultMaxListeners = 10;
function $54cabf57d810dd2b$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($54cabf57d810dd2b$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $54cabf57d810dd2b$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $54cabf57d810dd2b$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $54cabf57d810dd2b$var$defaultMaxListeners = arg;
    }
});
$54cabf57d810dd2b$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$54cabf57d810dd2b$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $54cabf57d810dd2b$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $54cabf57d810dd2b$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $54cabf57d810dd2b$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$54cabf57d810dd2b$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $54cabf57d810dd2b$var$_getMaxListeners(this);
};
$54cabf57d810dd2b$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $54cabf57d810dd2b$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $54cabf57d810dd2b$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$54cabf57d810dd2b$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $54cabf57d810dd2b$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $54cabf57d810dd2b$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $54cabf57d810dd2b$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $54cabf57d810dd2b$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$54cabf57d810dd2b$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $54cabf57d810dd2b$var$_addListener(this, type, listener, false);
};
$54cabf57d810dd2b$var$EventEmitter.prototype.on = $54cabf57d810dd2b$var$EventEmitter.prototype.addListener;
$54cabf57d810dd2b$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $54cabf57d810dd2b$var$_addListener(this, type, listener, true);
};
function $54cabf57d810dd2b$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $54cabf57d810dd2b$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $54cabf57d810dd2b$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$54cabf57d810dd2b$var$EventEmitter.prototype.once = function once(type, listener) {
    $54cabf57d810dd2b$var$checkListener(listener);
    this.on(type, $54cabf57d810dd2b$var$_onceWrap(this, type, listener));
    return this;
};
$54cabf57d810dd2b$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $54cabf57d810dd2b$var$checkListener(listener);
    this.prependListener(type, $54cabf57d810dd2b$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$54cabf57d810dd2b$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $54cabf57d810dd2b$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $54cabf57d810dd2b$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$54cabf57d810dd2b$var$EventEmitter.prototype.off = $54cabf57d810dd2b$var$EventEmitter.prototype.removeListener;
$54cabf57d810dd2b$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $54cabf57d810dd2b$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $54cabf57d810dd2b$var$unwrapListeners(evlistener) : $54cabf57d810dd2b$var$arrayClone(evlistener, evlistener.length);
}
$54cabf57d810dd2b$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $54cabf57d810dd2b$var$_listeners(this, type, true);
};
$54cabf57d810dd2b$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $54cabf57d810dd2b$var$_listeners(this, type, false);
};
$54cabf57d810dd2b$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $54cabf57d810dd2b$var$listenerCount.call(emitter, type);
};
$54cabf57d810dd2b$var$EventEmitter.prototype.listenerCount = $54cabf57d810dd2b$var$listenerCount;
function $54cabf57d810dd2b$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$54cabf57d810dd2b$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $54cabf57d810dd2b$var$ReflectOwnKeys(this._events) : [];
};
function $54cabf57d810dd2b$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $54cabf57d810dd2b$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $54cabf57d810dd2b$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $54cabf57d810dd2b$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $54cabf57d810dd2b$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $54cabf57d810dd2b$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $54cabf57d810dd2b$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $54cabf57d810dd2b$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $54cabf57d810dd2b$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("9jF5G", function(module, exports) {

$parcel$export(module.exports, "parseChainId", function () { return $6c85c32373d4b5cd$export$4764229d78de4437; });
$parcel$export(module.exports, "getAccountsFromNamespaces", function () { return $6c85c32373d4b5cd$export$23329703ad972840; });
$parcel$export(module.exports, "isNode", function () { return $6c85c32373d4b5cd$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isReactNative", function () { return $6c85c32373d4b5cd$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isAndroid", function () { return $6c85c32373d4b5cd$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isIos", function () { return $6c85c32373d4b5cd$export$41a665f744414057; });
$parcel$export(module.exports, "isBrowser", function () { return $6c85c32373d4b5cd$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "getAppId", function () { return $6c85c32373d4b5cd$export$fb2283f4a44fb53; });
$parcel$export(module.exports, "populateAppMetadata", function () { return $6c85c32373d4b5cd$export$40393344880c2ca3; });
$parcel$export(module.exports, "getAppMetadata", function () { return $6c85c32373d4b5cd$export$ba31e015127122bb; });
$parcel$export(module.exports, "formatUA", function () { return $6c85c32373d4b5cd$export$b55a4c6e272b719f; });
$parcel$export(module.exports, "formatRelayRpcUrl", function () { return $6c85c32373d4b5cd$export$d875b3963ef774f5; });
$parcel$export(module.exports, "mapToObj", function () { return $6c85c32373d4b5cd$export$c4b8dfeb6e237eb9; });
$parcel$export(module.exports, "objToMap", function () { return $6c85c32373d4b5cd$export$ac31b37c726bc3ba; });
$parcel$export(module.exports, "createDelayedPromise", function () { return $6c85c32373d4b5cd$export$cbf9e3cc9ffc85cb; });
$parcel$export(module.exports, "createExpiringPromise", function () { return $6c85c32373d4b5cd$export$3da2293b007ed708; });
$parcel$export(module.exports, "formatTopicTarget", function () { return $6c85c32373d4b5cd$export$43ab92477f8713b9; });
$parcel$export(module.exports, "formatIdTarget", function () { return $6c85c32373d4b5cd$export$bd13103c2e5cc0c3; });
$parcel$export(module.exports, "parseExpirerTarget", function () { return $6c85c32373d4b5cd$export$93adeb0f16e8e51d; });
$parcel$export(module.exports, "calcExpiry", function () { return $6c85c32373d4b5cd$export$b136d03015bfc12; });
$parcel$export(module.exports, "isExpired", function () { return $6c85c32373d4b5cd$export$57947cfd429801a2; });
$parcel$export(module.exports, "engineEvent", function () { return $6c85c32373d4b5cd$export$e3eb27ce66c0f6d9; });
$parcel$export(module.exports, "mergeArrays", function () { return $6c85c32373d4b5cd$export$9826fe7ad3921016; });
$parcel$export(module.exports, "handleDeeplinkRedirect", function () { return $6c85c32373d4b5cd$export$694a208c8abca99a; });
$parcel$export(module.exports, "getDeepLink", function () { return $6c85c32373d4b5cd$export$e55bfdac47149a32; });
$parcel$export(module.exports, "getSearchParamFromURL", function () { return $6c85c32373d4b5cd$export$e35f0b82969c30c3; });
$parcel$export(module.exports, "uuidv4", function () { return $6c85c32373d4b5cd$export$abe4376e1bf796d6; });
$parcel$export(module.exports, "isTestRun", function () { return $6c85c32373d4b5cd$export$b4bb0f87d8376dd4; });
$parcel$export(module.exports, "sleep", function () { return $6c85c32373d4b5cd$export$e772c8ff12451969; });
$parcel$export(module.exports, "extractSolanaTransactionId", function () { return $6c85c32373d4b5cd$export$22c18daeebb76cc2; });
$parcel$export(module.exports, "getNamespacedDidChainId", function () { return $6c85c32373d4b5cd$export$a8b149927aef7051; });
$parcel$export(module.exports, "getDidAddress", function () { return $6c85c32373d4b5cd$export$bf43cfbb4bd95de9; });
$parcel$export(module.exports, "validateSignedCacao", function () { return $6c85c32373d4b5cd$export$b7d566fce8e2b970; });
$parcel$export(module.exports, "formatMessage", function () { return $6c85c32373d4b5cd$export$25868d1e8e76735f; });
$parcel$export(module.exports, "getRecapFromResources", function () { return $6c85c32373d4b5cd$export$3bb18ae0fb9a9fa9; });
$parcel$export(module.exports, "createEncodedRecap", function () { return $6c85c32373d4b5cd$export$2bc35d2a08a09ad5; });
$parcel$export(module.exports, "mergeEncodedRecaps", function () { return $6c85c32373d4b5cd$export$c7a40c552af428b5; });
$parcel$export(module.exports, "getMethodsFromRecap", function () { return $6c85c32373d4b5cd$export$d6c6a43d36418efe; });
$parcel$export(module.exports, "getChainsFromRecap", function () { return $6c85c32373d4b5cd$export$372f88051a611988; });
$parcel$export(module.exports, "BASE16", function () { return $6c85c32373d4b5cd$export$49eb910ab2518105; });
$parcel$export(module.exports, "BASE64", function () { return $6c85c32373d4b5cd$export$9bff723d552e6bcf; });
$parcel$export(module.exports, "BASE64URL", function () { return $6c85c32373d4b5cd$export$e9cf21fb8029e645; });
$parcel$export(module.exports, "TYPE_1", function () { return $6c85c32373d4b5cd$export$406e97c329f0f3d4; });
$parcel$export(module.exports, "TYPE_2", function () { return $6c85c32373d4b5cd$export$d79eac6ee921504f; });
$parcel$export(module.exports, "generateKeyPair", function () { return $6c85c32373d4b5cd$export$a949d36eab55b41f; });
$parcel$export(module.exports, "generateRandomBytes32", function () { return $6c85c32373d4b5cd$export$d15a28e4f1821243; });
$parcel$export(module.exports, "deriveSymKey", function () { return $6c85c32373d4b5cd$export$f8378f68e053f5c6; });
$parcel$export(module.exports, "hashKey", function () { return $6c85c32373d4b5cd$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "hashMessage", function () { return $6c85c32373d4b5cd$export$d4c241cec96564c1; });
$parcel$export(module.exports, "decodeTypeByte", function () { return $6c85c32373d4b5cd$export$7547a514ee29b9d4; });
$parcel$export(module.exports, "encrypt", function () { return $6c85c32373d4b5cd$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $6c85c32373d4b5cd$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "deserialize", function () { return $6c85c32373d4b5cd$export$efcd34ab6248d3cd; });
$parcel$export(module.exports, "encodeTypeTwoEnvelope", function () { return $6c85c32373d4b5cd$export$99abb28d1c4baa95; });
$parcel$export(module.exports, "decodeTypeTwoEnvelope", function () { return $6c85c32373d4b5cd$export$6b54347426d28ee3; });
$parcel$export(module.exports, "validateDecoding", function () { return $6c85c32373d4b5cd$export$177f3e316562333d; });
$parcel$export(module.exports, "validateEncoding", function () { return $6c85c32373d4b5cd$export$7949f60f2444aef2; });
$parcel$export(module.exports, "isTypeOneEnvelope", function () { return $6c85c32373d4b5cd$export$8c165704db2d5c15; });
$parcel$export(module.exports, "isTypeTwoEnvelope", function () { return $6c85c32373d4b5cd$export$599538f59a4a14c3; });
$parcel$export(module.exports, "verifyP256Jwt", function () { return $6c85c32373d4b5cd$export$f65520390041ee33; });
$parcel$export(module.exports, "getRelayProtocolName", function () { return $6c85c32373d4b5cd$export$cf77af25151525db; });
$parcel$export(module.exports, "getRelayProtocolApi", function () { return $6c85c32373d4b5cd$export$604e3deb95e1b734; });
$parcel$export(module.exports, "parseUri", function () { return $6c85c32373d4b5cd$export$59f58847421cfb28; });
$parcel$export(module.exports, "formatUri", function () { return $6c85c32373d4b5cd$export$b2786ede34fb2350; });
$parcel$export(module.exports, "getLinkModeURL", function () { return $6c85c32373d4b5cd$export$556cb6cc912028c2; });
$parcel$export(module.exports, "isValidNamespaces", function () { return $6c85c32373d4b5cd$export$93f7b81dc815a714; });
$parcel$export(module.exports, "isConformingNamespaces", function () { return $6c85c32373d4b5cd$export$ba5b0a4b585cd1b4; });
$parcel$export(module.exports, "isCaipNamespace", function () { return $6c85c32373d4b5cd$export$e03e993df4723bde; });
$parcel$export(module.exports, "parseNamespaceKey", function () { return $6c85c32373d4b5cd$export$dd404c96fbbb1ff8; });
$parcel$export(module.exports, "isValidObject", function () { return $6c85c32373d4b5cd$export$16a0268bc22b47b0; });
$parcel$export(module.exports, "buildNamespacesFromAuth", function () { return $6c85c32373d4b5cd$export$b5744b1c39447540; });
$parcel$export(module.exports, "getInternalError", function () { return $6c85c32373d4b5cd$export$500d4c4a8fafe35; });
$parcel$export(module.exports, "getSdkError", function () { return $6c85c32373d4b5cd$export$8203ef1531c8b5b5; });
$parcel$export(module.exports, "isValidArray", function () { return $6c85c32373d4b5cd$export$41dd3d480aac4a71; });
$parcel$export(module.exports, "isUndefined", function () { return $6c85c32373d4b5cd$export$fce6876652108ab; });
$parcel$export(module.exports, "isValidString", function () { return $6c85c32373d4b5cd$export$ee898ca48ab56c74; });
$parcel$export(module.exports, "isSessionCompatible", function () { return $6c85c32373d4b5cd$export$6fc4971bf8f326a; });
$parcel$export(module.exports, "isValidUrl", function () { return $6c85c32373d4b5cd$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "isProposalStruct", function () { return $6c85c32373d4b5cd$export$f657f7976bb2769d; });
$parcel$export(module.exports, "isSessionStruct", function () { return $6c85c32373d4b5cd$export$c96d5113768aaf5e; });
$parcel$export(module.exports, "isValidController", function () { return $6c85c32373d4b5cd$export$5e1c5c89613c213f; });
$parcel$export(module.exports, "isValidRequiredNamespaces", function () { return $6c85c32373d4b5cd$export$9e2b2cae22c6a8b3; });
$parcel$export(module.exports, "isValidRelay", function () { return $6c85c32373d4b5cd$export$1b3fc298be8c9a7b; });
$parcel$export(module.exports, "isValidRelays", function () { return $6c85c32373d4b5cd$export$6294c30b976bd21e; });
$parcel$export(module.exports, "isValidId", function () { return $6c85c32373d4b5cd$export$53551be28ad5e34d; });
$parcel$export(module.exports, "isValidParams", function () { return $6c85c32373d4b5cd$export$b3f5fcca1d210454; });
$parcel$export(module.exports, "isValidErrorReason", function () { return $6c85c32373d4b5cd$export$766fe78377d96f2a; });
$parcel$export(module.exports, "isValidRequest", function () { return $6c85c32373d4b5cd$export$1a2af3c017fb6d42; });
$parcel$export(module.exports, "isValidResponse", function () { return $6c85c32373d4b5cd$export$1ae38cf0a848f651; });
$parcel$export(module.exports, "isValidEvent", function () { return $6c85c32373d4b5cd$export$cbe4cdc5960cfa11; });
$parcel$export(module.exports, "isValidNamespacesChainId", function () { return $6c85c32373d4b5cd$export$144fc36610eb6522; });
$parcel$export(module.exports, "isValidNamespacesRequest", function () { return $6c85c32373d4b5cd$export$8db4804e3a6de711; });
$parcel$export(module.exports, "isValidNamespacesEvent", function () { return $6c85c32373d4b5cd$export$df2c67ef8baad16b; });
$parcel$export(module.exports, "isValidRequestExpiry", function () { return $6c85c32373d4b5cd$export$59fba2af1ac782b; });
$parcel$export(module.exports, "isOnline", function () { return $6c85c32373d4b5cd$export$53c2fd0173ad2b80; });
$parcel$export(module.exports, "subscribeToNetworkChange", function () { return $6c85c32373d4b5cd$export$600a1ee4bc680996; });
$parcel$export(module.exports, "MemoryStore", function () { return $6c85c32373d4b5cd$export$b72d712fed4d036d; });

var $8VG1E = parcelRequire("8VG1E");

var $2TjUJ = parcelRequire("2TjUJ");

var $f4uqJ = parcelRequire("f4uqJ");

var $75xMO = parcelRequire("75xMO");

var $6vrIt = parcelRequire("6vrIt");

var $gi8t9 = parcelRequire("gi8t9");

var $islmt = parcelRequire("islmt");
parcelRequire("8l48q");
var $abuiC = parcelRequire("abuiC");
var $2AuZR = parcelRequire("2AuZR");
var $BCGxC = parcelRequire("BCGxC");

var $5fcsy = parcelRequire("5fcsy");

var $17tgv = parcelRequire("17tgv");

var $98IaM = parcelRequire("98IaM");
var $6c85c32373d4b5cd$require$Buffer = $98IaM.Buffer;
const $6c85c32373d4b5cd$var$se = ":";
function $6c85c32373d4b5cd$export$4764229d78de4437(t) {
    const [e, n] = t.split($6c85c32373d4b5cd$var$se);
    return {
        namespace: e,
        reference: n
    };
}
function $6c85c32373d4b5cd$export$a5999672e4930644(t) {
    const { namespace: e, reference: n } = t;
    return [
        e,
        n
    ].join($6c85c32373d4b5cd$var$se);
}
function $6c85c32373d4b5cd$export$276ab0158c66e3d(t) {
    const [e, n, r] = t.split($6c85c32373d4b5cd$var$se);
    return {
        namespace: e,
        reference: n,
        address: r
    };
}
function $6c85c32373d4b5cd$export$566a25328fb93a18(t) {
    const { namespace: e, reference: n, address: r } = t;
    return [
        e,
        n,
        r
    ].join($6c85c32373d4b5cd$var$se);
}
function $6c85c32373d4b5cd$export$d579bc26e95946b5(t, e) {
    const n = [];
    return t.forEach((r)=>{
        const o = e(r);
        n.includes(o) || n.push(o);
    }), n;
}
function $6c85c32373d4b5cd$export$2806d446053abd1d(t) {
    const { address: e } = $6c85c32373d4b5cd$export$276ab0158c66e3d(t);
    return e;
}
function $6c85c32373d4b5cd$export$93512919ec2ab555(t) {
    const { namespace: e, reference: n } = $6c85c32373d4b5cd$export$276ab0158c66e3d(t);
    return $6c85c32373d4b5cd$export$a5999672e4930644({
        namespace: e,
        reference: n
    });
}
function $6c85c32373d4b5cd$export$40283ddc77f27f6e(t, e) {
    const { namespace: n, reference: r } = $6c85c32373d4b5cd$export$4764229d78de4437(e);
    return $6c85c32373d4b5cd$export$566a25328fb93a18({
        namespace: n,
        reference: r,
        address: t
    });
}
function $6c85c32373d4b5cd$export$aa4a6b630dfcfa83(t) {
    return $6c85c32373d4b5cd$export$d579bc26e95946b5(t, $6c85c32373d4b5cd$export$2806d446053abd1d);
}
function $6c85c32373d4b5cd$export$d5ee58c6b13696e9(t) {
    return $6c85c32373d4b5cd$export$d579bc26e95946b5(t, $6c85c32373d4b5cd$export$93512919ec2ab555);
}
function $6c85c32373d4b5cd$export$23329703ad972840(t, e = []) {
    const n = [];
    return Object.keys(t).forEach((r)=>{
        if (e.length && !e.includes(r)) return;
        const o = t[r];
        n.push(...o.accounts);
    }), n;
}
function $6c85c32373d4b5cd$export$6281ff29da5f85fe(t, e = []) {
    const n = [];
    return Object.keys(t).forEach((r)=>{
        if (e.length && !e.includes(r)) return;
        const o = t[r];
        n.push(...$6c85c32373d4b5cd$export$d5ee58c6b13696e9(o.accounts));
    }), n;
}
function $6c85c32373d4b5cd$export$d1109eeb751412cf(t, e = []) {
    const n = [];
    return Object.keys(t).forEach((r)=>{
        if (e.length && !e.includes(r)) return;
        const o = t[r];
        n.push(...$6c85c32373d4b5cd$export$376384387cd15b27(r, o));
    }), n;
}
function $6c85c32373d4b5cd$export$376384387cd15b27(t, e) {
    return t.includes(":") ? [
        t
    ] : e.chains || [];
}
var $6c85c32373d4b5cd$var$Zo = Object.defineProperty, $6c85c32373d4b5cd$var$Yo = Object.defineProperties, $6c85c32373d4b5cd$var$Go = Object.getOwnPropertyDescriptors, $6c85c32373d4b5cd$var$Tn = Object.getOwnPropertySymbols, $6c85c32373d4b5cd$var$Wo = Object.prototype.hasOwnProperty, $6c85c32373d4b5cd$var$Xo = Object.prototype.propertyIsEnumerable, $6c85c32373d4b5cd$var$Rn = (t, e, n)=>e in t ? $6c85c32373d4b5cd$var$Zo(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n, $6c85c32373d4b5cd$var$_n = (t, e)=>{
    for(var n in e || (e = {}))$6c85c32373d4b5cd$var$Wo.call(e, n) && $6c85c32373d4b5cd$var$Rn(t, n, e[n]);
    if ($6c85c32373d4b5cd$var$Tn) for (var n of $6c85c32373d4b5cd$var$Tn(e))$6c85c32373d4b5cd$var$Xo.call(e, n) && $6c85c32373d4b5cd$var$Rn(t, n, e[n]);
    return t;
}, $6c85c32373d4b5cd$var$Jo = (t, e)=>$6c85c32373d4b5cd$var$Yo(t, $6c85c32373d4b5cd$var$Go(e));
const $6c85c32373d4b5cd$export$f12873d77424d47b = "ReactNative", $6c85c32373d4b5cd$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $6c85c32373d4b5cd$export$657dee6d5648750a = " ", $6c85c32373d4b5cd$export$96c3628b3b9d2079 = ":", $6c85c32373d4b5cd$export$98238152dfccf046 = "/", $6c85c32373d4b5cd$export$7f882bb969de14a3 = 2, $6c85c32373d4b5cd$export$77baccb4c6bd5852 = 1e3, $6c85c32373d4b5cd$export$e08b61c98317d88c = "js";
function $6c85c32373d4b5cd$export$8ee0fc9ee280b4ee() {
    return typeof $17tgv < "u" && typeof $17tgv.versions < "u" && typeof $17tgv.versions.node < "u";
}
function $6c85c32373d4b5cd$export$f7a1e23e542d38e3() {
    return !(0, $f4uqJ.getDocument)() && !!(0, $f4uqJ.getNavigator)() && navigator.product === $6c85c32373d4b5cd$export$f12873d77424d47b;
}
function $6c85c32373d4b5cd$export$a11b0059900ceec8() {
    return $6c85c32373d4b5cd$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u" && ($parcel$global == null ? void 0 : $parcel$global.Platform.OS) === "android";
}
function $6c85c32373d4b5cd$export$41a665f744414057() {
    return $6c85c32373d4b5cd$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u" && ($parcel$global == null ? void 0 : $parcel$global.Platform.OS) === "ios";
}
function $6c85c32373d4b5cd$export$4e09c449d6c407f7() {
    return !$6c85c32373d4b5cd$export$8ee0fc9ee280b4ee() && !!(0, $f4uqJ.getNavigator)() && !!(0, $f4uqJ.getDocument)();
}
function $6c85c32373d4b5cd$export$57570b1603cf6adb() {
    return $6c85c32373d4b5cd$export$f7a1e23e542d38e3() ? $6c85c32373d4b5cd$export$86b1301a63b15dd9.reactNative : $6c85c32373d4b5cd$export$8ee0fc9ee280b4ee() ? $6c85c32373d4b5cd$export$86b1301a63b15dd9.node : $6c85c32373d4b5cd$export$4e09c449d6c407f7() ? $6c85c32373d4b5cd$export$86b1301a63b15dd9.browser : $6c85c32373d4b5cd$export$86b1301a63b15dd9.unknown;
}
function $6c85c32373d4b5cd$export$fb2283f4a44fb53() {
    var t;
    try {
        return $6c85c32373d4b5cd$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (t = $parcel$global.Application) == null ? void 0 : t.applicationId : void 0;
    } catch  {
        return;
    }
}
function $6c85c32373d4b5cd$export$c4147c69f6845da(t, e) {
    const n = new URLSearchParams(t);
    for (const r of Object.keys(e).sort())if (e.hasOwnProperty(r)) {
        const o = e[r];
        o !== void 0 && n.set(r, o);
    }
    return n.toString();
}
function $6c85c32373d4b5cd$export$40393344880c2ca3(t) {
    var e, n;
    const r = $6c85c32373d4b5cd$export$ba31e015127122bb();
    try {
        return t != null && t.url && r.url && t.url !== r.url && (console.warn(`The configured WalletConnect 'metadata.url':${t.url} differs from the actual page url:${r.url}. This is probably unintended and can lead to issues.`), t.url = r.url), (e = t?.icons) != null && e.length && t.icons.length > 0 && (t.icons = t.icons.filter((o)=>o !== "")), $6c85c32373d4b5cd$var$Jo($6c85c32373d4b5cd$var$_n($6c85c32373d4b5cd$var$_n({}, r), t), {
            url: t?.url || r.url,
            name: t?.name || r.name,
            description: t?.description || r.description,
            icons: (n = t?.icons) != null && n.length && t.icons.length > 0 ? t.icons : r.icons
        });
    } catch (o) {
        return console.warn("Error populating app metadata", o), t || r;
    }
}
function $6c85c32373d4b5cd$export$ba31e015127122bb() {
    return (0, $75xMO.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $6c85c32373d4b5cd$export$6b05aa0115b6fc2d(t, e) {
    var n;
    const r = $6c85c32373d4b5cd$export$57570b1603cf6adb(), o = {
        protocol: t,
        version: e,
        env: r
    };
    return r === "browser" && (o.host = ((n = (0, $f4uqJ.getLocation)()) == null ? void 0 : n.host) || "unknown"), o;
}
function $6c85c32373d4b5cd$export$20d4a3cb5829b8b6() {
    if ($6c85c32373d4b5cd$export$57570b1603cf6adb() === $6c85c32373d4b5cd$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: n, Version: r } = $parcel$global.Platform;
        return [
            n,
            r
        ].join("-");
    }
    const t = (0, $8VG1E.detect)();
    if (t === null) return "unknown";
    const e = t.os ? t.os.replace(" ", "").toLowerCase() : "unknown";
    return t.type === "browser" ? [
        e,
        t.name,
        t.version
    ].join("-") : [
        e,
        t.version
    ].join("-");
}
function $6c85c32373d4b5cd$export$4389b0987726d52d() {
    var t;
    const e = $6c85c32373d4b5cd$export$57570b1603cf6adb();
    return e === $6c85c32373d4b5cd$export$86b1301a63b15dd9.browser ? [
        e,
        ((t = (0, $f4uqJ.getLocation)()) == null ? void 0 : t.host) || "unknown"
    ].join(":") : e;
}
function $6c85c32373d4b5cd$export$b55a4c6e272b719f(t, e, n) {
    const r = $6c85c32373d4b5cd$export$20d4a3cb5829b8b6(), o = $6c85c32373d4b5cd$export$4389b0987726d52d();
    return [
        [
            t,
            e
        ].join("-"),
        [
            $6c85c32373d4b5cd$export$e08b61c98317d88c,
            n
        ].join("-"),
        r,
        o
    ].join("/");
}
function $6c85c32373d4b5cd$export$d875b3963ef774f5({ protocol: t, version: e, relayUrl: n, sdkVersion: r, auth: o, projectId: i, useOnCloseEvent: s, bundleId: c, packageName: a }) {
    const u = n.split("?"), l = $6c85c32373d4b5cd$export$b55a4c6e272b719f(t, e, r), f = {
        auth: o,
        ua: l,
        projectId: i,
        useOnCloseEvent: s || void 0,
        packageName: a || void 0,
        bundleId: c || void 0
    }, h = $6c85c32373d4b5cd$export$c4147c69f6845da(u[1] || "", f);
    return u[0] + "?" + h;
}
function $6c85c32373d4b5cd$export$ed08891a8a54eb(t) {
    let e = (t.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const n = typeof e < "u" ? t.split("://")[1] : t;
    return e = e === "wss" ? "https" : "http", [
        e,
        n
    ].join("://");
}
function $6c85c32373d4b5cd$export$804de46662e4ac95(t, e, n) {
    if (!t[e] || typeof t[e] !== n) throw new Error(`Missing or invalid "${e}" param`);
}
function $6c85c32373d4b5cd$export$1e21530e896c0b0b(t, e = $6c85c32373d4b5cd$export$7f882bb969de14a3) {
    return $6c85c32373d4b5cd$export$7f00885504704576(t.split($6c85c32373d4b5cd$export$98238152dfccf046), e);
}
function $6c85c32373d4b5cd$export$80bffd46c37a96f6(t) {
    return $6c85c32373d4b5cd$export$1e21530e896c0b0b(t).join($6c85c32373d4b5cd$export$657dee6d5648750a);
}
function $6c85c32373d4b5cd$export$1468a49de573f7f9(t, e) {
    return t.filter((n)=>e.includes(n)).length === t.length;
}
function $6c85c32373d4b5cd$export$7f00885504704576(t, e = $6c85c32373d4b5cd$export$7f882bb969de14a3) {
    return t.slice(Math.max(t.length - e, 0));
}
function $6c85c32373d4b5cd$export$c4b8dfeb6e237eb9(t) {
    return Object.fromEntries(t.entries());
}
function $6c85c32373d4b5cd$export$ac31b37c726bc3ba(t) {
    return new Map(Object.entries(t));
}
function $6c85c32373d4b5cd$export$592ef47eabb05614(t, e) {
    const n = {};
    return Object.keys(t).forEach((r)=>{
        n[r] = e(t[r]);
    }), n;
}
const $6c85c32373d4b5cd$export$85c927578394b28b = (t)=>t;
function $6c85c32373d4b5cd$export$e9f8fcacef3bca4b(t) {
    return t.trim().replace(/^\w/, (e)=>e.toUpperCase());
}
function $6c85c32373d4b5cd$export$9a00dee1beb8f576(t) {
    return t.split($6c85c32373d4b5cd$export$657dee6d5648750a).map((e)=>$6c85c32373d4b5cd$export$e9f8fcacef3bca4b(e)).join($6c85c32373d4b5cd$export$657dee6d5648750a);
}
function $6c85c32373d4b5cd$export$cbf9e3cc9ffc85cb(t = (0, $2TjUJ.FIVE_MINUTES), e) {
    const n = (0, $2TjUJ.toMiliseconds)(t || (0, $2TjUJ.FIVE_MINUTES));
    let r, o, i, s;
    return {
        resolve: (c)=>{
            i && r && (clearTimeout(i), r(c), s = Promise.resolve(c));
        },
        reject: (c)=>{
            i && o && (clearTimeout(i), o(c));
        },
        done: ()=>new Promise((c, a)=>{
                if (s) return c(s);
                i = setTimeout(()=>{
                    const u = new Error(e);
                    s = Promise.reject(u), a(u);
                }, n), r = c, o = a;
            })
    };
}
function $6c85c32373d4b5cd$export$3da2293b007ed708(t, e, n) {
    return new Promise(async (r, o)=>{
        const i = setTimeout(()=>o(new Error(n)), e);
        try {
            const s = await t;
            r(s);
        } catch (s) {
            o(s);
        }
        clearTimeout(i);
    });
}
function $6c85c32373d4b5cd$export$187ab6574b2ae23f(t, e) {
    if (typeof e == "string" && e.startsWith(`${t}:`)) return e;
    if (t.toLowerCase() === "topic") {
        if (typeof e != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${e}`;
    } else if (t.toLowerCase() === "id") {
        if (typeof e != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${e}`;
    }
    throw new Error(`Unknown expirer target type: ${t}`);
}
function $6c85c32373d4b5cd$export$43ab92477f8713b9(t) {
    return $6c85c32373d4b5cd$export$187ab6574b2ae23f("topic", t);
}
function $6c85c32373d4b5cd$export$bd13103c2e5cc0c3(t) {
    return $6c85c32373d4b5cd$export$187ab6574b2ae23f("id", t);
}
function $6c85c32373d4b5cd$export$93adeb0f16e8e51d(t) {
    const [e, n] = t.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (e === "topic" && typeof n == "string") r.topic = n;
    else if (e === "id" && Number.isInteger(Number(n))) r.id = Number(n);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${n}`);
    return r;
}
function $6c85c32373d4b5cd$export$b136d03015bfc12(t, e) {
    return (0, $2TjUJ.fromMiliseconds)((e || Date.now()) + (0, $2TjUJ.toMiliseconds)(t));
}
function $6c85c32373d4b5cd$export$57947cfd429801a2(t) {
    return Date.now() >= (0, $2TjUJ.toMiliseconds)(t);
}
function $6c85c32373d4b5cd$export$e3eb27ce66c0f6d9(t, e) {
    return `${t}${e ? `:${e}` : ""}`;
}
function $6c85c32373d4b5cd$export$9826fe7ad3921016(t = [], e = []) {
    return [
        ...new Set([
            ...t,
            ...e
        ])
    ];
}
async function $6c85c32373d4b5cd$export$694a208c8abca99a({ id: t, topic: e, wcDeepLink: n }) {
    var r;
    try {
        if (!n) return;
        const o = typeof n == "string" ? JSON.parse(n) : n, i = o?.href;
        if (typeof i != "string") return;
        const s = $6c85c32373d4b5cd$export$50b95b57215c848b(i, t, e), c = $6c85c32373d4b5cd$export$57570b1603cf6adb();
        if (c === $6c85c32373d4b5cd$export$86b1301a63b15dd9.browser) {
            if (!((r = (0, $f4uqJ.getDocument)()) != null && r.hasFocus())) {
                console.warn("Document does not have focus, skipping deeplink.");
                return;
            }
            $6c85c32373d4b5cd$export$435b055258496866(s);
        } else c === $6c85c32373d4b5cd$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (o) {
        console.error(o);
    }
}
function $6c85c32373d4b5cd$export$50b95b57215c848b(t, e, n) {
    const r = `requestId=${e}&sessionTopic=${n}`;
    t.endsWith("/") && (t = t.slice(0, -1));
    let o = `${t}`;
    if (t.startsWith("https://t.me")) {
        const i = t.includes("?") ? "&startapp=" : "?startapp=";
        o = `${o}${i}${$6c85c32373d4b5cd$export$37cc283d8fbd3462(r, !0)}`;
    } else o = `${o}/wc?${r}`;
    return o;
}
function $6c85c32373d4b5cd$export$435b055258496866(t) {
    let e = "_self";
    $6c85c32373d4b5cd$export$e6c5ffa684aac4d7() ? e = "_top" : ($6c85c32373d4b5cd$export$859b6b071fc07ffd() || t.startsWith("https://") || t.startsWith("http://")) && (e = "_blank"), window.open(t, e, "noreferrer noopener");
}
async function $6c85c32373d4b5cd$export$e55bfdac47149a32(t, e) {
    let n = "";
    try {
        if ($6c85c32373d4b5cd$export$4e09c449d6c407f7() && (n = localStorage.getItem(e), n)) return n;
        n = await t.getItem(e);
    } catch (r) {
        console.error(r);
    }
    return n;
}
function $6c85c32373d4b5cd$export$f8aaf09178dd8b96(t, e) {
    return t.filter((n)=>e.includes(n));
}
function $6c85c32373d4b5cd$export$e35f0b82969c30c3(t, e) {
    if (!t.includes(e)) return null;
    const n = t.split(/([&,?,=])/), r = n.indexOf(e);
    return n[r + 2];
}
function $6c85c32373d4b5cd$export$abe4376e1bf796d6() {
    return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (t)=>{
        const e = Math.random() * 16 | 0;
        return (t === "x" ? e : e & 3 | 8).toString(16);
    });
}
function $6c85c32373d4b5cd$export$b4bb0f87d8376dd4() {
    return typeof $17tgv < "u" && false;
}
function $6c85c32373d4b5cd$export$859b6b071fc07ffd() {
    return typeof window < "u" && (!!window.TelegramWebviewProxy || !!window.Telegram || !!window.TelegramWebviewProxyProto);
}
function $6c85c32373d4b5cd$export$e6c5ffa684aac4d7() {
    try {
        return window.self !== window.top;
    } catch  {
        return !1;
    }
}
function $6c85c32373d4b5cd$export$37cc283d8fbd3462(t, e = !1) {
    const n = $6c85c32373d4b5cd$require$Buffer.from(t).toString("base64");
    return e ? n.replace(/[=]/g, "") : n;
}
function $6c85c32373d4b5cd$export$c537b38001c583b7(t) {
    return $6c85c32373d4b5cd$require$Buffer.from(t, "base64").toString("utf-8");
}
function $6c85c32373d4b5cd$export$e772c8ff12451969(t) {
    return new Promise((e)=>setTimeout(e, t));
}
function $6c85c32373d4b5cd$var$Gt(t) {
    if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function $6c85c32373d4b5cd$var$Ui(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $6c85c32373d4b5cd$var$Wt(t, ...e) {
    if (!$6c85c32373d4b5cd$var$Ui(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $6c85c32373d4b5cd$var$je(t) {
    if (typeof t != "function" || typeof t.create != "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $6c85c32373d4b5cd$var$Gt(t.outputLen), $6c85c32373d4b5cd$var$Gt(t.blockLen);
}
function $6c85c32373d4b5cd$var$Tt(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $6c85c32373d4b5cd$var$Gn(t, e) {
    $6c85c32373d4b5cd$var$Wt(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
const $6c85c32373d4b5cd$var$ue = BigInt(2 ** 32 - 1), $6c85c32373d4b5cd$var$Wn = BigInt(32);
function $6c85c32373d4b5cd$var$Ti(t, e = !1) {
    return e ? {
        h: Number(t & $6c85c32373d4b5cd$var$ue),
        l: Number(t >> $6c85c32373d4b5cd$var$Wn & $6c85c32373d4b5cd$var$ue)
    } : {
        h: Number(t >> $6c85c32373d4b5cd$var$Wn & $6c85c32373d4b5cd$var$ue) | 0,
        l: Number(t & $6c85c32373d4b5cd$var$ue) | 0
    };
}
function $6c85c32373d4b5cd$var$Ri(t, e = !1) {
    let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
    for(let o = 0; o < t.length; o++){
        const { h: i, l: s } = $6c85c32373d4b5cd$var$Ti(t[o], e);
        [n[o], r[o]] = [
            i,
            s
        ];
    }
    return [
        n,
        r
    ];
}
const $6c85c32373d4b5cd$var$_i = (t, e, n)=>t << n | e >>> 32 - n, $6c85c32373d4b5cd$var$$i = (t, e, n)=>e << n | t >>> 32 - n, $6c85c32373d4b5cd$var$Li = (t, e, n)=>e << n - 32 | t >>> 64 - n, $6c85c32373d4b5cd$var$ji = (t, e, n)=>t << n - 32 | e >>> 64 - n, $6c85c32373d4b5cd$var$Rt = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function $6c85c32373d4b5cd$var$Ci(t) {
    return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function $6c85c32373d4b5cd$var$Ce(t) {
    return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function $6c85c32373d4b5cd$var$st(t, e) {
    return t << 32 - e | t >>> e;
}
const $6c85c32373d4b5cd$var$Xn = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
function $6c85c32373d4b5cd$var$Pi(t) {
    return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
function $6c85c32373d4b5cd$var$Jn(t) {
    for(let e = 0; e < t.length; e++)t[e] = $6c85c32373d4b5cd$var$Pi(t[e]);
}
function $6c85c32373d4b5cd$var$ki(t) {
    if (typeof t != "string") throw new Error("utf8ToBytes expected string, got " + typeof t);
    return new Uint8Array(new TextEncoder().encode(t));
}
function $6c85c32373d4b5cd$var$_t(t) {
    return typeof t == "string" && (t = $6c85c32373d4b5cd$var$ki(t)), $6c85c32373d4b5cd$var$Wt(t), t;
}
function $6c85c32373d4b5cd$var$Vi(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $6c85c32373d4b5cd$var$Wt(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const i = t[r];
        n.set(i, o), o += i.length;
    }
    return n;
}
class $6c85c32373d4b5cd$var$Pe {
    clone() {
        return this._cloneInto();
    }
}
function $6c85c32373d4b5cd$var$Qn(t) {
    const e = (r)=>t().update($6c85c32373d4b5cd$var$_t(r)).digest(), n = t();
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = ()=>t(), e;
}
function $6c85c32373d4b5cd$var$$t(t = 32) {
    if ($6c85c32373d4b5cd$var$Rt && typeof $6c85c32373d4b5cd$var$Rt.getRandomValues == "function") return $6c85c32373d4b5cd$var$Rt.getRandomValues(new Uint8Array(t));
    if ($6c85c32373d4b5cd$var$Rt && typeof $6c85c32373d4b5cd$var$Rt.randomBytes == "function") return $6c85c32373d4b5cd$var$Rt.randomBytes(t);
    throw new Error("crypto.getRandomValues must be defined");
}
const $6c85c32373d4b5cd$var$tr = [], $6c85c32373d4b5cd$var$er = [], $6c85c32373d4b5cd$var$nr = [], $6c85c32373d4b5cd$var$Mi = BigInt(0), $6c85c32373d4b5cd$var$Xt = BigInt(1), $6c85c32373d4b5cd$var$Di = BigInt(2), $6c85c32373d4b5cd$var$Hi = BigInt(7), $6c85c32373d4b5cd$var$qi = BigInt(256), $6c85c32373d4b5cd$var$Ki = BigInt(113);
for(let t = 0, e = $6c85c32373d4b5cd$var$Xt, n = 1, r = 0; t < 24; t++){
    [n, r] = [
        r,
        (2 * n + 3 * r) % 5
    ], $6c85c32373d4b5cd$var$tr.push(2 * (5 * r + n)), $6c85c32373d4b5cd$var$er.push((t + 1) * (t + 2) / 2 % 64);
    let o = $6c85c32373d4b5cd$var$Mi;
    for(let i = 0; i < 7; i++)e = (e << $6c85c32373d4b5cd$var$Xt ^ (e >> $6c85c32373d4b5cd$var$Hi) * $6c85c32373d4b5cd$var$Ki) % $6c85c32373d4b5cd$var$qi, e & $6c85c32373d4b5cd$var$Di && (o ^= $6c85c32373d4b5cd$var$Xt << ($6c85c32373d4b5cd$var$Xt << BigInt(i)) - $6c85c32373d4b5cd$var$Xt);
    $6c85c32373d4b5cd$var$nr.push(o);
}
const [$6c85c32373d4b5cd$var$Fi, $6c85c32373d4b5cd$var$zi] = $6c85c32373d4b5cd$var$Ri($6c85c32373d4b5cd$var$nr, !0), $6c85c32373d4b5cd$var$rr = (t, e, n)=>n > 32 ? $6c85c32373d4b5cd$var$Li(t, e, n) : $6c85c32373d4b5cd$var$_i(t, e, n), $6c85c32373d4b5cd$var$or = (t, e, n)=>n > 32 ? $6c85c32373d4b5cd$var$ji(t, e, n) : $6c85c32373d4b5cd$var$$i(t, e, n);
function $6c85c32373d4b5cd$var$Zi(t, e = 24) {
    const n = new Uint32Array(10);
    for(let r = 24 - e; r < 24; r++){
        for(let s = 0; s < 10; s++)n[s] = t[s] ^ t[s + 10] ^ t[s + 20] ^ t[s + 30] ^ t[s + 40];
        for(let s = 0; s < 10; s += 2){
            const c = (s + 8) % 10, a = (s + 2) % 10, u = n[a], l = n[a + 1], f = $6c85c32373d4b5cd$var$rr(u, l, 1) ^ n[c], h = $6c85c32373d4b5cd$var$or(u, l, 1) ^ n[c + 1];
            for(let y = 0; y < 50; y += 10)t[s + y] ^= f, t[s + y + 1] ^= h;
        }
        let o = t[2], i = t[3];
        for(let s = 0; s < 24; s++){
            const c = $6c85c32373d4b5cd$var$er[s], a = $6c85c32373d4b5cd$var$rr(o, i, c), u = $6c85c32373d4b5cd$var$or(o, i, c), l = $6c85c32373d4b5cd$var$tr[s];
            o = t[l], i = t[l + 1], t[l] = a, t[l + 1] = u;
        }
        for(let s = 0; s < 50; s += 10){
            for(let c = 0; c < 10; c++)n[c] = t[s + c];
            for(let c = 0; c < 10; c++)t[s + c] ^= ~n[(c + 2) % 10] & n[(c + 4) % 10];
        }
        t[0] ^= $6c85c32373d4b5cd$var$Fi[r], t[1] ^= $6c85c32373d4b5cd$var$zi[r];
    }
    n.fill(0);
}
class $6c85c32373d4b5cd$var$En extends $6c85c32373d4b5cd$var$Pe {
    constructor(e, n, r, o = !1, i = 24){
        if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = o, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, $6c85c32373d4b5cd$var$Gt(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200), this.state32 = $6c85c32373d4b5cd$var$Ci(this.state);
    }
    keccak() {
        $6c85c32373d4b5cd$var$Xn || $6c85c32373d4b5cd$var$Jn(this.state32), $6c85c32373d4b5cd$var$Zi(this.state32, this.rounds), $6c85c32373d4b5cd$var$Xn || $6c85c32373d4b5cd$var$Jn(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(e) {
        $6c85c32373d4b5cd$var$Tt(this);
        const { blockLen: n, state: r } = this;
        e = $6c85c32373d4b5cd$var$_t(e);
        const o = e.length;
        for(let i = 0; i < o;){
            const s = Math.min(n - this.pos, o - i);
            for(let c = 0; c < s; c++)r[this.pos++] ^= e[i++];
            this.pos === n && this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = !0;
        const { state: e, suffix: n, pos: r, blockLen: o } = this;
        e[r] ^= n, (n & 128) !== 0 && r === o - 1 && this.keccak(), e[o - 1] ^= 128, this.keccak();
    }
    writeInto(e) {
        $6c85c32373d4b5cd$var$Tt(this, !1), $6c85c32373d4b5cd$var$Wt(e), this.finish();
        const n = this.state, { blockLen: r } = this;
        for(let o = 0, i = e.length; o < i;){
            this.posOut >= r && this.keccak();
            const s = Math.min(r - this.posOut, i - o);
            e.set(n.subarray(this.posOut, this.posOut + s), o), this.posOut += s, o += s;
        }
        return e;
    }
    xofInto(e) {
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(e);
    }
    xof(e) {
        return $6c85c32373d4b5cd$var$Gt(e), this.xofInto(new Uint8Array(e));
    }
    digestInto(e) {
        if ($6c85c32373d4b5cd$var$Gn(e, this), this.finished) throw new Error("digest() was already called");
        return this.writeInto(e), this.destroy(), e;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(e) {
        const { blockLen: n, suffix: r, outputLen: o, rounds: i, enableXOF: s } = this;
        return e || (e = new $6c85c32373d4b5cd$var$En(n, r, o, s, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = r, e.outputLen = o, e.enableXOF = s, e.destroyed = this.destroyed, e;
    }
}
const $6c85c32373d4b5cd$var$Yi = (t, e, n)=>$6c85c32373d4b5cd$var$Qn(()=>new $6c85c32373d4b5cd$var$En(e, t, n)), $6c85c32373d4b5cd$var$Gi = $6c85c32373d4b5cd$var$Yi(1, 136, 32), $6c85c32373d4b5cd$var$Wi = "https://rpc.walletconnect.org/v1";
function $6c85c32373d4b5cd$export$13666321730419b4(t) {
    const e = `Ethereum Signed Message:
${t.length}`, n = new TextEncoder().encode(e + t);
    return "0x" + $6c85c32373d4b5cd$require$Buffer.from($6c85c32373d4b5cd$var$Gi(n)).toString("hex");
}
async function $6c85c32373d4b5cd$export$ab54e47fdf2903bb(t, e, n, r, o, i) {
    switch(n.t){
        case "eip191":
            return await $6c85c32373d4b5cd$export$b5da105d64914e5a(t, e, n.s);
        case "eip1271":
            return await $6c85c32373d4b5cd$export$9bffe3330373b76b(t, e, n.s, r, o, i);
        default:
            throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${n.t}`);
    }
}
async function $6c85c32373d4b5cd$export$b5da105d64914e5a(t, e, n) {
    return (await (0, $6vrIt.recoverAddress)({
        hash: $6c85c32373d4b5cd$export$13666321730419b4(e),
        signature: n
    })).toLowerCase() === t.toLowerCase();
}
async function $6c85c32373d4b5cd$export$9bffe3330373b76b(t, e, n, r, o, i) {
    const s = $6c85c32373d4b5cd$export$4764229d78de4437(r);
    if (!s.namespace || !s.reference) throw new Error(`isValidEip1271Signature failed: chainId must be in CAIP-2 format, received: ${r}`);
    try {
        const c = "0x1626ba7e", a = "0000000000000000000000000000000000000000000000000000000000000040", u = "0000000000000000000000000000000000000000000000000000000000000041", l = n.substring(2), f = $6c85c32373d4b5cd$export$13666321730419b4(e).substring(2), h = c + f + a + u + l, y = await fetch(`${i || $6c85c32373d4b5cd$var$Wi}/?chainId=${r}&projectId=${o}`, {
            method: "POST",
            body: JSON.stringify({
                id: $6c85c32373d4b5cd$var$Xi(),
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        to: t,
                        data: h
                    },
                    "latest"
                ]
            })
        }), { result: E } = await y.json();
        return E ? E.slice(0, c.length).toLowerCase() === c.toLowerCase() : !1;
    } catch (c) {
        return console.error("isValidEip1271Signature: ", c), !1;
    }
}
function $6c85c32373d4b5cd$var$Xi() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
function $6c85c32373d4b5cd$export$22c18daeebb76cc2(t) {
    const e = atob(t), n = new Uint8Array(e.length);
    for(let s = 0; s < e.length; s++)n[s] = e.charCodeAt(s);
    const r = n[0];
    if (r === 0) throw new Error("No signatures found");
    const o = 1 + r * 64;
    if (n.length < o) throw new Error("Transaction data too short for claimed signature count");
    if (n.length < 100) throw new Error("Transaction too short");
    const i = $6c85c32373d4b5cd$require$Buffer.from(t, "base64").slice(1, 65);
    return (0, $gi8t9.default).encode(i);
}
var $6c85c32373d4b5cd$var$Qi = Object.defineProperty, $6c85c32373d4b5cd$var$ts = Object.defineProperties, $6c85c32373d4b5cd$var$es = Object.getOwnPropertyDescriptors, $6c85c32373d4b5cd$var$ar = Object.getOwnPropertySymbols, $6c85c32373d4b5cd$var$ns = Object.prototype.hasOwnProperty, $6c85c32373d4b5cd$var$rs = Object.prototype.propertyIsEnumerable, $6c85c32373d4b5cd$var$ur = (t, e, n)=>e in t ? $6c85c32373d4b5cd$var$Qi(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n, $6c85c32373d4b5cd$var$Ve = (t, e)=>{
    for(var n in e || (e = {}))$6c85c32373d4b5cd$var$ns.call(e, n) && $6c85c32373d4b5cd$var$ur(t, n, e[n]);
    if ($6c85c32373d4b5cd$var$ar) for (var n of $6c85c32373d4b5cd$var$ar(e))$6c85c32373d4b5cd$var$rs.call(e, n) && $6c85c32373d4b5cd$var$ur(t, n, e[n]);
    return t;
}, $6c85c32373d4b5cd$var$fr = (t, e)=>$6c85c32373d4b5cd$var$ts(t, $6c85c32373d4b5cd$var$es(e));
const $6c85c32373d4b5cd$var$os = "did:pkh:", $6c85c32373d4b5cd$export$a524ae552db7912 = (t)=>t?.split(":"), $6c85c32373d4b5cd$export$85f23c05c80b194 = (t)=>{
    const e = t && $6c85c32373d4b5cd$export$a524ae552db7912(t);
    if (e) return t.includes($6c85c32373d4b5cd$var$os) ? e[3] : e[1];
}, $6c85c32373d4b5cd$export$a8b149927aef7051 = (t)=>{
    const e = t && $6c85c32373d4b5cd$export$a524ae552db7912(t);
    if (e) return e[2] + ":" + e[3];
}, $6c85c32373d4b5cd$export$bf43cfbb4bd95de9 = (t)=>{
    const e = t && $6c85c32373d4b5cd$export$a524ae552db7912(t);
    if (e) return e.pop();
};
async function $6c85c32373d4b5cd$export$b7d566fce8e2b970(t) {
    const { cacao: e, projectId: n } = t, { s: r, p: o } = e, i = $6c85c32373d4b5cd$export$25868d1e8e76735f(o, o.iss), s = $6c85c32373d4b5cd$export$bf43cfbb4bd95de9(o.iss);
    return await $6c85c32373d4b5cd$export$ab54e47fdf2903bb(s, i, r, $6c85c32373d4b5cd$export$a8b149927aef7051(o.iss), n);
}
const $6c85c32373d4b5cd$export$25868d1e8e76735f = (t, e)=>{
    const n = `${t.domain} wants you to sign in with your Ethereum account:`, r = $6c85c32373d4b5cd$export$bf43cfbb4bd95de9(e);
    if (!t.aud && !t.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    let o = t.statement || void 0;
    const i = `URI: ${t.aud || t.uri}`, s = `Version: ${t.version}`, c = `Chain ID: ${$6c85c32373d4b5cd$export$85f23c05c80b194(e)}`, a = `Nonce: ${t.nonce}`, u = `Issued At: ${t.iat}`, l = t.exp ? `Expiration Time: ${t.exp}` : void 0, f = t.nbf ? `Not Before: ${t.nbf}` : void 0, h = t.requestId ? `Request ID: ${t.requestId}` : void 0, y = t.resources ? `Resources:${t.resources.map((p)=>`
- ${p}`).join("")}` : void 0, E = $6c85c32373d4b5cd$export$3bb18ae0fb9a9fa9(t.resources);
    if (E) {
        const p = $6c85c32373d4b5cd$export$d34522c9e5a1aed1(E);
        o = $6c85c32373d4b5cd$export$51673931d3a8308d(o, p);
    }
    return [
        n,
        r,
        "",
        o,
        "",
        i,
        s,
        c,
        a,
        u,
        l,
        f,
        h,
        y
    ].filter((p)=>p != null).join(`
`);
};
function $6c85c32373d4b5cd$export$905974078a05d5f9(t, e, n) {
    return n.includes("did:pkh:") || (n = `did:pkh:${n}`), {
        h: {
            t: "caip122"
        },
        p: {
            iss: n,
            domain: t.domain,
            aud: t.aud,
            version: t.version,
            nonce: t.nonce,
            iat: t.iat,
            statement: t.statement,
            requestId: t.requestId,
            resources: t.resources,
            nbf: t.nbf,
            exp: t.exp
        },
        s: e
    };
}
function $6c85c32373d4b5cd$export$2bfa2ac7d9bc193c(t) {
    var e;
    const { authPayload: n, chains: r, methods: o } = t, i = n.statement || "";
    if (!(r != null && r.length)) return n;
    const s = n.chains, c = $6c85c32373d4b5cd$export$f8aaf09178dd8b96(s, r);
    if (!(c != null && c.length)) throw new Error("No supported chains");
    const a = $6c85c32373d4b5cd$export$8db308c294c84efd(n.resources);
    if (!a) return n;
    $6c85c32373d4b5cd$export$ae8075c482503f32(a);
    const u = $6c85c32373d4b5cd$export$9595a56724061288(a, "eip155");
    let l = n?.resources || [];
    if (u != null && u.length) {
        const f = $6c85c32373d4b5cd$export$e1a9af3d61db3b68(u), h = $6c85c32373d4b5cd$export$f8aaf09178dd8b96(f, o);
        if (!(h != null && h.length)) throw new Error(`Supported methods don't satisfy the requested: ${JSON.stringify(f)}, supported: ${JSON.stringify(o)}`);
        const y = $6c85c32373d4b5cd$export$987cafd76db78dd1("request", h, {
            chains: c
        }), E = $6c85c32373d4b5cd$export$317cb0007b0867c1(a, "eip155", y);
        l = ((e = n?.resources) == null ? void 0 : e.slice(0, -1)) || [], l.push($6c85c32373d4b5cd$export$79a538532b4f11f7(E));
    }
    return $6c85c32373d4b5cd$var$fr($6c85c32373d4b5cd$var$Ve({}, n), {
        statement: $6c85c32373d4b5cd$export$fb351782bc6f001e(i, $6c85c32373d4b5cd$export$3bb18ae0fb9a9fa9(l)),
        chains: c,
        resources: n != null && n.resources || l.length > 0 ? l : void 0
    });
}
function $6c85c32373d4b5cd$export$8db308c294c84efd(t) {
    const e = $6c85c32373d4b5cd$export$3bb18ae0fb9a9fa9(t);
    if (e && $6c85c32373d4b5cd$export$d9f11bd9fec5a64(e)) return $6c85c32373d4b5cd$export$d34522c9e5a1aed1(e);
}
function $6c85c32373d4b5cd$export$771534f1eaa353c(t, e) {
    var n;
    return (n = t?.att) == null ? void 0 : n.hasOwnProperty(e);
}
function $6c85c32373d4b5cd$export$9595a56724061288(t, e) {
    var n, r;
    return (n = t?.att) != null && n[e] ? Object.keys((r = t?.att) == null ? void 0 : r[e]) : [];
}
function $6c85c32373d4b5cd$export$d4548b739f9dafe(t) {
    return t?.map((e)=>Object.keys(e)) || [];
}
function $6c85c32373d4b5cd$export$e1a9af3d61db3b68(t) {
    return t?.map((e)=>{
        var n;
        return (n = e.split("/")) == null ? void 0 : n[1];
    }) || [];
}
function $6c85c32373d4b5cd$export$e510a73ee562749(t) {
    return $6c85c32373d4b5cd$require$Buffer.from(JSON.stringify(t)).toString("base64");
}
function $6c85c32373d4b5cd$export$c62426fdd000a97e(t) {
    return JSON.parse($6c85c32373d4b5cd$require$Buffer.from(t, "base64").toString("utf-8"));
}
function $6c85c32373d4b5cd$export$ae8075c482503f32(t) {
    if (!t) throw new Error("No recap provided, value is undefined");
    if (!t.att) throw new Error("No `att` property found");
    const e = Object.keys(t.att);
    if (!(e != null && e.length)) throw new Error("No resources found in `att` property");
    e.forEach((n)=>{
        const r = t.att[n];
        if (Array.isArray(r)) throw new Error(`Resource must be an object: ${n}`);
        if (typeof r != "object") throw new Error(`Resource must be an object: ${n}`);
        if (!Object.keys(r).length) throw new Error(`Resource object is empty: ${n}`);
        Object.keys(r).forEach((o)=>{
            const i = r[o];
            if (!Array.isArray(i)) throw new Error(`Ability limits ${o} must be an array of objects, found: ${i}`);
            if (!i.length) throw new Error(`Value of ${o} is empty array, must be an array with objects`);
            i.forEach((s)=>{
                if (typeof s != "object") throw new Error(`Ability limits (${o}) must be an array of objects, found: ${s}`);
            });
        });
    });
}
function $6c85c32373d4b5cd$export$eea18a04b33506ed(t, e, n, r = {}) {
    return n?.sort((o, i)=>o.localeCompare(i)), {
        att: {
            [t]: $6c85c32373d4b5cd$export$987cafd76db78dd1(e, n, r)
        }
    };
}
function $6c85c32373d4b5cd$export$317cb0007b0867c1(t, e, n) {
    var r;
    t.att[e] = $6c85c32373d4b5cd$var$Ve({}, n);
    const o = (r = Object.keys(t.att)) == null ? void 0 : r.sort((s, c)=>s.localeCompare(c)), i = {
        att: {}
    };
    return o.reduce((s, c)=>(s.att[c] = t.att[c], s), i);
}
function $6c85c32373d4b5cd$export$987cafd76db78dd1(t, e, n = {}) {
    e = e?.sort((o, i)=>o.localeCompare(i));
    const r = e.map((o)=>({
            [`${t}/${o}`]: [
                n
            ]
        }));
    return Object.assign({}, ...r);
}
function $6c85c32373d4b5cd$export$79a538532b4f11f7(t) {
    return $6c85c32373d4b5cd$export$ae8075c482503f32(t), `urn:recap:${$6c85c32373d4b5cd$export$e510a73ee562749(t).replace(/=/g, "")}`;
}
function $6c85c32373d4b5cd$export$d34522c9e5a1aed1(t) {
    const e = $6c85c32373d4b5cd$export$c62426fdd000a97e(t.replace("urn:recap:", ""));
    return $6c85c32373d4b5cd$export$ae8075c482503f32(e), e;
}
function $6c85c32373d4b5cd$export$2bc35d2a08a09ad5(t, e, n) {
    const r = $6c85c32373d4b5cd$export$eea18a04b33506ed(t, e, n);
    return $6c85c32373d4b5cd$export$79a538532b4f11f7(r);
}
function $6c85c32373d4b5cd$export$d9f11bd9fec5a64(t) {
    return t && t.includes("urn:recap:");
}
function $6c85c32373d4b5cd$export$c7a40c552af428b5(t, e) {
    const n = $6c85c32373d4b5cd$export$d34522c9e5a1aed1(t), r = $6c85c32373d4b5cd$export$d34522c9e5a1aed1(e), o = $6c85c32373d4b5cd$export$2445df2492ef2cbd(n, r);
    return $6c85c32373d4b5cd$export$79a538532b4f11f7(o);
}
function $6c85c32373d4b5cd$export$2445df2492ef2cbd(t, e) {
    $6c85c32373d4b5cd$export$ae8075c482503f32(t), $6c85c32373d4b5cd$export$ae8075c482503f32(e);
    const n = Object.keys(t.att).concat(Object.keys(e.att)).sort((o, i)=>o.localeCompare(i)), r = {
        att: {}
    };
    return n.forEach((o)=>{
        var i, s;
        Object.keys(((i = t.att) == null ? void 0 : i[o]) || {}).concat(Object.keys(((s = e.att) == null ? void 0 : s[o]) || {})).sort((c, a)=>c.localeCompare(a)).forEach((c)=>{
            var a, u;
            r.att[o] = $6c85c32373d4b5cd$var$fr($6c85c32373d4b5cd$var$Ve({}, r.att[o]), {
                [c]: ((a = t.att[o]) == null ? void 0 : a[c]) || ((u = e.att[o]) == null ? void 0 : u[c])
            });
        });
    }), r;
}
function $6c85c32373d4b5cd$export$51673931d3a8308d(t = "", e) {
    $6c85c32373d4b5cd$export$ae8075c482503f32(e);
    const n = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (t.includes(n)) return t;
    const r = [];
    let o = 0;
    Object.keys(e.att).forEach((c)=>{
        const a = Object.keys(e.att[c]).map((f)=>({
                ability: f.split("/")[0],
                action: f.split("/")[1]
            }));
        a.sort((f, h)=>f.action.localeCompare(h.action));
        const u = {};
        a.forEach((f)=>{
            u[f.ability] || (u[f.ability] = []), u[f.ability].push(f.action);
        });
        const l = Object.keys(u).map((f)=>(o++, `(${o}) '${f}': '${u[f].join("', '")}' for '${c}'.`));
        r.push(l.join(", ").replace(".,", "."));
    });
    const i = r.join(" "), s = `${n}${i}`;
    return `${t ? t + " " : ""}${s}`;
}
function $6c85c32373d4b5cd$export$d6c6a43d36418efe(t) {
    var e;
    const n = $6c85c32373d4b5cd$export$d34522c9e5a1aed1(t);
    $6c85c32373d4b5cd$export$ae8075c482503f32(n);
    const r = (e = n.att) == null ? void 0 : e.eip155;
    return r ? Object.keys(r).map((o)=>o.split("/")[1]) : [];
}
function $6c85c32373d4b5cd$export$372f88051a611988(t) {
    const e = $6c85c32373d4b5cd$export$d34522c9e5a1aed1(t);
    $6c85c32373d4b5cd$export$ae8075c482503f32(e);
    const n = [];
    return Object.values(e.att).forEach((r)=>{
        Object.values(r).forEach((o)=>{
            var i;
            (i = o?.[0]) != null && i.chains && n.push(o[0].chains);
        });
    }), [
        ...new Set(n.flat())
    ];
}
function $6c85c32373d4b5cd$export$fb351782bc6f001e(t, e) {
    if (!e) return t;
    const n = $6c85c32373d4b5cd$export$d34522c9e5a1aed1(e);
    return $6c85c32373d4b5cd$export$ae8075c482503f32(n), $6c85c32373d4b5cd$export$51673931d3a8308d(t, n);
}
function $6c85c32373d4b5cd$export$3bb18ae0fb9a9fa9(t) {
    if (!t) return;
    const e = t?.[t.length - 1];
    return $6c85c32373d4b5cd$export$d9f11bd9fec5a64(e) ? e : void 0;
}
function $6c85c32373d4b5cd$var$Ke(t) {
    if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function $6c85c32373d4b5cd$var$Sr(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $6c85c32373d4b5cd$var$tt(t, ...e) {
    if (!$6c85c32373d4b5cd$var$Sr(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $6c85c32373d4b5cd$var$Or(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $6c85c32373d4b5cd$var$ps(t, e) {
    $6c85c32373d4b5cd$var$tt(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
function $6c85c32373d4b5cd$var$Ar(t) {
    if (typeof t != "boolean") throw new Error(`boolean expected, not ${t}`);
}
const $6c85c32373d4b5cd$var$mt = (t)=>new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)), $6c85c32373d4b5cd$var$gs = (t)=>new DataView(t.buffer, t.byteOffset, t.byteLength), $6c85c32373d4b5cd$var$ys = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
if (!$6c85c32373d4b5cd$var$ys) throw new Error("Non little-endian hardware is not supported");
function $6c85c32373d4b5cd$var$ms(t) {
    if (typeof t != "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(t));
}
function $6c85c32373d4b5cd$var$Fe(t) {
    if (typeof t == "string") t = $6c85c32373d4b5cd$var$ms(t);
    else if ($6c85c32373d4b5cd$var$Sr(t)) t = $6c85c32373d4b5cd$var$ze(t);
    else throw new Error("Uint8Array expected, got " + typeof t);
    return t;
}
function $6c85c32373d4b5cd$var$ws(t, e) {
    if (e == null || typeof e != "object") throw new Error("options must be defined");
    return Object.assign(t, e);
}
function $6c85c32373d4b5cd$var$bs(t, e) {
    if (t.length !== e.length) return !1;
    let n = 0;
    for(let r = 0; r < t.length; r++)n |= t[r] ^ e[r];
    return n === 0;
}
const $6c85c32373d4b5cd$var$Es = (t, e)=>{
    function n(r, ...o) {
        if ($6c85c32373d4b5cd$var$tt(r), t.nonceLength !== void 0) {
            const l = o[0];
            if (!l) throw new Error("nonce / iv required");
            t.varSizeNonce ? $6c85c32373d4b5cd$var$tt(l) : $6c85c32373d4b5cd$var$tt(l, t.nonceLength);
        }
        const i = t.tagLength;
        i && o[1] !== void 0 && $6c85c32373d4b5cd$var$tt(o[1]);
        const s = e(r, ...o), c = (l, f)=>{
            if (f !== void 0) {
                if (l !== 2) throw new Error("cipher output not supported");
                $6c85c32373d4b5cd$var$tt(f);
            }
        };
        let a = !1;
        return {
            encrypt (l, f) {
                if (a) throw new Error("cannot encrypt() twice with same key + nonce");
                return a = !0, $6c85c32373d4b5cd$var$tt(l), c(s.encrypt.length, f), s.encrypt(l, f);
            },
            decrypt (l, f) {
                if ($6c85c32373d4b5cd$var$tt(l), i && l.length < i) throw new Error("invalid ciphertext length: smaller than tagLength=" + i);
                return c(s.decrypt.length, f), s.decrypt(l, f);
            }
        };
    }
    return Object.assign(n, t), n;
};
function $6c85c32373d4b5cd$var$Br(t, e, n = !0) {
    if (e === void 0) return new Uint8Array(t);
    if (e.length !== t) throw new Error("invalid output length, expected " + t + ", got: " + e.length);
    if (n && !$6c85c32373d4b5cd$var$vs(e)) throw new Error("invalid output, must be aligned");
    return e;
}
function $6c85c32373d4b5cd$var$Ir(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), i = BigInt(4294967295), s = Number(n >> o & i), c = Number(n & i), a = r ? 4 : 0, u = r ? 0 : 4;
    t.setUint32(e + a, s, r), t.setUint32(e + u, c, r);
}
function $6c85c32373d4b5cd$var$vs(t) {
    return t.byteOffset % 4 === 0;
}
function $6c85c32373d4b5cd$var$ze(t) {
    return Uint8Array.from(t);
}
function $6c85c32373d4b5cd$var$Lt(...t) {
    for(let e = 0; e < t.length; e++)t[e].fill(0);
}
const $6c85c32373d4b5cd$var$Nr = (t)=>Uint8Array.from(t.split("").map((e)=>e.charCodeAt(0))), $6c85c32373d4b5cd$var$xs = $6c85c32373d4b5cd$var$Nr("expand 16-byte k"), $6c85c32373d4b5cd$var$Ss = $6c85c32373d4b5cd$var$Nr("expand 32-byte k"), $6c85c32373d4b5cd$var$Os = $6c85c32373d4b5cd$var$mt($6c85c32373d4b5cd$var$xs), $6c85c32373d4b5cd$var$As = $6c85c32373d4b5cd$var$mt($6c85c32373d4b5cd$var$Ss);
function $6c85c32373d4b5cd$var$V(t, e) {
    return t << e | t >>> 32 - e;
}
function $6c85c32373d4b5cd$var$Ze(t) {
    return t.byteOffset % 4 === 0;
}
const $6c85c32373d4b5cd$var$he = 64, $6c85c32373d4b5cd$var$Bs = 16, $6c85c32373d4b5cd$var$Ur = 2 ** 32 - 1, $6c85c32373d4b5cd$var$Tr = new Uint32Array;
function $6c85c32373d4b5cd$var$Is(t, e, n, r, o, i, s, c) {
    const a = o.length, u = new Uint8Array($6c85c32373d4b5cd$var$he), l = $6c85c32373d4b5cd$var$mt(u), f = $6c85c32373d4b5cd$var$Ze(o) && $6c85c32373d4b5cd$var$Ze(i), h = f ? $6c85c32373d4b5cd$var$mt(o) : $6c85c32373d4b5cd$var$Tr, y = f ? $6c85c32373d4b5cd$var$mt(i) : $6c85c32373d4b5cd$var$Tr;
    for(let E = 0; E < a; s++){
        if (t(e, n, r, l, s, c), s >= $6c85c32373d4b5cd$var$Ur) throw new Error("arx: counter overflow");
        const p = Math.min($6c85c32373d4b5cd$var$he, a - E);
        if (f && p === $6c85c32373d4b5cd$var$he) {
            const d = E / 4;
            if (E % 4 !== 0) throw new Error("arx: invalid block position");
            for(let v = 0, m; v < $6c85c32373d4b5cd$var$Bs; v++)m = d + v, y[m] = h[m] ^ l[v];
            E += $6c85c32373d4b5cd$var$he;
            continue;
        }
        for(let d = 0, v; d < p; d++)v = E + d, i[v] = o[v] ^ u[d];
        E += p;
    }
}
function $6c85c32373d4b5cd$var$Ns(t, e) {
    const { allowShortKeys: n, extendNonceFn: r, counterLength: o, counterRight: i, rounds: s } = $6c85c32373d4b5cd$var$ws({
        allowShortKeys: !1,
        counterLength: 8,
        counterRight: !1,
        rounds: 20
    }, e);
    if (typeof t != "function") throw new Error("core must be a function");
    return $6c85c32373d4b5cd$var$Ke(o), $6c85c32373d4b5cd$var$Ke(s), $6c85c32373d4b5cd$var$Ar(i), $6c85c32373d4b5cd$var$Ar(n), (c, a, u, l, f = 0)=>{
        $6c85c32373d4b5cd$var$tt(c), $6c85c32373d4b5cd$var$tt(a), $6c85c32373d4b5cd$var$tt(u);
        const h = u.length;
        if (l === void 0 && (l = new Uint8Array(h)), $6c85c32373d4b5cd$var$tt(l), $6c85c32373d4b5cd$var$Ke(f), f < 0 || f >= $6c85c32373d4b5cd$var$Ur) throw new Error("arx: counter overflow");
        if (l.length < h) throw new Error(`arx: output (${l.length}) is shorter than data (${h})`);
        const y = [];
        let E = c.length, p, d;
        if (E === 32) y.push(p = $6c85c32373d4b5cd$var$ze(c)), d = $6c85c32373d4b5cd$var$As;
        else if (E === 16 && n) p = new Uint8Array(32), p.set(c), p.set(c, 16), d = $6c85c32373d4b5cd$var$Os, y.push(p);
        else throw new Error(`arx: invalid 32-byte key, got length=${E}`);
        $6c85c32373d4b5cd$var$Ze(a) || y.push(a = $6c85c32373d4b5cd$var$ze(a));
        const v = $6c85c32373d4b5cd$var$mt(p);
        if (r) {
            if (a.length !== 24) throw new Error("arx: extended nonce must be 24 bytes");
            r(d, v, $6c85c32373d4b5cd$var$mt(a.subarray(0, 16)), v), a = a.subarray(16);
        }
        const m = 16 - o;
        if (m !== a.length) throw new Error(`arx: nonce must be ${m} or 16 bytes`);
        if (m !== 12) {
            const N = new Uint8Array(12);
            N.set(a, i ? 0 : 12 - a.length), a = N, y.push(a);
        }
        const O = $6c85c32373d4b5cd$var$mt(a);
        return $6c85c32373d4b5cd$var$Is(t, d, v, O, u, l, f, s), $6c85c32373d4b5cd$var$Lt(...y), l;
    };
}
const $6c85c32373d4b5cd$var$F = (t, e)=>t[e++] & 255 | (t[e++] & 255) << 8;
class $6c85c32373d4b5cd$var$Us {
    constructor(e){
        this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, e = $6c85c32373d4b5cd$var$Fe(e), $6c85c32373d4b5cd$var$tt(e, 32);
        const n = $6c85c32373d4b5cd$var$F(e, 0), r = $6c85c32373d4b5cd$var$F(e, 2), o = $6c85c32373d4b5cd$var$F(e, 4), i = $6c85c32373d4b5cd$var$F(e, 6), s = $6c85c32373d4b5cd$var$F(e, 8), c = $6c85c32373d4b5cd$var$F(e, 10), a = $6c85c32373d4b5cd$var$F(e, 12), u = $6c85c32373d4b5cd$var$F(e, 14);
        this.r[0] = n & 8191, this.r[1] = (n >>> 13 | r << 3) & 8191, this.r[2] = (r >>> 10 | o << 6) & 7939, this.r[3] = (o >>> 7 | i << 9) & 8191, this.r[4] = (i >>> 4 | s << 12) & 255, this.r[5] = s >>> 1 & 8190, this.r[6] = (s >>> 14 | c << 2) & 8191, this.r[7] = (c >>> 11 | a << 5) & 8065, this.r[8] = (a >>> 8 | u << 8) & 8191, this.r[9] = u >>> 5 & 127;
        for(let l = 0; l < 8; l++)this.pad[l] = $6c85c32373d4b5cd$var$F(e, 16 + 2 * l);
    }
    process(e, n, r = !1) {
        const o = r ? 0 : 2048, { h: i, r: s } = this, c = s[0], a = s[1], u = s[2], l = s[3], f = s[4], h = s[5], y = s[6], E = s[7], p = s[8], d = s[9], v = $6c85c32373d4b5cd$var$F(e, n + 0), m = $6c85c32373d4b5cd$var$F(e, n + 2), O = $6c85c32373d4b5cd$var$F(e, n + 4), N = $6c85c32373d4b5cd$var$F(e, n + 6), $ = $6c85c32373d4b5cd$var$F(e, n + 8), B = $6c85c32373d4b5cd$var$F(e, n + 10), A = $6c85c32373d4b5cd$var$F(e, n + 12), T = $6c85c32373d4b5cd$var$F(e, n + 14);
        let S = i[0] + (v & 8191), L = i[1] + ((v >>> 13 | m << 3) & 8191), U = i[2] + ((m >>> 10 | O << 6) & 8191), _ = i[3] + ((O >>> 7 | N << 9) & 8191), j = i[4] + ((N >>> 4 | $ << 12) & 8191), g = i[5] + ($ >>> 1 & 8191), w = i[6] + (($ >>> 14 | B << 2) & 8191), b = i[7] + ((B >>> 11 | A << 5) & 8191), I = i[8] + ((A >>> 8 | T << 8) & 8191), R = i[9] + (T >>> 5 | o), x = 0, C = x + S * c + L * (5 * d) + U * (5 * p) + _ * (5 * E) + j * (5 * y);
        x = C >>> 13, C &= 8191, C += g * (5 * h) + w * (5 * f) + b * (5 * l) + I * (5 * u) + R * (5 * a), x += C >>> 13, C &= 8191;
        let P = x + S * a + L * c + U * (5 * d) + _ * (5 * p) + j * (5 * E);
        x = P >>> 13, P &= 8191, P += g * (5 * y) + w * (5 * h) + b * (5 * f) + I * (5 * l) + R * (5 * u), x += P >>> 13, P &= 8191;
        let k = x + S * u + L * a + U * c + _ * (5 * d) + j * (5 * p);
        x = k >>> 13, k &= 8191, k += g * (5 * E) + w * (5 * y) + b * (5 * h) + I * (5 * f) + R * (5 * l), x += k >>> 13, k &= 8191;
        let M = x + S * l + L * u + U * a + _ * c + j * (5 * d);
        x = M >>> 13, M &= 8191, M += g * (5 * p) + w * (5 * E) + b * (5 * y) + I * (5 * h) + R * (5 * f), x += M >>> 13, M &= 8191;
        let D = x + S * f + L * l + U * u + _ * a + j * c;
        x = D >>> 13, D &= 8191, D += g * (5 * d) + w * (5 * p) + b * (5 * E) + I * (5 * y) + R * (5 * h), x += D >>> 13, D &= 8191;
        let z = x + S * h + L * f + U * l + _ * u + j * a;
        x = z >>> 13, z &= 8191, z += g * c + w * (5 * d) + b * (5 * p) + I * (5 * E) + R * (5 * y), x += z >>> 13, z &= 8191;
        let Z = x + S * y + L * h + U * f + _ * l + j * u;
        x = Z >>> 13, Z &= 8191, Z += g * a + w * c + b * (5 * d) + I * (5 * p) + R * (5 * E), x += Z >>> 13, Z &= 8191;
        let it = x + S * E + L * y + U * h + _ * f + j * l;
        x = it >>> 13, it &= 8191, it += g * u + w * a + b * c + I * (5 * d) + R * (5 * p), x += it >>> 13, it &= 8191;
        let W = x + S * p + L * E + U * y + _ * h + j * f;
        x = W >>> 13, W &= 8191, W += g * l + w * u + b * a + I * c + R * (5 * d), x += W >>> 13, W &= 8191;
        let J = x + S * d + L * p + U * E + _ * y + j * h;
        x = J >>> 13, J &= 8191, J += g * f + w * l + b * u + I * a + R * c, x += J >>> 13, J &= 8191, x = (x << 2) + x | 0, x = x + C | 0, C = x & 8191, x = x >>> 13, P += x, i[0] = C, i[1] = P, i[2] = k, i[3] = M, i[4] = D, i[5] = z, i[6] = Z, i[7] = it, i[8] = W, i[9] = J;
    }
    finalize() {
        const { h: e, pad: n } = this, r = new Uint16Array(10);
        let o = e[1] >>> 13;
        e[1] &= 8191;
        for(let c = 2; c < 10; c++)e[c] += o, o = e[c] >>> 13, e[c] &= 8191;
        e[0] += o * 5, o = e[0] >>> 13, e[0] &= 8191, e[1] += o, o = e[1] >>> 13, e[1] &= 8191, e[2] += o, r[0] = e[0] + 5, o = r[0] >>> 13, r[0] &= 8191;
        for(let c = 1; c < 10; c++)r[c] = e[c] + o, o = r[c] >>> 13, r[c] &= 8191;
        r[9] -= 8192;
        let i = (o ^ 1) - 1;
        for(let c = 0; c < 10; c++)r[c] &= i;
        i = ~i;
        for(let c = 0; c < 10; c++)e[c] = e[c] & i | r[c];
        e[0] = (e[0] | e[1] << 13) & 65535, e[1] = (e[1] >>> 3 | e[2] << 10) & 65535, e[2] = (e[2] >>> 6 | e[3] << 7) & 65535, e[3] = (e[3] >>> 9 | e[4] << 4) & 65535, e[4] = (e[4] >>> 12 | e[5] << 1 | e[6] << 14) & 65535, e[5] = (e[6] >>> 2 | e[7] << 11) & 65535, e[6] = (e[7] >>> 5 | e[8] << 8) & 65535, e[7] = (e[8] >>> 8 | e[9] << 5) & 65535;
        let s = e[0] + n[0];
        e[0] = s & 65535;
        for(let c = 1; c < 8; c++)s = (e[c] + n[c] | 0) + (s >>> 16) | 0, e[c] = s & 65535;
        $6c85c32373d4b5cd$var$Lt(r);
    }
    update(e) {
        $6c85c32373d4b5cd$var$Or(this);
        const { buffer: n, blockLen: r } = this;
        e = $6c85c32373d4b5cd$var$Fe(e);
        const o = e.length;
        for(let i = 0; i < o;){
            const s = Math.min(r - this.pos, o - i);
            if (s === r) {
                for(; r <= o - i; i += r)this.process(e, i);
                continue;
            }
            n.set(e.subarray(i, i + s), this.pos), this.pos += s, i += s, this.pos === r && (this.process(n, 0, !1), this.pos = 0);
        }
        return this;
    }
    destroy() {
        $6c85c32373d4b5cd$var$Lt(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(e) {
        $6c85c32373d4b5cd$var$Or(this), $6c85c32373d4b5cd$var$ps(e, this), this.finished = !0;
        const { buffer: n, h: r } = this;
        let { pos: o } = this;
        if (o) {
            for(n[o++] = 1; o < 16; o++)n[o] = 0;
            this.process(n, 0, !0);
        }
        this.finalize();
        let i = 0;
        for(let s = 0; s < 8; s++)e[i++] = r[s] >>> 0, e[i++] = r[s] >>> 8;
        return e;
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
}
function $6c85c32373d4b5cd$var$Ts(t) {
    const e = (r, o)=>t(o).update($6c85c32373d4b5cd$var$Fe(r)).digest(), n = t(new Uint8Array(32));
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = (r)=>t(r), e;
}
const $6c85c32373d4b5cd$var$Rs = $6c85c32373d4b5cd$var$Ts((t)=>new $6c85c32373d4b5cd$var$Us(t));
function $6c85c32373d4b5cd$var$_s(t, e, n, r, o, i = 20) {
    let s = t[0], c = t[1], a = t[2], u = t[3], l = e[0], f = e[1], h = e[2], y = e[3], E = e[4], p = e[5], d = e[6], v = e[7], m = o, O = n[0], N = n[1], $ = n[2], B = s, A = c, T = a, S = u, L = l, U = f, _ = h, j = y, g = E, w = p, b = d, I = v, R = m, x = O, C = N, P = $;
    for(let M = 0; M < i; M += 2)B = B + L | 0, R = $6c85c32373d4b5cd$var$V(R ^ B, 16), g = g + R | 0, L = $6c85c32373d4b5cd$var$V(L ^ g, 12), B = B + L | 0, R = $6c85c32373d4b5cd$var$V(R ^ B, 8), g = g + R | 0, L = $6c85c32373d4b5cd$var$V(L ^ g, 7), A = A + U | 0, x = $6c85c32373d4b5cd$var$V(x ^ A, 16), w = w + x | 0, U = $6c85c32373d4b5cd$var$V(U ^ w, 12), A = A + U | 0, x = $6c85c32373d4b5cd$var$V(x ^ A, 8), w = w + x | 0, U = $6c85c32373d4b5cd$var$V(U ^ w, 7), T = T + _ | 0, C = $6c85c32373d4b5cd$var$V(C ^ T, 16), b = b + C | 0, _ = $6c85c32373d4b5cd$var$V(_ ^ b, 12), T = T + _ | 0, C = $6c85c32373d4b5cd$var$V(C ^ T, 8), b = b + C | 0, _ = $6c85c32373d4b5cd$var$V(_ ^ b, 7), S = S + j | 0, P = $6c85c32373d4b5cd$var$V(P ^ S, 16), I = I + P | 0, j = $6c85c32373d4b5cd$var$V(j ^ I, 12), S = S + j | 0, P = $6c85c32373d4b5cd$var$V(P ^ S, 8), I = I + P | 0, j = $6c85c32373d4b5cd$var$V(j ^ I, 7), B = B + U | 0, P = $6c85c32373d4b5cd$var$V(P ^ B, 16), b = b + P | 0, U = $6c85c32373d4b5cd$var$V(U ^ b, 12), B = B + U | 0, P = $6c85c32373d4b5cd$var$V(P ^ B, 8), b = b + P | 0, U = $6c85c32373d4b5cd$var$V(U ^ b, 7), A = A + _ | 0, R = $6c85c32373d4b5cd$var$V(R ^ A, 16), I = I + R | 0, _ = $6c85c32373d4b5cd$var$V(_ ^ I, 12), A = A + _ | 0, R = $6c85c32373d4b5cd$var$V(R ^ A, 8), I = I + R | 0, _ = $6c85c32373d4b5cd$var$V(_ ^ I, 7), T = T + j | 0, x = $6c85c32373d4b5cd$var$V(x ^ T, 16), g = g + x | 0, j = $6c85c32373d4b5cd$var$V(j ^ g, 12), T = T + j | 0, x = $6c85c32373d4b5cd$var$V(x ^ T, 8), g = g + x | 0, j = $6c85c32373d4b5cd$var$V(j ^ g, 7), S = S + L | 0, C = $6c85c32373d4b5cd$var$V(C ^ S, 16), w = w + C | 0, L = $6c85c32373d4b5cd$var$V(L ^ w, 12), S = S + L | 0, C = $6c85c32373d4b5cd$var$V(C ^ S, 8), w = w + C | 0, L = $6c85c32373d4b5cd$var$V(L ^ w, 7);
    let k = 0;
    r[k++] = s + B | 0, r[k++] = c + A | 0, r[k++] = a + T | 0, r[k++] = u + S | 0, r[k++] = l + L | 0, r[k++] = f + U | 0, r[k++] = h + _ | 0, r[k++] = y + j | 0, r[k++] = E + g | 0, r[k++] = p + w | 0, r[k++] = d + b | 0, r[k++] = v + I | 0, r[k++] = m + R | 0, r[k++] = O + x | 0, r[k++] = N + C | 0, r[k++] = $ + P | 0;
}
const $6c85c32373d4b5cd$var$$s = $6c85c32373d4b5cd$var$Ns($6c85c32373d4b5cd$var$_s, {
    counterRight: !1,
    counterLength: 4,
    allowShortKeys: !1
}), $6c85c32373d4b5cd$var$Ls = new Uint8Array(16), $6c85c32373d4b5cd$var$Rr = (t, e)=>{
    t.update(e);
    const n = e.length % 16;
    n && t.update($6c85c32373d4b5cd$var$Ls.subarray(n));
}, $6c85c32373d4b5cd$var$js = new Uint8Array(32);
function $6c85c32373d4b5cd$var$_r(t, e, n, r, o) {
    const i = t(e, n, $6c85c32373d4b5cd$var$js), s = $6c85c32373d4b5cd$var$Rs.create(i);
    o && $6c85c32373d4b5cd$var$Rr(s, o), $6c85c32373d4b5cd$var$Rr(s, r);
    const c = new Uint8Array(16), a = $6c85c32373d4b5cd$var$gs(c);
    $6c85c32373d4b5cd$var$Ir(a, 0, BigInt(o ? o.length : 0), !0), $6c85c32373d4b5cd$var$Ir(a, 8, BigInt(r.length), !0), s.update(c);
    const u = s.digest();
    return $6c85c32373d4b5cd$var$Lt(i, c), u;
}
const $6c85c32373d4b5cd$var$Cs = (t)=>(e, n, r)=>({
            encrypt (i, s) {
                const c = i.length;
                s = $6c85c32373d4b5cd$var$Br(c + 16, s, !1), s.set(i);
                const a = s.subarray(0, -16);
                t(e, n, a, a, 1);
                const u = $6c85c32373d4b5cd$var$_r(t, e, n, a, r);
                return s.set(u, c), $6c85c32373d4b5cd$var$Lt(u), s;
            },
            decrypt (i, s) {
                s = $6c85c32373d4b5cd$var$Br(i.length - 16, s, !1);
                const c = i.subarray(0, -16), a = i.subarray(-16), u = $6c85c32373d4b5cd$var$_r(t, e, n, c, r);
                if (!$6c85c32373d4b5cd$var$bs(a, u)) throw new Error("invalid tag");
                return s.set(i.subarray(0, -16)), t(e, n, s, s, 1), $6c85c32373d4b5cd$var$Lt(u), s;
            }
        }), $6c85c32373d4b5cd$var$$r = $6c85c32373d4b5cd$var$Es({
    blockSize: 64,
    nonceLength: 12,
    tagLength: 16
}, $6c85c32373d4b5cd$var$Cs($6c85c32373d4b5cd$var$$s));
class $6c85c32373d4b5cd$var$Lr extends $6c85c32373d4b5cd$var$Pe {
    constructor(e, n){
        super(), this.finished = !1, this.destroyed = !1, $6c85c32373d4b5cd$var$je(e);
        const r = $6c85c32373d4b5cd$var$_t(n);
        if (this.iHash = e.create(), typeof this.iHash.update != "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const o = this.blockLen, i = new Uint8Array(o);
        i.set(r.length > o ? e.create().update(r).digest() : r);
        for(let s = 0; s < i.length; s++)i[s] ^= 54;
        this.iHash.update(i), this.oHash = e.create();
        for(let s = 0; s < i.length; s++)i[s] ^= 106;
        this.oHash.update(i), i.fill(0);
    }
    update(e) {
        return $6c85c32373d4b5cd$var$Tt(this), this.iHash.update(e), this;
    }
    digestInto(e) {
        $6c85c32373d4b5cd$var$Tt(this), $6c85c32373d4b5cd$var$Wt(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
    }
    digest() {
        const e = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(e), e;
    }
    _cloneInto(e) {
        e || (e = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: n, iHash: r, finished: o, destroyed: i, blockLen: s, outputLen: c } = this;
        return e, e.finished = o, e.destroyed = i, e.blockLen = s, e.outputLen = c, e.oHash = n._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
    }
    destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
}
const $6c85c32373d4b5cd$var$pe = (t, e, n)=>new $6c85c32373d4b5cd$var$Lr(t, e).update(n).digest();
$6c85c32373d4b5cd$var$pe.create = (t, e)=>new $6c85c32373d4b5cd$var$Lr(t, e);
function $6c85c32373d4b5cd$var$Ps(t, e, n) {
    return $6c85c32373d4b5cd$var$je(t), n === void 0 && (n = new Uint8Array(t.outputLen)), $6c85c32373d4b5cd$var$pe(t, $6c85c32373d4b5cd$var$_t(n), $6c85c32373d4b5cd$var$_t(e));
}
const $6c85c32373d4b5cd$var$Ye = new Uint8Array([
    0
]), $6c85c32373d4b5cd$var$jr = new Uint8Array;
function $6c85c32373d4b5cd$var$ks(t, e, n, r = 32) {
    if ($6c85c32373d4b5cd$var$je(t), $6c85c32373d4b5cd$var$Gt(r), r > 255 * t.outputLen) throw new Error("Length should be <= 255*HashLen");
    const o = Math.ceil(r / t.outputLen);
    n === void 0 && (n = $6c85c32373d4b5cd$var$jr);
    const i = new Uint8Array(o * t.outputLen), s = $6c85c32373d4b5cd$var$pe.create(t, e), c = s._cloneInto(), a = new Uint8Array(s.outputLen);
    for(let u = 0; u < o; u++)$6c85c32373d4b5cd$var$Ye[0] = u + 1, c.update(u === 0 ? $6c85c32373d4b5cd$var$jr : a).update(n).update($6c85c32373d4b5cd$var$Ye).digestInto(a), i.set(a, t.outputLen * u), s._cloneInto(c);
    return s.destroy(), c.destroy(), a.fill(0), $6c85c32373d4b5cd$var$Ye.fill(0), i.slice(0, r);
}
const $6c85c32373d4b5cd$var$Vs = (t, e, n, r, o)=>$6c85c32373d4b5cd$var$ks(t, $6c85c32373d4b5cd$var$Ps(t, e, n), r, o);
function $6c85c32373d4b5cd$var$Ms(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), i = BigInt(4294967295), s = Number(n >> o & i), c = Number(n & i), a = r ? 4 : 0, u = r ? 0 : 4;
    t.setUint32(e + a, s, r), t.setUint32(e + u, c, r);
}
function $6c85c32373d4b5cd$var$Ds(t, e, n) {
    return t & e ^ ~t & n;
}
function $6c85c32373d4b5cd$var$Hs(t, e, n) {
    return t & e ^ t & n ^ e & n;
}
class $6c85c32373d4b5cd$var$qs extends $6c85c32373d4b5cd$var$Pe {
    constructor(e, n, r, o){
        super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $6c85c32373d4b5cd$var$Ce(this.buffer);
    }
    update(e) {
        $6c85c32373d4b5cd$var$Tt(this);
        const { view: n, buffer: r, blockLen: o } = this;
        e = $6c85c32373d4b5cd$var$_t(e);
        const i = e.length;
        for(let s = 0; s < i;){
            const c = Math.min(o - this.pos, i - s);
            if (c === o) {
                const a = $6c85c32373d4b5cd$var$Ce(e);
                for(; o <= i - s; s += o)this.process(a, s);
                continue;
            }
            r.set(e.subarray(s, s + c), this.pos), this.pos += c, s += c, this.pos === o && (this.process(n, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $6c85c32373d4b5cd$var$Tt(this), $6c85c32373d4b5cd$var$Gn(e, this), this.finished = !0;
        const { buffer: n, view: r, blockLen: o, isLE: i } = this;
        let { pos: s } = this;
        n[s++] = 128, this.buffer.subarray(s).fill(0), this.padOffset > o - s && (this.process(r, 0), s = 0);
        for(let f = s; f < o; f++)n[f] = 0;
        $6c85c32373d4b5cd$var$Ms(r, o - 8, BigInt(this.length * 8), i), this.process(r, 0);
        const c = $6c85c32373d4b5cd$var$Ce(e), a = this.outputLen;
        if (a % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const u = a / 4, l = this.get();
        if (u > l.length) throw new Error("_sha2: outputLen bigger than state");
        for(let f = 0; f < u; f++)c.setUint32(4 * f, l[f], i);
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: n, buffer: r, length: o, finished: i, destroyed: s, pos: c } = this;
        return e.length = o, e.pos = c, e.finished = i, e.destroyed = s, o % n && e.buffer.set(r), e;
    }
}
const $6c85c32373d4b5cd$var$Ks = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]), $6c85c32373d4b5cd$var$wt = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]), $6c85c32373d4b5cd$var$bt = new Uint32Array(64);
class $6c85c32373d4b5cd$var$Fs extends $6c85c32373d4b5cd$var$qs {
    constructor(){
        super(64, 32, 8, !1), this.A = $6c85c32373d4b5cd$var$wt[0] | 0, this.B = $6c85c32373d4b5cd$var$wt[1] | 0, this.C = $6c85c32373d4b5cd$var$wt[2] | 0, this.D = $6c85c32373d4b5cd$var$wt[3] | 0, this.E = $6c85c32373d4b5cd$var$wt[4] | 0, this.F = $6c85c32373d4b5cd$var$wt[5] | 0, this.G = $6c85c32373d4b5cd$var$wt[6] | 0, this.H = $6c85c32373d4b5cd$var$wt[7] | 0;
    }
    get() {
        const { A: e, B: n, C: r, D: o, E: i, F: s, G: c, H: a } = this;
        return [
            e,
            n,
            r,
            o,
            i,
            s,
            c,
            a
        ];
    }
    set(e, n, r, o, i, s, c, a) {
        this.A = e | 0, this.B = n | 0, this.C = r | 0, this.D = o | 0, this.E = i | 0, this.F = s | 0, this.G = c | 0, this.H = a | 0;
    }
    process(e, n) {
        for(let f = 0; f < 16; f++, n += 4)$6c85c32373d4b5cd$var$bt[f] = e.getUint32(n, !1);
        for(let f = 16; f < 64; f++){
            const h = $6c85c32373d4b5cd$var$bt[f - 15], y = $6c85c32373d4b5cd$var$bt[f - 2], E = $6c85c32373d4b5cd$var$st(h, 7) ^ $6c85c32373d4b5cd$var$st(h, 18) ^ h >>> 3, p = $6c85c32373d4b5cd$var$st(y, 17) ^ $6c85c32373d4b5cd$var$st(y, 19) ^ y >>> 10;
            $6c85c32373d4b5cd$var$bt[f] = p + $6c85c32373d4b5cd$var$bt[f - 7] + E + $6c85c32373d4b5cd$var$bt[f - 16] | 0;
        }
        let { A: r, B: o, C: i, D: s, E: c, F: a, G: u, H: l } = this;
        for(let f = 0; f < 64; f++){
            const h = $6c85c32373d4b5cd$var$st(c, 6) ^ $6c85c32373d4b5cd$var$st(c, 11) ^ $6c85c32373d4b5cd$var$st(c, 25), y = l + h + $6c85c32373d4b5cd$var$Ds(c, a, u) + $6c85c32373d4b5cd$var$Ks[f] + $6c85c32373d4b5cd$var$bt[f] | 0, p = ($6c85c32373d4b5cd$var$st(r, 2) ^ $6c85c32373d4b5cd$var$st(r, 13) ^ $6c85c32373d4b5cd$var$st(r, 22)) + $6c85c32373d4b5cd$var$Hs(r, o, i) | 0;
            l = u, u = a, a = c, c = s + y | 0, s = i, i = o, o = r, r = y + p | 0;
        }
        r = r + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, s = s + this.D | 0, c = c + this.E | 0, a = a + this.F | 0, u = u + this.G | 0, l = l + this.H | 0, this.set(r, o, i, s, c, a, u, l);
    }
    roundClean() {
        $6c85c32373d4b5cd$var$bt.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
const $6c85c32373d4b5cd$var$Jt = $6c85c32373d4b5cd$var$Qn(()=>new $6c85c32373d4b5cd$var$Fs); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $6c85c32373d4b5cd$var$ge = BigInt(0), $6c85c32373d4b5cd$var$ye = BigInt(1), $6c85c32373d4b5cd$var$zs = BigInt(2);
function $6c85c32373d4b5cd$var$St(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $6c85c32373d4b5cd$var$Qt(t) {
    if (!$6c85c32373d4b5cd$var$St(t)) throw new Error("Uint8Array expected");
}
function $6c85c32373d4b5cd$var$jt(t, e) {
    if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
const $6c85c32373d4b5cd$var$Zs = Array.from({
    length: 256
}, (t, e)=>e.toString(16).padStart(2, "0"));
function $6c85c32373d4b5cd$var$Ct(t) {
    $6c85c32373d4b5cd$var$Qt(t);
    let e = "";
    for(let n = 0; n < t.length; n++)e += $6c85c32373d4b5cd$var$Zs[t[n]];
    return e;
}
function $6c85c32373d4b5cd$var$Pt(t) {
    const e = t.toString(16);
    return e.length & 1 ? "0" + e : e;
}
function $6c85c32373d4b5cd$var$Ge(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    return t === "" ? $6c85c32373d4b5cd$var$ge : BigInt("0x" + t);
}
const $6c85c32373d4b5cd$var$ut = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $6c85c32373d4b5cd$var$Cr(t) {
    if (t >= $6c85c32373d4b5cd$var$ut._0 && t <= $6c85c32373d4b5cd$var$ut._9) return t - $6c85c32373d4b5cd$var$ut._0;
    if (t >= $6c85c32373d4b5cd$var$ut.A && t <= $6c85c32373d4b5cd$var$ut.F) return t - ($6c85c32373d4b5cd$var$ut.A - 10);
    if (t >= $6c85c32373d4b5cd$var$ut.a && t <= $6c85c32373d4b5cd$var$ut.f) return t - ($6c85c32373d4b5cd$var$ut.a - 10);
}
function $6c85c32373d4b5cd$var$kt(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    const e = t.length, n = e / 2;
    if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
    const r = new Uint8Array(n);
    for(let o = 0, i = 0; o < n; o++, i += 2){
        const s = $6c85c32373d4b5cd$var$Cr(t.charCodeAt(i)), c = $6c85c32373d4b5cd$var$Cr(t.charCodeAt(i + 1));
        if (s === void 0 || c === void 0) {
            const a = t[i] + t[i + 1];
            throw new Error('hex string expected, got non-hex character "' + a + '" at index ' + i);
        }
        r[o] = s * 16 + c;
    }
    return r;
}
function $6c85c32373d4b5cd$var$Ot(t) {
    return $6c85c32373d4b5cd$var$Ge($6c85c32373d4b5cd$var$Ct(t));
}
function $6c85c32373d4b5cd$var$te(t) {
    return $6c85c32373d4b5cd$var$Qt(t), $6c85c32373d4b5cd$var$Ge($6c85c32373d4b5cd$var$Ct(Uint8Array.from(t).reverse()));
}
function $6c85c32373d4b5cd$var$Vt(t, e) {
    return $6c85c32373d4b5cd$var$kt(t.toString(16).padStart(e * 2, "0"));
}
function $6c85c32373d4b5cd$var$me(t, e) {
    return $6c85c32373d4b5cd$var$Vt(t, e).reverse();
}
function $6c85c32373d4b5cd$var$Ys(t) {
    return $6c85c32373d4b5cd$var$kt($6c85c32373d4b5cd$var$Pt(t));
}
function $6c85c32373d4b5cd$var$et(t, e, n) {
    let r;
    if (typeof e == "string") try {
        r = $6c85c32373d4b5cd$var$kt(e);
    } catch (i) {
        throw new Error(t + " must be hex string or Uint8Array, cause: " + i);
    }
    else if ($6c85c32373d4b5cd$var$St(e)) r = Uint8Array.from(e);
    else throw new Error(t + " must be hex string or Uint8Array");
    const o = r.length;
    if (typeof n == "number" && o !== n) throw new Error(t + " of length " + n + " expected, got " + o);
    return r;
}
function $6c85c32373d4b5cd$var$ee(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $6c85c32373d4b5cd$var$Qt(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const i = t[r];
        n.set(i, o), o += i.length;
    }
    return n;
}
function $6c85c32373d4b5cd$var$Gs(t, e) {
    if (t.length !== e.length) return !1;
    let n = 0;
    for(let r = 0; r < t.length; r++)n |= t[r] ^ e[r];
    return n === 0;
}
function $6c85c32373d4b5cd$var$Ws(t) {
    if (typeof t != "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(t));
}
const $6c85c32373d4b5cd$var$We = (t)=>typeof t == "bigint" && $6c85c32373d4b5cd$var$ge <= t;
function $6c85c32373d4b5cd$var$we(t, e, n) {
    return $6c85c32373d4b5cd$var$We(t) && $6c85c32373d4b5cd$var$We(e) && $6c85c32373d4b5cd$var$We(n) && e <= t && t < n;
}
function $6c85c32373d4b5cd$var$ft(t, e, n, r) {
    if (!$6c85c32373d4b5cd$var$we(e, n, r)) throw new Error("expected valid " + t + ": " + n + " <= n < " + r + ", got " + e);
}
function $6c85c32373d4b5cd$var$Pr(t) {
    let e;
    for(e = 0; t > $6c85c32373d4b5cd$var$ge; t >>= $6c85c32373d4b5cd$var$ye, e += 1);
    return e;
}
function $6c85c32373d4b5cd$var$Xs(t, e) {
    return t >> BigInt(e) & $6c85c32373d4b5cd$var$ye;
}
function $6c85c32373d4b5cd$var$Js(t, e, n) {
    return t | (n ? $6c85c32373d4b5cd$var$ye : $6c85c32373d4b5cd$var$ge) << BigInt(e);
}
const $6c85c32373d4b5cd$var$Xe = (t)=>($6c85c32373d4b5cd$var$zs << BigInt(t - 1)) - $6c85c32373d4b5cd$var$ye, $6c85c32373d4b5cd$var$Je = (t)=>new Uint8Array(t), $6c85c32373d4b5cd$var$kr = (t)=>Uint8Array.from(t);
function $6c85c32373d4b5cd$var$Vr(t, e, n) {
    if (typeof t != "number" || t < 2) throw new Error("hashLen must be a number");
    if (typeof e != "number" || e < 2) throw new Error("qByteLen must be a number");
    if (typeof n != "function") throw new Error("hmacFn must be a function");
    let r = $6c85c32373d4b5cd$var$Je(t), o = $6c85c32373d4b5cd$var$Je(t), i = 0;
    const s = ()=>{
        r.fill(1), o.fill(0), i = 0;
    }, c = (...f)=>n(o, r, ...f), a = (f = $6c85c32373d4b5cd$var$Je())=>{
        o = c($6c85c32373d4b5cd$var$kr([
            0
        ]), f), r = c(), f.length !== 0 && (o = c($6c85c32373d4b5cd$var$kr([
            1
        ]), f), r = c());
    }, u = ()=>{
        if (i++ >= 1e3) throw new Error("drbg: tried 1000 values");
        let f = 0;
        const h = [];
        for(; f < e;){
            r = c();
            const y = r.slice();
            h.push(y), f += r.length;
        }
        return $6c85c32373d4b5cd$var$ee(...h);
    };
    return (f, h)=>{
        s(), a(f);
        let y;
        for(; !(y = h(u()));)a();
        return s(), y;
    };
}
const $6c85c32373d4b5cd$var$Qs = {
    bigint: (t)=>typeof t == "bigint",
    function: (t)=>typeof t == "function",
    boolean: (t)=>typeof t == "boolean",
    string: (t)=>typeof t == "string",
    stringOrUint8Array: (t)=>typeof t == "string" || $6c85c32373d4b5cd$var$St(t),
    isSafeInteger: (t)=>Number.isSafeInteger(t),
    array: (t)=>Array.isArray(t),
    field: (t, e)=>e.Fp.isValid(t),
    hash: (t)=>typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function $6c85c32373d4b5cd$var$Mt(t, e, n = {}) {
    const r = (o, i, s)=>{
        const c = $6c85c32373d4b5cd$var$Qs[i];
        if (typeof c != "function") throw new Error("invalid validator function");
        const a = t[o];
        if (!(s && a === void 0) && !c(a, t)) throw new Error("param " + String(o) + " is invalid. Expected " + i + ", got " + a);
    };
    for (const [o, i] of Object.entries(e))r(o, i, !1);
    for (const [o, i] of Object.entries(n))r(o, i, !0);
    return t;
}
const $6c85c32373d4b5cd$var$tc = ()=>{
    throw new Error("not implemented");
};
function $6c85c32373d4b5cd$var$Qe(t) {
    const e = new WeakMap;
    return (n, ...r)=>{
        const o = e.get(n);
        if (o !== void 0) return o;
        const i = t(n, ...r);
        return e.set(n, i), i;
    };
}
var $6c85c32373d4b5cd$var$ec = Object.freeze({
    __proto__: null,
    isBytes: $6c85c32373d4b5cd$var$St,
    abytes: $6c85c32373d4b5cd$var$Qt,
    abool: $6c85c32373d4b5cd$var$jt,
    bytesToHex: $6c85c32373d4b5cd$var$Ct,
    numberToHexUnpadded: $6c85c32373d4b5cd$var$Pt,
    hexToNumber: $6c85c32373d4b5cd$var$Ge,
    hexToBytes: $6c85c32373d4b5cd$var$kt,
    bytesToNumberBE: $6c85c32373d4b5cd$var$Ot,
    bytesToNumberLE: $6c85c32373d4b5cd$var$te,
    numberToBytesBE: $6c85c32373d4b5cd$var$Vt,
    numberToBytesLE: $6c85c32373d4b5cd$var$me,
    numberToVarBytesBE: $6c85c32373d4b5cd$var$Ys,
    ensureBytes: $6c85c32373d4b5cd$var$et,
    concatBytes: $6c85c32373d4b5cd$var$ee,
    equalBytes: $6c85c32373d4b5cd$var$Gs,
    utf8ToBytes: $6c85c32373d4b5cd$var$Ws,
    inRange: $6c85c32373d4b5cd$var$we,
    aInRange: $6c85c32373d4b5cd$var$ft,
    bitLen: $6c85c32373d4b5cd$var$Pr,
    bitGet: $6c85c32373d4b5cd$var$Xs,
    bitSet: $6c85c32373d4b5cd$var$Js,
    bitMask: $6c85c32373d4b5cd$var$Xe,
    createHmacDrbg: $6c85c32373d4b5cd$var$Vr,
    validateObject: $6c85c32373d4b5cd$var$Mt,
    notImplemented: $6c85c32373d4b5cd$var$tc,
    memoized: $6c85c32373d4b5cd$var$Qe
});
const $6c85c32373d4b5cd$var$q = BigInt(0), $6c85c32373d4b5cd$var$H = BigInt(1), $6c85c32373d4b5cd$var$At = BigInt(2), $6c85c32373d4b5cd$var$nc = BigInt(3), $6c85c32373d4b5cd$var$tn = BigInt(4), $6c85c32373d4b5cd$var$Mr = BigInt(5), $6c85c32373d4b5cd$var$Dr = BigInt(8);
function $6c85c32373d4b5cd$var$X(t, e) {
    const n = t % e;
    return n >= $6c85c32373d4b5cd$var$q ? n : e + n;
}
function $6c85c32373d4b5cd$var$Hr(t, e, n) {
    if (e < $6c85c32373d4b5cd$var$q) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $6c85c32373d4b5cd$var$q) throw new Error("invalid modulus");
    if (n === $6c85c32373d4b5cd$var$H) return $6c85c32373d4b5cd$var$q;
    let r = $6c85c32373d4b5cd$var$H;
    for(; e > $6c85c32373d4b5cd$var$q;)e & $6c85c32373d4b5cd$var$H && (r = r * t % n), t = t * t % n, e >>= $6c85c32373d4b5cd$var$H;
    return r;
}
function $6c85c32373d4b5cd$var$ot(t, e, n) {
    let r = t;
    for(; e-- > $6c85c32373d4b5cd$var$q;)r *= r, r %= n;
    return r;
}
function $6c85c32373d4b5cd$var$en(t, e) {
    if (t === $6c85c32373d4b5cd$var$q) throw new Error("invert: expected non-zero number");
    if (e <= $6c85c32373d4b5cd$var$q) throw new Error("invert: expected positive modulus, got " + e);
    let n = $6c85c32373d4b5cd$var$X(t, e), r = e, o = $6c85c32373d4b5cd$var$q, i = $6c85c32373d4b5cd$var$H;
    for(; n !== $6c85c32373d4b5cd$var$q;){
        const c = r / n, a = r % n, u = o - i * c;
        r = n, n = a, o = i, i = u;
    }
    if (r !== $6c85c32373d4b5cd$var$H) throw new Error("invert: does not exist");
    return $6c85c32373d4b5cd$var$X(o, e);
}
function $6c85c32373d4b5cd$var$rc(t) {
    const e = (t - $6c85c32373d4b5cd$var$H) / $6c85c32373d4b5cd$var$At;
    let n, r, o;
    for(n = t - $6c85c32373d4b5cd$var$H, r = 0; n % $6c85c32373d4b5cd$var$At === $6c85c32373d4b5cd$var$q; n /= $6c85c32373d4b5cd$var$At, r++);
    for(o = $6c85c32373d4b5cd$var$At; o < t && $6c85c32373d4b5cd$var$Hr(o, e, t) !== t - $6c85c32373d4b5cd$var$H; o++)if (o > 1e3) throw new Error("Cannot find square root: likely non-prime P");
    if (r === 1) {
        const s = (t + $6c85c32373d4b5cd$var$H) / $6c85c32373d4b5cd$var$tn;
        return function(a, u) {
            const l = a.pow(u, s);
            if (!a.eql(a.sqr(l), u)) throw new Error("Cannot find square root");
            return l;
        };
    }
    const i = (n + $6c85c32373d4b5cd$var$H) / $6c85c32373d4b5cd$var$At;
    return function(c, a) {
        if (c.pow(a, e) === c.neg(c.ONE)) throw new Error("Cannot find square root");
        let u = r, l = c.pow(c.mul(c.ONE, o), n), f = c.pow(a, i), h = c.pow(a, n);
        for(; !c.eql(h, c.ONE);){
            if (c.eql(h, c.ZERO)) return c.ZERO;
            let y = 1;
            for(let p = c.sqr(h); y < u && !c.eql(p, c.ONE); y++)p = c.sqr(p);
            const E = c.pow(l, $6c85c32373d4b5cd$var$H << BigInt(u - y - 1));
            l = c.sqr(E), f = c.mul(f, E), h = c.mul(h, l), u = y;
        }
        return f;
    };
}
function $6c85c32373d4b5cd$var$oc(t) {
    if (t % $6c85c32373d4b5cd$var$tn === $6c85c32373d4b5cd$var$nc) {
        const e = (t + $6c85c32373d4b5cd$var$H) / $6c85c32373d4b5cd$var$tn;
        return function(r, o) {
            const i = r.pow(o, e);
            if (!r.eql(r.sqr(i), o)) throw new Error("Cannot find square root");
            return i;
        };
    }
    if (t % $6c85c32373d4b5cd$var$Dr === $6c85c32373d4b5cd$var$Mr) {
        const e = (t - $6c85c32373d4b5cd$var$Mr) / $6c85c32373d4b5cd$var$Dr;
        return function(r, o) {
            const i = r.mul(o, $6c85c32373d4b5cd$var$At), s = r.pow(i, e), c = r.mul(o, s), a = r.mul(r.mul(c, $6c85c32373d4b5cd$var$At), s), u = r.mul(c, r.sub(a, r.ONE));
            if (!r.eql(r.sqr(u), o)) throw new Error("Cannot find square root");
            return u;
        };
    }
    return $6c85c32373d4b5cd$var$rc(t);
}
const $6c85c32373d4b5cd$var$ic = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $6c85c32373d4b5cd$var$sc(t) {
    const e = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    }, n = $6c85c32373d4b5cd$var$ic.reduce((r, o)=>(r[o] = "function", r), e);
    return $6c85c32373d4b5cd$var$Mt(t, n);
}
function $6c85c32373d4b5cd$var$cc(t, e, n) {
    if (n < $6c85c32373d4b5cd$var$q) throw new Error("invalid exponent, negatives unsupported");
    if (n === $6c85c32373d4b5cd$var$q) return t.ONE;
    if (n === $6c85c32373d4b5cd$var$H) return e;
    let r = t.ONE, o = e;
    for(; n > $6c85c32373d4b5cd$var$q;)n & $6c85c32373d4b5cd$var$H && (r = t.mul(r, o)), o = t.sqr(o), n >>= $6c85c32373d4b5cd$var$H;
    return r;
}
function $6c85c32373d4b5cd$var$ac(t, e) {
    const n = new Array(e.length), r = e.reduce((i, s, c)=>t.is0(s) ? i : (n[c] = i, t.mul(i, s)), t.ONE), o = t.inv(r);
    return e.reduceRight((i, s, c)=>t.is0(s) ? i : (n[c] = t.mul(i, n[c]), t.mul(i, s)), o), n;
}
function $6c85c32373d4b5cd$var$qr(t, e) {
    const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
    return {
        nBitLength: n,
        nByteLength: r
    };
}
function $6c85c32373d4b5cd$var$Kr(t, e, n = !1, r = {}) {
    if (t <= $6c85c32373d4b5cd$var$q) throw new Error("invalid field: expected ORDER > 0, got " + t);
    const { nBitLength: o, nByteLength: i } = $6c85c32373d4b5cd$var$qr(t, e);
    if (i > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let s;
    const c = Object.freeze({
        ORDER: t,
        isLE: n,
        BITS: o,
        BYTES: i,
        MASK: $6c85c32373d4b5cd$var$Xe(o),
        ZERO: $6c85c32373d4b5cd$var$q,
        ONE: $6c85c32373d4b5cd$var$H,
        create: (a)=>$6c85c32373d4b5cd$var$X(a, t),
        isValid: (a)=>{
            if (typeof a != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof a);
            return $6c85c32373d4b5cd$var$q <= a && a < t;
        },
        is0: (a)=>a === $6c85c32373d4b5cd$var$q,
        isOdd: (a)=>(a & $6c85c32373d4b5cd$var$H) === $6c85c32373d4b5cd$var$H,
        neg: (a)=>$6c85c32373d4b5cd$var$X(-a, t),
        eql: (a, u)=>a === u,
        sqr: (a)=>$6c85c32373d4b5cd$var$X(a * a, t),
        add: (a, u)=>$6c85c32373d4b5cd$var$X(a + u, t),
        sub: (a, u)=>$6c85c32373d4b5cd$var$X(a - u, t),
        mul: (a, u)=>$6c85c32373d4b5cd$var$X(a * u, t),
        pow: (a, u)=>$6c85c32373d4b5cd$var$cc(c, a, u),
        div: (a, u)=>$6c85c32373d4b5cd$var$X(a * $6c85c32373d4b5cd$var$en(u, t), t),
        sqrN: (a)=>a * a,
        addN: (a, u)=>a + u,
        subN: (a, u)=>a - u,
        mulN: (a, u)=>a * u,
        inv: (a)=>$6c85c32373d4b5cd$var$en(a, t),
        sqrt: r.sqrt || ((a)=>(s || (s = $6c85c32373d4b5cd$var$oc(t)), s(c, a))),
        invertBatch: (a)=>$6c85c32373d4b5cd$var$ac(c, a),
        cmov: (a, u, l)=>l ? u : a,
        toBytes: (a)=>n ? $6c85c32373d4b5cd$var$me(a, i) : $6c85c32373d4b5cd$var$Vt(a, i),
        fromBytes: (a)=>{
            if (a.length !== i) throw new Error("Field.fromBytes: expected " + i + " bytes, got " + a.length);
            return n ? $6c85c32373d4b5cd$var$te(a) : $6c85c32373d4b5cd$var$Ot(a);
        }
    });
    return Object.freeze(c);
}
function $6c85c32373d4b5cd$var$Fr(t) {
    if (typeof t != "bigint") throw new Error("field order must be bigint");
    const e = t.toString(2).length;
    return Math.ceil(e / 8);
}
function $6c85c32373d4b5cd$var$zr(t) {
    const e = $6c85c32373d4b5cd$var$Fr(t);
    return e + Math.ceil(e / 2);
}
function $6c85c32373d4b5cd$var$uc(t, e, n = !1) {
    const r = t.length, o = $6c85c32373d4b5cd$var$Fr(e), i = $6c85c32373d4b5cd$var$zr(e);
    if (r < 16 || r < i || r > 1024) throw new Error("expected " + i + "-1024 bytes of input, got " + r);
    const s = n ? $6c85c32373d4b5cd$var$te(t) : $6c85c32373d4b5cd$var$Ot(t), c = $6c85c32373d4b5cd$var$X(s, e - $6c85c32373d4b5cd$var$H) + $6c85c32373d4b5cd$var$H;
    return n ? $6c85c32373d4b5cd$var$me(c, o) : $6c85c32373d4b5cd$var$Vt(c, o);
}
const $6c85c32373d4b5cd$var$Zr = BigInt(0), $6c85c32373d4b5cd$var$be = BigInt(1);
function $6c85c32373d4b5cd$var$nn(t, e) {
    const n = e.negate();
    return t ? n : e;
}
function $6c85c32373d4b5cd$var$Yr(t, e) {
    if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function $6c85c32373d4b5cd$var$rn(t, e) {
    $6c85c32373d4b5cd$var$Yr(t, e);
    const n = Math.ceil(e / t) + 1, r = 2 ** (t - 1);
    return {
        windows: n,
        windowSize: r
    };
}
function $6c85c32373d4b5cd$var$fc(t, e) {
    if (!Array.isArray(t)) throw new Error("array expected");
    t.forEach((n, r)=>{
        if (!(n instanceof e)) throw new Error("invalid point at index " + r);
    });
}
function $6c85c32373d4b5cd$var$lc(t, e) {
    if (!Array.isArray(t)) throw new Error("array of scalars expected");
    t.forEach((n, r)=>{
        if (!e.isValid(n)) throw new Error("invalid scalar at index " + r);
    });
}
const $6c85c32373d4b5cd$var$on = new WeakMap, $6c85c32373d4b5cd$var$Gr = new WeakMap;
function $6c85c32373d4b5cd$var$sn(t) {
    return $6c85c32373d4b5cd$var$Gr.get(t) || 1;
}
function $6c85c32373d4b5cd$var$dc(t, e) {
    return {
        constTimeNegate: $6c85c32373d4b5cd$var$nn,
        hasPrecomputes (n) {
            return $6c85c32373d4b5cd$var$sn(n) !== 1;
        },
        unsafeLadder (n, r, o = t.ZERO) {
            let i = n;
            for(; r > $6c85c32373d4b5cd$var$Zr;)r & $6c85c32373d4b5cd$var$be && (o = o.add(i)), i = i.double(), r >>= $6c85c32373d4b5cd$var$be;
            return o;
        },
        precomputeWindow (n, r) {
            const { windows: o, windowSize: i } = $6c85c32373d4b5cd$var$rn(r, e), s = [];
            let c = n, a = c;
            for(let u = 0; u < o; u++){
                a = c, s.push(a);
                for(let l = 1; l < i; l++)a = a.add(c), s.push(a);
                c = a.double();
            }
            return s;
        },
        wNAF (n, r, o) {
            const { windows: i, windowSize: s } = $6c85c32373d4b5cd$var$rn(n, e);
            let c = t.ZERO, a = t.BASE;
            const u = BigInt(2 ** n - 1), l = 2 ** n, f = BigInt(n);
            for(let h = 0; h < i; h++){
                const y = h * s;
                let E = Number(o & u);
                o >>= f, E > s && (E -= l, o += $6c85c32373d4b5cd$var$be);
                const p = y, d = y + Math.abs(E) - 1, v = h % 2 !== 0, m = E < 0;
                E === 0 ? a = a.add($6c85c32373d4b5cd$var$nn(v, r[p])) : c = c.add($6c85c32373d4b5cd$var$nn(m, r[d]));
            }
            return {
                p: c,
                f: a
            };
        },
        wNAFUnsafe (n, r, o, i = t.ZERO) {
            const { windows: s, windowSize: c } = $6c85c32373d4b5cd$var$rn(n, e), a = BigInt(2 ** n - 1), u = 2 ** n, l = BigInt(n);
            for(let f = 0; f < s; f++){
                const h = f * c;
                if (o === $6c85c32373d4b5cd$var$Zr) break;
                let y = Number(o & a);
                if (o >>= l, y > c && (y -= u, o += $6c85c32373d4b5cd$var$be), y === 0) continue;
                let E = r[h + Math.abs(y) - 1];
                y < 0 && (E = E.negate()), i = i.add(E);
            }
            return i;
        },
        getPrecomputes (n, r, o) {
            let i = $6c85c32373d4b5cd$var$on.get(r);
            return i || (i = this.precomputeWindow(r, n), n !== 1 && $6c85c32373d4b5cd$var$on.set(r, o(i))), i;
        },
        wNAFCached (n, r, o) {
            const i = $6c85c32373d4b5cd$var$sn(n);
            return this.wNAF(i, this.getPrecomputes(i, n, o), r);
        },
        wNAFCachedUnsafe (n, r, o, i) {
            const s = $6c85c32373d4b5cd$var$sn(n);
            return s === 1 ? this.unsafeLadder(n, r, i) : this.wNAFUnsafe(s, this.getPrecomputes(s, n, o), r, i);
        },
        setWindowSize (n, r) {
            $6c85c32373d4b5cd$var$Yr(r, e), $6c85c32373d4b5cd$var$Gr.set(n, r), $6c85c32373d4b5cd$var$on.delete(n);
        }
    };
}
function $6c85c32373d4b5cd$var$hc(t, e, n, r) {
    if ($6c85c32373d4b5cd$var$fc(n, t), $6c85c32373d4b5cd$var$lc(r, e), n.length !== r.length) throw new Error("arrays of points and scalars must have equal length");
    const o = t.ZERO, i = $6c85c32373d4b5cd$var$Pr(BigInt(n.length)), s = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, c = (1 << s) - 1, a = new Array(c + 1).fill(o), u = Math.floor((e.BITS - 1) / s) * s;
    let l = o;
    for(let f = u; f >= 0; f -= s){
        a.fill(o);
        for(let y = 0; y < r.length; y++){
            const E = r[y], p = Number(E >> BigInt(f) & BigInt(c));
            a[p] = a[p].add(n[y]);
        }
        let h = o;
        for(let y = a.length - 1, E = o; y > 0; y--)E = E.add(a[y]), h = h.add(E);
        if (l = l.add(h), f !== 0) for(let y = 0; y < s; y++)l = l.double();
    }
    return l;
}
function $6c85c32373d4b5cd$var$Wr(t) {
    return $6c85c32373d4b5cd$var$sc(t.Fp), $6c85c32373d4b5cd$var$Mt(t, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...$6c85c32373d4b5cd$var$qr(t.n, t.nBitLength),
        ...t,
        p: t.Fp.ORDER
    });
}
BigInt(0), BigInt(1), BigInt(2), BigInt(8);
const $6c85c32373d4b5cd$var$Dt = BigInt(0), $6c85c32373d4b5cd$var$cn = BigInt(1);
function $6c85c32373d4b5cd$var$pc(t) {
    return $6c85c32373d4b5cd$var$Mt(t, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    }), Object.freeze({
        ...t
    });
}
function $6c85c32373d4b5cd$var$gc(t) {
    const e = $6c85c32373d4b5cd$var$pc(t), { P: n } = e, r = (m)=>$6c85c32373d4b5cd$var$X(m, n), o = e.montgomeryBits, i = Math.ceil(o / 8), s = e.nByteLength, c = e.adjustScalarBytes || ((m)=>m), a = e.powPminus2 || ((m)=>$6c85c32373d4b5cd$var$Hr(m, n - BigInt(2), n));
    function u(m, O, N) {
        const $ = r(m * (O - N));
        return O = r(O - $), N = r(N + $), [
            O,
            N
        ];
    }
    const l = (e.a - BigInt(2)) / BigInt(4);
    function f(m, O) {
        $6c85c32373d4b5cd$var$ft("u", m, $6c85c32373d4b5cd$var$Dt, n), $6c85c32373d4b5cd$var$ft("scalar", O, $6c85c32373d4b5cd$var$Dt, n);
        const N = O, $ = m;
        let B = $6c85c32373d4b5cd$var$cn, A = $6c85c32373d4b5cd$var$Dt, T = m, S = $6c85c32373d4b5cd$var$cn, L = $6c85c32373d4b5cd$var$Dt, U;
        for(let j = BigInt(o - 1); j >= $6c85c32373d4b5cd$var$Dt; j--){
            const g = N >> j & $6c85c32373d4b5cd$var$cn;
            L ^= g, U = u(L, B, T), B = U[0], T = U[1], U = u(L, A, S), A = U[0], S = U[1], L = g;
            const w = B + A, b = r(w * w), I = B - A, R = r(I * I), x = b - R, C = T + S, P = T - S, k = r(P * w), M = r(C * I), D = k + M, z = k - M;
            T = r(D * D), S = r($ * r(z * z)), B = r(b * R), A = r(x * (b + r(l * x)));
        }
        U = u(L, B, T), B = U[0], T = U[1], U = u(L, A, S), A = U[0], S = U[1];
        const _ = a(A);
        return r(B * _);
    }
    function h(m) {
        return $6c85c32373d4b5cd$var$me(r(m), i);
    }
    function y(m) {
        const O = $6c85c32373d4b5cd$var$et("u coordinate", m, i);
        return s === 32 && (O[31] &= 127), $6c85c32373d4b5cd$var$te(O);
    }
    function E(m) {
        const O = $6c85c32373d4b5cd$var$et("scalar", m), N = O.length;
        if (N !== i && N !== s) {
            let $ = "" + i + " or " + s;
            throw new Error("invalid scalar, expected " + $ + " bytes, got " + N);
        }
        return $6c85c32373d4b5cd$var$te(c(O));
    }
    function p(m, O) {
        const N = y(O), $ = E(m), B = f(N, $);
        if (B === $6c85c32373d4b5cd$var$Dt) throw new Error("invalid private or public key received");
        return h(B);
    }
    const d = h(e.Gu);
    function v(m) {
        return p(m, d);
    }
    return {
        scalarMult: p,
        scalarMultBase: v,
        getSharedSecret: (m, O)=>p(m, O),
        getPublicKey: (m)=>v(m),
        utils: {
            randomPrivateKey: ()=>e.randomBytes(e.nByteLength)
        },
        GuBytes: d
    };
}
const $6c85c32373d4b5cd$var$an = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
BigInt(0);
const $6c85c32373d4b5cd$var$yc = BigInt(1), $6c85c32373d4b5cd$var$Xr = BigInt(2), $6c85c32373d4b5cd$var$mc = BigInt(3), $6c85c32373d4b5cd$var$wc = BigInt(5);
BigInt(8);
function $6c85c32373d4b5cd$var$bc(t) {
    const e = BigInt(10), n = BigInt(20), r = BigInt(40), o = BigInt(80), i = $6c85c32373d4b5cd$var$an, c = t * t % i * t % i, a = $6c85c32373d4b5cd$var$ot(c, $6c85c32373d4b5cd$var$Xr, i) * c % i, u = $6c85c32373d4b5cd$var$ot(a, $6c85c32373d4b5cd$var$yc, i) * t % i, l = $6c85c32373d4b5cd$var$ot(u, $6c85c32373d4b5cd$var$wc, i) * u % i, f = $6c85c32373d4b5cd$var$ot(l, e, i) * l % i, h = $6c85c32373d4b5cd$var$ot(f, n, i) * f % i, y = $6c85c32373d4b5cd$var$ot(h, r, i) * h % i, E = $6c85c32373d4b5cd$var$ot(y, o, i) * y % i, p = $6c85c32373d4b5cd$var$ot(E, o, i) * y % i, d = $6c85c32373d4b5cd$var$ot(p, e, i) * l % i;
    return {
        pow_p_5_8: $6c85c32373d4b5cd$var$ot(d, $6c85c32373d4b5cd$var$Xr, i) * t % i,
        b2: c
    };
}
function $6c85c32373d4b5cd$var$Ec(t) {
    return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
const $6c85c32373d4b5cd$var$un = $6c85c32373d4b5cd$var$gc({
    P: $6c85c32373d4b5cd$var$an,
    a: BigInt(486662),
    montgomeryBits: 255,
    nByteLength: 32,
    Gu: BigInt(9),
    powPminus2: (t)=>{
        const e = $6c85c32373d4b5cd$var$an, { pow_p_5_8: n, b2: r } = $6c85c32373d4b5cd$var$bc(t);
        return $6c85c32373d4b5cd$var$X($6c85c32373d4b5cd$var$ot(n, $6c85c32373d4b5cd$var$mc, e) * r, e);
    },
    adjustScalarBytes: $6c85c32373d4b5cd$var$Ec,
    randomBytes: $6c85c32373d4b5cd$var$$t
});
function $6c85c32373d4b5cd$var$Jr(t) {
    t.lowS !== void 0 && $6c85c32373d4b5cd$var$jt("lowS", t.lowS), t.prehash !== void 0 && $6c85c32373d4b5cd$var$jt("prehash", t.prehash);
}
function $6c85c32373d4b5cd$var$vc(t) {
    const e = $6c85c32373d4b5cd$var$Wr(t);
    $6c85c32373d4b5cd$var$Mt(e, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: n, Fp: r, a: o } = e;
    if (n) {
        if (!r.eql(o, r.ZERO)) throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
        if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function") throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...e
    });
}
const { bytesToNumberBE: $6c85c32373d4b5cd$var$xc, hexToBytes: $6c85c32373d4b5cd$var$Sc } = $6c85c32373d4b5cd$var$ec;
class $6c85c32373d4b5cd$var$Oc extends Error {
    constructor(e = ""){
        super(e);
    }
}
const $6c85c32373d4b5cd$var$lt = {
    Err: $6c85c32373d4b5cd$var$Oc,
    _tlv: {
        encode: (t, e)=>{
            const { Err: n } = $6c85c32373d4b5cd$var$lt;
            if (t < 0 || t > 256) throw new n("tlv.encode: wrong tag");
            if (e.length & 1) throw new n("tlv.encode: unpadded data");
            const r = e.length / 2, o = $6c85c32373d4b5cd$var$Pt(r);
            if (o.length / 2 & 128) throw new n("tlv.encode: long form length too big");
            const i = r > 127 ? $6c85c32373d4b5cd$var$Pt(o.length / 2 | 128) : "";
            return $6c85c32373d4b5cd$var$Pt(t) + i + o + e;
        },
        decode (t, e) {
            const { Err: n } = $6c85c32373d4b5cd$var$lt;
            let r = 0;
            if (t < 0 || t > 256) throw new n("tlv.encode: wrong tag");
            if (e.length < 2 || e[r++] !== t) throw new n("tlv.decode: wrong tlv");
            const o = e[r++], i = !!(o & 128);
            let s = 0;
            if (!i) s = o;
            else {
                const a = o & 127;
                if (!a) throw new n("tlv.decode(long): indefinite length not supported");
                if (a > 4) throw new n("tlv.decode(long): byte length is too big");
                const u = e.subarray(r, r + a);
                if (u.length !== a) throw new n("tlv.decode: length bytes not complete");
                if (u[0] === 0) throw new n("tlv.decode(long): zero leftmost byte");
                for (const l of u)s = s << 8 | l;
                if (r += a, s < 128) throw new n("tlv.decode(long): not minimal encoding");
            }
            const c = e.subarray(r, r + s);
            if (c.length !== s) throw new n("tlv.decode: wrong value length");
            return {
                v: c,
                l: e.subarray(r + s)
            };
        }
    },
    _int: {
        encode (t) {
            const { Err: e } = $6c85c32373d4b5cd$var$lt;
            if (t < $6c85c32373d4b5cd$var$dt) throw new e("integer: negative integers are not allowed");
            let n = $6c85c32373d4b5cd$var$Pt(t);
            if (Number.parseInt(n[0], 16) & 8 && (n = "00" + n), n.length & 1) throw new e("unexpected DER parsing assertion: unpadded hex");
            return n;
        },
        decode (t) {
            const { Err: e } = $6c85c32373d4b5cd$var$lt;
            if (t[0] & 128) throw new e("invalid signature integer: negative");
            if (t[0] === 0 && !(t[1] & 128)) throw new e("invalid signature integer: unnecessary leading zero");
            return $6c85c32373d4b5cd$var$xc(t);
        }
    },
    toSig (t) {
        const { Err: e, _int: n, _tlv: r } = $6c85c32373d4b5cd$var$lt, o = typeof t == "string" ? $6c85c32373d4b5cd$var$Sc(t) : t;
        $6c85c32373d4b5cd$var$Qt(o);
        const { v: i, l: s } = r.decode(48, o);
        if (s.length) throw new e("invalid signature: left bytes after parsing");
        const { v: c, l: a } = r.decode(2, i), { v: u, l: l } = r.decode(2, a);
        if (l.length) throw new e("invalid signature: left bytes after parsing");
        return {
            r: n.decode(c),
            s: n.decode(u)
        };
    },
    hexFromSig (t) {
        const { _tlv: e, _int: n } = $6c85c32373d4b5cd$var$lt, r = e.encode(2, n.encode(t.r)), o = e.encode(2, n.encode(t.s)), i = r + o;
        return e.encode(48, i);
    }
}, $6c85c32373d4b5cd$var$dt = BigInt(0), $6c85c32373d4b5cd$var$K = BigInt(1);
BigInt(2);
const $6c85c32373d4b5cd$var$Qr = BigInt(3);
BigInt(4);
function $6c85c32373d4b5cd$var$Ac(t) {
    const e = $6c85c32373d4b5cd$var$vc(t), { Fp: n } = e, r = $6c85c32373d4b5cd$var$Kr(e.n, e.nBitLength), o = e.toBytes || ((p, d, v)=>{
        const m = d.toAffine();
        return $6c85c32373d4b5cd$var$ee(Uint8Array.from([
            4
        ]), n.toBytes(m.x), n.toBytes(m.y));
    }), i = e.fromBytes || ((p)=>{
        const d = p.subarray(1), v = n.fromBytes(d.subarray(0, n.BYTES)), m = n.fromBytes(d.subarray(n.BYTES, 2 * n.BYTES));
        return {
            x: v,
            y: m
        };
    });
    function s(p) {
        const { a: d, b: v } = e, m = n.sqr(p), O = n.mul(m, p);
        return n.add(n.add(O, n.mul(p, d)), v);
    }
    if (!n.eql(n.sqr(e.Gy), s(e.Gx))) throw new Error("bad generator point: equation left != right");
    function c(p) {
        return $6c85c32373d4b5cd$var$we(p, $6c85c32373d4b5cd$var$K, e.n);
    }
    function a(p) {
        const { allowedPrivateKeyLengths: d, nByteLength: v, wrapPrivateKey: m, n: O } = e;
        if (d && typeof p != "bigint") {
            if ($6c85c32373d4b5cd$var$St(p) && (p = $6c85c32373d4b5cd$var$Ct(p)), typeof p != "string" || !d.includes(p.length)) throw new Error("invalid private key");
            p = p.padStart(v * 2, "0");
        }
        let N;
        try {
            N = typeof p == "bigint" ? p : $6c85c32373d4b5cd$var$Ot($6c85c32373d4b5cd$var$et("private key", p, v));
        } catch  {
            throw new Error("invalid private key, expected hex or " + v + " bytes, got " + typeof p);
        }
        return m && (N = $6c85c32373d4b5cd$var$X(N, O)), $6c85c32373d4b5cd$var$ft("private key", N, $6c85c32373d4b5cd$var$K, O), N;
    }
    function u(p) {
        if (!(p instanceof h)) throw new Error("ProjectivePoint expected");
    }
    const l = $6c85c32373d4b5cd$var$Qe((p, d)=>{
        const { px: v, py: m, pz: O } = p;
        if (n.eql(O, n.ONE)) return {
            x: v,
            y: m
        };
        const N = p.is0();
        d == null && (d = N ? n.ONE : n.inv(O));
        const $ = n.mul(v, d), B = n.mul(m, d), A = n.mul(O, d);
        if (N) return {
            x: n.ZERO,
            y: n.ZERO
        };
        if (!n.eql(A, n.ONE)) throw new Error("invZ was invalid");
        return {
            x: $,
            y: B
        };
    }), f = $6c85c32373d4b5cd$var$Qe((p)=>{
        if (p.is0()) {
            if (e.allowInfinityPoint && !n.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        const { x: d, y: v } = p.toAffine();
        if (!n.isValid(d) || !n.isValid(v)) throw new Error("bad point: x or y not FE");
        const m = n.sqr(v), O = s(d);
        if (!n.eql(m, O)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return !0;
    });
    class h {
        constructor(d, v, m){
            if (this.px = d, this.py = v, this.pz = m, d == null || !n.isValid(d)) throw new Error("x required");
            if (v == null || !n.isValid(v)) throw new Error("y required");
            if (m == null || !n.isValid(m)) throw new Error("z required");
            Object.freeze(this);
        }
        static fromAffine(d) {
            const { x: v, y: m } = d || {};
            if (!d || !n.isValid(v) || !n.isValid(m)) throw new Error("invalid affine point");
            if (d instanceof h) throw new Error("projective point not allowed");
            const O = (N)=>n.eql(N, n.ZERO);
            return O(v) && O(m) ? h.ZERO : new h(v, m, n.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static normalizeZ(d) {
            const v = n.invertBatch(d.map((m)=>m.pz));
            return d.map((m, O)=>m.toAffine(v[O])).map(h.fromAffine);
        }
        static fromHex(d) {
            const v = h.fromAffine(i($6c85c32373d4b5cd$var$et("pointHex", d)));
            return v.assertValidity(), v;
        }
        static fromPrivateKey(d) {
            return h.BASE.multiply(a(d));
        }
        static msm(d, v) {
            return $6c85c32373d4b5cd$var$hc(h, r, d, v);
        }
        _setWindowSize(d) {
            E.setWindowSize(this, d);
        }
        assertValidity() {
            f(this);
        }
        hasEvenY() {
            const { y: d } = this.toAffine();
            if (n.isOdd) return !n.isOdd(d);
            throw new Error("Field doesn't support isOdd");
        }
        equals(d) {
            u(d);
            const { px: v, py: m, pz: O } = this, { px: N, py: $, pz: B } = d, A = n.eql(n.mul(v, B), n.mul(N, O)), T = n.eql(n.mul(m, B), n.mul($, O));
            return A && T;
        }
        negate() {
            return new h(this.px, n.neg(this.py), this.pz);
        }
        double() {
            const { a: d, b: v } = e, m = n.mul(v, $6c85c32373d4b5cd$var$Qr), { px: O, py: N, pz: $ } = this;
            let B = n.ZERO, A = n.ZERO, T = n.ZERO, S = n.mul(O, O), L = n.mul(N, N), U = n.mul($, $), _ = n.mul(O, N);
            return _ = n.add(_, _), T = n.mul(O, $), T = n.add(T, T), B = n.mul(d, T), A = n.mul(m, U), A = n.add(B, A), B = n.sub(L, A), A = n.add(L, A), A = n.mul(B, A), B = n.mul(_, B), T = n.mul(m, T), U = n.mul(d, U), _ = n.sub(S, U), _ = n.mul(d, _), _ = n.add(_, T), T = n.add(S, S), S = n.add(T, S), S = n.add(S, U), S = n.mul(S, _), A = n.add(A, S), U = n.mul(N, $), U = n.add(U, U), S = n.mul(U, _), B = n.sub(B, S), T = n.mul(U, L), T = n.add(T, T), T = n.add(T, T), new h(B, A, T);
        }
        add(d) {
            u(d);
            const { px: v, py: m, pz: O } = this, { px: N, py: $, pz: B } = d;
            let A = n.ZERO, T = n.ZERO, S = n.ZERO;
            const L = e.a, U = n.mul(e.b, $6c85c32373d4b5cd$var$Qr);
            let _ = n.mul(v, N), j = n.mul(m, $), g = n.mul(O, B), w = n.add(v, m), b = n.add(N, $);
            w = n.mul(w, b), b = n.add(_, j), w = n.sub(w, b), b = n.add(v, O);
            let I = n.add(N, B);
            return b = n.mul(b, I), I = n.add(_, g), b = n.sub(b, I), I = n.add(m, O), A = n.add($, B), I = n.mul(I, A), A = n.add(j, g), I = n.sub(I, A), S = n.mul(L, b), A = n.mul(U, g), S = n.add(A, S), A = n.sub(j, S), S = n.add(j, S), T = n.mul(A, S), j = n.add(_, _), j = n.add(j, _), g = n.mul(L, g), b = n.mul(U, b), j = n.add(j, g), g = n.sub(_, g), g = n.mul(L, g), b = n.add(b, g), _ = n.mul(j, b), T = n.add(T, _), _ = n.mul(I, b), A = n.mul(w, A), A = n.sub(A, _), _ = n.mul(w, j), S = n.mul(I, S), S = n.add(S, _), new h(A, T, S);
        }
        subtract(d) {
            return this.add(d.negate());
        }
        is0() {
            return this.equals(h.ZERO);
        }
        wNAF(d) {
            return E.wNAFCached(this, d, h.normalizeZ);
        }
        multiplyUnsafe(d) {
            const { endo: v, n: m } = e;
            $6c85c32373d4b5cd$var$ft("scalar", d, $6c85c32373d4b5cd$var$dt, m);
            const O = h.ZERO;
            if (d === $6c85c32373d4b5cd$var$dt) return O;
            if (this.is0() || d === $6c85c32373d4b5cd$var$K) return this;
            if (!v || E.hasPrecomputes(this)) return E.wNAFCachedUnsafe(this, d, h.normalizeZ);
            let { k1neg: N, k1: $, k2neg: B, k2: A } = v.splitScalar(d), T = O, S = O, L = this;
            for(; $ > $6c85c32373d4b5cd$var$dt || A > $6c85c32373d4b5cd$var$dt;)$ & $6c85c32373d4b5cd$var$K && (T = T.add(L)), A & $6c85c32373d4b5cd$var$K && (S = S.add(L)), L = L.double(), $ >>= $6c85c32373d4b5cd$var$K, A >>= $6c85c32373d4b5cd$var$K;
            return N && (T = T.negate()), B && (S = S.negate()), S = new h(n.mul(S.px, v.beta), S.py, S.pz), T.add(S);
        }
        multiply(d) {
            const { endo: v, n: m } = e;
            $6c85c32373d4b5cd$var$ft("scalar", d, $6c85c32373d4b5cd$var$K, m);
            let O, N;
            if (v) {
                const { k1neg: $, k1: B, k2neg: A, k2: T } = v.splitScalar(d);
                let { p: S, f: L } = this.wNAF(B), { p: U, f: _ } = this.wNAF(T);
                S = E.constTimeNegate($, S), U = E.constTimeNegate(A, U), U = new h(n.mul(U.px, v.beta), U.py, U.pz), O = S.add(U), N = L.add(_);
            } else {
                const { p: $, f: B } = this.wNAF(d);
                O = $, N = B;
            }
            return h.normalizeZ([
                O,
                N
            ])[0];
        }
        multiplyAndAddUnsafe(d, v, m) {
            const O = h.BASE, N = (B, A)=>A === $6c85c32373d4b5cd$var$dt || A === $6c85c32373d4b5cd$var$K || !B.equals(O) ? B.multiplyUnsafe(A) : B.multiply(A), $ = N(this, v).add(N(d, m));
            return $.is0() ? void 0 : $;
        }
        toAffine(d) {
            return l(this, d);
        }
        isTorsionFree() {
            const { h: d, isTorsionFree: v } = e;
            if (d === $6c85c32373d4b5cd$var$K) return !0;
            if (v) return v(h, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: d, clearCofactor: v } = e;
            return d === $6c85c32373d4b5cd$var$K ? this : v ? v(h, this) : this.multiplyUnsafe(e.h);
        }
        toRawBytes(d = !0) {
            return $6c85c32373d4b5cd$var$jt("isCompressed", d), this.assertValidity(), o(h, this, d);
        }
        toHex(d = !0) {
            return $6c85c32373d4b5cd$var$jt("isCompressed", d), $6c85c32373d4b5cd$var$Ct(this.toRawBytes(d));
        }
    }
    h.BASE = new h(e.Gx, e.Gy, n.ONE), h.ZERO = new h(n.ZERO, n.ONE, n.ZERO);
    const y = e.nBitLength, E = $6c85c32373d4b5cd$var$dc(h, e.endo ? Math.ceil(y / 2) : y);
    return {
        CURVE: e,
        ProjectivePoint: h,
        normPrivateKeyToScalar: a,
        weierstrassEquation: s,
        isWithinCurveOrder: c
    };
}
function $6c85c32373d4b5cd$var$Bc(t) {
    const e = $6c85c32373d4b5cd$var$Wr(t);
    return $6c85c32373d4b5cd$var$Mt(e, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    }), Object.freeze({
        lowS: !0,
        ...e
    });
}
function $6c85c32373d4b5cd$var$Ic(t) {
    const e = $6c85c32373d4b5cd$var$Bc(t), { Fp: n, n: r } = e, o = n.BYTES + 1, i = 2 * n.BYTES + 1;
    function s(g) {
        return $6c85c32373d4b5cd$var$X(g, r);
    }
    function c(g) {
        return $6c85c32373d4b5cd$var$en(g, r);
    }
    const { ProjectivePoint: a, normPrivateKeyToScalar: u, weierstrassEquation: l, isWithinCurveOrder: f } = $6c85c32373d4b5cd$var$Ac({
        ...e,
        toBytes (g, w, b) {
            const I = w.toAffine(), R = n.toBytes(I.x), x = $6c85c32373d4b5cd$var$ee;
            return $6c85c32373d4b5cd$var$jt("isCompressed", b), b ? x(Uint8Array.from([
                w.hasEvenY() ? 2 : 3
            ]), R) : x(Uint8Array.from([
                4
            ]), R, n.toBytes(I.y));
        },
        fromBytes (g) {
            const w = g.length, b = g[0], I = g.subarray(1);
            if (w === o && (b === 2 || b === 3)) {
                const R = $6c85c32373d4b5cd$var$Ot(I);
                if (!$6c85c32373d4b5cd$var$we(R, $6c85c32373d4b5cd$var$K, n.ORDER)) throw new Error("Point is not on curve");
                const x = l(R);
                let C;
                try {
                    C = n.sqrt(x);
                } catch (M) {
                    const D = M instanceof Error ? ": " + M.message : "";
                    throw new Error("Point is not on curve" + D);
                }
                const P = (C & $6c85c32373d4b5cd$var$K) === $6c85c32373d4b5cd$var$K;
                return (b & 1) === 1 !== P && (C = n.neg(C)), {
                    x: R,
                    y: C
                };
            } else if (w === i && b === 4) {
                const R = n.fromBytes(I.subarray(0, n.BYTES)), x = n.fromBytes(I.subarray(n.BYTES, 2 * n.BYTES));
                return {
                    x: R,
                    y: x
                };
            } else {
                const R = o, x = i;
                throw new Error("invalid Point, expected length of " + R + ", or uncompressed " + x + ", got " + w);
            }
        }
    }), h = (g)=>$6c85c32373d4b5cd$var$Ct($6c85c32373d4b5cd$var$Vt(g, e.nByteLength));
    function y(g) {
        const w = r >> $6c85c32373d4b5cd$var$K;
        return g > w;
    }
    function E(g) {
        return y(g) ? s(-g) : g;
    }
    const p = (g, w, b)=>$6c85c32373d4b5cd$var$Ot(g.slice(w, b));
    class d {
        constructor(w, b, I){
            this.r = w, this.s = b, this.recovery = I, this.assertValidity();
        }
        static fromCompact(w) {
            const b = e.nByteLength;
            return w = $6c85c32373d4b5cd$var$et("compactSignature", w, b * 2), new d(p(w, 0, b), p(w, b, 2 * b));
        }
        static fromDER(w) {
            const { r: b, s: I } = $6c85c32373d4b5cd$var$lt.toSig($6c85c32373d4b5cd$var$et("DER", w));
            return new d(b, I);
        }
        assertValidity() {
            $6c85c32373d4b5cd$var$ft("r", this.r, $6c85c32373d4b5cd$var$K, r), $6c85c32373d4b5cd$var$ft("s", this.s, $6c85c32373d4b5cd$var$K, r);
        }
        addRecoveryBit(w) {
            return new d(this.r, this.s, w);
        }
        recoverPublicKey(w) {
            const { r: b, s: I, recovery: R } = this, x = B($6c85c32373d4b5cd$var$et("msgHash", w));
            if (R == null || ![
                0,
                1,
                2,
                3
            ].includes(R)) throw new Error("recovery id invalid");
            const C = R === 2 || R === 3 ? b + e.n : b;
            if (C >= n.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const P = (R & 1) === 0 ? "02" : "03", k = a.fromHex(P + h(C)), M = c(C), D = s(-x * M), z = s(I * M), Z = a.BASE.multiplyAndAddUnsafe(k, D, z);
            if (!Z) throw new Error("point at infinify");
            return Z.assertValidity(), Z;
        }
        hasHighS() {
            return y(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new d(this.r, s(-this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return $6c85c32373d4b5cd$var$kt(this.toDERHex());
        }
        toDERHex() {
            return $6c85c32373d4b5cd$var$lt.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        toCompactRawBytes() {
            return $6c85c32373d4b5cd$var$kt(this.toCompactHex());
        }
        toCompactHex() {
            return h(this.r) + h(this.s);
        }
    }
    const v = {
        isValidPrivateKey (g) {
            try {
                return u(g), !0;
            } catch  {
                return !1;
            }
        },
        normPrivateKeyToScalar: u,
        randomPrivateKey: ()=>{
            const g = $6c85c32373d4b5cd$var$zr(e.n);
            return $6c85c32373d4b5cd$var$uc(e.randomBytes(g), e.n);
        },
        precompute (g = 8, w = a.BASE) {
            return w._setWindowSize(g), w.multiply(BigInt(3)), w;
        }
    };
    function m(g, w = !0) {
        return a.fromPrivateKey(g).toRawBytes(w);
    }
    function O(g) {
        const w = $6c85c32373d4b5cd$var$St(g), b = typeof g == "string", I = (w || b) && g.length;
        return w ? I === o || I === i : b ? I === 2 * o || I === 2 * i : g instanceof a;
    }
    function N(g, w, b = !0) {
        if (O(g)) throw new Error("first arg must be private key");
        if (!O(w)) throw new Error("second arg must be public key");
        return a.fromHex(w).multiply(u(g)).toRawBytes(b);
    }
    const $ = e.bits2int || function(g) {
        if (g.length > 8192) throw new Error("input is too large");
        const w = $6c85c32373d4b5cd$var$Ot(g), b = g.length * 8 - e.nBitLength;
        return b > 0 ? w >> BigInt(b) : w;
    }, B = e.bits2int_modN || function(g) {
        return s($(g));
    }, A = $6c85c32373d4b5cd$var$Xe(e.nBitLength);
    function T(g) {
        return $6c85c32373d4b5cd$var$ft("num < 2^" + e.nBitLength, g, $6c85c32373d4b5cd$var$dt, A), $6c85c32373d4b5cd$var$Vt(g, e.nByteLength);
    }
    function S(g, w, b = L) {
        if ([
            "recovered",
            "canonical"
        ].some((W)=>W in b)) throw new Error("sign() legacy options not supported");
        const { hash: I, randomBytes: R } = e;
        let { lowS: x, prehash: C, extraEntropy: P } = b;
        x == null && (x = !0), g = $6c85c32373d4b5cd$var$et("msgHash", g), $6c85c32373d4b5cd$var$Jr(b), C && (g = $6c85c32373d4b5cd$var$et("prehashed msgHash", I(g)));
        const k = B(g), M = u(w), D = [
            T(M),
            T(k)
        ];
        if (P != null && P !== !1) {
            const W = P === !0 ? R(n.BYTES) : P;
            D.push($6c85c32373d4b5cd$var$et("extraEntropy", W));
        }
        const z = $6c85c32373d4b5cd$var$ee(...D), Z = k;
        function it(W) {
            const J = $(W);
            if (!f(J)) return;
            const Oe = c(J), Ft = a.BASE.multiply(J).toAffine(), vt = s(Ft.x);
            if (vt === $6c85c32373d4b5cd$var$dt) return;
            const zt = s(Oe * s(Z + vt * M));
            if (zt === $6c85c32373d4b5cd$var$dt) return;
            let Ut = (Ft.x === vt ? 0 : 2) | Number(Ft.y & $6c85c32373d4b5cd$var$K), vn = zt;
            return x && y(zt) && (vn = E(zt), Ut ^= 1), new d(vt, vn, Ut);
        }
        return {
            seed: z,
            k2sig: it
        };
    }
    const L = {
        lowS: e.lowS,
        prehash: !1
    }, U = {
        lowS: e.lowS,
        prehash: !1
    };
    function _(g, w, b = L) {
        const { seed: I, k2sig: R } = S(g, w, b), x = e;
        return $6c85c32373d4b5cd$var$Vr(x.hash.outputLen, x.nByteLength, x.hmac)(I, R);
    }
    a.BASE._setWindowSize(8);
    function j(g, w, b, I = U) {
        const R = g;
        w = $6c85c32373d4b5cd$var$et("msgHash", w), b = $6c85c32373d4b5cd$var$et("publicKey", b);
        const { lowS: x, prehash: C, format: P } = I;
        if ($6c85c32373d4b5cd$var$Jr(I), "strict" in I) throw new Error("options.strict was renamed to lowS");
        if (P !== void 0 && P !== "compact" && P !== "der") throw new Error("format must be compact or der");
        const k = typeof R == "string" || $6c85c32373d4b5cd$var$St(R), M = !k && !P && typeof R == "object" && R !== null && typeof R.r == "bigint" && typeof R.s == "bigint";
        if (!k && !M) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        let D, z;
        try {
            if (M && (D = new d(R.r, R.s)), k) {
                try {
                    P !== "compact" && (D = d.fromDER(R));
                } catch (Ut) {
                    if (!(Ut instanceof $6c85c32373d4b5cd$var$lt.Err)) throw Ut;
                }
                !D && P !== "der" && (D = d.fromCompact(R));
            }
            z = a.fromHex(b);
        } catch  {
            return !1;
        }
        if (!D || x && D.hasHighS()) return !1;
        C && (w = e.hash(w));
        const { r: Z, s: it } = D, W = B(w), J = c(it), Oe = s(W * J), Ft = s(Z * J), vt = a.BASE.multiplyAndAddUnsafe(z, Oe, Ft)?.toAffine();
        return vt ? s(vt.x) === Z : !1;
    }
    return {
        CURVE: e,
        getPublicKey: m,
        getSharedSecret: N,
        sign: _,
        verify: j,
        ProjectivePoint: a,
        Signature: d,
        utils: v
    };
}
function $6c85c32373d4b5cd$var$Nc(t) {
    return {
        hash: t,
        hmac: (e, ...n)=>$6c85c32373d4b5cd$var$pe(t, e, $6c85c32373d4b5cd$var$Vi(...n)),
        randomBytes: $6c85c32373d4b5cd$var$$t
    };
}
function $6c85c32373d4b5cd$var$Uc(t, e) {
    const n = (r)=>$6c85c32373d4b5cd$var$Ic({
            ...t,
            ...$6c85c32373d4b5cd$var$Nc(r)
        });
    return {
        ...n(e),
        create: n
    };
}
const $6c85c32373d4b5cd$var$to = $6c85c32373d4b5cd$var$Kr(BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff")), $6c85c32373d4b5cd$var$Tc = $6c85c32373d4b5cd$var$to.create(BigInt("-3")), $6c85c32373d4b5cd$var$Rc = BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), $6c85c32373d4b5cd$var$_c = $6c85c32373d4b5cd$var$Uc({
    a: $6c85c32373d4b5cd$var$Tc,
    b: $6c85c32373d4b5cd$var$Rc,
    Fp: $6c85c32373d4b5cd$var$to,
    n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"),
    Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
    Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
    h: BigInt(1),
    lowS: !1
}, $6c85c32373d4b5cd$var$Jt), $6c85c32373d4b5cd$export$f7403969428298bd = "base10", $6c85c32373d4b5cd$export$49eb910ab2518105 = "base16", $6c85c32373d4b5cd$export$9bff723d552e6bcf = "base64pad", $6c85c32373d4b5cd$export$e9cf21fb8029e645 = "base64url", $6c85c32373d4b5cd$export$9560dad2a83e4f04 = "utf8", $6c85c32373d4b5cd$export$3425bd336a9673d8 = 0, $6c85c32373d4b5cd$export$406e97c329f0f3d4 = 1, $6c85c32373d4b5cd$export$d79eac6ee921504f = 2, $6c85c32373d4b5cd$var$$c = 0, $6c85c32373d4b5cd$var$eo = 1, $6c85c32373d4b5cd$var$re = 12, $6c85c32373d4b5cd$var$dn = 32;
function $6c85c32373d4b5cd$export$a949d36eab55b41f() {
    const t = $6c85c32373d4b5cd$var$un.utils.randomPrivateKey(), e = $6c85c32373d4b5cd$var$un.getPublicKey(t);
    return {
        privateKey: (0, $BCGxC.toString)(t, $6c85c32373d4b5cd$export$49eb910ab2518105),
        publicKey: (0, $BCGxC.toString)(e, $6c85c32373d4b5cd$export$49eb910ab2518105)
    };
}
function $6c85c32373d4b5cd$export$d15a28e4f1821243() {
    const t = $6c85c32373d4b5cd$var$$t($6c85c32373d4b5cd$var$dn);
    return (0, $BCGxC.toString)(t, $6c85c32373d4b5cd$export$49eb910ab2518105);
}
function $6c85c32373d4b5cd$export$f8378f68e053f5c6(t, e) {
    const n = $6c85c32373d4b5cd$var$un.getSharedSecret((0, $2AuZR.fromString)(t, $6c85c32373d4b5cd$export$49eb910ab2518105), (0, $2AuZR.fromString)(e, $6c85c32373d4b5cd$export$49eb910ab2518105)), r = $6c85c32373d4b5cd$var$Vs($6c85c32373d4b5cd$var$Jt, n, void 0, void 0, $6c85c32373d4b5cd$var$dn);
    return (0, $BCGxC.toString)(r, $6c85c32373d4b5cd$export$49eb910ab2518105);
}
function $6c85c32373d4b5cd$export$1e87d19d4aab5805(t) {
    const e = $6c85c32373d4b5cd$var$Jt((0, $2AuZR.fromString)(t, $6c85c32373d4b5cd$export$49eb910ab2518105));
    return (0, $BCGxC.toString)(e, $6c85c32373d4b5cd$export$49eb910ab2518105);
}
function $6c85c32373d4b5cd$export$d4c241cec96564c1(t) {
    const e = $6c85c32373d4b5cd$var$Jt((0, $2AuZR.fromString)(t, $6c85c32373d4b5cd$export$9560dad2a83e4f04));
    return (0, $BCGxC.toString)(e, $6c85c32373d4b5cd$export$49eb910ab2518105);
}
function $6c85c32373d4b5cd$export$e9d2f9ba70428fb6(t) {
    return (0, $2AuZR.fromString)(`${t}`, $6c85c32373d4b5cd$export$f7403969428298bd);
}
function $6c85c32373d4b5cd$export$7547a514ee29b9d4(t) {
    return Number((0, $BCGxC.toString)(t, $6c85c32373d4b5cd$export$f7403969428298bd));
}
function $6c85c32373d4b5cd$var$no(t) {
    return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $6c85c32373d4b5cd$var$ro(t) {
    const e = t.replace(/-/g, "+").replace(/_/g, "/"), n = (4 - e.length % 4) % 4;
    return e + "=".repeat(n);
}
function $6c85c32373d4b5cd$export$5b0f6292f11d1d18(t) {
    const e = $6c85c32373d4b5cd$export$e9d2f9ba70428fb6(typeof t.type < "u" ? t.type : $6c85c32373d4b5cd$export$3425bd336a9673d8);
    if ($6c85c32373d4b5cd$export$7547a514ee29b9d4(e) === $6c85c32373d4b5cd$export$406e97c329f0f3d4 && typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const n = typeof t.senderPublicKey < "u" ? (0, $2AuZR.fromString)(t.senderPublicKey, $6c85c32373d4b5cd$export$49eb910ab2518105) : void 0, r = typeof t.iv < "u" ? (0, $2AuZR.fromString)(t.iv, $6c85c32373d4b5cd$export$49eb910ab2518105) : $6c85c32373d4b5cd$var$$t($6c85c32373d4b5cd$var$re), o = (0, $2AuZR.fromString)(t.symKey, $6c85c32373d4b5cd$export$49eb910ab2518105), i = $6c85c32373d4b5cd$var$$r(o, r).encrypt((0, $2AuZR.fromString)(t.message, $6c85c32373d4b5cd$export$9560dad2a83e4f04)), s = $6c85c32373d4b5cd$export$dfdc1655ccc5b9cb({
        type: e,
        sealed: i,
        iv: r,
        senderPublicKey: n
    });
    return t.encoding === $6c85c32373d4b5cd$export$e9cf21fb8029e645 ? $6c85c32373d4b5cd$var$no(s) : s;
}
function $6c85c32373d4b5cd$export$e85a0c9a1067c5d3(t) {
    const e = (0, $2AuZR.fromString)(t.symKey, $6c85c32373d4b5cd$export$49eb910ab2518105), { sealed: n, iv: r } = $6c85c32373d4b5cd$export$efcd34ab6248d3cd({
        encoded: t.encoded,
        encoding: t.encoding
    }), o = $6c85c32373d4b5cd$var$$r(e, r).decrypt(n);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $BCGxC.toString)(o, $6c85c32373d4b5cd$export$9560dad2a83e4f04);
}
function $6c85c32373d4b5cd$export$99abb28d1c4baa95(t, e) {
    const n = $6c85c32373d4b5cd$export$e9d2f9ba70428fb6($6c85c32373d4b5cd$export$d79eac6ee921504f), r = $6c85c32373d4b5cd$var$$t($6c85c32373d4b5cd$var$re), o = (0, $2AuZR.fromString)(t, $6c85c32373d4b5cd$export$9560dad2a83e4f04), i = $6c85c32373d4b5cd$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r
    });
    return e === $6c85c32373d4b5cd$export$e9cf21fb8029e645 ? $6c85c32373d4b5cd$var$no(i) : i;
}
function $6c85c32373d4b5cd$export$6b54347426d28ee3(t, e) {
    const { sealed: n } = $6c85c32373d4b5cd$export$efcd34ab6248d3cd({
        encoded: t,
        encoding: e
    });
    return (0, $BCGxC.toString)(n, $6c85c32373d4b5cd$export$9560dad2a83e4f04);
}
function $6c85c32373d4b5cd$export$dfdc1655ccc5b9cb(t) {
    if ($6c85c32373d4b5cd$export$7547a514ee29b9d4(t.type) === $6c85c32373d4b5cd$export$d79eac6ee921504f) return (0, $BCGxC.toString)((0, $abuiC.concat)([
        t.type,
        t.sealed
    ]), $6c85c32373d4b5cd$export$9bff723d552e6bcf);
    if ($6c85c32373d4b5cd$export$7547a514ee29b9d4(t.type) === $6c85c32373d4b5cd$export$406e97c329f0f3d4) {
        if (typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $BCGxC.toString)((0, $abuiC.concat)([
            t.type,
            t.senderPublicKey,
            t.iv,
            t.sealed
        ]), $6c85c32373d4b5cd$export$9bff723d552e6bcf);
    }
    return (0, $BCGxC.toString)((0, $abuiC.concat)([
        t.type,
        t.iv,
        t.sealed
    ]), $6c85c32373d4b5cd$export$9bff723d552e6bcf);
}
function $6c85c32373d4b5cd$export$efcd34ab6248d3cd(t) {
    const e = (t.encoding || $6c85c32373d4b5cd$export$9bff723d552e6bcf) === $6c85c32373d4b5cd$export$e9cf21fb8029e645 ? $6c85c32373d4b5cd$var$ro(t.encoded) : t.encoded, n = (0, $2AuZR.fromString)(e, $6c85c32373d4b5cd$export$9bff723d552e6bcf), r = n.slice($6c85c32373d4b5cd$var$$c, $6c85c32373d4b5cd$var$eo), o = $6c85c32373d4b5cd$var$eo;
    if ($6c85c32373d4b5cd$export$7547a514ee29b9d4(r) === $6c85c32373d4b5cd$export$406e97c329f0f3d4) {
        const a = o + $6c85c32373d4b5cd$var$dn, u = a + $6c85c32373d4b5cd$var$re, l = n.slice(o, a), f = n.slice(a, u), h = n.slice(u);
        return {
            type: r,
            sealed: h,
            iv: f,
            senderPublicKey: l
        };
    }
    if ($6c85c32373d4b5cd$export$7547a514ee29b9d4(r) === $6c85c32373d4b5cd$export$d79eac6ee921504f) {
        const a = n.slice(o), u = $6c85c32373d4b5cd$var$$t($6c85c32373d4b5cd$var$re);
        return {
            type: r,
            sealed: a,
            iv: u
        };
    }
    const i = o + $6c85c32373d4b5cd$var$re, s = n.slice(o, i), c = n.slice(i);
    return {
        type: r,
        sealed: c,
        iv: s
    };
}
function $6c85c32373d4b5cd$export$177f3e316562333d(t, e) {
    const n = $6c85c32373d4b5cd$export$efcd34ab6248d3cd({
        encoded: t,
        encoding: e?.encoding
    });
    return $6c85c32373d4b5cd$export$7949f60f2444aef2({
        type: $6c85c32373d4b5cd$export$7547a514ee29b9d4(n.type),
        senderPublicKey: typeof n.senderPublicKey < "u" ? (0, $BCGxC.toString)(n.senderPublicKey, $6c85c32373d4b5cd$export$49eb910ab2518105) : void 0,
        receiverPublicKey: e?.receiverPublicKey
    });
}
function $6c85c32373d4b5cd$export$7949f60f2444aef2(t) {
    const e = t?.type || $6c85c32373d4b5cd$export$3425bd336a9673d8;
    if (e === $6c85c32373d4b5cd$export$406e97c329f0f3d4) {
        if (typeof t?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof t?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: e,
        senderPublicKey: t?.senderPublicKey,
        receiverPublicKey: t?.receiverPublicKey
    };
}
function $6c85c32373d4b5cd$export$8c165704db2d5c15(t) {
    return t.type === $6c85c32373d4b5cd$export$406e97c329f0f3d4 && typeof t.senderPublicKey == "string" && typeof t.receiverPublicKey == "string";
}
function $6c85c32373d4b5cd$export$599538f59a4a14c3(t) {
    return t.type === $6c85c32373d4b5cd$export$d79eac6ee921504f;
}
function $6c85c32373d4b5cd$export$63aed4db4cd72ee8(t) {
    const e = $6c85c32373d4b5cd$require$Buffer.from(t.x, "base64"), n = $6c85c32373d4b5cd$require$Buffer.from(t.y, "base64");
    return (0, $abuiC.concat)([
        new Uint8Array([
            4
        ]),
        e,
        n
    ]);
}
function $6c85c32373d4b5cd$export$f65520390041ee33(t, e) {
    const [n, r, o] = t.split("."), i = $6c85c32373d4b5cd$require$Buffer.from($6c85c32373d4b5cd$var$ro(o), "base64");
    if (i.length !== 64) throw new Error("Invalid signature length");
    const s = i.slice(0, 32), c = i.slice(32, 64), a = `${n}.${r}`, u = $6c85c32373d4b5cd$var$Jt(a), l = $6c85c32373d4b5cd$export$63aed4db4cd72ee8(e);
    if (!$6c85c32373d4b5cd$var$_c.verify((0, $abuiC.concat)([
        s,
        c
    ]), u, l)) throw new Error("Invalid signature");
    return (0, $islmt.decodeJWT)(t).payload;
}
const $6c85c32373d4b5cd$export$822d0bd1635d5360 = "irn";
function $6c85c32373d4b5cd$export$cf77af25151525db(t) {
    return t?.relay || {
        protocol: $6c85c32373d4b5cd$export$822d0bd1635d5360
    };
}
function $6c85c32373d4b5cd$export$604e3deb95e1b734(t) {
    const e = (0, $5fcsy.RELAY_JSONRPC)[t];
    if (typeof e > "u") throw new Error(`Relay Protocol not supported: ${t}`);
    return e;
}
function $6c85c32373d4b5cd$export$3d24f408c2ac468a(t, e = "-") {
    const n = {}, r = "relay" + e;
    return Object.keys(t).forEach((o)=>{
        if (o.startsWith(r)) {
            const i = o.replace(r, ""), s = t[o];
            n[i] = s;
        }
    }), n;
}
function $6c85c32373d4b5cd$export$59f58847421cfb28(t) {
    if (!t.includes("wc:")) {
        const u = $6c85c32373d4b5cd$export$c537b38001c583b7(t);
        u != null && u.includes("wc:") && (t = u);
    }
    t = t.includes("wc://") ? t.replace("wc://", "") : t, t = t.includes("wc:") ? t.replace("wc:", "") : t;
    const e = t.indexOf(":"), n = t.indexOf("?") !== -1 ? t.indexOf("?") : void 0, r = t.substring(0, e), o = t.substring(e + 1, n).split("@"), i = typeof n < "u" ? t.substring(n) : "", s = new URLSearchParams(i), c = {};
    s.forEach((u, l)=>{
        c[l] = u;
    });
    const a = typeof c.methods == "string" ? c.methods.split(",") : void 0;
    return {
        protocol: r,
        topic: $6c85c32373d4b5cd$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: c.symKey,
        relay: $6c85c32373d4b5cd$export$3d24f408c2ac468a(c),
        methods: a,
        expiryTimestamp: c.expiryTimestamp ? parseInt(c.expiryTimestamp, 10) : void 0
    };
}
function $6c85c32373d4b5cd$export$5ddc9ebef1d00f28(t) {
    return t.startsWith("//") ? t.substring(2) : t;
}
function $6c85c32373d4b5cd$export$65c55c7ccd19bb8f(t, e = "-") {
    const n = "relay", r = {};
    return Object.keys(t).forEach((o)=>{
        const i = o, s = n + e + i;
        t[i] && (r[s] = t[i]);
    }), r;
}
function $6c85c32373d4b5cd$export$b2786ede34fb2350(t) {
    const e = new URLSearchParams, n = $6c85c32373d4b5cd$export$65c55c7ccd19bb8f(t.relay);
    Object.keys(n).sort().forEach((o)=>{
        e.set(o, n[o]);
    }), e.set("symKey", t.symKey), t.expiryTimestamp && e.set("expiryTimestamp", t.expiryTimestamp.toString()), t.methods && e.set("methods", t.methods.join(","));
    const r = e.toString();
    return `${t.protocol}:${t.topic}@${t.version}?${r}`;
}
function $6c85c32373d4b5cd$export$556cb6cc912028c2(t, e, n) {
    return `${t}?wc_ev=${n}&topic=${e}`;
}
var $6c85c32373d4b5cd$var$Jc = Object.defineProperty, $6c85c32373d4b5cd$var$Qc = Object.defineProperties, $6c85c32373d4b5cd$var$ta = Object.getOwnPropertyDescriptors, $6c85c32373d4b5cd$var$fo = Object.getOwnPropertySymbols, $6c85c32373d4b5cd$var$ea = Object.prototype.hasOwnProperty, $6c85c32373d4b5cd$var$na = Object.prototype.propertyIsEnumerable, $6c85c32373d4b5cd$var$lo = (t, e, n)=>e in t ? $6c85c32373d4b5cd$var$Jc(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n, $6c85c32373d4b5cd$var$ra = (t, e)=>{
    for(var n in e || (e = {}))$6c85c32373d4b5cd$var$ea.call(e, n) && $6c85c32373d4b5cd$var$lo(t, n, e[n]);
    if ($6c85c32373d4b5cd$var$fo) for (var n of $6c85c32373d4b5cd$var$fo(e))$6c85c32373d4b5cd$var$na.call(e, n) && $6c85c32373d4b5cd$var$lo(t, n, e[n]);
    return t;
}, $6c85c32373d4b5cd$var$oa = (t, e)=>$6c85c32373d4b5cd$var$Qc(t, $6c85c32373d4b5cd$var$ta(e));
function $6c85c32373d4b5cd$export$d46695d9c3664fe9(t) {
    const e = [];
    return t.forEach((n)=>{
        const [r, o] = n.split(":");
        e.push(`${r}:${o}`);
    }), e;
}
function $6c85c32373d4b5cd$export$fb6db6038e742b14(t) {
    const e = [];
    return Object.values(t).forEach((n)=>{
        e.push(...$6c85c32373d4b5cd$export$d46695d9c3664fe9(n.accounts));
    }), e;
}
function $6c85c32373d4b5cd$export$7dcf4808e17b15ac(t, e) {
    const n = [];
    return Object.values(t).forEach((r)=>{
        $6c85c32373d4b5cd$export$d46695d9c3664fe9(r.accounts).includes(e) && n.push(...r.methods);
    }), n;
}
function $6c85c32373d4b5cd$export$94ee6d00e384a22(t, e) {
    const n = [];
    return Object.values(t).forEach((r)=>{
        $6c85c32373d4b5cd$export$d46695d9c3664fe9(r.accounts).includes(e) && n.push(...r.events);
    }), n;
}
function $6c85c32373d4b5cd$export$a8daa26a7c60ef90(t, e) {
    const n = $6c85c32373d4b5cd$export$93f7b81dc815a714(t, e);
    if (n) throw new Error(n.message);
    const r = {};
    for (const [o, i] of Object.entries(t))r[o] = {
        methods: i.methods,
        events: i.events,
        chains: i.accounts.map((s)=>`${s.split(":")[0]}:${s.split(":")[1]}`)
    };
    return r;
}
function $6c85c32373d4b5cd$export$c0b86bc9b7d9f338(t) {
    const { proposal: { requiredNamespaces: e, optionalNamespaces: n = {} }, supportedNamespaces: r } = t, o = $6c85c32373d4b5cd$export$2994550cda701c96(e), i = $6c85c32373d4b5cd$export$2994550cda701c96(n), s = {};
    Object.keys(r).forEach((u)=>{
        const l = r[u].chains, f = r[u].methods, h = r[u].events, y = r[u].accounts;
        l.forEach((E)=>{
            if (!y.some((p)=>p.includes(E))) throw new Error(`No accounts provided for chain ${E} in namespace ${u}`);
        }), s[u] = {
            chains: l,
            methods: f,
            events: h,
            accounts: y
        };
    });
    const c = $6c85c32373d4b5cd$export$ba5b0a4b585cd1b4(e, s, "approve()");
    if (c) throw new Error(c.message);
    const a = {};
    return !Object.keys(e).length && !Object.keys(n).length ? s : (Object.keys(o).forEach((u)=>{
        const l = r[u].chains.filter((E)=>{
            var p, d;
            return (d = (p = o[u]) == null ? void 0 : p.chains) == null ? void 0 : d.includes(E);
        }), f = r[u].methods.filter((E)=>{
            var p, d;
            return (d = (p = o[u]) == null ? void 0 : p.methods) == null ? void 0 : d.includes(E);
        }), h = r[u].events.filter((E)=>{
            var p, d;
            return (d = (p = o[u]) == null ? void 0 : p.events) == null ? void 0 : d.includes(E);
        }), y = l.map((E)=>r[u].accounts.filter((p)=>p.includes(`${E}:`))).flat();
        a[u] = {
            chains: l,
            methods: f,
            events: h,
            accounts: y
        };
    }), Object.keys(i).forEach((u)=>{
        var l, f, h, y, E, p;
        if (!r[u]) return;
        const d = (f = (l = i[u]) == null ? void 0 : l.chains) == null ? void 0 : f.filter((N)=>r[u].chains.includes(N)), v = r[u].methods.filter((N)=>{
            var $, B;
            return (B = ($ = i[u]) == null ? void 0 : $.methods) == null ? void 0 : B.includes(N);
        }), m = r[u].events.filter((N)=>{
            var $, B;
            return (B = ($ = i[u]) == null ? void 0 : $.events) == null ? void 0 : B.includes(N);
        }), O = d?.map((N)=>r[u].accounts.filter(($)=>$.includes(`${N}:`))).flat();
        a[u] = {
            chains: $6c85c32373d4b5cd$export$9826fe7ad3921016((h = a[u]) == null ? void 0 : h.chains, d),
            methods: $6c85c32373d4b5cd$export$9826fe7ad3921016((y = a[u]) == null ? void 0 : y.methods, v),
            events: $6c85c32373d4b5cd$export$9826fe7ad3921016((E = a[u]) == null ? void 0 : E.events, m),
            accounts: $6c85c32373d4b5cd$export$9826fe7ad3921016((p = a[u]) == null ? void 0 : p.accounts, O)
        };
    }), a);
}
function $6c85c32373d4b5cd$export$e03e993df4723bde(t) {
    return t.includes(":");
}
function $6c85c32373d4b5cd$export$dd404c96fbbb1ff8(t) {
    return $6c85c32373d4b5cd$export$e03e993df4723bde(t) ? t.split(":")[0] : t;
}
function $6c85c32373d4b5cd$export$2994550cda701c96(t) {
    var e, n, r;
    const o = {};
    if (!$6c85c32373d4b5cd$export$16a0268bc22b47b0(t)) return o;
    for (const [i, s] of Object.entries(t)){
        const c = $6c85c32373d4b5cd$export$e03e993df4723bde(i) ? [
            i
        ] : s.chains, a = s.methods || [], u = s.events || [], l = $6c85c32373d4b5cd$export$dd404c96fbbb1ff8(i);
        o[l] = $6c85c32373d4b5cd$var$oa($6c85c32373d4b5cd$var$ra({}, o[l]), {
            chains: $6c85c32373d4b5cd$export$9826fe7ad3921016(c, (e = o[l]) == null ? void 0 : e.chains),
            methods: $6c85c32373d4b5cd$export$9826fe7ad3921016(a, (n = o[l]) == null ? void 0 : n.methods),
            events: $6c85c32373d4b5cd$export$9826fe7ad3921016(u, (r = o[l]) == null ? void 0 : r.events)
        });
    }
    return o;
}
function $6c85c32373d4b5cd$export$293459f1cc8d700(t) {
    const e = {};
    return t?.forEach((n)=>{
        var r;
        const [o, i] = n.split(":");
        e[o] || (e[o] = {
            accounts: [],
            chains: [],
            events: [],
            methods: []
        }), e[o].accounts.push(n), (r = e[o].chains) == null || r.push(`${o}:${i}`);
    }), e;
}
function $6c85c32373d4b5cd$export$b5744b1c39447540(t, e) {
    e = e.map((r)=>r.replace("did:pkh:", ""));
    const n = $6c85c32373d4b5cd$export$293459f1cc8d700(e);
    for (const [r, o] of Object.entries(n))o.methods ? o.methods = $6c85c32373d4b5cd$export$9826fe7ad3921016(o.methods, t) : o.methods = t, o.events = [
        "chainChanged",
        "accountsChanged"
    ];
    return n;
}
const $6c85c32373d4b5cd$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $6c85c32373d4b5cd$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $6c85c32373d4b5cd$export$500d4c4a8fafe35(t, e) {
    const { message: n, code: r } = $6c85c32373d4b5cd$export$77b3faa414a0ce61[t];
    return {
        message: e ? `${n} ${e}` : n,
        code: r
    };
}
function $6c85c32373d4b5cd$export$8203ef1531c8b5b5(t, e) {
    const { message: n, code: r } = $6c85c32373d4b5cd$export$990de0b632caca05[t];
    return {
        message: e ? `${n} ${e}` : n,
        code: r
    };
}
function $6c85c32373d4b5cd$export$41dd3d480aac4a71(t, e) {
    return Array.isArray(t) ? typeof e < "u" && t.length ? t.every(e) : !0 : !1;
}
function $6c85c32373d4b5cd$export$16a0268bc22b47b0(t) {
    return Object.getPrototypeOf(t) === Object.prototype && Object.keys(t).length;
}
function $6c85c32373d4b5cd$export$fce6876652108ab(t) {
    return typeof t > "u";
}
function $6c85c32373d4b5cd$export$ee898ca48ab56c74(t, e) {
    return e && $6c85c32373d4b5cd$export$fce6876652108ab(t) ? !0 : typeof t == "string" && !!t.trim().length;
}
function $6c85c32373d4b5cd$export$d6781b696a0576d1(t, e) {
    return e && $6c85c32373d4b5cd$export$fce6876652108ab(t) ? !0 : typeof t == "number" && !isNaN(t);
}
function $6c85c32373d4b5cd$export$6fc4971bf8f326a(t, e) {
    const { requiredNamespaces: n } = e, r = Object.keys(t.namespaces), o = Object.keys(n);
    let i = !0;
    return $6c85c32373d4b5cd$export$1468a49de573f7f9(o, r) ? (r.forEach((s)=>{
        const { accounts: c, methods: a, events: u } = t.namespaces[s], l = $6c85c32373d4b5cd$export$d46695d9c3664fe9(c), f = n[s];
        (!$6c85c32373d4b5cd$export$1468a49de573f7f9($6c85c32373d4b5cd$export$376384387cd15b27(s, f), l) || !$6c85c32373d4b5cd$export$1468a49de573f7f9(f.methods, a) || !$6c85c32373d4b5cd$export$1468a49de573f7f9(f.events, u)) && (i = !1);
    }), i) : !1;
}
function $6c85c32373d4b5cd$export$e544b39f0a22e47a(t) {
    return $6c85c32373d4b5cd$export$ee898ca48ab56c74(t, !1) && t.includes(":") ? t.split(":").length === 2 : !1;
}
function $6c85c32373d4b5cd$export$49e4a5b6862e3c71(t) {
    if ($6c85c32373d4b5cd$export$ee898ca48ab56c74(t, !1) && t.includes(":")) {
        const e = t.split(":");
        if (e.length === 3) {
            const n = e[0] + ":" + e[1];
            return !!e[2] && $6c85c32373d4b5cd$export$e544b39f0a22e47a(n);
        }
    }
    return !1;
}
function $6c85c32373d4b5cd$export$bef94a5618bf18bf(t) {
    function e(n) {
        try {
            return typeof new URL(n) < "u";
        } catch  {
            return !1;
        }
    }
    try {
        if ($6c85c32373d4b5cd$export$ee898ca48ab56c74(t, !1)) {
            if (e(t)) return !0;
            const n = $6c85c32373d4b5cd$export$c537b38001c583b7(t);
            return e(n);
        }
    } catch  {}
    return !1;
}
function $6c85c32373d4b5cd$export$f657f7976bb2769d(t) {
    var e;
    return (e = t?.proposer) == null ? void 0 : e.publicKey;
}
function $6c85c32373d4b5cd$export$c96d5113768aaf5e(t) {
    return t?.topic;
}
function $6c85c32373d4b5cd$export$5e1c5c89613c213f(t, e) {
    let n = null;
    return $6c85c32373d4b5cd$export$ee898ca48ab56c74(t?.publicKey, !1) || (n = $6c85c32373d4b5cd$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${e} controller public key should be a string`)), n;
}
function $6c85c32373d4b5cd$export$c12fced8176774f3(t) {
    let e = !0;
    return $6c85c32373d4b5cd$export$41dd3d480aac4a71(t) ? t.length && (e = t.every((n)=>$6c85c32373d4b5cd$export$ee898ca48ab56c74(n, !1))) : e = !1, e;
}
function $6c85c32373d4b5cd$export$df46c123d7e298ce(t, e, n) {
    let r = null;
    return $6c85c32373d4b5cd$export$41dd3d480aac4a71(e) && e.length ? e.forEach((o)=>{
        r || $6c85c32373d4b5cd$export$e544b39f0a22e47a(o) || (r = $6c85c32373d4b5cd$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${n}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $6c85c32373d4b5cd$export$e544b39f0a22e47a(t) || (r = $6c85c32373d4b5cd$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${n}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $6c85c32373d4b5cd$export$94ae96fb66f29e08(t, e, n) {
    let r = null;
    return Object.entries(t).forEach(([o, i])=>{
        if (r) return;
        const s = $6c85c32373d4b5cd$export$df46c123d7e298ce(o, $6c85c32373d4b5cd$export$376384387cd15b27(o, i), `${e} ${n}`);
        s && (r = s);
    }), r;
}
function $6c85c32373d4b5cd$export$d5644026aaffb9e7(t, e) {
    let n = null;
    return $6c85c32373d4b5cd$export$41dd3d480aac4a71(t) ? t.forEach((r)=>{
        n || $6c85c32373d4b5cd$export$49e4a5b6862e3c71(r) || (n = $6c85c32373d4b5cd$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${e}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : n = $6c85c32373d4b5cd$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${e}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), n;
}
function $6c85c32373d4b5cd$export$2a2012e7bfa1cfb4(t, e) {
    let n = null;
    return Object.values(t).forEach((r)=>{
        if (n) return;
        const o = $6c85c32373d4b5cd$export$d5644026aaffb9e7(r?.accounts, `${e} namespace`);
        o && (n = o);
    }), n;
}
function $6c85c32373d4b5cd$export$b32541d63753af56(t, e) {
    let n = null;
    return $6c85c32373d4b5cd$export$c12fced8176774f3(t?.methods) ? $6c85c32373d4b5cd$export$c12fced8176774f3(t?.events) || (n = $6c85c32373d4b5cd$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${e}, events should be an array of strings or empty array for no events`)) : n = $6c85c32373d4b5cd$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${e}, methods should be an array of strings or empty array for no methods`), n;
}
function $6c85c32373d4b5cd$export$27682c78deeca9d7(t, e) {
    let n = null;
    return Object.values(t).forEach((r)=>{
        if (n) return;
        const o = $6c85c32373d4b5cd$export$b32541d63753af56(r, `${e}, namespace`);
        o && (n = o);
    }), n;
}
function $6c85c32373d4b5cd$export$9e2b2cae22c6a8b3(t, e, n) {
    let r = null;
    if (t && $6c85c32373d4b5cd$export$16a0268bc22b47b0(t)) {
        const o = $6c85c32373d4b5cd$export$27682c78deeca9d7(t, e);
        o && (r = o);
        const i = $6c85c32373d4b5cd$export$94ae96fb66f29e08(t, e, n);
        i && (r = i);
    } else r = $6c85c32373d4b5cd$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${e}, ${n} should be an object with data`);
    return r;
}
function $6c85c32373d4b5cd$export$93f7b81dc815a714(t, e) {
    let n = null;
    if (t && $6c85c32373d4b5cd$export$16a0268bc22b47b0(t)) {
        const r = $6c85c32373d4b5cd$export$27682c78deeca9d7(t, e);
        r && (n = r);
        const o = $6c85c32373d4b5cd$export$2a2012e7bfa1cfb4(t, e);
        o && (n = o);
    } else n = $6c85c32373d4b5cd$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${e}, namespaces should be an object with data`);
    return n;
}
function $6c85c32373d4b5cd$export$1b3fc298be8c9a7b(t) {
    return $6c85c32373d4b5cd$export$ee898ca48ab56c74(t.protocol, !0);
}
function $6c85c32373d4b5cd$export$6294c30b976bd21e(t, e) {
    let n = !1;
    return e && !t ? n = !0 : t && $6c85c32373d4b5cd$export$41dd3d480aac4a71(t) && t.length && t.forEach((r)=>{
        n = $6c85c32373d4b5cd$export$1b3fc298be8c9a7b(r);
    }), n;
}
function $6c85c32373d4b5cd$export$53551be28ad5e34d(t) {
    return typeof t == "number";
}
function $6c85c32373d4b5cd$export$b3f5fcca1d210454(t) {
    return typeof t < "u" && true;
}
function $6c85c32373d4b5cd$export$766fe78377d96f2a(t) {
    return !(!t || typeof t != "object" || !t.code || !$6c85c32373d4b5cd$export$d6781b696a0576d1(t.code, !1) || !t.message || !$6c85c32373d4b5cd$export$ee898ca48ab56c74(t.message, !1));
}
function $6c85c32373d4b5cd$export$1a2af3c017fb6d42(t) {
    return !($6c85c32373d4b5cd$export$fce6876652108ab(t) || !$6c85c32373d4b5cd$export$ee898ca48ab56c74(t.method, !1));
}
function $6c85c32373d4b5cd$export$1ae38cf0a848f651(t) {
    return !($6c85c32373d4b5cd$export$fce6876652108ab(t) || $6c85c32373d4b5cd$export$fce6876652108ab(t.result) && $6c85c32373d4b5cd$export$fce6876652108ab(t.error) || !$6c85c32373d4b5cd$export$d6781b696a0576d1(t.id, !1) || !$6c85c32373d4b5cd$export$ee898ca48ab56c74(t.jsonrpc, !1));
}
function $6c85c32373d4b5cd$export$cbe4cdc5960cfa11(t) {
    return !($6c85c32373d4b5cd$export$fce6876652108ab(t) || !$6c85c32373d4b5cd$export$ee898ca48ab56c74(t.name, !1));
}
function $6c85c32373d4b5cd$export$144fc36610eb6522(t, e) {
    return !(!$6c85c32373d4b5cd$export$e544b39f0a22e47a(e) || !$6c85c32373d4b5cd$export$fb6db6038e742b14(t).includes(e));
}
function $6c85c32373d4b5cd$export$8db4804e3a6de711(t, e, n) {
    return $6c85c32373d4b5cd$export$ee898ca48ab56c74(n, !1) ? $6c85c32373d4b5cd$export$7dcf4808e17b15ac(t, e).includes(n) : !1;
}
function $6c85c32373d4b5cd$export$df2c67ef8baad16b(t, e, n) {
    return $6c85c32373d4b5cd$export$ee898ca48ab56c74(n, !1) ? $6c85c32373d4b5cd$export$94ee6d00e384a22(t, e).includes(n) : !1;
}
function $6c85c32373d4b5cd$export$ba5b0a4b585cd1b4(t, e, n) {
    let r = null;
    const o = $6c85c32373d4b5cd$var$Oa(t), i = $6c85c32373d4b5cd$var$Aa(e), s = Object.keys(o), c = Object.keys(i), a = $6c85c32373d4b5cd$var$Uo(Object.keys(t)), u = $6c85c32373d4b5cd$var$Uo(Object.keys(e)), l = a.filter((f)=>!u.includes(f));
    return l.length && (r = $6c85c32373d4b5cd$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces keys don't satisfy requiredNamespaces.
      Required: ${l.toString()}
      Received: ${Object.keys(e).toString()}`)), $6c85c32373d4b5cd$export$1468a49de573f7f9(s, c) || (r = $6c85c32373d4b5cd$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces chains don't satisfy required namespaces.
      Required: ${s.toString()}
      Approved: ${c.toString()}`)), Object.keys(e).forEach((f)=>{
        if (!f.includes(":") || r) return;
        const h = $6c85c32373d4b5cd$export$d46695d9c3664fe9(e[f].accounts);
        h.includes(f) || (r = $6c85c32373d4b5cd$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces accounts don't satisfy namespace accounts for ${f}
        Required: ${f}
        Approved: ${h.toString()}`));
    }), s.forEach((f)=>{
        r || ($6c85c32373d4b5cd$export$1468a49de573f7f9(o[f].methods, i[f].methods) ? $6c85c32373d4b5cd$export$1468a49de573f7f9(o[f].events, i[f].events) || (r = $6c85c32373d4b5cd$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces events don't satisfy namespace events for ${f}`)) : r = $6c85c32373d4b5cd$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${n} namespaces methods don't satisfy namespace methods for ${f}`));
    }), r;
}
function $6c85c32373d4b5cd$var$Oa(t) {
    const e = {};
    return Object.keys(t).forEach((n)=>{
        var r;
        n.includes(":") ? e[n] = t[n] : (r = t[n].chains) == null || r.forEach((o)=>{
            e[o] = {
                methods: t[n].methods,
                events: t[n].events
            };
        });
    }), e;
}
function $6c85c32373d4b5cd$var$Uo(t) {
    return [
        ...new Set(t.map((e)=>e.includes(":") ? e.split(":")[0] : e))
    ];
}
function $6c85c32373d4b5cd$var$Aa(t) {
    const e = {};
    return Object.keys(t).forEach((n)=>{
        if (n.includes(":")) e[n] = t[n];
        else {
            const r = $6c85c32373d4b5cd$export$d46695d9c3664fe9(t[n].accounts);
            r?.forEach((o)=>{
                e[o] = {
                    accounts: t[n].accounts.filter((i)=>i.includes(`${o}:`)),
                    methods: t[n].methods,
                    events: t[n].events
                };
            });
        }
    }), e;
}
function $6c85c32373d4b5cd$export$59fba2af1ac782b(t, e) {
    return $6c85c32373d4b5cd$export$d6781b696a0576d1(t, !1) && t <= e.max && t >= e.min;
}
function $6c85c32373d4b5cd$export$53c2fd0173ad2b80() {
    const t = $6c85c32373d4b5cd$export$57570b1603cf6adb();
    return new Promise((e)=>{
        switch(t){
            case $6c85c32373d4b5cd$export$86b1301a63b15dd9.browser:
                e($6c85c32373d4b5cd$export$2f147c609a999e49());
                break;
            case $6c85c32373d4b5cd$export$86b1301a63b15dd9.reactNative:
                e($6c85c32373d4b5cd$export$1444c95b1570bd12());
                break;
            case $6c85c32373d4b5cd$export$86b1301a63b15dd9.node:
                e($6c85c32373d4b5cd$export$aec5b2d627eec500());
                break;
            default:
                e(!0);
        }
    });
}
function $6c85c32373d4b5cd$export$2f147c609a999e49() {
    return $6c85c32373d4b5cd$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $6c85c32373d4b5cd$export$1444c95b1570bd12() {
    if ($6c85c32373d4b5cd$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const t = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return t?.isConnected;
    }
    return !0;
}
function $6c85c32373d4b5cd$export$aec5b2d627eec500() {
    return !0;
}
function $6c85c32373d4b5cd$export$600a1ee4bc680996(t) {
    switch($6c85c32373d4b5cd$export$57570b1603cf6adb()){
        case $6c85c32373d4b5cd$export$86b1301a63b15dd9.browser:
            $6c85c32373d4b5cd$export$d32b24f18d96c5f2(t);
            break;
        case $6c85c32373d4b5cd$export$86b1301a63b15dd9.reactNative:
            $6c85c32373d4b5cd$export$904edb1c18ec91c7(t);
            break;
        case $6c85c32373d4b5cd$export$86b1301a63b15dd9.node:
            break;
    }
}
function $6c85c32373d4b5cd$export$d32b24f18d96c5f2(t) {
    !$6c85c32373d4b5cd$export$f7a1e23e542d38e3() && $6c85c32373d4b5cd$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>t(!0)), window.addEventListener("offline", ()=>t(!1)));
}
function $6c85c32373d4b5cd$export$904edb1c18ec91c7(t) {
    $6c85c32373d4b5cd$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((e)=>t(e?.isConnected));
}
const $6c85c32373d4b5cd$var$bn = {};
class $6c85c32373d4b5cd$export$b72d712fed4d036d {
    static get(e) {
        return $6c85c32373d4b5cd$var$bn[e];
    }
    static set(e, n) {
        $6c85c32373d4b5cd$var$bn[e] = n;
    }
    static delete(e) {
        delete $6c85c32373d4b5cd$var$bn[e];
    }
}

});
parcelRegister("8VG1E", function(module, exports) {

$parcel$export(module.exports, "detect", function () { return $68043f01e1e5164d$export$17b446b869dad473; });

var $17tgv = parcelRequire("17tgv");
var $68043f01e1e5164d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $68043f01e1e5164d$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $68043f01e1e5164d$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $17tgv.platform;
    }
    return NodeInfo;
}();
var $68043f01e1e5164d$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $68043f01e1e5164d$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $68043f01e1e5164d$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $68043f01e1e5164d$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $68043f01e1e5164d$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $68043f01e1e5164d$var$REQUIRED_VERSION_PARTS = 3;
var $68043f01e1e5164d$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $68043f01e1e5164d$var$SEARCHBOX_UA_REGEX
    ]
];
var $68043f01e1e5164d$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $68043f01e1e5164d$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $68043f01e1e5164d$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $68043f01e1e5164d$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $68043f01e1e5164d$export$1184956100eddc3c(navigator.userAgent);
    return $68043f01e1e5164d$export$bf2c6630ab904918();
}
function $68043f01e1e5164d$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $68043f01e1e5164d$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $68043f01e1e5164d$export$89ca9f8ca1a50fd5(ua) {
    var data = $68043f01e1e5164d$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $68043f01e1e5164d$export$1184956100eddc3c(ua) {
    var matchedRule = $68043f01e1e5164d$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $68043f01e1e5164d$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $68043f01e1e5164d$var$REQUIRED_VERSION_PARTS) versionParts = $68043f01e1e5164d$var$__spreadArray($68043f01e1e5164d$var$__spreadArray([], versionParts, true), $68043f01e1e5164d$var$createVersionParts($68043f01e1e5164d$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $68043f01e1e5164d$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $68043f01e1e5164d$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $68043f01e1e5164d$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $68043f01e1e5164d$export$8fa985da04a86f0(name, version, os);
}
function $68043f01e1e5164d$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $68043f01e1e5164d$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $68043f01e1e5164d$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $68043f01e1e5164d$export$bf2c6630ab904918() {
    var isNode = typeof $17tgv !== "undefined" && $17tgv.version;
    return isNode ? new $68043f01e1e5164d$export$62457c674e0167c0($17tgv.version.slice(1)) : null;
}
function $68043f01e1e5164d$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});

parcelRegister("2TjUJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aQDsN = parcelRequire("aQDsN");

$aQDsN.__exportStar((parcelRequire("ekCNn")), module.exports);

$aQDsN.__exportStar((parcelRequire("bnRfG")), module.exports);

$aQDsN.__exportStar((parcelRequire("ihvNm")), module.exports);

$aQDsN.__exportStar((parcelRequire("qZVIE")), module.exports);

});
parcelRegister("aQDsN", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $7e5d5f55f5ac48e7$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7e5d5f55f5ac48e7$var$extendStatics = function(d, b) {
    $7e5d5f55f5ac48e7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7e5d5f55f5ac48e7$var$extendStatics(d, b);
};
function $7e5d5f55f5ac48e7$export$a8ba968b8961cb8a(d, b) {
    $7e5d5f55f5ac48e7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7e5d5f55f5ac48e7$export$18ce0697a983be9b = function() {
    $7e5d5f55f5ac48e7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e5d5f55f5ac48e7$export$18ce0697a983be9b.apply(this, arguments);
};
function $7e5d5f55f5ac48e7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7e5d5f55f5ac48e7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7e5d5f55f5ac48e7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7e5d5f55f5ac48e7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7e5d5f55f5ac48e7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7e5d5f55f5ac48e7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7e5d5f55f5ac48e7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $7e5d5f55f5ac48e7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7e5d5f55f5ac48e7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7e5d5f55f5ac48e7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7e5d5f55f5ac48e7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7e5d5f55f5ac48e7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7e5d5f55f5ac48e7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7e5d5f55f5ac48e7$export$10c90e4f7922046c(v) {
    return this instanceof $7e5d5f55f5ac48e7$export$10c90e4f7922046c ? (this.v = v, this) : new $7e5d5f55f5ac48e7$export$10c90e4f7922046c(v);
}
function $7e5d5f55f5ac48e7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7e5d5f55f5ac48e7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7e5d5f55f5ac48e7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7e5d5f55f5ac48e7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7e5d5f55f5ac48e7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7e5d5f55f5ac48e7$export$19a8beecd37a4c45 === "function" ? $7e5d5f55f5ac48e7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7e5d5f55f5ac48e7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7e5d5f55f5ac48e7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7e5d5f55f5ac48e7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7e5d5f55f5ac48e7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7e5d5f55f5ac48e7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("ekCNn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aQDsN = parcelRequire("aQDsN");

$aQDsN.__exportStar((parcelRequire("5l31a")), module.exports);

$aQDsN.__exportStar((parcelRequire("bEkqp")), module.exports);

});
parcelRegister("5l31a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $3e314135e30f50be$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $3e314135e30f50be$var$delay;

});

parcelRegister("bEkqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $qZVIE = parcelRequire("qZVIE");
function $87b34615da871dd0$var$toMiliseconds(seconds) {
    return seconds * $qZVIE.ONE_THOUSAND;
}
module.exports.toMiliseconds = $87b34615da871dd0$var$toMiliseconds;
function $87b34615da871dd0$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $qZVIE.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $87b34615da871dd0$var$fromMiliseconds;

});
parcelRegister("qZVIE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aQDsN = parcelRequire("aQDsN");

$aQDsN.__exportStar((parcelRequire("eGIew")), module.exports);

$aQDsN.__exportStar((parcelRequire("hQies")), module.exports);

});
parcelRegister("eGIew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("hQies", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("bnRfG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $849b266cb55a667e$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $849b266cb55a667e$var$Watch;
module.exports.default = $849b266cb55a667e$var$Watch;

});

parcelRegister("ihvNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aQDsN = parcelRequire("aQDsN");

$aQDsN.__exportStar((parcelRequire("eWp0Z")), module.exports);

});
parcelRegister("eWp0Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $ae09e2e5aed823a1$var$IWatch {
}
module.exports.IWatch = $ae09e2e5aed823a1$var$IWatch;

});



parcelRegister("f4uqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $af8ed587f758b6f2$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $af8ed587f758b6f2$var$getFromWindow;
function $af8ed587f758b6f2$var$getFromWindowOrThrow(name) {
    const res = $af8ed587f758b6f2$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
module.exports.getFromWindowOrThrow = $af8ed587f758b6f2$var$getFromWindowOrThrow;
function $af8ed587f758b6f2$var$getDocumentOrThrow() {
    return $af8ed587f758b6f2$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $af8ed587f758b6f2$var$getDocumentOrThrow;
function $af8ed587f758b6f2$var$getDocument() {
    return $af8ed587f758b6f2$var$getFromWindow("document");
}
module.exports.getDocument = $af8ed587f758b6f2$var$getDocument;
function $af8ed587f758b6f2$var$getNavigatorOrThrow() {
    return $af8ed587f758b6f2$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $af8ed587f758b6f2$var$getNavigatorOrThrow;
function $af8ed587f758b6f2$var$getNavigator() {
    return $af8ed587f758b6f2$var$getFromWindow("navigator");
}
module.exports.getNavigator = $af8ed587f758b6f2$var$getNavigator;
function $af8ed587f758b6f2$var$getLocationOrThrow() {
    return $af8ed587f758b6f2$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $af8ed587f758b6f2$var$getLocationOrThrow;
function $af8ed587f758b6f2$var$getLocation() {
    return $af8ed587f758b6f2$var$getFromWindow("location");
}
module.exports.getLocation = $af8ed587f758b6f2$var$getLocation;
function $af8ed587f758b6f2$var$getCryptoOrThrow() {
    return $af8ed587f758b6f2$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $af8ed587f758b6f2$var$getCryptoOrThrow;
function $af8ed587f758b6f2$var$getCrypto() {
    return $af8ed587f758b6f2$var$getFromWindow("crypto");
}
module.exports.getCrypto = $af8ed587f758b6f2$var$getCrypto;
function $af8ed587f758b6f2$var$getLocalStorageOrThrow() {
    return $af8ed587f758b6f2$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $af8ed587f758b6f2$var$getLocalStorageOrThrow;
function $af8ed587f758b6f2$var$getLocalStorage() {
    return $af8ed587f758b6f2$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $af8ed587f758b6f2$var$getLocalStorage;

});

parcelRegister("75xMO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $f4uqJ = parcelRequire("f4uqJ");
function $5293354772fcd975$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $f4uqJ.getDocumentOrThrow();
        loc = $f4uqJ.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $5293354772fcd975$var$getWindowMetadata;

});

parcelRegister("gi8t9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc4e596d245f3d1$export$2e2bcd8739ae039; });

var $ln6rp = parcelRequire("ln6rp");
var $bdc4e596d245f3d1$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $bdc4e596d245f3d1$export$2e2bcd8739ae039 = (0, $ln6rp.default)($bdc4e596d245f3d1$var$ALPHABET);

});
parcelRegister("ln6rp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8f0be0104dcd00c$export$2e2bcd8739ae039; });
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $f8f0be0104dcd00c$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    const BASE_MAP = new Uint8Array(256);
    for(let j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(let i = 0; i < ALPHABET.length; i++){
        const x = ALPHABET.charAt(i);
        const xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    const BASE = ALPHABET.length;
    const LEADER = ALPHABET.charAt(0);
    const FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    const iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        let zeroes = 0;
        let length = 0;
        let pbegin = 0;
        const pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        const size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        const b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            let carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            let i = 0;
            for(let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        let it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        let str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        let psz = 0;
        // Skip and count leading '1's.
        let zeroes = 0;
        let length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        const size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        const b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            const charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            let carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            let i = 0;
            for(let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        let it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        const vch = new Uint8Array(zeroes + (size - it4));
        let j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        const buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $f8f0be0104dcd00c$export$2e2bcd8739ae039 = $f8f0be0104dcd00c$var$base;

});


parcelRegister("islmt", function(module, exports) {

$parcel$export(module.exports, "encodeIss", function () { return $d6fb6971f474fbcf$export$1b29ef9371459e10; });
$parcel$export(module.exports, "decodeJWT", function () { return $d6fb6971f474fbcf$export$9a62e6c0a30e00bc; });
$parcel$export(module.exports, "generateKeyPair", function () { return $d6fb6971f474fbcf$export$a949d36eab55b41f; });
$parcel$export(module.exports, "signJWT", function () { return $d6fb6971f474fbcf$export$a8dda30659d36d45; });

var $2TjUJ = parcelRequire("2TjUJ");

var $4yffS = parcelRequire("4yffS");
function $d6fb6971f474fbcf$var$En(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $d6fb6971f474fbcf$var$fe(t, ...e) {
    if (!$d6fb6971f474fbcf$var$En(t)) throw new Error("Uint8Array expected");
    if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function $d6fb6971f474fbcf$var$De(t, e = !0) {
    if (t.destroyed) throw new Error("Hash instance has been destroyed");
    if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function $d6fb6971f474fbcf$var$gn(t, e) {
    $d6fb6971f474fbcf$var$fe(t);
    const n = e.outputLen;
    if (t.length < n) throw new Error("digestInto() expects output buffer of length at least " + n);
}
const $d6fb6971f474fbcf$var$it = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0; /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $d6fb6971f474fbcf$var$_t = (t)=>new DataView(t.buffer, t.byteOffset, t.byteLength);
function $d6fb6971f474fbcf$var$yn(t) {
    if (typeof t != "string") throw new Error("utf8ToBytes expected string, got " + typeof t);
    return new Uint8Array(new TextEncoder().encode(t));
}
function $d6fb6971f474fbcf$var$de(t) {
    return typeof t == "string" && (t = $d6fb6971f474fbcf$var$yn(t)), $d6fb6971f474fbcf$var$fe(t), t;
}
class $d6fb6971f474fbcf$var$xn {
    clone() {
        return this._cloneInto();
    }
}
function $d6fb6971f474fbcf$var$Bn(t) {
    const e = (r)=>t().update($d6fb6971f474fbcf$var$de(r)).digest(), n = t();
    return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = ()=>t(), e;
}
function $d6fb6971f474fbcf$var$he(t = 32) {
    if ($d6fb6971f474fbcf$var$it && typeof $d6fb6971f474fbcf$var$it.getRandomValues == "function") return $d6fb6971f474fbcf$var$it.getRandomValues(new Uint8Array(t));
    if ($d6fb6971f474fbcf$var$it && typeof $d6fb6971f474fbcf$var$it.randomBytes == "function") return $d6fb6971f474fbcf$var$it.randomBytes(t);
    throw new Error("crypto.getRandomValues must be defined");
}
function $d6fb6971f474fbcf$var$Cn(t, e, n, r) {
    if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, n, r);
    const o = BigInt(32), s = BigInt(4294967295), a = Number(n >> o & s), u = Number(n & s), i = r ? 4 : 0, D = r ? 0 : 4;
    t.setUint32(e + i, a, r), t.setUint32(e + D, u, r);
}
class $d6fb6971f474fbcf$var$An extends $d6fb6971f474fbcf$var$xn {
    constructor(e, n, r, o){
        super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $d6fb6971f474fbcf$var$_t(this.buffer);
    }
    update(e) {
        $d6fb6971f474fbcf$var$De(this);
        const { view: n, buffer: r, blockLen: o } = this;
        e = $d6fb6971f474fbcf$var$de(e);
        const s = e.length;
        for(let a = 0; a < s;){
            const u = Math.min(o - this.pos, s - a);
            if (u === o) {
                const i = $d6fb6971f474fbcf$var$_t(e);
                for(; o <= s - a; a += o)this.process(i, a);
                continue;
            }
            r.set(e.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(n, 0), this.pos = 0);
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        $d6fb6971f474fbcf$var$De(this), $d6fb6971f474fbcf$var$gn(e, this), this.finished = !0;
        const { buffer: n, view: r, blockLen: o, isLE: s } = this;
        let { pos: a } = this;
        n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(r, 0), a = 0);
        for(let l = a; l < o; l++)n[l] = 0;
        $d6fb6971f474fbcf$var$Cn(r, o - 8, BigInt(this.length * 8), s), this.process(r, 0);
        const u = $d6fb6971f474fbcf$var$_t(e), i = this.outputLen;
        if (i % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const D = i / 4, c = this.get();
        if (D > c.length) throw new Error("_sha2: outputLen bigger than state");
        for(let l = 0; l < D; l++)u.setUint32(4 * l, c[l], s);
    }
    digest() {
        const { buffer: e, outputLen: n } = this;
        this.digestInto(e);
        const r = e.slice(0, n);
        return this.destroy(), r;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: n, buffer: r, length: o, finished: s, destroyed: a, pos: u } = this;
        return e.length = o, e.pos = u, e.finished = s, e.destroyed = a, o % n && e.buffer.set(r), e;
    }
}
const $d6fb6971f474fbcf$var$wt = BigInt(2 ** 32 - 1), $d6fb6971f474fbcf$var$St = BigInt(32);
function $d6fb6971f474fbcf$var$le(t, e = !1) {
    return e ? {
        h: Number(t & $d6fb6971f474fbcf$var$wt),
        l: Number(t >> $d6fb6971f474fbcf$var$St & $d6fb6971f474fbcf$var$wt)
    } : {
        h: Number(t >> $d6fb6971f474fbcf$var$St & $d6fb6971f474fbcf$var$wt) | 0,
        l: Number(t & $d6fb6971f474fbcf$var$wt) | 0
    };
}
function $d6fb6971f474fbcf$var$mn(t, e = !1) {
    let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
    for(let o = 0; o < t.length; o++){
        const { h: s, l: a } = $d6fb6971f474fbcf$var$le(t[o], e);
        [n[o], r[o]] = [
            s,
            a
        ];
    }
    return [
        n,
        r
    ];
}
const $d6fb6971f474fbcf$var$_n = (t, e)=>BigInt(t >>> 0) << $d6fb6971f474fbcf$var$St | BigInt(e >>> 0), $d6fb6971f474fbcf$var$Sn = (t, e, n)=>t >>> n, $d6fb6971f474fbcf$var$vn = (t, e, n)=>t << 32 - n | e >>> n, $d6fb6971f474fbcf$var$In = (t, e, n)=>t >>> n | e << 32 - n, $d6fb6971f474fbcf$var$Un = (t, e, n)=>t << 32 - n | e >>> n, $d6fb6971f474fbcf$var$Tn = (t, e, n)=>t << 64 - n | e >>> n - 32, $d6fb6971f474fbcf$var$Fn = (t, e, n)=>t >>> n - 32 | e << 64 - n, $d6fb6971f474fbcf$var$Nn = (t, e)=>e, $d6fb6971f474fbcf$var$Ln = (t, e)=>t, $d6fb6971f474fbcf$var$On = (t, e, n)=>t << n | e >>> 32 - n, $d6fb6971f474fbcf$var$Hn = (t, e, n)=>e << n | t >>> 32 - n, $d6fb6971f474fbcf$var$zn = (t, e, n)=>e << n - 32 | t >>> 64 - n, $d6fb6971f474fbcf$var$Mn = (t, e, n)=>t << n - 32 | e >>> 64 - n;
function $d6fb6971f474fbcf$var$qn(t, e, n, r) {
    const o = (e >>> 0) + (r >>> 0);
    return {
        h: t + n + (o / 2 ** 32 | 0) | 0,
        l: o | 0
    };
}
const $d6fb6971f474fbcf$var$$n = (t, e, n)=>(t >>> 0) + (e >>> 0) + (n >>> 0), $d6fb6971f474fbcf$var$kn = (t, e, n, r)=>e + n + r + (t / 2 ** 32 | 0) | 0, $d6fb6971f474fbcf$var$Rn = (t, e, n, r)=>(t >>> 0) + (e >>> 0) + (n >>> 0) + (r >>> 0), $d6fb6971f474fbcf$var$jn = (t, e, n, r, o)=>e + n + r + o + (t / 2 ** 32 | 0) | 0, $d6fb6971f474fbcf$var$Zn = (t, e, n, r, o)=>(t >>> 0) + (e >>> 0) + (n >>> 0) + (r >>> 0) + (o >>> 0), $d6fb6971f474fbcf$var$Gn = (t, e, n, r, o, s)=>e + n + r + o + s + (t / 2 ** 32 | 0) | 0, $d6fb6971f474fbcf$var$x = {
    fromBig: $d6fb6971f474fbcf$var$le,
    split: $d6fb6971f474fbcf$var$mn,
    toBig: $d6fb6971f474fbcf$var$_n,
    shrSH: $d6fb6971f474fbcf$var$Sn,
    shrSL: $d6fb6971f474fbcf$var$vn,
    rotrSH: $d6fb6971f474fbcf$var$In,
    rotrSL: $d6fb6971f474fbcf$var$Un,
    rotrBH: $d6fb6971f474fbcf$var$Tn,
    rotrBL: $d6fb6971f474fbcf$var$Fn,
    rotr32H: $d6fb6971f474fbcf$var$Nn,
    rotr32L: $d6fb6971f474fbcf$var$Ln,
    rotlSH: $d6fb6971f474fbcf$var$On,
    rotlSL: $d6fb6971f474fbcf$var$Hn,
    rotlBH: $d6fb6971f474fbcf$var$zn,
    rotlBL: $d6fb6971f474fbcf$var$Mn,
    add: $d6fb6971f474fbcf$var$qn,
    add3L: $d6fb6971f474fbcf$var$$n,
    add3H: $d6fb6971f474fbcf$var$kn,
    add4L: $d6fb6971f474fbcf$var$Rn,
    add4H: $d6fb6971f474fbcf$var$jn,
    add5H: $d6fb6971f474fbcf$var$Gn,
    add5L: $d6fb6971f474fbcf$var$Zn
}, [$d6fb6971f474fbcf$var$Vn, $d6fb6971f474fbcf$var$Yn] = (()=>$d6fb6971f474fbcf$var$x.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((t)=>BigInt(t))))(), $d6fb6971f474fbcf$var$P = new Uint32Array(80), $d6fb6971f474fbcf$var$Q = new Uint32Array(80);
class $d6fb6971f474fbcf$var$Jn extends $d6fb6971f474fbcf$var$An {
    constructor(){
        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    get() {
        const { Ah: e, Al: n, Bh: r, Bl: o, Ch: s, Cl: a, Dh: u, Dl: i, Eh: D, El: c, Fh: l, Fl: p, Gh: w, Gl: h, Hh: g, Hl: S } = this;
        return [
            e,
            n,
            r,
            o,
            s,
            a,
            u,
            i,
            D,
            c,
            l,
            p,
            w,
            h,
            g,
            S
        ];
    }
    set(e, n, r, o, s, a, u, i, D, c, l, p, w, h, g, S) {
        this.Ah = e | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = o | 0, this.Ch = s | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = i | 0, this.Eh = D | 0, this.El = c | 0, this.Fh = l | 0, this.Fl = p | 0, this.Gh = w | 0, this.Gl = h | 0, this.Hh = g | 0, this.Hl = S | 0;
    }
    process(e, n) {
        for(let d = 0; d < 16; d++, n += 4)$d6fb6971f474fbcf$var$P[d] = e.getUint32(n), $d6fb6971f474fbcf$var$Q[d] = e.getUint32(n += 4);
        for(let d = 16; d < 80; d++){
            const m = $d6fb6971f474fbcf$var$P[d - 15] | 0, F = $d6fb6971f474fbcf$var$Q[d - 15] | 0, q = $d6fb6971f474fbcf$var$x.rotrSH(m, F, 1) ^ $d6fb6971f474fbcf$var$x.rotrSH(m, F, 8) ^ $d6fb6971f474fbcf$var$x.shrSH(m, F, 7), z = $d6fb6971f474fbcf$var$x.rotrSL(m, F, 1) ^ $d6fb6971f474fbcf$var$x.rotrSL(m, F, 8) ^ $d6fb6971f474fbcf$var$x.shrSL(m, F, 7), I = $d6fb6971f474fbcf$var$P[d - 2] | 0, O = $d6fb6971f474fbcf$var$Q[d - 2] | 0, ot = $d6fb6971f474fbcf$var$x.rotrSH(I, O, 19) ^ $d6fb6971f474fbcf$var$x.rotrBH(I, O, 61) ^ $d6fb6971f474fbcf$var$x.shrSH(I, O, 6), tt = $d6fb6971f474fbcf$var$x.rotrSL(I, O, 19) ^ $d6fb6971f474fbcf$var$x.rotrBL(I, O, 61) ^ $d6fb6971f474fbcf$var$x.shrSL(I, O, 6), st = $d6fb6971f474fbcf$var$x.add4L(z, tt, $d6fb6971f474fbcf$var$Q[d - 7], $d6fb6971f474fbcf$var$Q[d - 16]), at = $d6fb6971f474fbcf$var$x.add4H(st, q, ot, $d6fb6971f474fbcf$var$P[d - 7], $d6fb6971f474fbcf$var$P[d - 16]);
            $d6fb6971f474fbcf$var$P[d] = at | 0, $d6fb6971f474fbcf$var$Q[d] = st | 0;
        }
        let { Ah: r, Al: o, Bh: s, Bl: a, Ch: u, Cl: i, Dh: D, Dl: c, Eh: l, El: p, Fh: w, Fl: h, Gh: g, Gl: S, Hh: v, Hl: L } = this;
        for(let d = 0; d < 80; d++){
            const m = $d6fb6971f474fbcf$var$x.rotrSH(l, p, 14) ^ $d6fb6971f474fbcf$var$x.rotrSH(l, p, 18) ^ $d6fb6971f474fbcf$var$x.rotrBH(l, p, 41), F = $d6fb6971f474fbcf$var$x.rotrSL(l, p, 14) ^ $d6fb6971f474fbcf$var$x.rotrSL(l, p, 18) ^ $d6fb6971f474fbcf$var$x.rotrBL(l, p, 41), q = l & w ^ ~l & g, z = p & h ^ ~p & S, I = $d6fb6971f474fbcf$var$x.add5L(L, F, z, $d6fb6971f474fbcf$var$Yn[d], $d6fb6971f474fbcf$var$Q[d]), O = $d6fb6971f474fbcf$var$x.add5H(I, v, m, q, $d6fb6971f474fbcf$var$Vn[d], $d6fb6971f474fbcf$var$P[d]), ot = I | 0, tt = $d6fb6971f474fbcf$var$x.rotrSH(r, o, 28) ^ $d6fb6971f474fbcf$var$x.rotrBH(r, o, 34) ^ $d6fb6971f474fbcf$var$x.rotrBH(r, o, 39), st = $d6fb6971f474fbcf$var$x.rotrSL(r, o, 28) ^ $d6fb6971f474fbcf$var$x.rotrBL(r, o, 34) ^ $d6fb6971f474fbcf$var$x.rotrBL(r, o, 39), at = r & s ^ r & u ^ s & u, Ct = o & a ^ o & i ^ a & i;
            v = g | 0, L = S | 0, g = w | 0, S = h | 0, w = l | 0, h = p | 0, ({ h: l, l: p } = $d6fb6971f474fbcf$var$x.add(D | 0, c | 0, O | 0, ot | 0)), D = u | 0, c = i | 0, u = s | 0, i = a | 0, s = r | 0, a = o | 0;
            const At = $d6fb6971f474fbcf$var$x.add3L(ot, st, Ct);
            r = $d6fb6971f474fbcf$var$x.add3H(At, O, tt, at), o = At | 0;
        }
        ({ h: r, l: o } = $d6fb6971f474fbcf$var$x.add(this.Ah | 0, this.Al | 0, r | 0, o | 0)), ({ h: s, l: a } = $d6fb6971f474fbcf$var$x.add(this.Bh | 0, this.Bl | 0, s | 0, a | 0)), ({ h: u, l: i } = $d6fb6971f474fbcf$var$x.add(this.Ch | 0, this.Cl | 0, u | 0, i | 0)), ({ h: D, l: c } = $d6fb6971f474fbcf$var$x.add(this.Dh | 0, this.Dl | 0, D | 0, c | 0)), ({ h: l, l: p } = $d6fb6971f474fbcf$var$x.add(this.Eh | 0, this.El | 0, l | 0, p | 0)), ({ h: w, l: h } = $d6fb6971f474fbcf$var$x.add(this.Fh | 0, this.Fl | 0, w | 0, h | 0)), ({ h: g, l: S } = $d6fb6971f474fbcf$var$x.add(this.Gh | 0, this.Gl | 0, g | 0, S | 0)), ({ h: v, l: L } = $d6fb6971f474fbcf$var$x.add(this.Hh | 0, this.Hl | 0, v | 0, L | 0)), this.set(r, o, s, a, u, i, D, c, l, p, w, h, g, S, v, L);
    }
    roundClean() {
        $d6fb6971f474fbcf$var$P.fill(0), $d6fb6971f474fbcf$var$Q.fill(0);
    }
    destroy() {
        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
const $d6fb6971f474fbcf$var$Kn = $d6fb6971f474fbcf$var$Bn(()=>new $d6fb6971f474fbcf$var$Jn); /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $d6fb6971f474fbcf$var$vt = BigInt(0), $d6fb6971f474fbcf$var$be = BigInt(1), $d6fb6971f474fbcf$var$Wn = BigInt(2);
function $d6fb6971f474fbcf$var$It(t) {
    return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function $d6fb6971f474fbcf$var$Ut(t) {
    if (!$d6fb6971f474fbcf$var$It(t)) throw new Error("Uint8Array expected");
}
function $d6fb6971f474fbcf$var$Tt(t, e) {
    if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
const $d6fb6971f474fbcf$var$Xn = Array.from({
    length: 256
}, (t, e)=>e.toString(16).padStart(2, "0"));
function $d6fb6971f474fbcf$var$Ft(t) {
    $d6fb6971f474fbcf$var$Ut(t);
    let e = "";
    for(let n = 0; n < t.length; n++)e += $d6fb6971f474fbcf$var$Xn[t[n]];
    return e;
}
function $d6fb6971f474fbcf$var$pe(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    return t === "" ? $d6fb6971f474fbcf$var$vt : BigInt("0x" + t);
}
const $d6fb6971f474fbcf$var$K = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $d6fb6971f474fbcf$var$we(t) {
    if (t >= $d6fb6971f474fbcf$var$K._0 && t <= $d6fb6971f474fbcf$var$K._9) return t - $d6fb6971f474fbcf$var$K._0;
    if (t >= $d6fb6971f474fbcf$var$K.A && t <= $d6fb6971f474fbcf$var$K.F) return t - ($d6fb6971f474fbcf$var$K.A - 10);
    if (t >= $d6fb6971f474fbcf$var$K.a && t <= $d6fb6971f474fbcf$var$K.f) return t - ($d6fb6971f474fbcf$var$K.a - 10);
}
function $d6fb6971f474fbcf$var$Ee(t) {
    if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
    const e = t.length, n = e / 2;
    if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
    const r = new Uint8Array(n);
    for(let o = 0, s = 0; o < n; o++, s += 2){
        const a = $d6fb6971f474fbcf$var$we(t.charCodeAt(s)), u = $d6fb6971f474fbcf$var$we(t.charCodeAt(s + 1));
        if (a === void 0 || u === void 0) {
            const i = t[s] + t[s + 1];
            throw new Error('hex string expected, got non-hex character "' + i + '" at index ' + s);
        }
        r[o] = a * 16 + u;
    }
    return r;
}
function $d6fb6971f474fbcf$var$Pn(t) {
    return $d6fb6971f474fbcf$var$pe($d6fb6971f474fbcf$var$Ft(t));
}
function $d6fb6971f474fbcf$var$Et(t) {
    return $d6fb6971f474fbcf$var$Ut(t), $d6fb6971f474fbcf$var$pe($d6fb6971f474fbcf$var$Ft(Uint8Array.from(t).reverse()));
}
function $d6fb6971f474fbcf$var$ge(t, e) {
    return $d6fb6971f474fbcf$var$Ee(t.toString(16).padStart(e * 2, "0"));
}
function $d6fb6971f474fbcf$var$Nt(t, e) {
    return $d6fb6971f474fbcf$var$ge(t, e).reverse();
}
function $d6fb6971f474fbcf$var$W(t, e, n) {
    let r;
    if (typeof e == "string") try {
        r = $d6fb6971f474fbcf$var$Ee(e);
    } catch (s) {
        throw new Error(t + " must be hex string or Uint8Array, cause: " + s);
    }
    else if ($d6fb6971f474fbcf$var$It(e)) r = Uint8Array.from(e);
    else throw new Error(t + " must be hex string or Uint8Array");
    const o = r.length;
    if (typeof n == "number" && o !== n) throw new Error(t + " of length " + n + " expected, got " + o);
    return r;
}
function $d6fb6971f474fbcf$var$ye(...t) {
    let e = 0;
    for(let r = 0; r < t.length; r++){
        const o = t[r];
        $d6fb6971f474fbcf$var$Ut(o), e += o.length;
    }
    const n = new Uint8Array(e);
    for(let r = 0, o = 0; r < t.length; r++){
        const s = t[r];
        n.set(s, o), o += s.length;
    }
    return n;
}
const $d6fb6971f474fbcf$var$Lt = (t)=>typeof t == "bigint" && $d6fb6971f474fbcf$var$vt <= t;
function $d6fb6971f474fbcf$var$Qn(t, e, n) {
    return $d6fb6971f474fbcf$var$Lt(t) && $d6fb6971f474fbcf$var$Lt(e) && $d6fb6971f474fbcf$var$Lt(n) && e <= t && t < n;
}
function $d6fb6971f474fbcf$var$ft(t, e, n, r) {
    if (!$d6fb6971f474fbcf$var$Qn(e, n, r)) throw new Error("expected valid " + t + ": " + n + " <= n < " + r + ", got " + e);
}
function $d6fb6971f474fbcf$var$tr(t) {
    let e;
    for(e = 0; t > $d6fb6971f474fbcf$var$vt; t >>= $d6fb6971f474fbcf$var$be, e += 1);
    return e;
}
const $d6fb6971f474fbcf$var$er = (t)=>($d6fb6971f474fbcf$var$Wn << BigInt(t - 1)) - $d6fb6971f474fbcf$var$be, $d6fb6971f474fbcf$var$nr = {
    bigint: (t)=>typeof t == "bigint",
    function: (t)=>typeof t == "function",
    boolean: (t)=>typeof t == "boolean",
    string: (t)=>typeof t == "string",
    stringOrUint8Array: (t)=>typeof t == "string" || $d6fb6971f474fbcf$var$It(t),
    isSafeInteger: (t)=>Number.isSafeInteger(t),
    array: (t)=>Array.isArray(t),
    field: (t, e)=>e.Fp.isValid(t),
    hash: (t)=>typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function $d6fb6971f474fbcf$var$Ot(t, e, n = {}) {
    const r = (o, s, a)=>{
        const u = $d6fb6971f474fbcf$var$nr[s];
        if (typeof u != "function") throw new Error("invalid validator function");
        const i = t[o];
        if (!(a && i === void 0) && !u(i, t)) throw new Error("param " + String(o) + " is invalid. Expected " + s + ", got " + i);
    };
    for (const [o, s] of Object.entries(e))r(o, s, !1);
    for (const [o, s] of Object.entries(n))r(o, s, !0);
    return t;
}
function $d6fb6971f474fbcf$var$xe(t) {
    const e = new WeakMap;
    return (n, ...r)=>{
        const o = e.get(n);
        if (o !== void 0) return o;
        const s = t(n, ...r);
        return e.set(n, s), s;
    };
}
const $d6fb6971f474fbcf$var$M = BigInt(0), $d6fb6971f474fbcf$var$N = BigInt(1), $d6fb6971f474fbcf$var$nt = BigInt(2), $d6fb6971f474fbcf$var$rr = BigInt(3), $d6fb6971f474fbcf$var$Ht = BigInt(4), $d6fb6971f474fbcf$var$Be = BigInt(5), $d6fb6971f474fbcf$var$Ce = BigInt(8);
function $d6fb6971f474fbcf$var$H(t, e) {
    const n = t % e;
    return n >= $d6fb6971f474fbcf$var$M ? n : e + n;
}
function $d6fb6971f474fbcf$var$or(t, e, n) {
    if (e < $d6fb6971f474fbcf$var$M) throw new Error("invalid exponent, negatives unsupported");
    if (n <= $d6fb6971f474fbcf$var$M) throw new Error("invalid modulus");
    if (n === $d6fb6971f474fbcf$var$N) return $d6fb6971f474fbcf$var$M;
    let r = $d6fb6971f474fbcf$var$N;
    for(; e > $d6fb6971f474fbcf$var$M;)e & $d6fb6971f474fbcf$var$N && (r = r * t % n), t = t * t % n, e >>= $d6fb6971f474fbcf$var$N;
    return r;
}
function $d6fb6971f474fbcf$var$J(t, e, n) {
    let r = t;
    for(; e-- > $d6fb6971f474fbcf$var$M;)r *= r, r %= n;
    return r;
}
function $d6fb6971f474fbcf$var$Ae(t, e) {
    if (t === $d6fb6971f474fbcf$var$M) throw new Error("invert: expected non-zero number");
    if (e <= $d6fb6971f474fbcf$var$M) throw new Error("invert: expected positive modulus, got " + e);
    let n = $d6fb6971f474fbcf$var$H(t, e), r = e, o = $d6fb6971f474fbcf$var$M, s = $d6fb6971f474fbcf$var$N;
    for(; n !== $d6fb6971f474fbcf$var$M;){
        const u = r / n, i = r % n, D = o - s * u;
        r = n, n = i, o = s, s = D;
    }
    if (r !== $d6fb6971f474fbcf$var$N) throw new Error("invert: does not exist");
    return $d6fb6971f474fbcf$var$H(o, e);
}
function $d6fb6971f474fbcf$var$sr(t) {
    const e = (t - $d6fb6971f474fbcf$var$N) / $d6fb6971f474fbcf$var$nt;
    let n, r, o;
    for(n = t - $d6fb6971f474fbcf$var$N, r = 0; n % $d6fb6971f474fbcf$var$nt === $d6fb6971f474fbcf$var$M; n /= $d6fb6971f474fbcf$var$nt, r++);
    for(o = $d6fb6971f474fbcf$var$nt; o < t && $d6fb6971f474fbcf$var$or(o, e, t) !== t - $d6fb6971f474fbcf$var$N; o++)if (o > 1e3) throw new Error("Cannot find square root: likely non-prime P");
    if (r === 1) {
        const a = (t + $d6fb6971f474fbcf$var$N) / $d6fb6971f474fbcf$var$Ht;
        return function(i, D) {
            const c = i.pow(D, a);
            if (!i.eql(i.sqr(c), D)) throw new Error("Cannot find square root");
            return c;
        };
    }
    const s = (n + $d6fb6971f474fbcf$var$N) / $d6fb6971f474fbcf$var$nt;
    return function(u, i) {
        if (u.pow(i, e) === u.neg(u.ONE)) throw new Error("Cannot find square root");
        let D = r, c = u.pow(u.mul(u.ONE, o), n), l = u.pow(i, s), p = u.pow(i, n);
        for(; !u.eql(p, u.ONE);){
            if (u.eql(p, u.ZERO)) return u.ZERO;
            let w = 1;
            for(let g = u.sqr(p); w < D && !u.eql(g, u.ONE); w++)g = u.sqr(g);
            const h = u.pow(c, $d6fb6971f474fbcf$var$N << BigInt(D - w - 1));
            c = u.sqr(h), l = u.mul(l, h), p = u.mul(p, c), D = w;
        }
        return l;
    };
}
function $d6fb6971f474fbcf$var$ir(t) {
    if (t % $d6fb6971f474fbcf$var$Ht === $d6fb6971f474fbcf$var$rr) {
        const e = (t + $d6fb6971f474fbcf$var$N) / $d6fb6971f474fbcf$var$Ht;
        return function(r, o) {
            const s = r.pow(o, e);
            if (!r.eql(r.sqr(s), o)) throw new Error("Cannot find square root");
            return s;
        };
    }
    if (t % $d6fb6971f474fbcf$var$Ce === $d6fb6971f474fbcf$var$Be) {
        const e = (t - $d6fb6971f474fbcf$var$Be) / $d6fb6971f474fbcf$var$Ce;
        return function(r, o) {
            const s = r.mul(o, $d6fb6971f474fbcf$var$nt), a = r.pow(s, e), u = r.mul(o, a), i = r.mul(r.mul(u, $d6fb6971f474fbcf$var$nt), a), D = r.mul(u, r.sub(i, r.ONE));
            if (!r.eql(r.sqr(D), o)) throw new Error("Cannot find square root");
            return D;
        };
    }
    return $d6fb6971f474fbcf$var$sr(t);
}
const $d6fb6971f474fbcf$var$ur = (t, e)=>($d6fb6971f474fbcf$var$H(t, e) & $d6fb6971f474fbcf$var$N) === $d6fb6971f474fbcf$var$N, $d6fb6971f474fbcf$var$cr = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $d6fb6971f474fbcf$var$ar(t) {
    const e = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    }, n = $d6fb6971f474fbcf$var$cr.reduce((r, o)=>(r[o] = "function", r), e);
    return $d6fb6971f474fbcf$var$Ot(t, n);
}
function $d6fb6971f474fbcf$var$fr(t, e, n) {
    if (n < $d6fb6971f474fbcf$var$M) throw new Error("invalid exponent, negatives unsupported");
    if (n === $d6fb6971f474fbcf$var$M) return t.ONE;
    if (n === $d6fb6971f474fbcf$var$N) return e;
    let r = t.ONE, o = e;
    for(; n > $d6fb6971f474fbcf$var$M;)n & $d6fb6971f474fbcf$var$N && (r = t.mul(r, o)), o = t.sqr(o), n >>= $d6fb6971f474fbcf$var$N;
    return r;
}
function $d6fb6971f474fbcf$var$Dr(t, e) {
    const n = new Array(e.length), r = e.reduce((s, a, u)=>t.is0(a) ? s : (n[u] = s, t.mul(s, a)), t.ONE), o = t.inv(r);
    return e.reduceRight((s, a, u)=>t.is0(a) ? s : (n[u] = t.mul(s, n[u]), t.mul(s, a)), o), n;
}
function $d6fb6971f474fbcf$var$me(t, e) {
    const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
    return {
        nBitLength: n,
        nByteLength: r
    };
}
function $d6fb6971f474fbcf$var$_e(t, e, n = !1, r = {}) {
    if (t <= $d6fb6971f474fbcf$var$M) throw new Error("invalid field: expected ORDER > 0, got " + t);
    const { nBitLength: o, nByteLength: s } = $d6fb6971f474fbcf$var$me(t, e);
    if (s > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let a;
    const u = Object.freeze({
        ORDER: t,
        isLE: n,
        BITS: o,
        BYTES: s,
        MASK: $d6fb6971f474fbcf$var$er(o),
        ZERO: $d6fb6971f474fbcf$var$M,
        ONE: $d6fb6971f474fbcf$var$N,
        create: (i)=>$d6fb6971f474fbcf$var$H(i, t),
        isValid: (i)=>{
            if (typeof i != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof i);
            return $d6fb6971f474fbcf$var$M <= i && i < t;
        },
        is0: (i)=>i === $d6fb6971f474fbcf$var$M,
        isOdd: (i)=>(i & $d6fb6971f474fbcf$var$N) === $d6fb6971f474fbcf$var$N,
        neg: (i)=>$d6fb6971f474fbcf$var$H(-i, t),
        eql: (i, D)=>i === D,
        sqr: (i)=>$d6fb6971f474fbcf$var$H(i * i, t),
        add: (i, D)=>$d6fb6971f474fbcf$var$H(i + D, t),
        sub: (i, D)=>$d6fb6971f474fbcf$var$H(i - D, t),
        mul: (i, D)=>$d6fb6971f474fbcf$var$H(i * D, t),
        pow: (i, D)=>$d6fb6971f474fbcf$var$fr(u, i, D),
        div: (i, D)=>$d6fb6971f474fbcf$var$H(i * $d6fb6971f474fbcf$var$Ae(D, t), t),
        sqrN: (i)=>i * i,
        addN: (i, D)=>i + D,
        subN: (i, D)=>i - D,
        mulN: (i, D)=>i * D,
        inv: (i)=>$d6fb6971f474fbcf$var$Ae(i, t),
        sqrt: r.sqrt || ((i)=>(a || (a = $d6fb6971f474fbcf$var$ir(t)), a(u, i))),
        invertBatch: (i)=>$d6fb6971f474fbcf$var$Dr(u, i),
        cmov: (i, D, c)=>c ? D : i,
        toBytes: (i)=>n ? $d6fb6971f474fbcf$var$Nt(i, s) : $d6fb6971f474fbcf$var$ge(i, s),
        fromBytes: (i)=>{
            if (i.length !== s) throw new Error("Field.fromBytes: expected " + s + " bytes, got " + i.length);
            return n ? $d6fb6971f474fbcf$var$Et(i) : $d6fb6971f474fbcf$var$Pn(i);
        }
    });
    return Object.freeze(u);
}
const $d6fb6971f474fbcf$var$Se = BigInt(0), $d6fb6971f474fbcf$var$gt = BigInt(1);
function $d6fb6971f474fbcf$var$zt(t, e) {
    const n = e.negate();
    return t ? n : e;
}
function $d6fb6971f474fbcf$var$ve(t, e) {
    if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function $d6fb6971f474fbcf$var$Mt(t, e) {
    $d6fb6971f474fbcf$var$ve(t, e);
    const n = Math.ceil(e / t) + 1, r = 2 ** (t - 1);
    return {
        windows: n,
        windowSize: r
    };
}
function $d6fb6971f474fbcf$var$dr(t, e) {
    if (!Array.isArray(t)) throw new Error("array expected");
    t.forEach((n, r)=>{
        if (!(n instanceof e)) throw new Error("invalid point at index " + r);
    });
}
function $d6fb6971f474fbcf$var$hr(t, e) {
    if (!Array.isArray(t)) throw new Error("array of scalars expected");
    t.forEach((n, r)=>{
        if (!e.isValid(n)) throw new Error("invalid scalar at index " + r);
    });
}
const $d6fb6971f474fbcf$var$qt = new WeakMap, $d6fb6971f474fbcf$var$Ie = new WeakMap;
function $d6fb6971f474fbcf$var$$t(t) {
    return $d6fb6971f474fbcf$var$Ie.get(t) || 1;
}
function $d6fb6971f474fbcf$var$lr(t, e) {
    return {
        constTimeNegate: $d6fb6971f474fbcf$var$zt,
        hasPrecomputes (n) {
            return $d6fb6971f474fbcf$var$$t(n) !== 1;
        },
        unsafeLadder (n, r, o = t.ZERO) {
            let s = n;
            for(; r > $d6fb6971f474fbcf$var$Se;)r & $d6fb6971f474fbcf$var$gt && (o = o.add(s)), s = s.double(), r >>= $d6fb6971f474fbcf$var$gt;
            return o;
        },
        precomputeWindow (n, r) {
            const { windows: o, windowSize: s } = $d6fb6971f474fbcf$var$Mt(r, e), a = [];
            let u = n, i = u;
            for(let D = 0; D < o; D++){
                i = u, a.push(i);
                for(let c = 1; c < s; c++)i = i.add(u), a.push(i);
                u = i.double();
            }
            return a;
        },
        wNAF (n, r, o) {
            const { windows: s, windowSize: a } = $d6fb6971f474fbcf$var$Mt(n, e);
            let u = t.ZERO, i = t.BASE;
            const D = BigInt(2 ** n - 1), c = 2 ** n, l = BigInt(n);
            for(let p = 0; p < s; p++){
                const w = p * a;
                let h = Number(o & D);
                o >>= l, h > a && (h -= c, o += $d6fb6971f474fbcf$var$gt);
                const g = w, S = w + Math.abs(h) - 1, v = p % 2 !== 0, L = h < 0;
                h === 0 ? i = i.add($d6fb6971f474fbcf$var$zt(v, r[g])) : u = u.add($d6fb6971f474fbcf$var$zt(L, r[S]));
            }
            return {
                p: u,
                f: i
            };
        },
        wNAFUnsafe (n, r, o, s = t.ZERO) {
            const { windows: a, windowSize: u } = $d6fb6971f474fbcf$var$Mt(n, e), i = BigInt(2 ** n - 1), D = 2 ** n, c = BigInt(n);
            for(let l = 0; l < a; l++){
                const p = l * u;
                if (o === $d6fb6971f474fbcf$var$Se) break;
                let w = Number(o & i);
                if (o >>= c, w > u && (w -= D, o += $d6fb6971f474fbcf$var$gt), w === 0) continue;
                let h = r[p + Math.abs(w) - 1];
                w < 0 && (h = h.negate()), s = s.add(h);
            }
            return s;
        },
        getPrecomputes (n, r, o) {
            let s = $d6fb6971f474fbcf$var$qt.get(r);
            return s || (s = this.precomputeWindow(r, n), n !== 1 && $d6fb6971f474fbcf$var$qt.set(r, o(s))), s;
        },
        wNAFCached (n, r, o) {
            const s = $d6fb6971f474fbcf$var$$t(n);
            return this.wNAF(s, this.getPrecomputes(s, n, o), r);
        },
        wNAFCachedUnsafe (n, r, o, s) {
            const a = $d6fb6971f474fbcf$var$$t(n);
            return a === 1 ? this.unsafeLadder(n, r, s) : this.wNAFUnsafe(a, this.getPrecomputes(a, n, o), r, s);
        },
        setWindowSize (n, r) {
            $d6fb6971f474fbcf$var$ve(r, e), $d6fb6971f474fbcf$var$Ie.set(n, r), $d6fb6971f474fbcf$var$qt.delete(n);
        }
    };
}
function $d6fb6971f474fbcf$var$br(t, e, n, r) {
    if ($d6fb6971f474fbcf$var$dr(n, t), $d6fb6971f474fbcf$var$hr(r, e), n.length !== r.length) throw new Error("arrays of points and scalars must have equal length");
    const o = t.ZERO, s = $d6fb6971f474fbcf$var$tr(BigInt(n.length)), a = s > 12 ? s - 3 : s > 4 ? s - 2 : s ? 2 : 1, u = (1 << a) - 1, i = new Array(u + 1).fill(o), D = Math.floor((e.BITS - 1) / a) * a;
    let c = o;
    for(let l = D; l >= 0; l -= a){
        i.fill(o);
        for(let w = 0; w < r.length; w++){
            const h = r[w], g = Number(h >> BigInt(l) & BigInt(u));
            i[g] = i[g].add(n[w]);
        }
        let p = o;
        for(let w = i.length - 1, h = o; w > 0; w--)h = h.add(i[w]), p = p.add(h);
        if (c = c.add(p), l !== 0) for(let w = 0; w < a; w++)c = c.double();
    }
    return c;
}
function $d6fb6971f474fbcf$var$pr(t) {
    return $d6fb6971f474fbcf$var$ar(t.Fp), $d6fb6971f474fbcf$var$Ot(t, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...$d6fb6971f474fbcf$var$me(t.n, t.nBitLength),
        ...t,
        p: t.Fp.ORDER
    });
}
const $d6fb6971f474fbcf$var$G = BigInt(0), $d6fb6971f474fbcf$var$j = BigInt(1), $d6fb6971f474fbcf$var$yt = BigInt(2), $d6fb6971f474fbcf$var$wr = BigInt(8), $d6fb6971f474fbcf$var$Er = {
    zip215: !0
};
function $d6fb6971f474fbcf$var$gr(t) {
    const e = $d6fb6971f474fbcf$var$pr(t);
    return $d6fb6971f474fbcf$var$Ot(t, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    }), Object.freeze({
        ...e
    });
}
function $d6fb6971f474fbcf$var$yr(t) {
    const e = $d6fb6971f474fbcf$var$gr(t), { Fp: n, n: r, prehash: o, hash: s, randomBytes: a, nByteLength: u, h: i } = e, D = $d6fb6971f474fbcf$var$yt << BigInt(u * 8) - $d6fb6971f474fbcf$var$j, c = n.create, l = $d6fb6971f474fbcf$var$_e(e.n, e.nBitLength), p = e.uvRatio || ((y, f)=>{
        try {
            return {
                isValid: !0,
                value: n.sqrt(y * n.inv(f))
            };
        } catch  {
            return {
                isValid: !1,
                value: $d6fb6971f474fbcf$var$G
            };
        }
    }), w = e.adjustScalarBytes || ((y)=>y), h = e.domain || ((y, f, b)=>{
        if ($d6fb6971f474fbcf$var$Tt("phflag", b), f.length || b) throw new Error("Contexts/pre-hash are not supported");
        return y;
    });
    function g(y, f) {
        $d6fb6971f474fbcf$var$ft("coordinate " + y, f, $d6fb6971f474fbcf$var$G, D);
    }
    function S(y) {
        if (!(y instanceof d)) throw new Error("ExtendedPoint expected");
    }
    const v = $d6fb6971f474fbcf$var$xe((y, f)=>{
        const { ex: b, ey: E, ez: B } = y, C = y.is0();
        f == null && (f = C ? $d6fb6971f474fbcf$var$wr : n.inv(B));
        const A = c(b * f), U = c(E * f), _ = c(B * f);
        if (C) return {
            x: $d6fb6971f474fbcf$var$G,
            y: $d6fb6971f474fbcf$var$j
        };
        if (_ !== $d6fb6971f474fbcf$var$j) throw new Error("invZ was invalid");
        return {
            x: A,
            y: U
        };
    }), L = $d6fb6971f474fbcf$var$xe((y)=>{
        const { a: f, d: b } = e;
        if (y.is0()) throw new Error("bad point: ZERO");
        const { ex: E, ey: B, ez: C, et: A } = y, U = c(E * E), _ = c(B * B), T = c(C * C), $ = c(T * T), R = c(U * f), V = c(T * c(R + _)), Y = c($ + c(b * c(U * _)));
        if (V !== Y) throw new Error("bad point: equation left != right (1)");
        const Z = c(E * B), X = c(C * A);
        if (Z !== X) throw new Error("bad point: equation left != right (2)");
        return !0;
    });
    class d {
        constructor(f, b, E, B){
            this.ex = f, this.ey = b, this.ez = E, this.et = B, g("x", f), g("y", b), g("z", E), g("t", B), Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(f) {
            if (f instanceof d) throw new Error("extended point not allowed");
            const { x: b, y: E } = f || {};
            return g("x", b), g("y", E), new d(b, E, $d6fb6971f474fbcf$var$j, c(b * E));
        }
        static normalizeZ(f) {
            const b = n.invertBatch(f.map((E)=>E.ez));
            return f.map((E, B)=>E.toAffine(b[B])).map(d.fromAffine);
        }
        static msm(f, b) {
            return $d6fb6971f474fbcf$var$br(d, l, f, b);
        }
        _setWindowSize(f) {
            q.setWindowSize(this, f);
        }
        assertValidity() {
            L(this);
        }
        equals(f) {
            S(f);
            const { ex: b, ey: E, ez: B } = this, { ex: C, ey: A, ez: U } = f, _ = c(b * U), T = c(C * B), $ = c(E * U), R = c(A * B);
            return _ === T && $ === R;
        }
        is0() {
            return this.equals(d.ZERO);
        }
        negate() {
            return new d(c(-this.ex), this.ey, this.ez, c(-this.et));
        }
        double() {
            const { a: f } = e, { ex: b, ey: E, ez: B } = this, C = c(b * b), A = c(E * E), U = c($d6fb6971f474fbcf$var$yt * c(B * B)), _ = c(f * C), T = b + E, $ = c(c(T * T) - C - A), R = _ + A, V = R - U, Y = _ - A, Z = c($ * V), X = c(R * Y), et = c($ * Y), pt = c(V * R);
            return new d(Z, X, pt, et);
        }
        add(f) {
            S(f);
            const { a: b, d: E } = e, { ex: B, ey: C, ez: A, et: U } = this, { ex: _, ey: T, ez: $, et: R } = f;
            if (b === BigInt(-1)) {
                const re = c((C - B) * (T + _)), oe = c((C + B) * (T - _)), mt = c(oe - re);
                if (mt === $d6fb6971f474fbcf$var$G) return this.double();
                const se = c(A * $d6fb6971f474fbcf$var$yt * R), ie = c(U * $d6fb6971f474fbcf$var$yt * $), ue = ie + se, ce = oe + re, ae = ie - se, Dn = c(ue * mt), dn = c(ce * ae), hn = c(ue * ae), ln = c(mt * ce);
                return new d(Dn, dn, ln, hn);
            }
            const V = c(B * _), Y = c(C * T), Z = c(U * E * R), X = c(A * $), et = c((B + C) * (_ + T) - V - Y), pt = X - Z, ee = X + Z, ne = c(Y - b * V), un = c(et * pt), cn = c(ee * ne), an = c(et * ne), fn = c(pt * ee);
            return new d(un, cn, fn, an);
        }
        subtract(f) {
            return this.add(f.negate());
        }
        wNAF(f) {
            return q.wNAFCached(this, f, d.normalizeZ);
        }
        multiply(f) {
            const b = f;
            $d6fb6971f474fbcf$var$ft("scalar", b, $d6fb6971f474fbcf$var$j, r);
            const { p: E, f: B } = this.wNAF(b);
            return d.normalizeZ([
                E,
                B
            ])[0];
        }
        multiplyUnsafe(f, b = d.ZERO) {
            const E = f;
            return $d6fb6971f474fbcf$var$ft("scalar", E, $d6fb6971f474fbcf$var$G, r), E === $d6fb6971f474fbcf$var$G ? F : this.is0() || E === $d6fb6971f474fbcf$var$j ? this : q.wNAFCachedUnsafe(this, E, d.normalizeZ, b);
        }
        isSmallOrder() {
            return this.multiplyUnsafe(i).is0();
        }
        isTorsionFree() {
            return q.unsafeLadder(this, r).is0();
        }
        toAffine(f) {
            return v(this, f);
        }
        clearCofactor() {
            const { h: f } = e;
            return f === $d6fb6971f474fbcf$var$j ? this : this.multiplyUnsafe(f);
        }
        static fromHex(f, b = !1) {
            const { d: E, a: B } = e, C = n.BYTES;
            f = $d6fb6971f474fbcf$var$W("pointHex", f, C), $d6fb6971f474fbcf$var$Tt("zip215", b);
            const A = f.slice(), U = f[C - 1];
            A[C - 1] = U & -129;
            const _ = $d6fb6971f474fbcf$var$Et(A), T = b ? D : n.ORDER;
            $d6fb6971f474fbcf$var$ft("pointHex.y", _, $d6fb6971f474fbcf$var$G, T);
            const $ = c(_ * _), R = c($ - $d6fb6971f474fbcf$var$j), V = c(E * $ - B);
            let { isValid: Y, value: Z } = p(R, V);
            if (!Y) throw new Error("Point.fromHex: invalid y coordinate");
            const X = (Z & $d6fb6971f474fbcf$var$j) === $d6fb6971f474fbcf$var$j, et = (U & 128) !== 0;
            if (!b && Z === $d6fb6971f474fbcf$var$G && et) throw new Error("Point.fromHex: x=0 and x_0=1");
            return et !== X && (Z = c(-Z)), d.fromAffine({
                x: Z,
                y: _
            });
        }
        static fromPrivateKey(f) {
            return O(f).point;
        }
        toRawBytes() {
            const { x: f, y: b } = this.toAffine(), E = $d6fb6971f474fbcf$var$Nt(b, n.BYTES);
            return E[E.length - 1] |= f & $d6fb6971f474fbcf$var$j ? 128 : 0, E;
        }
        toHex() {
            return $d6fb6971f474fbcf$var$Ft(this.toRawBytes());
        }
    }
    d.BASE = new d(e.Gx, e.Gy, $d6fb6971f474fbcf$var$j, c(e.Gx * e.Gy)), d.ZERO = new d($d6fb6971f474fbcf$var$G, $d6fb6971f474fbcf$var$j, $d6fb6971f474fbcf$var$j, $d6fb6971f474fbcf$var$G);
    const { BASE: m, ZERO: F } = d, q = $d6fb6971f474fbcf$var$lr(d, u * 8);
    function z(y) {
        return $d6fb6971f474fbcf$var$H(y, r);
    }
    function I(y) {
        return z($d6fb6971f474fbcf$var$Et(y));
    }
    function O(y) {
        const f = n.BYTES;
        y = $d6fb6971f474fbcf$var$W("private key", y, f);
        const b = $d6fb6971f474fbcf$var$W("hashed private key", s(y), 2 * f), E = w(b.slice(0, f)), B = b.slice(f, 2 * f), C = I(E), A = m.multiply(C), U = A.toRawBytes();
        return {
            head: E,
            prefix: B,
            scalar: C,
            point: A,
            pointBytes: U
        };
    }
    function ot(y) {
        return O(y).pointBytes;
    }
    function tt(y = new Uint8Array, ...f) {
        const b = $d6fb6971f474fbcf$var$ye(...f);
        return I(s(h(b, $d6fb6971f474fbcf$var$W("context", y), !!o)));
    }
    function st(y, f, b = {}) {
        y = $d6fb6971f474fbcf$var$W("message", y), o && (y = o(y));
        const { prefix: E, scalar: B, pointBytes: C } = O(f), A = tt(b.context, E, y), U = m.multiply(A).toRawBytes(), _ = tt(b.context, U, C, y), T = z(A + _ * B);
        $d6fb6971f474fbcf$var$ft("signature.s", T, $d6fb6971f474fbcf$var$G, r);
        const $ = $d6fb6971f474fbcf$var$ye(U, $d6fb6971f474fbcf$var$Nt(T, n.BYTES));
        return $d6fb6971f474fbcf$var$W("result", $, n.BYTES * 2);
    }
    const at = $d6fb6971f474fbcf$var$Er;
    function Ct(y, f, b, E = at) {
        const { context: B, zip215: C } = E, A = n.BYTES;
        y = $d6fb6971f474fbcf$var$W("signature", y, 2 * A), f = $d6fb6971f474fbcf$var$W("message", f), b = $d6fb6971f474fbcf$var$W("publicKey", b, A), C !== void 0 && $d6fb6971f474fbcf$var$Tt("zip215", C), o && (f = o(f));
        const U = $d6fb6971f474fbcf$var$Et(y.slice(A, 2 * A));
        let _, T, $;
        try {
            _ = d.fromHex(b, C), T = d.fromHex(y.slice(0, A), C), $ = m.multiplyUnsafe(U);
        } catch  {
            return !1;
        }
        if (!C && _.isSmallOrder()) return !1;
        const R = tt(B, T.toRawBytes(), _.toRawBytes(), f);
        return T.add(_.multiplyUnsafe(R)).subtract($).clearCofactor().equals(d.ZERO);
    }
    return m._setWindowSize(8), {
        CURVE: e,
        getPublicKey: ot,
        sign: st,
        verify: Ct,
        ExtendedPoint: d,
        utils: {
            getExtendedPublicKey: O,
            randomPrivateKey: ()=>a(n.BYTES),
            precompute (y = 8, f = d.BASE) {
                return f._setWindowSize(y), f.multiply(BigInt(3)), f;
            }
        }
    };
}
BigInt(0), BigInt(1);
const $d6fb6971f474fbcf$var$kt = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), $d6fb6971f474fbcf$var$Ue = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const $d6fb6971f474fbcf$var$xr = BigInt(1), $d6fb6971f474fbcf$var$Te = BigInt(2);
BigInt(3);
const $d6fb6971f474fbcf$var$Br = BigInt(5), $d6fb6971f474fbcf$var$Cr = BigInt(8);
function $d6fb6971f474fbcf$var$Ar(t) {
    const e = BigInt(10), n = BigInt(20), r = BigInt(40), o = BigInt(80), s = $d6fb6971f474fbcf$var$kt, u = t * t % s * t % s, i = $d6fb6971f474fbcf$var$J(u, $d6fb6971f474fbcf$var$Te, s) * u % s, D = $d6fb6971f474fbcf$var$J(i, $d6fb6971f474fbcf$var$xr, s) * t % s, c = $d6fb6971f474fbcf$var$J(D, $d6fb6971f474fbcf$var$Br, s) * D % s, l = $d6fb6971f474fbcf$var$J(c, e, s) * c % s, p = $d6fb6971f474fbcf$var$J(l, n, s) * l % s, w = $d6fb6971f474fbcf$var$J(p, r, s) * p % s, h = $d6fb6971f474fbcf$var$J(w, o, s) * w % s, g = $d6fb6971f474fbcf$var$J(h, o, s) * w % s, S = $d6fb6971f474fbcf$var$J(g, e, s) * c % s;
    return {
        pow_p_5_8: $d6fb6971f474fbcf$var$J(S, $d6fb6971f474fbcf$var$Te, s) * t % s,
        b2: u
    };
}
function $d6fb6971f474fbcf$var$mr(t) {
    return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
function $d6fb6971f474fbcf$var$_r(t, e) {
    const n = $d6fb6971f474fbcf$var$kt, r = $d6fb6971f474fbcf$var$H(e * e * e, n), o = $d6fb6971f474fbcf$var$H(r * r * e, n), s = $d6fb6971f474fbcf$var$Ar(t * o).pow_p_5_8;
    let a = $d6fb6971f474fbcf$var$H(t * r * s, n);
    const u = $d6fb6971f474fbcf$var$H(e * a * a, n), i = a, D = $d6fb6971f474fbcf$var$H(a * $d6fb6971f474fbcf$var$Ue, n), c = u === t, l = u === $d6fb6971f474fbcf$var$H(-t, n), p = u === $d6fb6971f474fbcf$var$H(-t * $d6fb6971f474fbcf$var$Ue, n);
    return c && (a = i), (l || p) && (a = D), $d6fb6971f474fbcf$var$ur(a, n) && (a = $d6fb6971f474fbcf$var$H(-a, n)), {
        isValid: c || l,
        value: a
    };
}
const $d6fb6971f474fbcf$var$Sr = (()=>$d6fb6971f474fbcf$var$_e($d6fb6971f474fbcf$var$kt, void 0, !0))(), $d6fb6971f474fbcf$var$vr = (()=>({
        a: BigInt(-1),
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: $d6fb6971f474fbcf$var$Sr,
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        h: $d6fb6971f474fbcf$var$Cr,
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: $d6fb6971f474fbcf$var$Kn,
        randomBytes: $d6fb6971f474fbcf$var$he,
        adjustScalarBytes: $d6fb6971f474fbcf$var$mr,
        uvRatio: $d6fb6971f474fbcf$var$_r
    }))(), $d6fb6971f474fbcf$var$Rt = (()=>$d6fb6971f474fbcf$var$yr($d6fb6971f474fbcf$var$vr))(), $d6fb6971f474fbcf$export$51745f7832485c34 = "EdDSA", $d6fb6971f474fbcf$export$f51b45e220f2ba98 = "JWT", $d6fb6971f474fbcf$export$a3e35a0f952eb3ef = ".", $d6fb6971f474fbcf$export$d2e6fe38c55f8e23 = "base64url", $d6fb6971f474fbcf$export$c09c2801e10a2b95 = "utf8", $d6fb6971f474fbcf$export$1e9219c0b91a4257 = "utf8", $d6fb6971f474fbcf$export$d4057275de9d060b = ":", $d6fb6971f474fbcf$export$acf13c61a1a0ccf3 = "did", $d6fb6971f474fbcf$export$b908fe81ccf30934 = "key", $d6fb6971f474fbcf$export$7bd18b7a7a4d0471 = "base58btc", $d6fb6971f474fbcf$export$6d6d3d2e39be8d68 = "z", $d6fb6971f474fbcf$export$9902a33a5776d1fc = "K36", $d6fb6971f474fbcf$export$ca477e91394a742a = 32, $d6fb6971f474fbcf$export$f09ad228919f26fb = 32;
function $d6fb6971f474fbcf$var$Xt(t) {
    return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function $d6fb6971f474fbcf$var$Le(t = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $d6fb6971f474fbcf$var$Xt(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function $d6fb6971f474fbcf$var$Oe(t, e) {
    e || (e = t.reduce((o, s)=>o + s.length, 0));
    const n = $d6fb6971f474fbcf$var$Le(e);
    let r = 0;
    for (const o of t)n.set(o, r), r += o.length;
    return $d6fb6971f474fbcf$var$Xt(n);
}
function $d6fb6971f474fbcf$var$Ir(t, e) {
    if (t.length >= 255) throw new TypeError("Alphabet too long");
    for(var n = new Uint8Array(256), r = 0; r < n.length; r++)n[r] = 255;
    for(var o = 0; o < t.length; o++){
        var s = t.charAt(o), a = s.charCodeAt(0);
        if (n[a] !== 255) throw new TypeError(s + " is ambiguous");
        n[a] = o;
    }
    var u = t.length, i = t.charAt(0), D = Math.log(u) / Math.log(256), c = Math.log(256) / Math.log(u);
    function l(h) {
        if (h instanceof Uint8Array || (ArrayBuffer.isView(h) ? h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : Array.isArray(h) && (h = Uint8Array.from(h))), !(h instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (h.length === 0) return "";
        for(var g = 0, S = 0, v = 0, L = h.length; v !== L && h[v] === 0;)v++, g++;
        for(var d = (L - v) * c + 1 >>> 0, m = new Uint8Array(d); v !== L;){
            for(var F = h[v], q = 0, z = d - 1; (F !== 0 || q < S) && z !== -1; z--, q++)F += 256 * m[z] >>> 0, m[z] = F % u >>> 0, F = F / u >>> 0;
            if (F !== 0) throw new Error("Non-zero carry");
            S = q, v++;
        }
        for(var I = d - S; I !== d && m[I] === 0;)I++;
        for(var O = i.repeat(g); I < d; ++I)O += t.charAt(m[I]);
        return O;
    }
    function p(h) {
        if (typeof h != "string") throw new TypeError("Expected String");
        if (h.length === 0) return new Uint8Array;
        var g = 0;
        if (h[g] !== " ") {
            for(var S = 0, v = 0; h[g] === i;)S++, g++;
            for(var L = (h.length - g) * D + 1 >>> 0, d = new Uint8Array(L); h[g];){
                var m = n[h.charCodeAt(g)];
                if (m === 255) return;
                for(var F = 0, q = L - 1; (m !== 0 || F < v) && q !== -1; q--, F++)m += u * d[q] >>> 0, d[q] = m % 256 >>> 0, m = m / 256 >>> 0;
                if (m !== 0) throw new Error("Non-zero carry");
                v = F, g++;
            }
            if (h[g] !== " ") {
                for(var z = L - v; z !== L && d[z] === 0;)z++;
                for(var I = new Uint8Array(S + (L - z)), O = S; z !== L;)I[O++] = d[z++];
                return I;
            }
        }
    }
    function w(h) {
        var g = p(h);
        if (g) return g;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: l,
        decodeUnsafe: p,
        decode: w
    };
}
var $d6fb6971f474fbcf$var$Ur = $d6fb6971f474fbcf$var$Ir, $d6fb6971f474fbcf$var$Tr = $d6fb6971f474fbcf$var$Ur;
const $d6fb6971f474fbcf$var$He = (t)=>{
    if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
    if (t instanceof ArrayBuffer) return new Uint8Array(t);
    if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $d6fb6971f474fbcf$var$Fr = (t)=>new TextEncoder().encode(t), $d6fb6971f474fbcf$var$Nr = (t)=>new TextDecoder().decode(t);
class $d6fb6971f474fbcf$var$Lr {
    constructor(e, n, r){
        this.name = e, this.prefix = n, this.baseEncode = r;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $d6fb6971f474fbcf$var$Or {
    constructor(e, n, r){
        if (this.name = e, this.prefix = n, n.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = n.codePointAt(0), this.baseDecode = r;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $d6fb6971f474fbcf$var$ze(this, e);
    }
}
class $d6fb6971f474fbcf$var$Hr {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $d6fb6971f474fbcf$var$ze(this, e);
    }
    decode(e) {
        const n = e[0], r = this.decoders[n];
        if (r) return r.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $d6fb6971f474fbcf$var$ze = (t, e)=>new $d6fb6971f474fbcf$var$Hr({
        ...t.decoders || {
            [t.prefix]: t
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $d6fb6971f474fbcf$var$zr {
    constructor(e, n, r, o){
        this.name = e, this.prefix = n, this.baseEncode = r, this.baseDecode = o, this.encoder = new $d6fb6971f474fbcf$var$Lr(e, n, r), this.decoder = new $d6fb6971f474fbcf$var$Or(e, n, o);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $d6fb6971f474fbcf$var$Bt = ({ name: t, prefix: e, encode: n, decode: r })=>new $d6fb6971f474fbcf$var$zr(t, e, n, r), $d6fb6971f474fbcf$var$ht = ({ prefix: t, name: e, alphabet: n })=>{
    const { encode: r, decode: o } = $d6fb6971f474fbcf$var$Tr(n, e);
    return $d6fb6971f474fbcf$var$Bt({
        prefix: t,
        name: e,
        encode: r,
        decode: (s)=>$d6fb6971f474fbcf$var$He(o(s))
    });
}, $d6fb6971f474fbcf$var$Mr = (t, e, n, r)=>{
    const o = {};
    for(let c = 0; c < e.length; ++c)o[e[c]] = c;
    let s = t.length;
    for(; t[s - 1] === "=";)--s;
    const a = new Uint8Array(s * n / 8 | 0);
    let u = 0, i = 0, D = 0;
    for(let c = 0; c < s; ++c){
        const l = o[t[c]];
        if (l === void 0) throw new SyntaxError(`Non-${r} character`);
        i = i << n | l, u += n, u >= 8 && (u -= 8, a[D++] = 255 & i >> u);
    }
    if (u >= n || 255 & i << 8 - u) throw new SyntaxError("Unexpected end of data");
    return a;
}, $d6fb6971f474fbcf$var$qr = (t, e, n)=>{
    const r = e[e.length - 1] === "=", o = (1 << n) - 1;
    let s = "", a = 0, u = 0;
    for(let i = 0; i < t.length; ++i)for(u = u << 8 | t[i], a += 8; a > n;)a -= n, s += e[o & u >> a];
    if (a && (s += e[o & u << n - a]), r) for(; s.length * n & 7;)s += "=";
    return s;
}, $d6fb6971f474fbcf$var$k = ({ name: t, prefix: e, bitsPerChar: n, alphabet: r })=>$d6fb6971f474fbcf$var$Bt({
        prefix: e,
        name: t,
        encode (o) {
            return $d6fb6971f474fbcf$var$qr(o, r, n);
        },
        decode (o) {
            return $d6fb6971f474fbcf$var$Mr(o, r, n, t);
        }
    }), $d6fb6971f474fbcf$var$$r = $d6fb6971f474fbcf$var$Bt({
    prefix: "\0",
    name: "identity",
    encode: (t)=>$d6fb6971f474fbcf$var$Nr(t),
    decode: (t)=>$d6fb6971f474fbcf$var$Fr(t)
});
var $d6fb6971f474fbcf$var$kr = Object.freeze({
    __proto__: null,
    identity: $d6fb6971f474fbcf$var$$r
});
const $d6fb6971f474fbcf$var$Rr = $d6fb6971f474fbcf$var$k({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $d6fb6971f474fbcf$var$jr = Object.freeze({
    __proto__: null,
    base2: $d6fb6971f474fbcf$var$Rr
});
const $d6fb6971f474fbcf$var$Zr = $d6fb6971f474fbcf$var$k({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $d6fb6971f474fbcf$var$Gr = Object.freeze({
    __proto__: null,
    base8: $d6fb6971f474fbcf$var$Zr
});
const $d6fb6971f474fbcf$var$Vr = $d6fb6971f474fbcf$var$ht({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $d6fb6971f474fbcf$var$Yr = Object.freeze({
    __proto__: null,
    base10: $d6fb6971f474fbcf$var$Vr
});
const $d6fb6971f474fbcf$var$Jr = $d6fb6971f474fbcf$var$k({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $d6fb6971f474fbcf$var$Kr = $d6fb6971f474fbcf$var$k({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $d6fb6971f474fbcf$var$Wr = Object.freeze({
    __proto__: null,
    base16: $d6fb6971f474fbcf$var$Jr,
    base16upper: $d6fb6971f474fbcf$var$Kr
});
const $d6fb6971f474fbcf$var$Xr = $d6fb6971f474fbcf$var$k({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$Pr = $d6fb6971f474fbcf$var$k({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$Qr = $d6fb6971f474fbcf$var$k({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$to = $d6fb6971f474fbcf$var$k({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$eo = $d6fb6971f474fbcf$var$k({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$no = $d6fb6971f474fbcf$var$k({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$ro = $d6fb6971f474fbcf$var$k({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$oo = $d6fb6971f474fbcf$var$k({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $d6fb6971f474fbcf$var$so = $d6fb6971f474fbcf$var$k({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $d6fb6971f474fbcf$var$io = Object.freeze({
    __proto__: null,
    base32: $d6fb6971f474fbcf$var$Xr,
    base32upper: $d6fb6971f474fbcf$var$Pr,
    base32pad: $d6fb6971f474fbcf$var$Qr,
    base32padupper: $d6fb6971f474fbcf$var$to,
    base32hex: $d6fb6971f474fbcf$var$eo,
    base32hexupper: $d6fb6971f474fbcf$var$no,
    base32hexpad: $d6fb6971f474fbcf$var$ro,
    base32hexpadupper: $d6fb6971f474fbcf$var$oo,
    base32z: $d6fb6971f474fbcf$var$so
});
const $d6fb6971f474fbcf$var$uo = $d6fb6971f474fbcf$var$ht({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $d6fb6971f474fbcf$var$co = $d6fb6971f474fbcf$var$ht({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $d6fb6971f474fbcf$var$ao = Object.freeze({
    __proto__: null,
    base36: $d6fb6971f474fbcf$var$uo,
    base36upper: $d6fb6971f474fbcf$var$co
});
const $d6fb6971f474fbcf$var$fo = $d6fb6971f474fbcf$var$ht({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $d6fb6971f474fbcf$var$Do = $d6fb6971f474fbcf$var$ht({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $d6fb6971f474fbcf$var$ho = Object.freeze({
    __proto__: null,
    base58btc: $d6fb6971f474fbcf$var$fo,
    base58flickr: $d6fb6971f474fbcf$var$Do
});
const $d6fb6971f474fbcf$var$lo = $d6fb6971f474fbcf$var$k({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $d6fb6971f474fbcf$var$bo = $d6fb6971f474fbcf$var$k({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $d6fb6971f474fbcf$var$po = $d6fb6971f474fbcf$var$k({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $d6fb6971f474fbcf$var$wo = $d6fb6971f474fbcf$var$k({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $d6fb6971f474fbcf$var$Eo = Object.freeze({
    __proto__: null,
    base64: $d6fb6971f474fbcf$var$lo,
    base64pad: $d6fb6971f474fbcf$var$bo,
    base64url: $d6fb6971f474fbcf$var$po,
    base64urlpad: $d6fb6971f474fbcf$var$wo
});
const $d6fb6971f474fbcf$var$Me = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $d6fb6971f474fbcf$var$go = $d6fb6971f474fbcf$var$Me.reduce((t, e, n)=>(t[n] = e, t), []), $d6fb6971f474fbcf$var$yo = $d6fb6971f474fbcf$var$Me.reduce((t, e, n)=>(t[e.codePointAt(0)] = n, t), []);
function $d6fb6971f474fbcf$var$xo(t) {
    return t.reduce((e, n)=>(e += $d6fb6971f474fbcf$var$go[n], e), "");
}
function $d6fb6971f474fbcf$var$Bo(t) {
    const e = [];
    for (const n of t){
        const r = $d6fb6971f474fbcf$var$yo[n.codePointAt(0)];
        if (r === void 0) throw new Error(`Non-base256emoji character: ${n}`);
        e.push(r);
    }
    return new Uint8Array(e);
}
const $d6fb6971f474fbcf$var$Co = $d6fb6971f474fbcf$var$Bt({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $d6fb6971f474fbcf$var$xo,
    decode: $d6fb6971f474fbcf$var$Bo
});
var $d6fb6971f474fbcf$var$Ao = Object.freeze({
    __proto__: null,
    base256emoji: $d6fb6971f474fbcf$var$Co
}), $d6fb6971f474fbcf$var$mo = $d6fb6971f474fbcf$var$$e, $d6fb6971f474fbcf$var$qe = 128, $d6fb6971f474fbcf$var$_o = 127, $d6fb6971f474fbcf$var$So = ~$d6fb6971f474fbcf$var$_o, $d6fb6971f474fbcf$var$vo = Math.pow(2, 31);
function $d6fb6971f474fbcf$var$$e(t, e, n) {
    e = e || [], n = n || 0;
    for(var r = n; t >= $d6fb6971f474fbcf$var$vo;)e[n++] = t & 255 | $d6fb6971f474fbcf$var$qe, t /= 128;
    for(; t & $d6fb6971f474fbcf$var$So;)e[n++] = t & 255 | $d6fb6971f474fbcf$var$qe, t >>>= 7;
    return e[n] = t | 0, $d6fb6971f474fbcf$var$$e.bytes = n - r + 1, e;
}
var $d6fb6971f474fbcf$var$Io = $d6fb6971f474fbcf$var$Pt, $d6fb6971f474fbcf$var$Uo = 128, $d6fb6971f474fbcf$var$ke = 127;
function $d6fb6971f474fbcf$var$Pt(t, r) {
    var n = 0, r = r || 0, o = 0, s = r, a, u = t.length;
    do {
        if (s >= u) throw $d6fb6971f474fbcf$var$Pt.bytes = 0, new RangeError("Could not decode varint");
        a = t[s++], n += o < 28 ? (a & $d6fb6971f474fbcf$var$ke) << o : (a & $d6fb6971f474fbcf$var$ke) * Math.pow(2, o), o += 7;
    }while (a >= $d6fb6971f474fbcf$var$Uo);
    return $d6fb6971f474fbcf$var$Pt.bytes = s - r, n;
}
var $d6fb6971f474fbcf$var$To = Math.pow(2, 7), $d6fb6971f474fbcf$var$Fo = Math.pow(2, 14), $d6fb6971f474fbcf$var$No = Math.pow(2, 21), $d6fb6971f474fbcf$var$Lo = Math.pow(2, 28), $d6fb6971f474fbcf$var$Oo = Math.pow(2, 35), $d6fb6971f474fbcf$var$Ho = Math.pow(2, 42), $d6fb6971f474fbcf$var$zo = Math.pow(2, 49), $d6fb6971f474fbcf$var$Mo = Math.pow(2, 56), $d6fb6971f474fbcf$var$qo = Math.pow(2, 63), $d6fb6971f474fbcf$var$$o = function(t) {
    return t < $d6fb6971f474fbcf$var$To ? 1 : t < $d6fb6971f474fbcf$var$Fo ? 2 : t < $d6fb6971f474fbcf$var$No ? 3 : t < $d6fb6971f474fbcf$var$Lo ? 4 : t < $d6fb6971f474fbcf$var$Oo ? 5 : t < $d6fb6971f474fbcf$var$Ho ? 6 : t < $d6fb6971f474fbcf$var$zo ? 7 : t < $d6fb6971f474fbcf$var$Mo ? 8 : t < $d6fb6971f474fbcf$var$qo ? 9 : 10;
}, $d6fb6971f474fbcf$var$ko = {
    encode: $d6fb6971f474fbcf$var$mo,
    decode: $d6fb6971f474fbcf$var$Io,
    encodingLength: $d6fb6971f474fbcf$var$$o
}, $d6fb6971f474fbcf$var$Re = $d6fb6971f474fbcf$var$ko;
const $d6fb6971f474fbcf$var$je = (t, e, n = 0)=>($d6fb6971f474fbcf$var$Re.encode(t, e, n), e), $d6fb6971f474fbcf$var$Ze = (t)=>$d6fb6971f474fbcf$var$Re.encodingLength(t), $d6fb6971f474fbcf$var$Qt = (t, e)=>{
    const n = e.byteLength, r = $d6fb6971f474fbcf$var$Ze(t), o = r + $d6fb6971f474fbcf$var$Ze(n), s = new Uint8Array(o + n);
    return $d6fb6971f474fbcf$var$je(t, s, 0), $d6fb6971f474fbcf$var$je(n, s, r), s.set(e, o), new $d6fb6971f474fbcf$var$Ro(t, n, e, s);
};
class $d6fb6971f474fbcf$var$Ro {
    constructor(e, n, r, o){
        this.code = e, this.size = n, this.digest = r, this.bytes = o;
    }
}
const $d6fb6971f474fbcf$var$Ge = ({ name: t, code: e, encode: n })=>new $d6fb6971f474fbcf$var$jo(t, e, n);
class $d6fb6971f474fbcf$var$jo {
    constructor(e, n, r){
        this.name = e, this.code = n, this.encode = r;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const n = this.encode(e);
            return n instanceof Uint8Array ? $d6fb6971f474fbcf$var$Qt(this.code, n) : n.then((r)=>$d6fb6971f474fbcf$var$Qt(this.code, r));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $d6fb6971f474fbcf$var$Ve = (t)=>async (e)=>new Uint8Array(await crypto.subtle.digest(t, e)), $d6fb6971f474fbcf$var$Zo = $d6fb6971f474fbcf$var$Ge({
    name: "sha2-256",
    code: 18,
    encode: $d6fb6971f474fbcf$var$Ve("SHA-256")
}), $d6fb6971f474fbcf$var$Go = $d6fb6971f474fbcf$var$Ge({
    name: "sha2-512",
    code: 19,
    encode: $d6fb6971f474fbcf$var$Ve("SHA-512")
});
var $d6fb6971f474fbcf$var$Vo = Object.freeze({
    __proto__: null,
    sha256: $d6fb6971f474fbcf$var$Zo,
    sha512: $d6fb6971f474fbcf$var$Go
});
const $d6fb6971f474fbcf$var$Ye = 0, $d6fb6971f474fbcf$var$Yo = "identity", $d6fb6971f474fbcf$var$Je = $d6fb6971f474fbcf$var$He, $d6fb6971f474fbcf$var$Jo = (t)=>$d6fb6971f474fbcf$var$Qt($d6fb6971f474fbcf$var$Ye, $d6fb6971f474fbcf$var$Je(t)), $d6fb6971f474fbcf$var$Ko = {
    code: $d6fb6971f474fbcf$var$Ye,
    name: $d6fb6971f474fbcf$var$Yo,
    encode: $d6fb6971f474fbcf$var$Je,
    digest: $d6fb6971f474fbcf$var$Jo
};
var $d6fb6971f474fbcf$var$Wo = Object.freeze({
    __proto__: null,
    identity: $d6fb6971f474fbcf$var$Ko
});
new TextEncoder, new TextDecoder;
const $d6fb6971f474fbcf$var$Ke = {
    ...$d6fb6971f474fbcf$var$kr,
    ...$d6fb6971f474fbcf$var$jr,
    ...$d6fb6971f474fbcf$var$Gr,
    ...$d6fb6971f474fbcf$var$Yr,
    ...$d6fb6971f474fbcf$var$Wr,
    ...$d6fb6971f474fbcf$var$io,
    ...$d6fb6971f474fbcf$var$ao,
    ...$d6fb6971f474fbcf$var$ho,
    ...$d6fb6971f474fbcf$var$Eo,
    ...$d6fb6971f474fbcf$var$Ao
};
({
    ...$d6fb6971f474fbcf$var$Vo,
    ...$d6fb6971f474fbcf$var$Wo
});
function $d6fb6971f474fbcf$var$We(t, e, n, r) {
    return {
        name: t,
        prefix: e,
        encoder: {
            name: t,
            prefix: e,
            encode: n
        },
        decoder: {
            decode: r
        }
    };
}
const $d6fb6971f474fbcf$var$Xe = $d6fb6971f474fbcf$var$We("utf8", "u", (t)=>"u" + new TextDecoder("utf8").decode(t), (t)=>new TextEncoder().encode(t.substring(1))), $d6fb6971f474fbcf$var$te = $d6fb6971f474fbcf$var$We("ascii", "a", (t)=>{
    let e = "a";
    for(let n = 0; n < t.length; n++)e += String.fromCharCode(t[n]);
    return e;
}, (t)=>{
    t = t.substring(1);
    const e = $d6fb6971f474fbcf$var$Le(t.length);
    for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
    return e;
}), $d6fb6971f474fbcf$var$Pe = {
    utf8: $d6fb6971f474fbcf$var$Xe,
    "utf-8": $d6fb6971f474fbcf$var$Xe,
    hex: $d6fb6971f474fbcf$var$Ke.base16,
    latin1: $d6fb6971f474fbcf$var$te,
    ascii: $d6fb6971f474fbcf$var$te,
    binary: $d6fb6971f474fbcf$var$te,
    ...$d6fb6971f474fbcf$var$Ke
};
function $d6fb6971f474fbcf$var$ct(t, e = "utf8") {
    const n = $d6fb6971f474fbcf$var$Pe[e];
    if (!n) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : n.encoder.encode(t).substring(1);
}
function $d6fb6971f474fbcf$var$rt(t, e = "utf8") {
    const n = $d6fb6971f474fbcf$var$Pe[e];
    if (!n) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $d6fb6971f474fbcf$var$Xt(globalThis.Buffer.from(t, "utf-8")) : n.decoder.decode(`${n.prefix}${t}`);
}
function $d6fb6971f474fbcf$export$2030d1af6cd0ef93(t) {
    return (0, $4yffS.safeJsonParse)($d6fb6971f474fbcf$var$ct($d6fb6971f474fbcf$var$rt(t, $d6fb6971f474fbcf$export$d2e6fe38c55f8e23), $d6fb6971f474fbcf$export$c09c2801e10a2b95));
}
function $d6fb6971f474fbcf$export$84046f8082657cdf(t) {
    return $d6fb6971f474fbcf$var$ct($d6fb6971f474fbcf$var$rt((0, $4yffS.safeJsonStringify)(t), $d6fb6971f474fbcf$export$c09c2801e10a2b95), $d6fb6971f474fbcf$export$d2e6fe38c55f8e23);
}
function $d6fb6971f474fbcf$export$1b29ef9371459e10(t) {
    const e = $d6fb6971f474fbcf$var$rt($d6fb6971f474fbcf$export$9902a33a5776d1fc, $d6fb6971f474fbcf$export$7bd18b7a7a4d0471), n = $d6fb6971f474fbcf$export$6d6d3d2e39be8d68 + $d6fb6971f474fbcf$var$ct($d6fb6971f474fbcf$var$Oe([
        e,
        t
    ]), $d6fb6971f474fbcf$export$7bd18b7a7a4d0471);
    return [
        $d6fb6971f474fbcf$export$acf13c61a1a0ccf3,
        $d6fb6971f474fbcf$export$b908fe81ccf30934,
        n
    ].join($d6fb6971f474fbcf$export$d4057275de9d060b);
}
function $d6fb6971f474fbcf$export$86ac046d72244356(t) {
    const [e, n, r] = t.split($d6fb6971f474fbcf$export$d4057275de9d060b);
    if (e !== $d6fb6971f474fbcf$export$acf13c61a1a0ccf3 || n !== $d6fb6971f474fbcf$export$b908fe81ccf30934) throw new Error('Issuer must be a DID with method "key"');
    if (r.slice(0, 1) !== $d6fb6971f474fbcf$export$6d6d3d2e39be8d68) throw new Error("Issuer must be a key in mulicodec format");
    const o = $d6fb6971f474fbcf$var$rt(r.slice(1), $d6fb6971f474fbcf$export$7bd18b7a7a4d0471);
    if ($d6fb6971f474fbcf$var$ct(o.slice(0, 2), $d6fb6971f474fbcf$export$7bd18b7a7a4d0471) !== $d6fb6971f474fbcf$export$9902a33a5776d1fc) throw new Error('Issuer must be a public key with type "Ed25519"');
    const s = o.slice(2);
    if (s.length !== $d6fb6971f474fbcf$export$ca477e91394a742a) throw new Error("Issuer must be a public key with length 32 bytes");
    return s;
}
function $d6fb6971f474fbcf$export$d9746ef301b2089b(t) {
    return $d6fb6971f474fbcf$var$ct(t, $d6fb6971f474fbcf$export$d2e6fe38c55f8e23);
}
function $d6fb6971f474fbcf$export$c37aeb372ac07c0e(t) {
    return $d6fb6971f474fbcf$var$rt(t, $d6fb6971f474fbcf$export$d2e6fe38c55f8e23);
}
function $d6fb6971f474fbcf$export$cfdd1f2478131e3d(t) {
    return $d6fb6971f474fbcf$var$rt([
        $d6fb6971f474fbcf$export$84046f8082657cdf(t.header),
        $d6fb6971f474fbcf$export$84046f8082657cdf(t.payload)
    ].join($d6fb6971f474fbcf$export$a3e35a0f952eb3ef), $d6fb6971f474fbcf$export$1e9219c0b91a4257);
}
function $d6fb6971f474fbcf$export$13923bea59211b58(t) {
    const e = $d6fb6971f474fbcf$var$ct(t, $d6fb6971f474fbcf$export$1e9219c0b91a4257).split($d6fb6971f474fbcf$export$a3e35a0f952eb3ef), n = $d6fb6971f474fbcf$export$2030d1af6cd0ef93(e[0]), r = $d6fb6971f474fbcf$export$2030d1af6cd0ef93(e[1]);
    return {
        header: n,
        payload: r
    };
}
function $d6fb6971f474fbcf$export$1b70f4551c751d68(t) {
    return [
        $d6fb6971f474fbcf$export$84046f8082657cdf(t.header),
        $d6fb6971f474fbcf$export$84046f8082657cdf(t.payload),
        $d6fb6971f474fbcf$export$d9746ef301b2089b(t.signature)
    ].join($d6fb6971f474fbcf$export$a3e35a0f952eb3ef);
}
function $d6fb6971f474fbcf$export$9a62e6c0a30e00bc(t) {
    const e = t.split($d6fb6971f474fbcf$export$a3e35a0f952eb3ef), n = $d6fb6971f474fbcf$export$2030d1af6cd0ef93(e[0]), r = $d6fb6971f474fbcf$export$2030d1af6cd0ef93(e[1]), o = $d6fb6971f474fbcf$export$c37aeb372ac07c0e(e[2]), s = $d6fb6971f474fbcf$var$rt(e.slice(0, 2).join($d6fb6971f474fbcf$export$a3e35a0f952eb3ef), $d6fb6971f474fbcf$export$1e9219c0b91a4257);
    return {
        header: n,
        payload: r,
        signature: o,
        data: s
    };
}
function $d6fb6971f474fbcf$export$a949d36eab55b41f(t = $d6fb6971f474fbcf$var$he($d6fb6971f474fbcf$export$f09ad228919f26fb)) {
    const e = $d6fb6971f474fbcf$var$Rt.getPublicKey(t);
    return {
        secretKey: $d6fb6971f474fbcf$var$Oe([
            t,
            e
        ]),
        publicKey: e
    };
}
async function $d6fb6971f474fbcf$export$a8dda30659d36d45(t, e, n, r, o = (0, $2TjUJ.fromMiliseconds)(Date.now())) {
    const s = {
        alg: $d6fb6971f474fbcf$export$51745f7832485c34,
        typ: $d6fb6971f474fbcf$export$f51b45e220f2ba98
    }, a = $d6fb6971f474fbcf$export$1b29ef9371459e10(r.publicKey), u = o + n, i = {
        iss: a,
        sub: t,
        aud: e,
        iat: o,
        exp: u
    }, D = $d6fb6971f474fbcf$export$cfdd1f2478131e3d({
        header: s,
        payload: i
    }), c = $d6fb6971f474fbcf$var$Rt.sign(D, r.secretKey.slice(0, 32));
    return $d6fb6971f474fbcf$export$1b70f4551c751d68({
        header: s,
        payload: i,
        signature: c
    });
}
async function $d6fb6971f474fbcf$export$7b6fc79aa8c5b79c(t) {
    const { header: e, payload: n, data: r, signature: o } = $d6fb6971f474fbcf$export$9a62e6c0a30e00bc(t);
    if (e.alg !== $d6fb6971f474fbcf$export$51745f7832485c34 || e.typ !== $d6fb6971f474fbcf$export$f51b45e220f2ba98) throw new Error("JWT must use EdDSA algorithm");
    const s = $d6fb6971f474fbcf$export$86ac046d72244356(n.iss);
    return $d6fb6971f474fbcf$var$Rt.verify(o, r, s);
}

});
parcelRegister("4yffS", function(module, exports) {

$parcel$export(module.exports, "safeJsonParse", function () { return $35062bc0f8752b49$export$84137bb44359aed5; });
$parcel$export(module.exports, "safeJsonStringify", function () { return $35062bc0f8752b49$export$abc3f407e87918a4; });
const $35062bc0f8752b49$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $35062bc0f8752b49$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $35062bc0f8752b49$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $35062bc0f8752b49$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $35062bc0f8752b49$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $35062bc0f8752b49$var$JSONStringify(value) || "";
}

});


parcelRegister("8l48q", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return (parcelRequire("abuiC")).concat; });
$parcel$export(module.exports, "fromString", function () { return (parcelRequire("2AuZR")).fromString; });
$parcel$export(module.exports, "toString", function () { return (parcelRequire("BCGxC")).toString; });

var $7Xyve = parcelRequire("7Xyve");

var $abuiC = parcelRequire("abuiC");

var $5dqcr = parcelRequire("5dqcr");

var $2AuZR = parcelRequire("2AuZR");

var $BCGxC = parcelRequire("BCGxC");

var $2ly2w = parcelRequire("2ly2w");

});
parcelRegister("7Xyve", function(module, exports) {
function $5cb8ce97fb15eb34$export$398604a469f7de9a(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}

});

parcelRegister("abuiC", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $76a26f4b4d792633$export$ee1b3e54f0441b22; });

var $bPwtR = parcelRequire("bPwtR");
function $76a26f4b4d792633$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = (0, $bPwtR.allocUnsafe)(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}

});
parcelRegister("bPwtR", function(module, exports) {

$parcel$export(module.exports, "allocUnsafe", function () { return $89cda720e686e452$export$19833a56117fe205; });
function $89cda720e686e452$export$2de70f21292aac9e(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $89cda720e686e452$export$19833a56117fe205(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}

});


parcelRegister("5dqcr", function(module, exports) {
function $3cc27d594c44fcc0$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}

});

parcelRegister("2AuZR", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $1e26fce4e349a346$export$3004f64547af360e; });

var $fKl46 = parcelRequire("fKl46");
function $1e26fce4e349a346$export$3004f64547af360e(string, encoding = "utf8") {
    const base = (0, $fKl46.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, "utf8");
    return base.decoder.decode(`${base.prefix}${string}`);
}

});
parcelRegister("fKl46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b76b7dfba453523d$export$2e2bcd8739ae039; });

var $41YhS = parcelRequire("41YhS");

var $bPwtR = parcelRequire("bPwtR");
function $b76b7dfba453523d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $b76b7dfba453523d$var$string = $b76b7dfba453523d$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $b76b7dfba453523d$var$ascii = $b76b7dfba453523d$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = (0, $bPwtR.allocUnsafe)(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $b76b7dfba453523d$var$BASES = {
    utf8: $b76b7dfba453523d$var$string,
    "utf-8": $b76b7dfba453523d$var$string,
    hex: (0, $41YhS.bases).base16,
    latin1: $b76b7dfba453523d$var$ascii,
    ascii: $b76b7dfba453523d$var$ascii,
    binary: $b76b7dfba453523d$var$ascii,
    ...(0, $41YhS.bases)
};
var $b76b7dfba453523d$export$2e2bcd8739ae039 = $b76b7dfba453523d$var$BASES;

});
parcelRegister("41YhS", function(module, exports) {

$parcel$export(module.exports, "bases", function () { return $2ef605340aa0d196$export$196f613671eb7dd9; });

var $cDPG8 = parcelRequire("cDPG8");

var $9jeeo = parcelRequire("9jeeo");

var $4g1si = parcelRequire("4g1si");

var $gZQhI = parcelRequire("gZQhI");

var $fwZfS = parcelRequire("fwZfS");

var $itJmu = parcelRequire("itJmu");

var $b5mij = parcelRequire("b5mij");

var $fmasl = parcelRequire("fmasl");

var $8oVwE = parcelRequire("8oVwE");

var $7BEwb = parcelRequire("7BEwb");

var $1GzIA = parcelRequire("1GzIA");

var $hXniq = parcelRequire("hXniq");

var $43Bnv = parcelRequire("43Bnv");

var $32SgA = parcelRequire("32SgA");
parcelRequire("6kvD3");
var $cDvYj = parcelRequire("cDvYj");
var $72k4s = parcelRequire("72k4s");
var $2gCI5 = parcelRequire("2gCI5");
var $efRTy = parcelRequire("efRTy");
var $dwwI0 = parcelRequire("dwwI0");
const $2ef605340aa0d196$export$196f613671eb7dd9 = {
    ...$cDPG8,
    ...$9jeeo,
    ...$4g1si,
    ...$gZQhI,
    ...$fwZfS,
    ...$itJmu,
    ...$b5mij,
    ...$fmasl,
    ...$8oVwE,
    ...$7BEwb
};
const $2ef605340aa0d196$export$cff071c6f82b8944 = {
    ...$1GzIA,
    ...$hXniq
};
const $2ef605340aa0d196$export$b2c6ab3b27d60531 = {
    raw: $43Bnv,
    json: $32SgA
};

});
parcelRegister("cDPG8", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $934136d8de53dd73$export$f0954fd7d5368655; });

var $2cwAC = parcelRequire("2cwAC");

var $dwwI0 = parcelRequire("dwwI0");
const $934136d8de53dd73$export$f0954fd7d5368655 = (0, $2cwAC.from)({
    prefix: "\0",
    name: "identity",
    encode: (buf)=>(0, $dwwI0.toString)(buf),
    decode: (str)=>(0, $dwwI0.fromString)(str)
});

});
parcelRegister("2cwAC", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $19a5fb601fbeafdc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "baseX", function () { return $19a5fb601fbeafdc$export$180c73aedea7f385; });
$parcel$export(module.exports, "rfc4648", function () { return $19a5fb601fbeafdc$export$fa9dde04c7d2f31a; });

var $1DnEL = parcelRequire("1DnEL");

var $dwwI0 = parcelRequire("dwwI0");
class $19a5fb601fbeafdc$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $19a5fb601fbeafdc$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $19a5fb601fbeafdc$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $19a5fb601fbeafdc$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $19a5fb601fbeafdc$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $19a5fb601fbeafdc$export$252bb8b3bbdf6749 = (left, right)=>new $19a5fb601fbeafdc$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $19a5fb601fbeafdc$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $19a5fb601fbeafdc$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $19a5fb601fbeafdc$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $19a5fb601fbeafdc$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $19a5fb601fbeafdc$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $19a5fb601fbeafdc$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $1DnEL.default)(alphabet, name);
    return $19a5fb601fbeafdc$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $dwwI0.coerce)(decode(text))
    });
};
const $19a5fb601fbeafdc$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $19a5fb601fbeafdc$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $19a5fb601fbeafdc$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $19a5fb601fbeafdc$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $19a5fb601fbeafdc$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $19a5fb601fbeafdc$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};

});
parcelRegister("1DnEL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130bc8a3f9949eac$export$2e2bcd8739ae039; });
function $130bc8a3f9949eac$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $130bc8a3f9949eac$var$src = $130bc8a3f9949eac$var$base;
var $130bc8a3f9949eac$var$_brrp__multiformats_scope_baseX = $130bc8a3f9949eac$var$src;
var $130bc8a3f9949eac$export$2e2bcd8739ae039 = $130bc8a3f9949eac$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("dwwI0", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $9d87a2d20044c0f3$export$e9bab7fafb253603; });
$parcel$export(module.exports, "coerce", function () { return $9d87a2d20044c0f3$export$8c14e57e778d3873; });
$parcel$export(module.exports, "fromString", function () { return $9d87a2d20044c0f3$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $9d87a2d20044c0f3$export$f84e8e69fd4488a5; });
const $9d87a2d20044c0f3$export$6e22c362a0406a2c = new Uint8Array(0);
const $9d87a2d20044c0f3$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $9d87a2d20044c0f3$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $9d87a2d20044c0f3$export$6e22c362a0406a2c;
};
const $9d87a2d20044c0f3$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $9d87a2d20044c0f3$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $9d87a2d20044c0f3$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $9d87a2d20044c0f3$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $9d87a2d20044c0f3$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);

});



parcelRegister("9jeeo", function(module, exports) {

$parcel$export(module.exports, "base2", function () { return $6c70ed665a54df30$export$ed5f7917e37e31aa; });

var $2cwAC = parcelRequire("2cwAC");
const $6c70ed665a54df30$export$ed5f7917e37e31aa = (0, $2cwAC.rfc4648)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});

});

parcelRegister("4g1si", function(module, exports) {

$parcel$export(module.exports, "base8", function () { return $3199c908e2e3cf52$export$43b580ac9deb5b96; });

var $2cwAC = parcelRequire("2cwAC");
const $3199c908e2e3cf52$export$43b580ac9deb5b96 = (0, $2cwAC.rfc4648)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});

});

parcelRegister("gZQhI", function(module, exports) {

$parcel$export(module.exports, "base10", function () { return $c5fae67fd42f113d$export$63d6a7de0ff813cc; });

var $2cwAC = parcelRequire("2cwAC");
const $c5fae67fd42f113d$export$63d6a7de0ff813cc = (0, $2cwAC.baseX)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});

});

parcelRegister("fwZfS", function(module, exports) {

$parcel$export(module.exports, "base16", function () { return $b4e95c25770bb835$export$586f61c71cb02fe4; });
$parcel$export(module.exports, "base16upper", function () { return $b4e95c25770bb835$export$2d835b8dd4032b62; });

var $2cwAC = parcelRequire("2cwAC");
const $b4e95c25770bb835$export$586f61c71cb02fe4 = (0, $2cwAC.rfc4648)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $b4e95c25770bb835$export$2d835b8dd4032b62 = (0, $2cwAC.rfc4648)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});

});

parcelRegister("itJmu", function(module, exports) {

$parcel$export(module.exports, "base32", function () { return $d73e1f4faba14320$export$4a4d5965e2738b2a; });
$parcel$export(module.exports, "base32upper", function () { return $d73e1f4faba14320$export$fbaa3bbbd754def4; });
$parcel$export(module.exports, "base32pad", function () { return $d73e1f4faba14320$export$e194fa100d329365; });
$parcel$export(module.exports, "base32padupper", function () { return $d73e1f4faba14320$export$3a9fc48d294dce32; });
$parcel$export(module.exports, "base32hex", function () { return $d73e1f4faba14320$export$c57d6760d519c8ac; });
$parcel$export(module.exports, "base32hexupper", function () { return $d73e1f4faba14320$export$8cf4640df3165d29; });
$parcel$export(module.exports, "base32hexpad", function () { return $d73e1f4faba14320$export$8c6a05c08ec7d456; });
$parcel$export(module.exports, "base32hexpadupper", function () { return $d73e1f4faba14320$export$29f73c6a744e639f; });
$parcel$export(module.exports, "base32z", function () { return $d73e1f4faba14320$export$fdad9af4bdc05e3; });

var $2cwAC = parcelRequire("2cwAC");
const $d73e1f4faba14320$export$4a4d5965e2738b2a = (0, $2cwAC.rfc4648)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$fbaa3bbbd754def4 = (0, $2cwAC.rfc4648)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$e194fa100d329365 = (0, $2cwAC.rfc4648)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$3a9fc48d294dce32 = (0, $2cwAC.rfc4648)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$c57d6760d519c8ac = (0, $2cwAC.rfc4648)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$8cf4640df3165d29 = (0, $2cwAC.rfc4648)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$8c6a05c08ec7d456 = (0, $2cwAC.rfc4648)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$29f73c6a744e639f = (0, $2cwAC.rfc4648)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $d73e1f4faba14320$export$fdad9af4bdc05e3 = (0, $2cwAC.rfc4648)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});

});

parcelRegister("b5mij", function(module, exports) {

$parcel$export(module.exports, "base36", function () { return $8121748e2ce2b47f$export$95b61e7c39ae893a; });
$parcel$export(module.exports, "base36upper", function () { return $8121748e2ce2b47f$export$bab7c9bdb963afd; });

var $2cwAC = parcelRequire("2cwAC");
const $8121748e2ce2b47f$export$95b61e7c39ae893a = (0, $2cwAC.baseX)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $8121748e2ce2b47f$export$bab7c9bdb963afd = (0, $2cwAC.baseX)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});

});

parcelRegister("fmasl", function(module, exports) {

$parcel$export(module.exports, "base58btc", function () { return $b2e1057c4394c2aa$export$65c61748a9b98a2c; });
$parcel$export(module.exports, "base58flickr", function () { return $b2e1057c4394c2aa$export$c6a7baed2941aad2; });

var $2cwAC = parcelRequire("2cwAC");
const $b2e1057c4394c2aa$export$65c61748a9b98a2c = (0, $2cwAC.baseX)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $b2e1057c4394c2aa$export$c6a7baed2941aad2 = (0, $2cwAC.baseX)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});

});

parcelRegister("8oVwE", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $61dd3002d6ed38a9$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64pad", function () { return $61dd3002d6ed38a9$export$a9c086fc40b4563c; });
$parcel$export(module.exports, "base64url", function () { return $61dd3002d6ed38a9$export$7d21597c7bc64465; });
$parcel$export(module.exports, "base64urlpad", function () { return $61dd3002d6ed38a9$export$e87ddc9183aa53c9; });

var $2cwAC = parcelRequire("2cwAC");
const $61dd3002d6ed38a9$export$b3b2de96497acc47 = (0, $2cwAC.rfc4648)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $61dd3002d6ed38a9$export$a9c086fc40b4563c = (0, $2cwAC.rfc4648)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $61dd3002d6ed38a9$export$7d21597c7bc64465 = (0, $2cwAC.rfc4648)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $61dd3002d6ed38a9$export$e87ddc9183aa53c9 = (0, $2cwAC.rfc4648)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});

});

parcelRegister("7BEwb", function(module, exports) {

$parcel$export(module.exports, "base256emoji", function () { return $589b6b24c53d45d7$export$6a5d4ab6075d2779; });

var $2cwAC = parcelRequire("2cwAC");
const $589b6b24c53d45d7$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $589b6b24c53d45d7$var$alphabetBytesToChars = $589b6b24c53d45d7$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $589b6b24c53d45d7$var$alphabetCharsToBytes = $589b6b24c53d45d7$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $589b6b24c53d45d7$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $589b6b24c53d45d7$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $589b6b24c53d45d7$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $589b6b24c53d45d7$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $589b6b24c53d45d7$export$6a5d4ab6075d2779 = (0, $2cwAC.from)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $589b6b24c53d45d7$var$encode,
    decode: $589b6b24c53d45d7$var$decode
});

});

parcelRegister("1GzIA", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $13a56b949a3ac2e3$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $13a56b949a3ac2e3$export$a888d2532e6dc7bb; });

var $72k4s = parcelRequire("72k4s");
const $13a56b949a3ac2e3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $13a56b949a3ac2e3$export$bced8d2aada2d1c9 = (0, $72k4s.from)({
    name: "sha2-256",
    code: 18,
    encode: $13a56b949a3ac2e3$var$sha("SHA-256")
});
const $13a56b949a3ac2e3$export$a888d2532e6dc7bb = (0, $72k4s.from)({
    name: "sha2-512",
    code: 19,
    encode: $13a56b949a3ac2e3$var$sha("SHA-512")
});

});
parcelRegister("72k4s", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $51f849fc33a3b9cc$export$6788812c4e6611e6; });

var $2gCI5 = parcelRequire("2gCI5");
const $51f849fc33a3b9cc$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $51f849fc33a3b9cc$export$df06eed23808f4d0(name, code, encode);
class $51f849fc33a3b9cc$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $2gCI5.create(this.code, result) : result.then((digest)=>$2gCI5.create(this.code, digest));
        } else throw Error("Unknown type, must be binary type");
    }
}

});
parcelRegister("2gCI5", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $1a6b1a676ad07961$export$185802fd694ee1f5; });
$parcel$export(module.exports, "Digest", function () { return $1a6b1a676ad07961$export$d67a82ff561eff43; });
$parcel$export(module.exports, "decode", function () { return $1a6b1a676ad07961$export$2f872c0f2117be69; });
$parcel$export(module.exports, "equals", function () { return $1a6b1a676ad07961$export$e9bab7fafb253603; });

var $dwwI0 = parcelRequire("dwwI0");

var $efRTy = parcelRequire("efRTy");
const $1a6b1a676ad07961$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $efRTy.encodingLength(code);
    const digestOffset = sizeOffset + $efRTy.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $efRTy.encodeTo(code, bytes, 0);
    $efRTy.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $1a6b1a676ad07961$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $1a6b1a676ad07961$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $dwwI0.coerce)(multihash);
    const [code, sizeOffset] = $efRTy.decode(bytes);
    const [size, digestOffset] = $efRTy.decode(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $1a6b1a676ad07961$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $1a6b1a676ad07961$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $dwwI0.equals)(a.bytes, b.bytes);
};
class $1a6b1a676ad07961$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}

});
parcelRegister("efRTy", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $a60c45d2862bfa2a$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encodeTo", function () { return $a60c45d2862bfa2a$export$8512cbe4228de3b3; });
$parcel$export(module.exports, "encodingLength", function () { return $a60c45d2862bfa2a$export$cbee51f25f0626d7; });

var $k27Ou = parcelRequire("k27Ou");
const $a60c45d2862bfa2a$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $k27Ou.default).decode(data, offset);
    return [
        code,
        (0, $k27Ou.default).decode.bytes
    ];
};
const $a60c45d2862bfa2a$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $k27Ou.default).encode(int, target, offset);
    return target;
};
const $a60c45d2862bfa2a$export$cbee51f25f0626d7 = (int)=>{
    return (0, $k27Ou.default).encodingLength(int);
};

});
parcelRegister("k27Ou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95a0e23d4a0a067$export$2e2bcd8739ae039; });
var $e95a0e23d4a0a067$var$encode_1 = $e95a0e23d4a0a067$var$encode;
var $e95a0e23d4a0a067$var$MSB = 128, $e95a0e23d4a0a067$var$REST = 127, $e95a0e23d4a0a067$var$MSBALL = ~$e95a0e23d4a0a067$var$REST, $e95a0e23d4a0a067$var$INT = Math.pow(2, 31);
function $e95a0e23d4a0a067$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $e95a0e23d4a0a067$var$INT){
        out[offset++] = num & 255 | $e95a0e23d4a0a067$var$MSB;
        num /= 128;
    }
    while(num & $e95a0e23d4a0a067$var$MSBALL){
        out[offset++] = num & 255 | $e95a0e23d4a0a067$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $e95a0e23d4a0a067$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $e95a0e23d4a0a067$var$decode = $e95a0e23d4a0a067$var$read;
var $e95a0e23d4a0a067$var$MSB$1 = 128, $e95a0e23d4a0a067$var$REST$1 = 127;
function $e95a0e23d4a0a067$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $e95a0e23d4a0a067$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $e95a0e23d4a0a067$var$REST$1) << shift : (b & $e95a0e23d4a0a067$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $e95a0e23d4a0a067$var$MSB$1);
    $e95a0e23d4a0a067$var$read.bytes = counter - offset;
    return res;
}
var $e95a0e23d4a0a067$var$N1 = Math.pow(2, 7);
var $e95a0e23d4a0a067$var$N2 = Math.pow(2, 14);
var $e95a0e23d4a0a067$var$N3 = Math.pow(2, 21);
var $e95a0e23d4a0a067$var$N4 = Math.pow(2, 28);
var $e95a0e23d4a0a067$var$N5 = Math.pow(2, 35);
var $e95a0e23d4a0a067$var$N6 = Math.pow(2, 42);
var $e95a0e23d4a0a067$var$N7 = Math.pow(2, 49);
var $e95a0e23d4a0a067$var$N8 = Math.pow(2, 56);
var $e95a0e23d4a0a067$var$N9 = Math.pow(2, 63);
var $e95a0e23d4a0a067$var$length = function(value) {
    return value < $e95a0e23d4a0a067$var$N1 ? 1 : value < $e95a0e23d4a0a067$var$N2 ? 2 : value < $e95a0e23d4a0a067$var$N3 ? 3 : value < $e95a0e23d4a0a067$var$N4 ? 4 : value < $e95a0e23d4a0a067$var$N5 ? 5 : value < $e95a0e23d4a0a067$var$N6 ? 6 : value < $e95a0e23d4a0a067$var$N7 ? 7 : value < $e95a0e23d4a0a067$var$N8 ? 8 : value < $e95a0e23d4a0a067$var$N9 ? 9 : 10;
};
var $e95a0e23d4a0a067$var$varint = {
    encode: $e95a0e23d4a0a067$var$encode_1,
    decode: $e95a0e23d4a0a067$var$decode,
    encodingLength: $e95a0e23d4a0a067$var$length
};
var $e95a0e23d4a0a067$var$_brrp_varint = $e95a0e23d4a0a067$var$varint;
var $e95a0e23d4a0a067$export$2e2bcd8739ae039 = $e95a0e23d4a0a067$var$_brrp_varint;

});





parcelRegister("hXniq", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $d12a047c97d58415$export$f0954fd7d5368655; });

var $dwwI0 = parcelRequire("dwwI0");

var $2gCI5 = parcelRequire("2gCI5");
const $d12a047c97d58415$var$code = 0;
const $d12a047c97d58415$var$name = "identity";
const $d12a047c97d58415$var$encode = (0, $dwwI0.coerce);
const $d12a047c97d58415$var$digest = (input)=>$2gCI5.create($d12a047c97d58415$var$code, $d12a047c97d58415$var$encode(input));
const $d12a047c97d58415$export$f0954fd7d5368655 = {
    code: $d12a047c97d58415$var$code,
    name: $d12a047c97d58415$var$name,
    encode: $d12a047c97d58415$var$encode,
    digest: $d12a047c97d58415$var$digest
};

});

parcelRegister("43Bnv", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $2f446fc2bc7ce24d$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $2f446fc2bc7ce24d$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $2f446fc2bc7ce24d$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $2f446fc2bc7ce24d$export$2f872c0f2117be69; });

var $dwwI0 = parcelRequire("dwwI0");
const $2f446fc2bc7ce24d$export$a8ff84c12d48cfa6 = "raw";
const $2f446fc2bc7ce24d$export$6565f9f03506010b = 85;
const $2f446fc2bc7ce24d$export$c564cdbbe6da493 = (node)=>(0, $dwwI0.coerce)(node);
const $2f446fc2bc7ce24d$export$2f872c0f2117be69 = (data)=>(0, $dwwI0.coerce)(data);

});

parcelRegister("32SgA", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $237ba737981cc00e$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $237ba737981cc00e$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $237ba737981cc00e$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $237ba737981cc00e$export$2f872c0f2117be69; });
const $237ba737981cc00e$var$textEncoder = new TextEncoder();
const $237ba737981cc00e$var$textDecoder = new TextDecoder();
const $237ba737981cc00e$export$a8ff84c12d48cfa6 = "json";
const $237ba737981cc00e$export$6565f9f03506010b = 512;
const $237ba737981cc00e$export$c564cdbbe6da493 = (node)=>$237ba737981cc00e$var$textEncoder.encode(JSON.stringify(node));
const $237ba737981cc00e$export$2f872c0f2117be69 = (data)=>JSON.parse($237ba737981cc00e$var$textDecoder.decode(data));

});

parcelRegister("6kvD3", function(module, exports) {

var $cDvYj = parcelRequire("cDvYj");

var $efRTy = parcelRequire("efRTy");

var $dwwI0 = parcelRequire("dwwI0");

var $72k4s = parcelRequire("72k4s");

var $2gCI5 = parcelRequire("2gCI5");

});
parcelRegister("cDvYj", function(module, exports) {

var $efRTy = parcelRequire("efRTy");

var $2gCI5 = parcelRequire("2gCI5");

var $fmasl = parcelRequire("fmasl");

var $itJmu = parcelRequire("itJmu");

var $dwwI0 = parcelRequire("dwwI0");
class $9331ed7be7cacdb4$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $9331ed7be7cacdb4$var$hidden,
            byteLength: $9331ed7be7cacdb4$var$hidden,
            code: $9331ed7be7cacdb4$var$readonly,
            version: $9331ed7be7cacdb4$var$readonly,
            multihash: $9331ed7be7cacdb4$var$readonly,
            bytes: $9331ed7be7cacdb4$var$readonly,
            _baseCache: $9331ed7be7cacdb4$var$hidden,
            asCID: $9331ed7be7cacdb4$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $9331ed7be7cacdb4$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $9331ed7be7cacdb4$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $9331ed7be7cacdb4$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $2gCI5.create(code, digest);
                    return $9331ed7be7cacdb4$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $2gCI5.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $9331ed7be7cacdb4$var$toStringV0(bytes, _baseCache, base || (0, $fmasl.base58btc).encoder);
            default:
                return $9331ed7be7cacdb4$var$toStringV1(bytes, _baseCache, base || (0, $itJmu.base32).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $9331ed7be7cacdb4$var$deprecate(/^0\.0/, $9331ed7be7cacdb4$var$IS_CID_DEPRECATION);
        return !!(value && (value[$9331ed7be7cacdb4$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $9331ed7be7cacdb4$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $9331ed7be7cacdb4$export$12d863fcef3f6aa(version, code, multihash, bytes || $9331ed7be7cacdb4$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$9331ed7be7cacdb4$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $2gCI5.decode(multihash);
            return $9331ed7be7cacdb4$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $9331ed7be7cacdb4$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$9331ed7be7cacdb4$var$DAG_PB_CODE}) block encoding`);
                else return new $9331ed7be7cacdb4$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $9331ed7be7cacdb4$var$encodeCID(version, code, digest.bytes);
                    return new $9331ed7be7cacdb4$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $9331ed7be7cacdb4$export$12d863fcef3f6aa.create(0, $9331ed7be7cacdb4$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $9331ed7be7cacdb4$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $9331ed7be7cacdb4$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $9331ed7be7cacdb4$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $dwwI0.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $2gCI5.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $9331ed7be7cacdb4$export$12d863fcef3f6aa.createV0(digest) : $9331ed7be7cacdb4$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $efRTy.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $9331ed7be7cacdb4$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $9331ed7be7cacdb4$var$parseCIDtoBytes(source, base);
        const cid = $9331ed7be7cacdb4$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $9331ed7be7cacdb4$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || (0, $fmasl.base58btc);
                return [
                    (0, $fmasl.base58btc).prefix,
                    decoder.decode(`${(0, $fmasl.base58btc).prefix}${source}`)
                ];
            }
        case (0, $fmasl.base58btc).prefix:
            {
                const decoder = base || (0, $fmasl.base58btc);
                return [
                    (0, $fmasl.base58btc).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $itJmu.base32).prefix:
            {
                const decoder = base || (0, $itJmu.base32);
                return [
                    (0, $itJmu.base32).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $9331ed7be7cacdb4$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $fmasl.base58btc).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $9331ed7be7cacdb4$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $9331ed7be7cacdb4$var$DAG_PB_CODE = 112;
const $9331ed7be7cacdb4$var$SHA_256_CODE = 18;
const $9331ed7be7cacdb4$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $efRTy.encodingLength(version);
    const hashOffset = codeOffset + $efRTy.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $efRTy.encodeTo(version, bytes, 0);
    $efRTy.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $9331ed7be7cacdb4$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $9331ed7be7cacdb4$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $9331ed7be7cacdb4$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $9331ed7be7cacdb4$var$version = "0.0.0-dev";
const $9331ed7be7cacdb4$var$deprecate = (range, message)=>{
    if (range.test($9331ed7be7cacdb4$var$version)) console.warn(message);
    else throw new Error(message);
};
const $9331ed7be7cacdb4$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

});





parcelRegister("BCGxC", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $071176e180382e6f$export$f84e8e69fd4488a5; });

var $fKl46 = parcelRequire("fKl46");
function $071176e180382e6f$export$f84e8e69fd4488a5(array, encoding = "utf8") {
    const base = (0, $fKl46.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}

});

parcelRegister("2ly2w", function(module, exports) {

var $bPwtR = parcelRequire("bPwtR");
function $1b57f27d8a1fe34e$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = (0, $bPwtR.allocUnsafe)(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}

});


parcelRegister("5fcsy", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", function () { return $3d1804b1a20cb76f$export$af490b3b9a6de00f; });
function $3d1804b1a20cb76f$var$e(s, r, i = "string") {
    if (!s[r] || typeof s[r] !== i) throw new Error(`Missing or invalid "${r}" param`);
}
function $3d1804b1a20cb76f$var$l(s, r) {
    let i = !0;
    return r.forEach((t)=>{
        t in s || (i = !1);
    }), i;
}
function $3d1804b1a20cb76f$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $3d1804b1a20cb76f$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $3d1804b1a20cb76f$var$u(s, r, i) {
    return (i.length ? $3d1804b1a20cb76f$var$w(s, r.length) : $3d1804b1a20cb76f$var$f(s, r.length)) ? $3d1804b1a20cb76f$var$l(s, r) : !1;
}
function $3d1804b1a20cb76f$var$n(s, r, i = "_") {
    const t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $3d1804b1a20cb76f$export$c75580565fa025bd(s) {
    return $3d1804b1a20cb76f$export$f576347163de0984(s.method) && $3d1804b1a20cb76f$export$dae2311546d43680(s.params);
}
function $3d1804b1a20cb76f$export$f576347163de0984(s) {
    return $3d1804b1a20cb76f$var$n(s, "subscribe");
}
function $3d1804b1a20cb76f$export$dae2311546d43680(s) {
    return $3d1804b1a20cb76f$var$u(s, [
        "topic"
    ], []);
}
function $3d1804b1a20cb76f$export$8fa7cf76b41caee0(s) {
    return $3d1804b1a20cb76f$export$71d4d33ac7f7a269(s.method) && $3d1804b1a20cb76f$export$71e8d1aa48c3e86f(s.params);
}
function $3d1804b1a20cb76f$export$71d4d33ac7f7a269(s) {
    return $3d1804b1a20cb76f$var$n(s, "publish");
}
function $3d1804b1a20cb76f$export$71e8d1aa48c3e86f(s) {
    return $3d1804b1a20cb76f$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $3d1804b1a20cb76f$export$83e292763180b41b(s) {
    return $3d1804b1a20cb76f$export$568d956f39536025(s.method) && $3d1804b1a20cb76f$export$cbc597c53c3b4f80(s.params);
}
function $3d1804b1a20cb76f$export$568d956f39536025(s) {
    return $3d1804b1a20cb76f$var$n(s, "unsubscribe");
}
function $3d1804b1a20cb76f$export$cbc597c53c3b4f80(s) {
    return $3d1804b1a20cb76f$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $3d1804b1a20cb76f$export$43cf4100d6287b8e(s) {
    return $3d1804b1a20cb76f$export$3cb4ad320e3a46a4(s.method) && $3d1804b1a20cb76f$export$6366ff9a39f2da4c(s.params);
}
function $3d1804b1a20cb76f$export$3cb4ad320e3a46a4(s) {
    return $3d1804b1a20cb76f$var$n(s, "subscription");
}
function $3d1804b1a20cb76f$export$6366ff9a39f2da4c(s) {
    return $3d1804b1a20cb76f$var$u(s, [
        "id",
        "data"
    ], []);
}
function $3d1804b1a20cb76f$export$abdf96c288cb375(s) {
    if (!$3d1804b1a20cb76f$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$3d1804b1a20cb76f$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const r = s.params;
    return $3d1804b1a20cb76f$var$e(r, "topic"), r;
}
function $3d1804b1a20cb76f$export$eac3e45ac5c5c9fa(s) {
    if (!$3d1804b1a20cb76f$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$3d1804b1a20cb76f$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const r = s.params;
    return $3d1804b1a20cb76f$var$e(r, "topic"), $3d1804b1a20cb76f$var$e(r, "message"), $3d1804b1a20cb76f$var$e(r, "ttl", "number"), r;
}
function $3d1804b1a20cb76f$export$78baa72f78156594(s) {
    if (!$3d1804b1a20cb76f$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$3d1804b1a20cb76f$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const r = s.params;
    return $3d1804b1a20cb76f$var$e(r, "id"), r;
}
function $3d1804b1a20cb76f$export$4d5822edd41f3b48(s) {
    if (!$3d1804b1a20cb76f$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$3d1804b1a20cb76f$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const r = s.params;
    return $3d1804b1a20cb76f$var$e(r, "id"), $3d1804b1a20cb76f$var$e(r, "data"), r;
}
const $3d1804b1a20cb76f$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};

});


parcelRegister("bzZjV", function(module, exports) {

$parcel$export(module.exports, "UniversalProvider", function () { return $86e2879031e4905e$export$63bc40680ab52599; });

var $ivHn0 = parcelRequire("ivHn0");

var $9jF5G = parcelRequire("9jF5G");

var $ksL7m = parcelRequire("ksL7m");
var $jt6FO = parcelRequire("jt6FO");

var $katVf = parcelRequire("katVf");

var $01Dhm = parcelRequire("01Dhm");
parcelRequire("3olrm");
var $3G8ou = parcelRequire("3G8ou");

var $7hlqZ = parcelRequire("7hlqZ");

var $98IaM = parcelRequire("98IaM");
var $86e2879031e4905e$require$Buffer = $98IaM.Buffer;
const $86e2879031e4905e$var$tt = "error", $86e2879031e4905e$var$St = "wss://relay.walletconnect.org", $86e2879031e4905e$var$Dt = "wc", $86e2879031e4905e$var$qt = "universal_provider", $86e2879031e4905e$var$_ = `${$86e2879031e4905e$var$Dt}@2:${$86e2879031e4905e$var$qt}:`, $86e2879031e4905e$var$et = "https://rpc.walletconnect.org/v1/", $86e2879031e4905e$var$w = "generic", $86e2879031e4905e$var$jt = `${$86e2879031e4905e$var$et}bundler`, $86e2879031e4905e$var$d = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
function $86e2879031e4905e$var$Rt() {}
function $86e2879031e4905e$var$G(s) {
    return s == null || typeof s != "object" && typeof s != "function";
}
function $86e2879031e4905e$var$J(s) {
    return ArrayBuffer.isView(s) && !(s instanceof DataView);
}
function $86e2879031e4905e$var$_t(s) {
    if ($86e2879031e4905e$var$G(s)) return s;
    if (Array.isArray(s) || $86e2879031e4905e$var$J(s) || s instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && s instanceof SharedArrayBuffer) return s.slice(0);
    const t = Object.getPrototypeOf(s), e = t.constructor;
    if (s instanceof Date || s instanceof Map || s instanceof Set) return new e(s);
    if (s instanceof RegExp) {
        const i = new e(s);
        return i.lastIndex = s.lastIndex, i;
    }
    if (s instanceof DataView) return new e(s.buffer.slice(0));
    if (s instanceof Error) {
        const i = new e(s.message);
        return i.stack = s.stack, i.name = s.name, i.cause = s.cause, i;
    }
    if (typeof File < "u" && s instanceof File) return new e([
        s
    ], s.name, {
        type: s.type,
        lastModified: s.lastModified
    });
    if (typeof s == "object") {
        const i = Object.create(t);
        return Object.assign(i, s);
    }
    return s;
}
function $86e2879031e4905e$var$st(s) {
    return typeof s == "object" && s !== null;
}
function $86e2879031e4905e$var$it(s) {
    return Object.getOwnPropertySymbols(s).filter((t)=>Object.prototype.propertyIsEnumerable.call(s, t));
}
function $86e2879031e4905e$var$rt(s) {
    return s == null ? s === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(s);
}
const $86e2879031e4905e$var$Ut = "[object RegExp]", $86e2879031e4905e$var$nt = "[object String]", $86e2879031e4905e$var$at = "[object Number]", $86e2879031e4905e$var$ct = "[object Boolean]", $86e2879031e4905e$var$ot = "[object Arguments]", $86e2879031e4905e$var$Ft = "[object Symbol]", $86e2879031e4905e$var$Lt = "[object Date]", $86e2879031e4905e$var$xt = "[object Map]", $86e2879031e4905e$var$Mt = "[object Set]", $86e2879031e4905e$var$Bt = "[object Array]", $86e2879031e4905e$var$Gt = "[object ArrayBuffer]", $86e2879031e4905e$var$Jt = "[object Object]", $86e2879031e4905e$var$zt = "[object DataView]", $86e2879031e4905e$var$kt = "[object Uint8Array]", $86e2879031e4905e$var$Wt = "[object Uint8ClampedArray]", $86e2879031e4905e$var$Kt = "[object Uint16Array]", $86e2879031e4905e$var$Vt = "[object Uint32Array]", $86e2879031e4905e$var$Xt = "[object Int8Array]", $86e2879031e4905e$var$Yt = "[object Int16Array]", $86e2879031e4905e$var$Qt = "[object Int32Array]", $86e2879031e4905e$var$Zt = "[object Float32Array]", $86e2879031e4905e$var$Tt = "[object Float64Array]";
function $86e2879031e4905e$var$te(s, t) {
    return $86e2879031e4905e$var$y(s, void 0, s, new Map, t);
}
function $86e2879031e4905e$var$y(s, t, e, i = new Map, n) {
    const a = n?.(s, t, e, i);
    if (a != null) return a;
    if ($86e2879031e4905e$var$G(s)) return s;
    if (i.has(s)) return i.get(s);
    if (Array.isArray(s)) {
        const r = new Array(s.length);
        i.set(s, r);
        for(let c = 0; c < s.length; c++)r[c] = $86e2879031e4905e$var$y(s[c], c, e, i, n);
        return Object.hasOwn(s, "index") && (r.index = s.index), Object.hasOwn(s, "input") && (r.input = s.input), r;
    }
    if (s instanceof Date) return new Date(s.getTime());
    if (s instanceof RegExp) {
        const r = new RegExp(s.source, s.flags);
        return r.lastIndex = s.lastIndex, r;
    }
    if (s instanceof Map) {
        const r = new Map;
        i.set(s, r);
        for (const [c, o] of s)r.set(c, $86e2879031e4905e$var$y(o, c, e, i, n));
        return r;
    }
    if (s instanceof Set) {
        const r = new Set;
        i.set(s, r);
        for (const c of s)r.add($86e2879031e4905e$var$y(c, void 0, e, i, n));
        return r;
    }
    if (typeof $86e2879031e4905e$require$Buffer < "u" && $86e2879031e4905e$require$Buffer.isBuffer(s)) return s.subarray();
    if ($86e2879031e4905e$var$J(s)) {
        const r = new (Object.getPrototypeOf(s)).constructor(s.length);
        i.set(s, r);
        for(let c = 0; c < s.length; c++)r[c] = $86e2879031e4905e$var$y(s[c], c, e, i, n);
        return r;
    }
    if (s instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && s instanceof SharedArrayBuffer) return s.slice(0);
    if (s instanceof DataView) {
        const r = new DataView(s.buffer.slice(0), s.byteOffset, s.byteLength);
        return i.set(s, r), $86e2879031e4905e$var$g(r, s, e, i, n), r;
    }
    if (typeof File < "u" && s instanceof File) {
        const r = new File([
            s
        ], s.name, {
            type: s.type
        });
        return i.set(s, r), $86e2879031e4905e$var$g(r, s, e, i, n), r;
    }
    if (s instanceof Blob) {
        const r = new Blob([
            s
        ], {
            type: s.type
        });
        return i.set(s, r), $86e2879031e4905e$var$g(r, s, e, i, n), r;
    }
    if (s instanceof Error) {
        const r = new s.constructor;
        return i.set(s, r), r.message = s.message, r.name = s.name, r.stack = s.stack, r.cause = s.cause, $86e2879031e4905e$var$g(r, s, e, i, n), r;
    }
    if (typeof s == "object" && $86e2879031e4905e$var$ee(s)) {
        const r = Object.create(Object.getPrototypeOf(s));
        return i.set(s, r), $86e2879031e4905e$var$g(r, s, e, i, n), r;
    }
    return s;
}
function $86e2879031e4905e$var$g(s, t, e = s, i, n) {
    const a = [
        ...Object.keys(t),
        ...$86e2879031e4905e$var$it(t)
    ];
    for(let r = 0; r < a.length; r++){
        const c = a[r], o = Object.getOwnPropertyDescriptor(s, c);
        (o == null || o.writable) && (s[c] = $86e2879031e4905e$var$y(t[c], c, e, i, n));
    }
}
function $86e2879031e4905e$var$ee(s) {
    switch($86e2879031e4905e$var$rt(s)){
        case $86e2879031e4905e$var$ot:
        case $86e2879031e4905e$var$Bt:
        case $86e2879031e4905e$var$Gt:
        case $86e2879031e4905e$var$zt:
        case $86e2879031e4905e$var$ct:
        case $86e2879031e4905e$var$Lt:
        case $86e2879031e4905e$var$Zt:
        case $86e2879031e4905e$var$Tt:
        case $86e2879031e4905e$var$Xt:
        case $86e2879031e4905e$var$Yt:
        case $86e2879031e4905e$var$Qt:
        case $86e2879031e4905e$var$xt:
        case $86e2879031e4905e$var$at:
        case $86e2879031e4905e$var$Jt:
        case $86e2879031e4905e$var$Ut:
        case $86e2879031e4905e$var$Mt:
        case $86e2879031e4905e$var$nt:
        case $86e2879031e4905e$var$Ft:
        case $86e2879031e4905e$var$kt:
        case $86e2879031e4905e$var$Wt:
        case $86e2879031e4905e$var$Kt:
        case $86e2879031e4905e$var$Vt:
            return !0;
        default:
            return !1;
    }
}
function $86e2879031e4905e$var$se(s, t) {
    return $86e2879031e4905e$var$te(s, (e, i, n, a)=>{
        const r = t?.(e, i, n, a);
        if (r != null) return r;
        if (typeof s == "object") switch(Object.prototype.toString.call(s)){
            case $86e2879031e4905e$var$at:
            case $86e2879031e4905e$var$nt:
            case $86e2879031e4905e$var$ct:
                {
                    const c = new s.constructor(s?.valueOf());
                    return $86e2879031e4905e$var$g(c, s), c;
                }
            case $86e2879031e4905e$var$ot:
                {
                    const c = {};
                    return $86e2879031e4905e$var$g(c, s), c.length = s.length, c[Symbol.iterator] = s[Symbol.iterator], c;
                }
            default:
                return;
        }
    });
}
function $86e2879031e4905e$var$ht(s) {
    return $86e2879031e4905e$var$se(s);
}
function $86e2879031e4905e$var$pt(s) {
    return s !== null && typeof s == "object" && $86e2879031e4905e$var$rt(s) === "[object Arguments]";
}
function $86e2879031e4905e$var$ie(s) {
    return $86e2879031e4905e$var$J(s);
}
function $86e2879031e4905e$var$re(s) {
    if (typeof s != "object" || s == null) return !1;
    if (Object.getPrototypeOf(s) === null) return !0;
    if (Object.prototype.toString.call(s) !== "[object Object]") {
        const e = s[Symbol.toStringTag];
        return e == null || !Object.getOwnPropertyDescriptor(s, Symbol.toStringTag)?.writable ? !1 : s.toString() === `[object ${e}]`;
    }
    let t = s;
    for(; Object.getPrototypeOf(t) !== null;)t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(s) === t;
}
function $86e2879031e4905e$var$ne(s, ...t) {
    const e = t.slice(0, -1), i = t[t.length - 1];
    let n = s;
    for(let a = 0; a < e.length; a++){
        const r = e[a];
        n = $86e2879031e4905e$var$U(n, r, i, new Map);
    }
    return n;
}
function $86e2879031e4905e$var$U(s, t, e, i) {
    if ($86e2879031e4905e$var$G(s) && (s = Object(s)), t == null || typeof t != "object") return s;
    if (i.has(t)) return $86e2879031e4905e$var$_t(i.get(t));
    if (i.set(t, s), Array.isArray(t)) {
        t = t.slice();
        for(let a = 0; a < t.length; a++)t[a] = t[a] ?? void 0;
    }
    const n = [
        ...Object.keys(t),
        ...$86e2879031e4905e$var$it(t)
    ];
    for(let a = 0; a < n.length; a++){
        const r = n[a];
        let c = t[r], o = s[r];
        if ($86e2879031e4905e$var$pt(c) && (c = {
            ...c
        }), $86e2879031e4905e$var$pt(o) && (o = {
            ...o
        }), typeof $86e2879031e4905e$require$Buffer < "u" && $86e2879031e4905e$require$Buffer.isBuffer(c) && (c = $86e2879031e4905e$var$ht(c)), Array.isArray(c)) {
            if (typeof o == "object" && o != null) {
                const j = [], R = Reflect.ownKeys(o);
                for(let f = 0; f < R.length; f++){
                    const Y = R[f];
                    j[Y] = o[Y];
                }
                o = j;
            } else o = [];
        }
        const v = e(o, c, r, s, t, i);
        v != null ? s[r] = v : Array.isArray(c) || $86e2879031e4905e$var$st(o) && $86e2879031e4905e$var$st(c) ? s[r] = $86e2879031e4905e$var$U(o, c, e, i) : o == null && $86e2879031e4905e$var$re(c) ? s[r] = $86e2879031e4905e$var$U({}, c, e, i) : o == null && $86e2879031e4905e$var$ie(c) ? s[r] = $86e2879031e4905e$var$ht(c) : (o === void 0 || c !== void 0) && (s[r] = c);
    }
    return s;
}
function $86e2879031e4905e$var$ae(s, ...t) {
    return $86e2879031e4905e$var$ne(s, ...t, $86e2879031e4905e$var$Rt);
}
var $86e2879031e4905e$var$ce = Object.defineProperty, $86e2879031e4905e$var$oe = Object.defineProperties, $86e2879031e4905e$var$he = Object.getOwnPropertyDescriptors, $86e2879031e4905e$var$dt = Object.getOwnPropertySymbols, $86e2879031e4905e$var$pe = Object.prototype.hasOwnProperty, $86e2879031e4905e$var$de = Object.prototype.propertyIsEnumerable, $86e2879031e4905e$var$ut = (s, t, e)=>t in s ? $86e2879031e4905e$var$ce(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$F = (s, t)=>{
    for(var e in t || (t = {}))$86e2879031e4905e$var$pe.call(t, e) && $86e2879031e4905e$var$ut(s, e, t[e]);
    if ($86e2879031e4905e$var$dt) for (var e of $86e2879031e4905e$var$dt(t))$86e2879031e4905e$var$de.call(t, e) && $86e2879031e4905e$var$ut(s, e, t[e]);
    return s;
}, $86e2879031e4905e$var$ue = (s, t)=>$86e2879031e4905e$var$oe(s, $86e2879031e4905e$var$he(t));
function $86e2879031e4905e$var$p(s, t, e) {
    var i;
    const n = (0, $9jF5G.parseChainId)(s);
    return ((i = t.rpcMap) == null ? void 0 : i[n.reference]) || `${$86e2879031e4905e$var$et}?chainId=${n.namespace}:${n.reference}&projectId=${e}`;
}
function $86e2879031e4905e$var$P(s) {
    return s.includes(":") ? s.split(":")[1] : s;
}
function $86e2879031e4905e$var$lt(s) {
    return s.map((t)=>`${t.split(":")[0]}:${t.split(":")[1]}`);
}
function $86e2879031e4905e$var$le(s, t) {
    const e = Object.keys(t.namespaces).filter((n)=>n.includes(s));
    if (!e.length) return [];
    const i = [];
    return e.forEach((n)=>{
        const a = t.namespaces[n].accounts;
        i.push(...a);
    }), i;
}
function $86e2879031e4905e$var$z(s = {}, t = {}) {
    const e = $86e2879031e4905e$var$ft(s), i = $86e2879031e4905e$var$ft(t);
    return $86e2879031e4905e$var$ae(e, i);
}
function $86e2879031e4905e$var$ft(s) {
    var t, e, i, n;
    const a = {};
    if (!(0, $9jF5G.isValidObject)(s)) return a;
    for (const [r, c] of Object.entries(s)){
        const o = (0, $9jF5G.isCaipNamespace)(r) ? [
            r
        ] : c.chains, v = c.methods || [], j = c.events || [], R = c.rpcMap || {}, f = (0, $9jF5G.parseNamespaceKey)(r);
        a[f] = $86e2879031e4905e$var$ue($86e2879031e4905e$var$F($86e2879031e4905e$var$F({}, a[f]), c), {
            chains: (0, $9jF5G.mergeArrays)(o, (t = a[f]) == null ? void 0 : t.chains),
            methods: (0, $9jF5G.mergeArrays)(v, (e = a[f]) == null ? void 0 : e.methods),
            events: (0, $9jF5G.mergeArrays)(j, (i = a[f]) == null ? void 0 : i.events),
            rpcMap: $86e2879031e4905e$var$F($86e2879031e4905e$var$F({}, R), (n = a[f]) == null ? void 0 : n.rpcMap)
        });
    }
    return a;
}
function $86e2879031e4905e$var$mt(s) {
    return s.includes(":") ? s.split(":")[2] : s;
}
function $86e2879031e4905e$var$vt(s) {
    const t = {};
    for (const [e, i] of Object.entries(s)){
        const n = i.methods || [], a = i.events || [], r = i.accounts || [], c = (0, $9jF5G.isCaipNamespace)(e) ? [
            e
        ] : i.chains ? i.chains : $86e2879031e4905e$var$lt(i.accounts);
        t[e] = {
            chains: c,
            methods: n,
            events: a,
            accounts: r
        };
    }
    return t;
}
function $86e2879031e4905e$var$k(s) {
    return typeof s == "number" ? s : s.includes("0x") ? parseInt(s, 16) : (s = s.includes(":") ? s.split(":")[1] : s, isNaN(Number(s)) ? s : Number(s));
}
const $86e2879031e4905e$var$gt = {}, $86e2879031e4905e$var$h = (s)=>$86e2879031e4905e$var$gt[s], $86e2879031e4905e$var$W = (s, t)=>{
    $86e2879031e4905e$var$gt[s] = t;
};
var $86e2879031e4905e$var$fe = Object.defineProperty, $86e2879031e4905e$var$me = (s, t, e)=>t in s ? $86e2879031e4905e$var$fe(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$b = (s, t, e)=>$86e2879031e4905e$var$me(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$ve {
    constructor(t){
        $86e2879031e4905e$var$b(this, "name", "polkadot"), $86e2879031e4905e$var$b(this, "client"), $86e2879031e4905e$var$b(this, "httpProviders"), $86e2879031e4905e$var$b(this, "events"), $86e2879031e4905e$var$b(this, "namespace"), $86e2879031e4905e$var$b(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $86e2879031e4905e$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$ge = Object.defineProperty, $86e2879031e4905e$var$Pe = Object.defineProperties, $86e2879031e4905e$var$we = Object.getOwnPropertyDescriptors, $86e2879031e4905e$var$Pt = Object.getOwnPropertySymbols, $86e2879031e4905e$var$ye = Object.prototype.hasOwnProperty, $86e2879031e4905e$var$be = Object.prototype.propertyIsEnumerable, $86e2879031e4905e$var$K = (s, t, e)=>t in s ? $86e2879031e4905e$var$ge(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$wt = (s, t)=>{
    for(var e in t || (t = {}))$86e2879031e4905e$var$ye.call(t, e) && $86e2879031e4905e$var$K(s, e, t[e]);
    if ($86e2879031e4905e$var$Pt) for (var e of $86e2879031e4905e$var$Pt(t))$86e2879031e4905e$var$be.call(t, e) && $86e2879031e4905e$var$K(s, e, t[e]);
    return s;
}, $86e2879031e4905e$var$yt = (s, t)=>$86e2879031e4905e$var$Pe(s, $86e2879031e4905e$var$we(t)), $86e2879031e4905e$var$I = (s, t, e)=>$86e2879031e4905e$var$K(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Ie {
    constructor(t){
        $86e2879031e4905e$var$I(this, "name", "eip155"), $86e2879031e4905e$var$I(this, "client"), $86e2879031e4905e$var$I(this, "chainId"), $86e2879031e4905e$var$I(this, "namespace"), $86e2879031e4905e$var$I(this, "httpProviders"), $86e2879031e4905e$var$I(this, "events"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(t) {
        switch(t.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(t);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
            case "wallet_getCapabilities":
                return await this.getCapabilities(t);
            case "wallet_getCallsStatus":
                return await this.getCallStatus(t);
        }
        return this.namespace.methods.includes(t.request.method) ? await this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(parseInt(t), e), this.chainId = parseInt(t), this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(`${this.name}:${t}`, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.HttpConnection)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = parseInt($86e2879031e4905e$var$P(e));
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const t = this.chainId, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    async handleSwitchChain(t) {
        var e, i;
        let n = t.request.params ? (e = t.request.params[0]) == null ? void 0 : e.chainId : "0x0";
        n = n.startsWith("0x") ? n : `0x${n}`;
        const a = parseInt(n, 16);
        if (this.isChainApproved(a)) this.setDefaultChain(`${a}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: t.topic,
            request: {
                method: t.request.method,
                params: [
                    {
                        chainId: n
                    }
                ]
            },
            chainId: (i = this.namespace.chains) == null ? void 0 : i[0]
        }), this.setDefaultChain(`${a}`);
        else throw new Error(`Failed to switch to chain 'eip155:${a}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(t) {
        return this.namespace.chains.includes(`${this.name}:${t}`);
    }
    async getCapabilities(t) {
        var e, i, n;
        const a = (i = (e = t.request) == null ? void 0 : e.params) == null ? void 0 : i[0];
        if (!a) throw new Error("Missing address parameter in `wallet_getCapabilities` request");
        const r = this.client.session.get(t.topic), c = ((n = r?.sessionProperties) == null ? void 0 : n.capabilities) || {};
        if (c != null && c[a]) return c?.[a];
        const o = await this.client.request(t);
        try {
            await this.client.session.update(t.topic, {
                sessionProperties: $86e2879031e4905e$var$yt($86e2879031e4905e$var$wt({}, r.sessionProperties || {}), {
                    capabilities: $86e2879031e4905e$var$yt($86e2879031e4905e$var$wt({}, c || {}), {
                        [a]: o
                    })
                })
            });
        } catch (v) {
            console.warn("Failed to update session with capabilities", v);
        }
        return o;
    }
    async getCallStatus(t) {
        var e, i;
        const n = this.client.session.get(t.topic), a = (e = n.sessionProperties) == null ? void 0 : e.bundler_name;
        if (a) {
            const c = this.getBundlerUrl(t.chainId, a);
            try {
                return await this.getUserOperationReceipt(c, t);
            } catch (o) {
                console.warn("Failed to fetch call status from bundler", o, c);
            }
        }
        const r = (i = n.sessionProperties) == null ? void 0 : i.bundler_url;
        if (r) try {
            return await this.getUserOperationReceipt(r, t);
        } catch (c) {
            console.warn("Failed to fetch call status from custom bundler", c, r);
        }
        if (this.namespace.methods.includes(t.request.method)) return await this.client.request(t);
        throw new Error("Fetching call status not approved by the wallet.");
    }
    async getUserOperationReceipt(t, e) {
        var i;
        const n = new URL(t), a = await fetch(n, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify((0, $3G8ou.formatJsonRpcRequest)("eth_getUserOperationReceipt", [
                (i = e.request.params) == null ? void 0 : i[0]
            ]))
        });
        if (!a.ok) throw new Error(`Failed to fetch user operation receipt - ${a.status}`);
        return await a.json();
    }
    getBundlerUrl(t, e) {
        return `${$86e2879031e4905e$var$jt}?projectId=${this.client.core.projectId}&chainId=${t}&bundler=${e}`;
    }
}
var $86e2879031e4905e$var$$e = Object.defineProperty, $86e2879031e4905e$var$Oe = (s, t, e)=>t in s ? $86e2879031e4905e$var$$e(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$$ = (s, t, e)=>$86e2879031e4905e$var$Oe(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Ae {
    constructor(t){
        $86e2879031e4905e$var$$(this, "name", "solana"), $86e2879031e4905e$var$$(this, "client"), $86e2879031e4905e$var$$(this, "httpProviders"), $86e2879031e4905e$var$$(this, "events"), $86e2879031e4905e$var$$(this, "namespace"), $86e2879031e4905e$var$$(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $86e2879031e4905e$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$Ce = Object.defineProperty, $86e2879031e4905e$var$He = (s, t, e)=>t in s ? $86e2879031e4905e$var$Ce(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$O = (s, t, e)=>$86e2879031e4905e$var$He(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Ee {
    constructor(t){
        $86e2879031e4905e$var$O(this, "name", "cosmos"), $86e2879031e4905e$var$O(this, "client"), $86e2879031e4905e$var$O(this, "httpProviders"), $86e2879031e4905e$var$O(this, "events"), $86e2879031e4905e$var$O(this, "namespace"), $86e2879031e4905e$var$O(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $86e2879031e4905e$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$Ne = Object.defineProperty, $86e2879031e4905e$var$Se = (s, t, e)=>t in s ? $86e2879031e4905e$var$Ne(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$A = (s, t, e)=>$86e2879031e4905e$var$Se(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$De {
    constructor(t){
        $86e2879031e4905e$var$A(this, "name", "algorand"), $86e2879031e4905e$var$A(this, "client"), $86e2879031e4905e$var$A(this, "httpProviders"), $86e2879031e4905e$var$A(this, "events"), $86e2879031e4905e$var$A(this, "namespace"), $86e2879031e4905e$var$A(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        if (!this.httpProviders[t]) {
            const i = e || $86e2879031e4905e$var$p(`${this.name}:${t}`, this.namespace, this.client.core.projectId);
            if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
            this.setHttpProvider(t, i);
        }
        this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            t[e] = this.createHttpProvider(e, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        return typeof i > "u" ? void 0 : new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$qe = Object.defineProperty, $86e2879031e4905e$var$je = (s, t, e)=>t in s ? $86e2879031e4905e$var$qe(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$C = (s, t, e)=>$86e2879031e4905e$var$je(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Re {
    constructor(t){
        $86e2879031e4905e$var$C(this, "name", "cip34"), $86e2879031e4905e$var$C(this, "client"), $86e2879031e4905e$var$C(this, "httpProviders"), $86e2879031e4905e$var$C(this, "events"), $86e2879031e4905e$var$C(this, "namespace"), $86e2879031e4905e$var$C(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            const i = this.getCardanoRPCUrl(e), n = $86e2879031e4905e$var$P(e);
            t[n] = this.createHttpProvider(n, i);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    getCardanoRPCUrl(t) {
        const e = this.namespace.rpcMap;
        if (e) return e[t];
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || this.getCardanoRPCUrl(t);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$_e = Object.defineProperty, $86e2879031e4905e$var$Ue = (s, t, e)=>t in s ? $86e2879031e4905e$var$_e(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$H = (s, t, e)=>$86e2879031e4905e$var$Ue(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Fe {
    constructor(t){
        $86e2879031e4905e$var$H(this, "name", "elrond"), $86e2879031e4905e$var$H(this, "client"), $86e2879031e4905e$var$H(this, "httpProviders"), $86e2879031e4905e$var$H(this, "events"), $86e2879031e4905e$var$H(this, "namespace"), $86e2879031e4905e$var$H(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $86e2879031e4905e$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$Le = Object.defineProperty, $86e2879031e4905e$var$xe = (s, t, e)=>t in s ? $86e2879031e4905e$var$Le(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$E = (s, t, e)=>$86e2879031e4905e$var$xe(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Me {
    constructor(t){
        $86e2879031e4905e$var$E(this, "name", "multiversx"), $86e2879031e4905e$var$E(this, "client"), $86e2879031e4905e$var$E(this, "httpProviders"), $86e2879031e4905e$var$E(this, "events"), $86e2879031e4905e$var$E(this, "namespace"), $86e2879031e4905e$var$E(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            const n = $86e2879031e4905e$var$P(e);
            t[n] = this.createHttpProvider(n, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$Be = Object.defineProperty, $86e2879031e4905e$var$Ge = (s, t, e)=>t in s ? $86e2879031e4905e$var$Be(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$N = (s, t, e)=>$86e2879031e4905e$var$Ge(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Je {
    constructor(t){
        $86e2879031e4905e$var$N(this, "name", "near"), $86e2879031e4905e$var$N(this, "client"), $86e2879031e4905e$var$N(this, "httpProviders"), $86e2879031e4905e$var$N(this, "events"), $86e2879031e4905e$var$N(this, "namespace"), $86e2879031e4905e$var$N(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        if (this.chainId = t, !this.httpProviders[t]) {
            const i = e || $86e2879031e4905e$var$p(`${this.name}:${t}`, this.namespace);
            if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
            this.setHttpProvider(t, i);
        }
        this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            var i;
            t[e] = this.createHttpProvider(e, (i = this.namespace.rpcMap) == null ? void 0 : i[e]);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace);
        return typeof i > "u" ? void 0 : new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$ze = Object.defineProperty, $86e2879031e4905e$var$ke = (s, t, e)=>t in s ? $86e2879031e4905e$var$ze(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$S = (s, t, e)=>$86e2879031e4905e$var$ke(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$We {
    constructor(t){
        $86e2879031e4905e$var$S(this, "name", "tezos"), $86e2879031e4905e$var$S(this, "client"), $86e2879031e4905e$var$S(this, "httpProviders"), $86e2879031e4905e$var$S(this, "events"), $86e2879031e4905e$var$S(this, "namespace"), $86e2879031e4905e$var$S(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace = Object.assign(this.namespace, t);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider().request(t.request);
    }
    setDefaultChain(t, e) {
        if (this.chainId = t, !this.httpProviders[t]) {
            const i = e || $86e2879031e4905e$var$p(`${this.name}:${t}`, this.namespace);
            if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
            this.setHttpProvider(t, i);
        }
        this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const t = {};
        return this.namespace.chains.forEach((e)=>{
            t[e] = this.createHttpProvider(e);
        }), t;
    }
    getHttpProvider() {
        const t = `${this.name}:${this.chainId}`, e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace);
        return typeof i > "u" ? void 0 : new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i));
    }
}
var $86e2879031e4905e$var$Ke = Object.defineProperty, $86e2879031e4905e$var$Ve = (s, t, e)=>t in s ? $86e2879031e4905e$var$Ke(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$D = (s, t, e)=>$86e2879031e4905e$var$Ve(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$var$Xe {
    constructor(t){
        $86e2879031e4905e$var$D(this, "name", $86e2879031e4905e$var$w), $86e2879031e4905e$var$D(this, "client"), $86e2879031e4905e$var$D(this, "httpProviders"), $86e2879031e4905e$var$D(this, "events"), $86e2879031e4905e$var$D(this, "namespace"), $86e2879031e4905e$var$D(this, "chainId"), this.namespace = t.namespace, this.events = $86e2879031e4905e$var$h("events"), this.client = $86e2879031e4905e$var$h("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(t) {
        this.namespace.chains = [
            ...new Set((this.namespace.chains || []).concat(t.chains || []))
        ], this.namespace.accounts = [
            ...new Set((this.namespace.accounts || []).concat(t.accounts || []))
        ], this.namespace.methods = [
            ...new Set((this.namespace.methods || []).concat(t.methods || []))
        ], this.namespace.events = [
            ...new Set((this.namespace.events || []).concat(t.events || []))
        ], this.httpProviders = this.createHttpProviders();
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(t) {
        return this.namespace.methods.includes(t.request.method) ? this.client.request(t) : this.getHttpProvider(t.chainId).request(t.request);
    }
    setDefaultChain(t, e) {
        this.httpProviders[t] || this.setHttpProvider(t, e), this.chainId = t, this.events.emit($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, `${this.name}:${t}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const t = this.namespace.chains[0];
        if (!t) throw new Error("ChainId not found");
        return t.split(":")[1];
    }
    getAccounts() {
        const t = this.namespace.accounts;
        return t ? [
            ...new Set(t.filter((e)=>e.split(":")[1] === this.chainId.toString()).map((e)=>e.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        var t, e;
        const i = {};
        return (e = (t = this.namespace) == null ? void 0 : t.accounts) == null || e.forEach((n)=>{
            const a = (0, $9jF5G.parseChainId)(n);
            i[`${a.namespace}:${a.reference}`] = this.createHttpProvider(n);
        }), i;
    }
    getHttpProvider(t) {
        const e = this.httpProviders[t];
        if (typeof e > "u") throw new Error(`JSON-RPC provider for ${t} not found`);
        return e;
    }
    setHttpProvider(t, e) {
        const i = this.createHttpProvider(t, e);
        i && (this.httpProviders[t] = i);
    }
    createHttpProvider(t, e) {
        const i = e || $86e2879031e4905e$var$p(t, this.namespace, this.client.core.projectId);
        if (!i) throw new Error(`No RPC url provided for chainId: ${t}`);
        return new (0, $01Dhm.JsonRpcProvider)(new (0, $katVf.default)(i, $86e2879031e4905e$var$h("disableProviderPing")));
    }
}
var $86e2879031e4905e$var$Ye = Object.defineProperty, $86e2879031e4905e$var$Qe = Object.defineProperties, $86e2879031e4905e$var$Ze = Object.getOwnPropertyDescriptors, $86e2879031e4905e$var$bt = Object.getOwnPropertySymbols, $86e2879031e4905e$var$Te = Object.prototype.hasOwnProperty, $86e2879031e4905e$var$ts = Object.prototype.propertyIsEnumerable, $86e2879031e4905e$var$V = (s, t, e)=>t in s ? $86e2879031e4905e$var$Ye(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e, $86e2879031e4905e$var$L = (s, t)=>{
    for(var e in t || (t = {}))$86e2879031e4905e$var$Te.call(t, e) && $86e2879031e4905e$var$V(s, e, t[e]);
    if ($86e2879031e4905e$var$bt) for (var e of $86e2879031e4905e$var$bt(t))$86e2879031e4905e$var$ts.call(t, e) && $86e2879031e4905e$var$V(s, e, t[e]);
    return s;
}, $86e2879031e4905e$var$X = (s, t)=>$86e2879031e4905e$var$Qe(s, $86e2879031e4905e$var$Ze(t)), $86e2879031e4905e$var$u = (s, t, e)=>$86e2879031e4905e$var$V(s, typeof t != "symbol" ? t + "" : t, e);
class $86e2879031e4905e$export$2e2bcd8739ae039 {
    constructor(t){
        $86e2879031e4905e$var$u(this, "client"), $86e2879031e4905e$var$u(this, "namespaces"), $86e2879031e4905e$var$u(this, "optionalNamespaces"), $86e2879031e4905e$var$u(this, "sessionProperties"), $86e2879031e4905e$var$u(this, "scopedProperties"), $86e2879031e4905e$var$u(this, "events", new (0, (/*@__PURE__*/$parcel$interopDefault($7hlqZ)))), $86e2879031e4905e$var$u(this, "rpcProviders", {}), $86e2879031e4905e$var$u(this, "session"), $86e2879031e4905e$var$u(this, "providerOpts"), $86e2879031e4905e$var$u(this, "logger"), $86e2879031e4905e$var$u(this, "uri"), $86e2879031e4905e$var$u(this, "disableProviderPing", !1), this.providerOpts = t, this.logger = typeof t?.logger < "u" && typeof t?.logger != "string" ? t.logger : (0, (/*@__PURE__*/$parcel$interopDefault($jt6FO)))((0, $ksL7m.getDefaultLoggerOptions)({
            level: t?.logger || $86e2879031e4905e$var$tt
        })), this.disableProviderPing = t?.disableProviderPing || !1;
    }
    static async init(t) {
        const e = new $86e2879031e4905e$export$2e2bcd8739ae039(t);
        return await e.initialize(), e;
    }
    async request(t, e, i) {
        const [n, a] = this.validateChain(e);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(n).request({
            request: $86e2879031e4905e$var$L({}, t),
            chainId: `${n}:${a}`,
            topic: this.session.topic,
            expiry: i
        });
    }
    sendAsync(t, e, i, n) {
        const a = new Date().getTime();
        this.request(t, i, n).then((r)=>e(null, (0, $3G8ou.formatJsonRpcResult)(a, r))).catch((r)=>e(r, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties,
            scopedProperties: this.scopedProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var t;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (t = this.session) == null ? void 0 : t.topic,
            reason: (0, $9jF5G.getSdkError)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(t) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(t), await this.cleanupPendingPairings(), !t.skipPairing) return await this.pair(t.pairingTopic);
    }
    async authenticate(t, e) {
        if (!this.client) throw new Error("Sign Client not initialized");
        this.setNamespaces(t), await this.cleanupPendingPairings();
        const { uri: i, response: n } = await this.client.authenticate(t, e);
        i && (this.uri = i, this.events.emit("display_uri", i));
        const a = await n();
        if (this.session = a.session, this.session) {
            const r = $86e2879031e4905e$var$vt(this.session.namespaces);
            this.namespaces = $86e2879031e4905e$var$z(this.namespaces, r), await this.persist("namespaces", this.namespaces), this.onConnect();
        }
        return a;
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(t) {
        const { uri: e, approval: i } = await this.client.connect({
            pairingTopic: t,
            requiredNamespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties,
            scopedProperties: this.scopedProperties
        });
        e && (this.uri = e, this.events.emit("display_uri", e));
        const n = await i();
        this.session = n;
        const a = $86e2879031e4905e$var$vt(n.namespaces);
        return this.namespaces = $86e2879031e4905e$var$z(this.namespaces, a), await this.persist("namespaces", this.namespaces), await this.persist("optionalNamespaces", this.optionalNamespaces), this.onConnect(), this.session;
    }
    setDefaultChain(t, e) {
        try {
            if (!this.session) return;
            const [i, n] = this.validateChain(t), a = this.getProvider(i);
            a.name === $86e2879031e4905e$var$w ? a.setDefaultChain(`${i}:${n}`, e) : a.setDefaultChain(n, e);
        } catch (i) {
            if (!/Please call connect/.test(i.message)) throw i;
        }
    }
    async cleanupPendingPairings(t = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const e = this.client.pairing.getAll();
        if ((0, $9jF5G.isValidArray)(e)) {
            for (const i of e)t.deletePairings ? this.client.core.expirer.set(i.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(i.topic);
            this.logger.info(`Inactive pairings cleared: ${e.length}`);
        }
    }
    abortPairingAttempt() {
        this.logger.warn("abortPairingAttempt is deprecated. This is now a no-op.");
    }
    async checkStorage() {
        this.namespaces = await this.getFromStore("namespaces") || {}, this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.session && this.createProviders();
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        var t, e;
        if (this.client = this.providerOpts.client || await (0, $ivHn0.default).init({
            core: this.providerOpts.core,
            logger: this.providerOpts.logger || $86e2879031e4905e$var$tt,
            relayUrl: this.providerOpts.relayUrl || $86e2879031e4905e$var$St,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name,
            customStoragePrefix: this.providerOpts.customStoragePrefix,
            telemetryEnabled: this.providerOpts.telemetryEnabled
        }), this.providerOpts.session) try {
            this.session = this.client.session.get(this.providerOpts.session.topic);
        } catch (i) {
            throw this.logger.error("Failed to get session", i), new Error(`The provided session: ${(e = (t = this.providerOpts) == null ? void 0 : t.session) == null ? void 0 : e.topic} doesn't exist in the Sign client`);
        }
        else {
            const i = this.client.session.getAll();
            this.session = i[0];
        }
        this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const t = [
            ...new Set(Object.keys(this.session.namespaces).map((e)=>(0, $9jF5G.parseNamespaceKey)(e)))
        ];
        $86e2879031e4905e$var$W("client", this.client), $86e2879031e4905e$var$W("events", this.events), $86e2879031e4905e$var$W("disableProviderPing", this.disableProviderPing), t.forEach((e)=>{
            if (!this.session) return;
            const i = $86e2879031e4905e$var$le(e, this.session), n = $86e2879031e4905e$var$lt(i), a = $86e2879031e4905e$var$z(this.namespaces, this.optionalNamespaces), r = $86e2879031e4905e$var$X($86e2879031e4905e$var$L({}, a[e]), {
                accounts: i,
                chains: n
            });
            switch(e){
                case "eip155":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Ie({
                        namespace: r
                    });
                    break;
                case "algorand":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$De({
                        namespace: r
                    });
                    break;
                case "solana":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Ae({
                        namespace: r
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Ee({
                        namespace: r
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$ve({
                        namespace: r
                    });
                    break;
                case "cip34":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Re({
                        namespace: r
                    });
                    break;
                case "elrond":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Fe({
                        namespace: r
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Me({
                        namespace: r
                    });
                    break;
                case "near":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$Je({
                        namespace: r
                    });
                    break;
                case "tezos":
                    this.rpcProviders[e] = new $86e2879031e4905e$var$We({
                        namespace: r
                    });
                    break;
                default:
                    this.rpcProviders[$86e2879031e4905e$var$w] ? this.rpcProviders[$86e2879031e4905e$var$w].updateNamespace(r) : this.rpcProviders[$86e2879031e4905e$var$w] = new $86e2879031e4905e$var$Xe({
                        namespace: r
                    });
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (t)=>{
            var e;
            const { topic: i } = t;
            i === ((e = this.session) == null ? void 0 : e.topic) && this.events.emit("session_ping", t);
        }), this.client.on("session_event", (t)=>{
            var e;
            const { params: i, topic: n } = t;
            if (n !== ((e = this.session) == null ? void 0 : e.topic)) return;
            const { event: a } = i;
            if (a.name === "accountsChanged") {
                const r = a.data;
                r && (0, $9jF5G.isValidArray)(r) && this.events.emit("accountsChanged", r.map($86e2879031e4905e$var$mt));
            } else if (a.name === "chainChanged") {
                const r = i.chainId, c = i.event.data, o = (0, $9jF5G.parseNamespaceKey)(r), v = $86e2879031e4905e$var$k(r) !== $86e2879031e4905e$var$k(c) ? `${o}:${$86e2879031e4905e$var$k(c)}` : r;
                this.onChainChanged(v);
            } else this.events.emit(a.name, a.data);
            this.events.emit("session_event", t);
        }), this.client.on("session_update", ({ topic: t, params: e })=>{
            var i, n;
            if (t !== ((i = this.session) == null ? void 0 : i.topic)) return;
            const { namespaces: a } = e, r = (n = this.client) == null ? void 0 : n.session.get(t);
            this.session = $86e2879031e4905e$var$X($86e2879031e4905e$var$L({}, r), {
                namespaces: a
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: t,
                params: e
            });
        }), this.client.on("session_delete", async (t)=>{
            var e;
            t.topic === ((e = this.session) == null ? void 0 : e.topic) && (await this.cleanup(), this.events.emit("session_delete", t), this.events.emit("disconnect", $86e2879031e4905e$var$X($86e2879031e4905e$var$L({}, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), {
                data: t.topic
            })));
        }), this.on($86e2879031e4905e$var$d.DEFAULT_CHAIN_CHANGED, (t)=>{
            this.onChainChanged(t, !0);
        });
    }
    getProvider(t) {
        return this.rpcProviders[t] || this.rpcProviders[$86e2879031e4905e$var$w];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((t)=>{
            var e;
            this.getProvider(t).updateNamespace((e = this.session) == null ? void 0 : e.namespaces[t]);
        });
    }
    setNamespaces(t) {
        const { namespaces: e, optionalNamespaces: i, sessionProperties: n, scopedProperties: a } = t;
        e && Object.keys(e).length && (this.namespaces = e), i && Object.keys(i).length && (this.optionalNamespaces = i), this.sessionProperties = n, this.scopedProperties = a;
    }
    validateChain(t) {
        const [e, i] = t?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            e,
            i
        ];
        if (e && !Object.keys(this.namespaces || {}).map((r)=>(0, $9jF5G.parseNamespaceKey)(r)).includes(e)) throw new Error(`Namespace '${e}' is not configured. Please call connect() first with namespace config.`);
        if (e && i) return [
            e,
            i
        ];
        const n = (0, $9jF5G.parseNamespaceKey)(Object.keys(this.namespaces)[0]), a = this.rpcProviders[n].getDefaultChain();
        return [
            n,
            a
        ];
    }
    async requestAccounts() {
        const [t] = this.validateChain();
        return await this.getProvider(t).requestAccounts();
    }
    async onChainChanged(t, e = !1) {
        if (!this.namespaces) return;
        const [i, n] = this.validateChain(t);
        if (!n) return;
        this.updateNamespaceChain(i, n), this.events.emit("chainChanged", n);
        const a = this.getProvider(i).getDefaultChain();
        e || this.getProvider(i).setDefaultChain(n), this.emitAccountsChangedOnChainChange({
            namespace: i,
            previousChainId: a,
            newChainId: t
        }), await this.persist("namespaces", this.namespaces);
    }
    emitAccountsChangedOnChainChange({ namespace: t, previousChainId: e, newChainId: i }) {
        var n, a;
        try {
            if (e === i) return;
            const r = (a = (n = this.session) == null ? void 0 : n.namespaces[t]) == null ? void 0 : a.accounts;
            if (!r) return;
            const c = r.filter((o)=>o.includes(`${i}:`)).map($86e2879031e4905e$var$mt);
            if (!(0, $9jF5G.isValidArray)(c)) return;
            this.events.emit("accountsChanged", c);
        } catch (r) {
            this.logger.warn("Failed to emit accountsChanged on chain change", r);
        }
    }
    updateNamespaceChain(t, e) {
        if (!this.namespaces) return;
        const i = this.namespaces[t] ? t : `${t}:${e}`, n = {
            chains: [],
            methods: [],
            events: [],
            defaultChain: e
        };
        this.namespaces[i] ? this.namespaces[i] && (this.namespaces[i].defaultChain = e) : this.namespaces[i] = n;
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, await this.deleteFromStore("namespaces"), await this.deleteFromStore("optionalNamespaces"), await this.deleteFromStore("sessionProperties"), this.session = void 0, await this.cleanupPendingPairings({
            deletePairings: !0
        }), await this.cleanupStorage();
    }
    async persist(t, e) {
        var i;
        const n = ((i = this.session) == null ? void 0 : i.topic) || "";
        await this.client.core.storage.setItem(`${$86e2879031e4905e$var$_}/${t}${n}`, e);
    }
    async getFromStore(t) {
        var e;
        const i = ((e = this.session) == null ? void 0 : e.topic) || "";
        return await this.client.core.storage.getItem(`${$86e2879031e4905e$var$_}/${t}${i}`);
    }
    async deleteFromStore(t) {
        var e;
        const i = ((e = this.session) == null ? void 0 : e.topic) || "";
        await this.client.core.storage.removeItem(`${$86e2879031e4905e$var$_}/${t}${i}`);
    }
    async cleanupStorage() {
        var t;
        try {
            if (((t = this.client) == null ? void 0 : t.session.length) > 0) return;
            const e = await this.client.core.storage.getKeys();
            for (const i of e)i.startsWith($86e2879031e4905e$var$_) && await this.client.core.storage.removeItem(i);
        } catch (e) {
            this.logger.warn("Failed to cleanup storage", e);
        }
    }
}
const $86e2879031e4905e$export$63bc40680ab52599 = $86e2879031e4905e$export$2e2bcd8739ae039;

});
parcelRegister("ivHn0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d79cc3a87842e2bb$export$2e2bcd8739ae039; });

var $cm4ZJ = parcelRequire("cm4ZJ");

var $ksL7m = parcelRequire("ksL7m");
var $jt6FO = parcelRequire("jt6FO");

var $dgxYa = parcelRequire("dgxYa");

var $2TjUJ = parcelRequire("2TjUJ");

var $9jF5G = parcelRequire("9jF5G");

var $7hlqZ = parcelRequire("7hlqZ");
parcelRequire("3olrm");
var $3G8ou = parcelRequire("3G8ou");
var $5ZYqc = parcelRequire("5ZYqc");
const $d79cc3a87842e2bb$export$4fa962fc67384e02 = "wc", $d79cc3a87842e2bb$export$61085c48796ff049 = 2, $d79cc3a87842e2bb$export$94715592c220319a = "client", $d79cc3a87842e2bb$export$7fa6f9ee1e2cab96 = `${$d79cc3a87842e2bb$export$4fa962fc67384e02}@${$d79cc3a87842e2bb$export$61085c48796ff049}:${$d79cc3a87842e2bb$export$94715592c220319a}:`, $d79cc3a87842e2bb$export$8dffb3242f2c5f72 = {
    name: $d79cc3a87842e2bb$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.org"
}, $d79cc3a87842e2bb$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire",
    session_connect: "session_connect"
}, $d79cc3a87842e2bb$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $d79cc3a87842e2bb$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $d79cc3a87842e2bb$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $d79cc3a87842e2bb$export$160142c73cb99dc3 = "history", $d79cc3a87842e2bb$export$8eba9ce85616c607 = "0.3", $d79cc3a87842e2bb$export$ae6c7a4f7ed730a1 = "proposal", $d79cc3a87842e2bb$export$6db28e89b135a53c = (0, $2TjUJ.THIRTY_DAYS), $d79cc3a87842e2bb$export$1e6a4dc5172f4830 = "Proposal expired", $d79cc3a87842e2bb$export$a069e98a8dfeec1e = "session", $d79cc3a87842e2bb$export$84b1b9dbcdea0475 = (0, $2TjUJ.SEVEN_DAYS), $d79cc3a87842e2bb$export$2db42d5151ad6eb8 = "engine", $d79cc3a87842e2bb$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        },
        reject: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1120
        },
        autoReject: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1121
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    },
    wc_sessionAuthenticate: {
        req: {
            ttl: (0, $2TjUJ.ONE_HOUR),
            prompt: !0,
            tag: 1116
        },
        res: {
            ttl: (0, $2TjUJ.ONE_HOUR),
            prompt: !1,
            tag: 1117
        },
        reject: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1118
        },
        autoReject: {
            ttl: (0, $2TjUJ.FIVE_MINUTES),
            prompt: !1,
            tag: 1119
        }
    }
}, $d79cc3a87842e2bb$export$409f0c0a13a1b7c6 = {
    min: (0, $2TjUJ.FIVE_MINUTES),
    max: (0, $2TjUJ.SEVEN_DAYS)
}, $d79cc3a87842e2bb$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $d79cc3a87842e2bb$export$a06a2a399442c35f = {
    eth_sendTransaction: {
        key: ""
    },
    eth_sendRawTransaction: {
        key: ""
    },
    wallet_sendCalls: {
        key: ""
    },
    solana_signTransaction: {
        key: "signature"
    },
    solana_signAllTransactions: {
        key: "transactions"
    },
    solana_signAndSendTransaction: {
        key: "signature"
    }
}, $d79cc3a87842e2bb$export$40b296af21bd38a4 = "request", $d79cc3a87842e2bb$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest",
    "wc_sessionAuthenticate"
], $d79cc3a87842e2bb$export$e24c518fa7fc04c = "wc", $d79cc3a87842e2bb$export$af233b4aa2e30834 = 1.5, $d79cc3a87842e2bb$export$e8b9bbdca3ac0ed = "auth", $d79cc3a87842e2bb$export$ab815cb37981e7e0 = "authKeys", $d79cc3a87842e2bb$export$5d9af9e20f678626 = "pairingTopics", $d79cc3a87842e2bb$export$3643b3579d091159 = "requests", $d79cc3a87842e2bb$export$323ba3ebb8028ed0 = `${$d79cc3a87842e2bb$export$e24c518fa7fc04c}@${1.5}:${$d79cc3a87842e2bb$export$e8b9bbdca3ac0ed}:`, $d79cc3a87842e2bb$export$efef74cb455ac30f = `${$d79cc3a87842e2bb$export$323ba3ebb8028ed0}:PUB_KEY`;
var $d79cc3a87842e2bb$var$Rs = Object.defineProperty, $d79cc3a87842e2bb$var$vs = Object.defineProperties, $d79cc3a87842e2bb$var$Is = Object.getOwnPropertyDescriptors, $d79cc3a87842e2bb$var$ft = Object.getOwnPropertySymbols, $d79cc3a87842e2bb$var$Ts = Object.prototype.hasOwnProperty, $d79cc3a87842e2bb$var$qs = Object.prototype.propertyIsEnumerable, $d79cc3a87842e2bb$var$Ke = (S, n, e)=>n in S ? $d79cc3a87842e2bb$var$Rs(S, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : S[n] = e, $d79cc3a87842e2bb$var$v = (S, n)=>{
    for(var e in n || (n = {}))$d79cc3a87842e2bb$var$Ts.call(n, e) && $d79cc3a87842e2bb$var$Ke(S, e, n[e]);
    if ($d79cc3a87842e2bb$var$ft) for (var e of $d79cc3a87842e2bb$var$ft(n))$d79cc3a87842e2bb$var$qs.call(n, e) && $d79cc3a87842e2bb$var$Ke(S, e, n[e]);
    return S;
}, $d79cc3a87842e2bb$var$b = (S, n)=>$d79cc3a87842e2bb$var$vs(S, $d79cc3a87842e2bb$var$Is(n)), $d79cc3a87842e2bb$var$c = (S, n, e)=>$d79cc3a87842e2bb$var$Ke(S, typeof n != "symbol" ? n + "" : n, e);
class $d79cc3a87842e2bb$var$Ps extends (0, $dgxYa.IEngine) {
    constructor(n){
        super(n), $d79cc3a87842e2bb$var$c(this, "name", $d79cc3a87842e2bb$export$2db42d5151ad6eb8), $d79cc3a87842e2bb$var$c(this, "events", new (0, (/*@__PURE__*/$parcel$interopDefault($7hlqZ)))), $d79cc3a87842e2bb$var$c(this, "initialized", !1), $d79cc3a87842e2bb$var$c(this, "requestQueue", {
            state: $d79cc3a87842e2bb$export$8602b201748df21a.idle,
            queue: []
        }), $d79cc3a87842e2bb$var$c(this, "sessionRequestQueue", {
            state: $d79cc3a87842e2bb$export$8602b201748df21a.idle,
            queue: []
        }), $d79cc3a87842e2bb$var$c(this, "requestQueueDelay", (0, $2TjUJ.ONE_SECOND)), $d79cc3a87842e2bb$var$c(this, "expectedPairingMethodMap", new Map), $d79cc3a87842e2bb$var$c(this, "recentlyDeletedMap", new Map), $d79cc3a87842e2bb$var$c(this, "recentlyDeletedLimit", 200), $d79cc3a87842e2bb$var$c(this, "relayMessageCache", []), $d79cc3a87842e2bb$var$c(this, "pendingSessions", new Map), $d79cc3a87842e2bb$var$c(this, "init", async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), await this.registerLinkModeListeners(), this.client.core.pairing.register({
                methods: Object.keys($d79cc3a87842e2bb$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(async ()=>{
                await this.processPendingMessageEvents(), this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $2TjUJ.toMiliseconds)(this.requestQueueDelay)));
        }), $d79cc3a87842e2bb$var$c(this, "connect", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            const t = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(t);
            const { pairingTopic: s, requiredNamespaces: i, optionalNamespaces: r, sessionProperties: o, scopedProperties: a, relays: l } = t;
            let p = s, h, u = !1;
            try {
                if (p) {
                    const T = this.client.core.pairing.pairings.get(p);
                    this.client.logger.warn("connect() with existing pairing topic is deprecated and will be removed in the next major release."), u = T.active;
                }
            } catch (T) {
                throw this.client.logger.error(`connect() -> pairing.get(${p}) failed`), T;
            }
            if (!p || !u) {
                const { topic: T, uri: U } = await this.client.core.pairing.create();
                p = T, h = U;
            }
            if (!p) {
                const { message: T } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `connect() pairing topic: ${p}`);
                throw new Error(T);
            }
            const d = await this.client.core.crypto.generateKeyPair(), w = $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $2TjUJ.FIVE_MINUTES), m = (0, $9jF5G.calcExpiry)(w), f = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v($d79cc3a87842e2bb$var$v({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: l ?? [
                    {
                        protocol: (0, $cm4ZJ.RELAYER_DEFAULT_PROTOCOL)
                    }
                ],
                proposer: {
                    publicKey: d,
                    metadata: this.client.metadata
                },
                expiryTimestamp: m,
                pairingTopic: p
            }, o && {
                sessionProperties: o
            }), a && {
                scopedProperties: a
            }), {
                id: (0, $3G8ou.payloadId)()
            }), _ = (0, $9jF5G.engineEvent)("session_connect", f.id), { reject: g, resolve: A, done: D } = (0, $9jF5G.createDelayedPromise)(w, $d79cc3a87842e2bb$export$1e6a4dc5172f4830), I = ({ id: T })=>{
                T === f.id && (this.client.events.off("proposal_expire", I), this.pendingSessions.delete(f.id), this.events.emit(_, {
                    error: {
                        message: $d79cc3a87842e2bb$export$1e6a4dc5172f4830,
                        code: 0
                    }
                }));
            };
            return this.client.events.on("proposal_expire", I), this.events.once(_, ({ error: T, session: U })=>{
                this.client.events.off("proposal_expire", I), T ? g(T) : U && A(U);
            }), await this.sendRequest({
                topic: p,
                method: "wc_sessionPropose",
                params: f,
                throwOnFailedPublish: !0,
                clientRpcId: f.id
            }), await this.setProposal(f.id, f), {
                uri: h,
                approval: D
            };
        }), $d79cc3a87842e2bb$var$c(this, "pair", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                return await this.client.core.pairing.pair(e);
            } catch (t) {
                throw this.client.logger.error("pair() failed"), t;
            }
        }), $d79cc3a87842e2bb$var$c(this, "approve", async (e)=>{
            var t, s, i;
            const r = this.client.core.eventClient.createEvent({
                properties: {
                    topic: (t = e?.id) == null ? void 0 : t.toString(),
                    trace: [
                        (0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized(), await this.confirmOnlineStateOrThrow();
            } catch (q) {
                throw r.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).no_internet_connection), q;
            }
            try {
                await this.isValidProposalId(e?.id);
            } catch (q) {
                throw this.client.logger.error(`approve() -> proposal.get(${e?.id}) failed`), r.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).proposal_not_found), q;
            }
            try {
                await this.isValidApprove(e);
            } catch (q) {
                throw this.client.logger.error("approve() -> isValidApprove() failed"), r.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).session_approve_namespace_validation_failure), q;
            }
            const { id: o, relayProtocol: a, namespaces: l, sessionProperties: p, scopedProperties: h, sessionConfig: u } = e, d = this.client.proposal.get(o);
            this.client.core.eventClient.deleteEvent({
                eventId: r.eventId
            });
            const { pairingTopic: w, proposer: m, requiredNamespaces: f, optionalNamespaces: _ } = d;
            let g = (s = this.client.core.eventClient) == null ? void 0 : s.getEvent({
                topic: w
            });
            g || (g = (i = this.client.core.eventClient) == null ? void 0 : i.createEvent({
                type: (0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                properties: {
                    topic: w,
                    trace: [
                        (0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                        (0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).session_namespaces_validation_success
                    ]
                }
            }));
            const A = await this.client.core.crypto.generateKeyPair(), D = m.publicKey, I = await this.client.core.crypto.generateSharedKey(A, D), T = $d79cc3a87842e2bb$var$v($d79cc3a87842e2bb$var$v($d79cc3a87842e2bb$var$v({
                relay: {
                    protocol: a ?? "irn"
                },
                namespaces: l,
                controller: {
                    publicKey: A,
                    metadata: this.client.metadata
                },
                expiry: (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$84b1b9dbcdea0475)
            }, p && {
                sessionProperties: p
            }), h && {
                scopedProperties: h
            }), u && {
                sessionConfig: u
            }), U = (0, $cm4ZJ.TRANSPORT_TYPES).relay;
            g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).subscribing_session_topic);
            try {
                await this.client.core.relayer.subscribe(I, {
                    transportType: U
                });
            } catch (q) {
                throw g.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).subscribe_session_topic_failure), q;
            }
            g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).subscribe_session_topic_success);
            const fe = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, T), {
                topic: I,
                requiredNamespaces: f,
                optionalNamespaces: _,
                pairingTopic: w,
                acknowledged: !1,
                self: T.controller,
                peer: {
                    publicKey: m.publicKey,
                    metadata: m.metadata
                },
                controller: A,
                transportType: (0, $cm4ZJ.TRANSPORT_TYPES).relay
            });
            await this.client.session.set(I, fe), g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).store_session);
            try {
                g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).publishing_session_settle), await this.sendRequest({
                    topic: I,
                    method: "wc_sessionSettle",
                    params: T,
                    throwOnFailedPublish: !0
                }).catch((q)=>{
                    throw g?.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).session_settle_publish_failure), q;
                }), g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).session_settle_publish_success), g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).publishing_session_approve), await this.sendResult({
                    id: o,
                    topic: w,
                    result: {
                        relay: {
                            protocol: a ?? "irn"
                        },
                        responderPublicKey: A
                    },
                    throwOnFailedPublish: !0
                }).catch((q)=>{
                    throw g?.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).session_approve_publish_failure), q;
                }), g.addTrace((0, $cm4ZJ.EVENT_CLIENT_SESSION_TRACES).session_approve_publish_success);
            } catch (q) {
                throw this.client.logger.error(q), this.client.session.delete(I, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(I), q;
            }
            return this.client.core.eventClient.deleteEvent({
                eventId: g.eventId
            }), await this.client.core.pairing.updateMetadata({
                topic: w,
                metadata: m.metadata
            }), await this.client.proposal.delete(o, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: w
            }), await this.setExpiry(I, (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$84b1b9dbcdea0475)), {
                topic: I,
                acknowledged: ()=>Promise.resolve(this.client.session.get(I))
            };
        }), $d79cc3a87842e2bb$var$c(this, "reject", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidReject(e);
            } catch (r) {
                throw this.client.logger.error("reject() -> isValidReject() failed"), r;
            }
            const { id: t, reason: s } = e;
            let i;
            try {
                i = this.client.proposal.get(t).pairingTopic;
            } catch (r) {
                throw this.client.logger.error(`reject() -> proposal.get(${t}) failed`), r;
            }
            i && (await this.sendError({
                id: t,
                topic: i,
                error: s,
                rpcOpts: $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.reject
            }), await this.client.proposal.delete(t, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")));
        }), $d79cc3a87842e2bb$var$c(this, "update", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidUpdate(e);
            } catch (h) {
                throw this.client.logger.error("update() -> isValidUpdate() failed"), h;
            }
            const { topic: t, namespaces: s } = e, { done: i, resolve: r, reject: o } = (0, $9jF5G.createDelayedPromise)(), a = (0, $3G8ou.payloadId)(), l = (0, $3G8ou.getBigIntRpcId)().toString(), p = this.client.session.get(t).namespaces;
            return this.events.once((0, $9jF5G.engineEvent)("session_update", a), ({ error: h })=>{
                h ? o(h) : r();
            }), await this.client.session.update(t, {
                namespaces: s
            }), await this.sendRequest({
                topic: t,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: s
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: l
            }).catch((h)=>{
                this.client.logger.error(h), this.client.session.update(t, {
                    namespaces: p
                }), o(h);
            }), {
                acknowledged: i
            };
        }), $d79cc3a87842e2bb$var$c(this, "extend", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidExtend(e);
            } catch (a) {
                throw this.client.logger.error("extend() -> isValidExtend() failed"), a;
            }
            const { topic: t } = e, s = (0, $3G8ou.payloadId)(), { done: i, resolve: r, reject: o } = (0, $9jF5G.createDelayedPromise)();
            return this.events.once((0, $9jF5G.engineEvent)("session_extend", s), ({ error: a })=>{
                a ? o(a) : r();
            }), await this.setExpiry(t, (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$84b1b9dbcdea0475)), this.sendRequest({
                topic: t,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: s,
                throwOnFailedPublish: !0
            }).catch((a)=>{
                o(a);
            }), {
                acknowledged: i
            };
        }), $d79cc3a87842e2bb$var$c(this, "request", async (e)=>{
            this.isInitialized();
            try {
                await this.isValidRequest(e);
            } catch (_) {
                throw this.client.logger.error("request() -> isValidRequest() failed"), _;
            }
            const { chainId: t, request: s, topic: i, expiry: r = $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = e, o = this.client.session.get(i);
            o?.transportType === (0, $cm4ZJ.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const a = (0, $3G8ou.payloadId)(), l = (0, $3G8ou.getBigIntRpcId)().toString(), { done: p, resolve: h, reject: u } = (0, $9jF5G.createDelayedPromise)(r, "Request expired. Please try again.");
            this.events.once((0, $9jF5G.engineEvent)("session_request", a), ({ error: _, result: g })=>{
                _ ? u(_) : h(g);
            });
            const d = "wc_sessionRequest", w = this.getAppLinkIfEnabled(o.peer.metadata, o.transportType);
            if (w) return await this.sendRequest({
                clientRpcId: a,
                relayRpcId: l,
                topic: i,
                method: d,
                params: {
                    request: $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, s), {
                        expiryTimestamp: (0, $9jF5G.calcExpiry)(r)
                    }),
                    chainId: t
                },
                expiry: r,
                throwOnFailedPublish: !0,
                appLink: w
            }).catch((_)=>u(_)), this.client.events.emit("session_request_sent", {
                topic: i,
                request: s,
                chainId: t,
                id: a
            }), await p();
            const m = {
                request: $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, s), {
                    expiryTimestamp: (0, $9jF5G.calcExpiry)(r)
                }),
                chainId: t
            }, f = this.shouldSetTVF(d, m);
            return await Promise.all([
                new Promise(async (_)=>{
                    await this.sendRequest($d79cc3a87842e2bb$var$v({
                        clientRpcId: a,
                        relayRpcId: l,
                        topic: i,
                        method: d,
                        params: m,
                        expiry: r,
                        throwOnFailedPublish: !0
                    }, f && {
                        tvf: this.getTVFParams(a, m)
                    })).catch((g)=>u(g)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: s,
                        chainId: t,
                        id: a
                    }), _();
                }),
                new Promise(async (_)=>{
                    var g;
                    if (!((g = o.sessionConfig) != null && g.disableDeepLink)) {
                        const A = await (0, $9jF5G.getDeepLink)(this.client.core.storage, $d79cc3a87842e2bb$export$a26ccd6441b7d638);
                        await (0, $9jF5G.handleDeeplinkRedirect)({
                            id: a,
                            topic: i,
                            wcDeepLink: A
                        });
                    }
                    _();
                }),
                p()
            ]).then((_)=>_[2]);
        }), $d79cc3a87842e2bb$var$c(this, "respond", async (e)=>{
            this.isInitialized(), await this.isValidRespond(e);
            const { topic: t, response: s } = e, { id: i } = s, r = this.client.session.get(t);
            r.transportType === (0, $cm4ZJ.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const o = this.getAppLinkIfEnabled(r.peer.metadata, r.transportType);
            (0, $5ZYqc.isJsonRpcResult)(s) ? await this.sendResult({
                id: i,
                topic: t,
                result: s.result,
                throwOnFailedPublish: !0,
                appLink: o
            }) : (0, $5ZYqc.isJsonRpcError)(s) && await this.sendError({
                id: i,
                topic: t,
                error: s.error,
                appLink: o
            }), this.cleanupAfterResponse(e);
        }), $d79cc3a87842e2bb$var$c(this, "ping", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow();
            try {
                await this.isValidPing(e);
            } catch (s) {
                throw this.client.logger.error("ping() -> isValidPing() failed"), s;
            }
            const { topic: t } = e;
            if (this.client.session.keys.includes(t)) {
                const s = (0, $3G8ou.payloadId)(), i = (0, $3G8ou.getBigIntRpcId)().toString(), { done: r, resolve: o, reject: a } = (0, $9jF5G.createDelayedPromise)();
                this.events.once((0, $9jF5G.engineEvent)("session_ping", s), ({ error: l })=>{
                    l ? a(l) : o();
                }), await Promise.all([
                    this.sendRequest({
                        topic: t,
                        method: "wc_sessionPing",
                        params: {},
                        throwOnFailedPublish: !0,
                        clientRpcId: s,
                        relayRpcId: i
                    }),
                    r()
                ]);
            } else this.client.core.pairing.pairings.keys.includes(t) && (this.client.logger.warn("ping() on pairing topic is deprecated and will be removed in the next major release."), await this.client.core.pairing.ping({
                topic: t
            }));
        }), $d79cc3a87842e2bb$var$c(this, "emit", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidEmit(e);
            const { topic: t, event: s, chainId: i } = e, r = (0, $3G8ou.getBigIntRpcId)().toString(), o = (0, $3G8ou.payloadId)();
            await this.sendRequest({
                topic: t,
                method: "wc_sessionEvent",
                params: {
                    event: s,
                    chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r,
                clientRpcId: o
            });
        }), $d79cc3a87842e2bb$var$c(this, "disconnect", async (e)=>{
            this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidDisconnect(e);
            const { topic: t } = e;
            if (this.client.session.keys.includes(t)) await this.sendRequest({
                topic: t,
                method: "wc_sessionDelete",
                params: (0, $9jF5G.getSdkError)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: t,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(t)) await this.client.core.pairing.disconnect({
                topic: t
            });
            else {
                const { message: s } = (0, $9jF5G.getInternalError)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${t}`);
                throw new Error(s);
            }
        }), $d79cc3a87842e2bb$var$c(this, "find", (e)=>(this.isInitialized(), this.client.session.getAll().filter((t)=>(0, $9jF5G.isSessionCompatible)(t, e)))), $d79cc3a87842e2bb$var$c(this, "getPendingSessionRequests", ()=>this.client.pendingRequest.getAll()), $d79cc3a87842e2bb$var$c(this, "authenticate", async (e, t)=>{
            var s;
            this.isInitialized(), this.isValidAuthenticate(e);
            const i = t && this.client.core.linkModeSupportedApps.includes(t) && ((s = this.client.metadata.redirect) == null ? void 0 : s.linkMode), r = i ? (0, $cm4ZJ.TRANSPORT_TYPES).link_mode : (0, $cm4ZJ.TRANSPORT_TYPES).relay;
            r === (0, $cm4ZJ.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const { chains: o, statement: a = "", uri: l, domain: p, nonce: h, type: u, exp: d, nbf: w, methods: m = [], expiry: f } = e, _ = [
                ...e.resources || []
            ], { topic: g, uri: A } = await this.client.core.pairing.create({
                methods: [
                    "wc_sessionAuthenticate"
                ],
                transportType: r
            });
            this.client.logger.info({
                message: "Generated new pairing",
                pairing: {
                    topic: g,
                    uri: A
                }
            });
            const D = await this.client.core.crypto.generateKeyPair(), I = (0, $9jF5G.hashKey)(D);
            if (await Promise.all([
                this.client.auth.authKeys.set($d79cc3a87842e2bb$export$efef74cb455ac30f, {
                    responseTopic: I,
                    publicKey: D
                }),
                this.client.auth.pairingTopics.set(I, {
                    topic: I,
                    pairingTopic: g
                })
            ]), await this.client.core.relayer.subscribe(I, {
                transportType: r
            }), this.client.logger.info(`sending request to new pairing topic: ${g}`), m.length > 0) {
                const { namespace: x } = (0, $9jF5G.parseChainId)(o[0]);
                let L = (0, $9jF5G.createEncodedRecap)(x, "request", m);
                (0, $9jF5G.getRecapFromResources)(_) && (L = (0, $9jF5G.mergeEncodedRecaps)(L, _.pop())), _.push(L);
            }
            const T = f && f > $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl ? f : $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl, U = {
                authPayload: {
                    type: u ?? "caip122",
                    chains: o,
                    statement: a,
                    aud: l,
                    domain: p,
                    version: "1",
                    nonce: h,
                    iat: new Date().toISOString(),
                    exp: d,
                    nbf: w,
                    resources: _
                },
                requester: {
                    publicKey: D,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $9jF5G.calcExpiry)(T)
            }, fe = {
                eip155: {
                    chains: o,
                    methods: [
                        ...new Set([
                            "personal_sign",
                            ...m
                        ])
                    ],
                    events: [
                        "chainChanged",
                        "accountsChanged"
                    ]
                }
            }, q = {
                requiredNamespaces: {},
                optionalNamespaces: fe,
                relays: [
                    {
                        protocol: "irn"
                    }
                ],
                pairingTopic: g,
                proposer: {
                    publicKey: D,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.req.ttl),
                id: (0, $3G8ou.payloadId)()
            }, { done: Rt, resolve: je, reject: Se } = (0, $9jF5G.createDelayedPromise)(T, "Request expired"), te = (0, $3G8ou.payloadId)(), le = (0, $9jF5G.engineEvent)("session_connect", q.id), Re = (0, $9jF5G.engineEvent)("session_request", te), pe = async ({ error: x, session: L })=>{
                this.events.off(Re, ve), x ? Se(x) : L && je({
                    session: L
                });
            }, ve = async (x)=>{
                var L, Fe, Qe;
                if (await this.deletePendingAuthRequest(te, {
                    message: "fulfilled",
                    code: 0
                }), x.error) {
                    const ie = (0, $9jF5G.getSdkError)("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                    return x.error.code === ie.code ? void 0 : (this.events.off(le, pe), Se(x.error.message));
                }
                await this.deleteProposal(q.id), this.events.off(le, pe);
                const { cacaos: He, responder: Q } = x.result, Te = [], ze = [];
                for (const ie of He){
                    await (0, $9jF5G.validateSignedCacao)({
                        cacao: ie,
                        projectId: this.client.core.projectId
                    }) || (this.client.logger.error(ie, "Signature verification failed"), Se((0, $9jF5G.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
                    const { p: qe } = ie, Pe = (0, $9jF5G.getRecapFromResources)(qe.resources), Ye = [
                        (0, $9jF5G.getNamespacedDidChainId)(qe.iss)
                    ], vt = (0, $9jF5G.getDidAddress)(qe.iss);
                    if (Pe) {
                        const Ne = (0, $9jF5G.getMethodsFromRecap)(Pe), It = (0, $9jF5G.getChainsFromRecap)(Pe);
                        Te.push(...Ne), Ye.push(...It);
                    }
                    for (const Ne of Ye)ze.push(`${Ne}:${vt}`);
                }
                const se = await this.client.core.crypto.generateSharedKey(D, Q.publicKey);
                let he;
                Te.length > 0 && (he = {
                    topic: se,
                    acknowledged: !0,
                    self: {
                        publicKey: D,
                        metadata: this.client.metadata
                    },
                    peer: Q,
                    controller: Q.publicKey,
                    expiry: (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$84b1b9dbcdea0475),
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: g,
                    namespaces: (0, $9jF5G.buildNamespacesFromAuth)([
                        ...new Set(Te)
                    ], [
                        ...new Set(ze)
                    ]),
                    transportType: r
                }, await this.client.core.relayer.subscribe(se, {
                    transportType: r
                }), await this.client.session.set(se, he), g && await this.client.core.pairing.updateMetadata({
                    topic: g,
                    metadata: Q.metadata
                }), he = this.client.session.get(se)), (L = this.client.metadata.redirect) != null && L.linkMode && (Fe = Q.metadata.redirect) != null && Fe.linkMode && (Qe = Q.metadata.redirect) != null && Qe.universal && t && (this.client.core.addLinkModeSupportedApp(Q.metadata.redirect.universal), this.client.session.update(se, {
                    transportType: (0, $cm4ZJ.TRANSPORT_TYPES).link_mode
                })), je({
                    auths: He,
                    session: he
                });
            };
            this.events.once(le, pe), this.events.once(Re, ve);
            let Ie;
            try {
                if (i) {
                    const x = (0, $3G8ou.formatJsonRpcRequest)("wc_sessionAuthenticate", U, te);
                    this.client.core.history.set(g, x);
                    const L = await this.client.core.crypto.encode("", x, {
                        type: (0, $9jF5G.TYPE_2),
                        encoding: (0, $9jF5G.BASE64URL)
                    });
                    Ie = (0, $9jF5G.getLinkModeURL)(t, g, L);
                } else await Promise.all([
                    this.sendRequest({
                        topic: g,
                        method: "wc_sessionAuthenticate",
                        params: U,
                        expiry: e.expiry,
                        throwOnFailedPublish: !0,
                        clientRpcId: te
                    }),
                    this.sendRequest({
                        topic: g,
                        method: "wc_sessionPropose",
                        params: q,
                        expiry: $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.req.ttl,
                        throwOnFailedPublish: !0,
                        clientRpcId: q.id
                    })
                ]);
            } catch (x) {
                throw this.events.off(le, pe), this.events.off(Re, ve), x;
            }
            return await this.setProposal(q.id, q), await this.setAuthRequest(te, {
                request: $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, U), {
                    verifyContext: {}
                }),
                pairingTopic: g,
                transportType: r
            }), {
                uri: Ie ?? A,
                response: Rt
            };
        }), $d79cc3a87842e2bb$var$c(this, "approveSessionAuthenticate", async (e)=>{
            const { id: t, auths: s } = e, i = this.client.core.eventClient.createEvent({
                properties: {
                    topic: t.toString(),
                    trace: [
                        (0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).authenticated_session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized();
            } catch (f) {
                throw i.setError((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_ERRORS).no_internet_connection), f;
            }
            const r = this.getPendingAuthRequest(t);
            if (!r) throw i.setError((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_pending_request_not_found), new Error(`Could not find pending auth request with id ${t}`);
            const o = r.transportType || (0, $cm4ZJ.TRANSPORT_TYPES).relay;
            o === (0, $cm4ZJ.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const a = r.requester.publicKey, l = await this.client.core.crypto.generateKeyPair(), p = (0, $9jF5G.hashKey)(a), h = {
                type: (0, $9jF5G.TYPE_1),
                receiverPublicKey: a,
                senderPublicKey: l
            }, u = [], d = [];
            for (const f of s){
                if (!await (0, $9jF5G.validateSignedCacao)({
                    cacao: f,
                    projectId: this.client.core.projectId
                })) {
                    i.setError((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_ERRORS).invalid_cacao);
                    const I = (0, $9jF5G.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
                    throw await this.sendError({
                        id: t,
                        topic: p,
                        error: I,
                        encodeOpts: h
                    }), new Error(I.message);
                }
                i.addTrace((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).cacaos_verified);
                const { p: _ } = f, g = (0, $9jF5G.getRecapFromResources)(_.resources), A = [
                    (0, $9jF5G.getNamespacedDidChainId)(_.iss)
                ], D = (0, $9jF5G.getDidAddress)(_.iss);
                if (g) {
                    const I = (0, $9jF5G.getMethodsFromRecap)(g), T = (0, $9jF5G.getChainsFromRecap)(g);
                    u.push(...I), A.push(...T);
                }
                for (const I of A)d.push(`${I}:${D}`);
            }
            const w = await this.client.core.crypto.generateSharedKey(l, a);
            i.addTrace((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).create_authenticated_session_topic);
            let m;
            if (u?.length > 0) {
                m = {
                    topic: w,
                    acknowledged: !0,
                    self: {
                        publicKey: l,
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: a,
                        metadata: r.requester.metadata
                    },
                    controller: a,
                    expiry: (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$84b1b9dbcdea0475),
                    authentication: s,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: r.pairingTopic,
                    namespaces: (0, $9jF5G.buildNamespacesFromAuth)([
                        ...new Set(u)
                    ], [
                        ...new Set(d)
                    ]),
                    transportType: o
                }, i.addTrace((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribing_authenticated_session_topic);
                try {
                    await this.client.core.relayer.subscribe(w, {
                        transportType: o
                    });
                } catch (f) {
                    throw i.setError((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_ERRORS).subscribe_authenticated_session_topic_failure), f;
                }
                i.addTrace((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribe_authenticated_session_topic_success), await this.client.session.set(w, m), i.addTrace((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).store_authenticated_session), await this.client.core.pairing.updateMetadata({
                    topic: r.pairingTopic,
                    metadata: r.requester.metadata
                });
            }
            i.addTrace((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_TRACES).publishing_authenticated_session_approve);
            try {
                await this.sendResult({
                    topic: p,
                    id: t,
                    result: {
                        cacaos: s,
                        responder: {
                            publicKey: l,
                            metadata: this.client.metadata
                        }
                    },
                    encodeOpts: h,
                    throwOnFailedPublish: !0,
                    appLink: this.getAppLinkIfEnabled(r.requester.metadata, o)
                });
            } catch (f) {
                throw i.setError((0, $cm4ZJ.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_approve_publish_failure), f;
            }
            return await this.client.auth.requests.delete(t, {
                message: "fulfilled",
                code: 0
            }), await this.client.core.pairing.activate({
                topic: r.pairingTopic
            }), this.client.core.eventClient.deleteEvent({
                eventId: i.eventId
            }), {
                session: m
            };
        }), $d79cc3a87842e2bb$var$c(this, "rejectSessionAuthenticate", async (e)=>{
            this.isInitialized();
            const { id: t, reason: s } = e, i = this.getPendingAuthRequest(t);
            if (!i) throw new Error(`Could not find pending auth request with id ${t}`);
            i.transportType === (0, $cm4ZJ.TRANSPORT_TYPES).relay && await this.confirmOnlineStateOrThrow();
            const r = i.requester.publicKey, o = await this.client.core.crypto.generateKeyPair(), a = (0, $9jF5G.hashKey)(r), l = {
                type: (0, $9jF5G.TYPE_1),
                receiverPublicKey: r,
                senderPublicKey: o
            };
            await this.sendError({
                id: t,
                topic: a,
                error: s,
                encodeOpts: l,
                rpcOpts: $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionAuthenticate.reject,
                appLink: this.getAppLinkIfEnabled(i.requester.metadata, i.transportType)
            }), await this.client.auth.requests.delete(t, {
                message: "rejected",
                code: 0
            }), await this.client.proposal.delete(t, (0, $9jF5G.getSdkError)("USER_DISCONNECTED"));
        }), $d79cc3a87842e2bb$var$c(this, "formatAuthMessage", (e)=>{
            this.isInitialized();
            const { request: t, iss: s } = e;
            return (0, $9jF5G.formatMessage)(t, s);
        }), $d79cc3a87842e2bb$var$c(this, "processRelayMessageCache", ()=>{
            setTimeout(async ()=>{
                if (this.relayMessageCache.length !== 0) for(; this.relayMessageCache.length > 0;)try {
                    const e = this.relayMessageCache.shift();
                    e && await this.onRelayMessage(e);
                } catch (e) {
                    this.client.logger.error(e);
                }
            }, 50);
        }), $d79cc3a87842e2bb$var$c(this, "cleanupDuplicatePairings", async (e)=>{
            if (e.pairingTopic) try {
                const t = this.client.core.pairing.pairings.get(e.pairingTopic), s = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var r, o;
                    return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== t.topic;
                });
                if (s.length === 0) return;
                this.client.logger.info(`Cleaning up ${s.length} duplicate pairing(s)`), await Promise.all(s.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (t) {
                this.client.logger.error(t);
            }
        }), $d79cc3a87842e2bb$var$c(this, "deleteSession", async (e)=>{
            var t;
            const { topic: s, expirerHasDeleted: i = !1, emitEvent: r = !0, id: o = 0 } = e, { self: a } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), this.addToRecentlyDeleted(s, "session"), this.client.core.crypto.keychain.has(a.publicKey) && await this.client.core.crypto.deleteKeyPair(a.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), i || this.client.core.expirer.del(s), this.client.core.storage.removeItem($d79cc3a87842e2bb$export$a26ccd6441b7d638).catch((l)=>this.client.logger.warn(l)), this.getPendingSessionRequests().forEach((l)=>{
                l.topic === s && this.deletePendingSessionRequest(l.id, (0, $9jF5G.getSdkError)("USER_DISCONNECTED"));
            }), s === ((t = this.sessionRequestQueue.queue[0]) == null ? void 0 : t.topic) && (this.sessionRequestQueue.state = $d79cc3a87842e2bb$export$8602b201748df21a.idle), r && this.client.events.emit("session_delete", {
                id: o,
                topic: s
            });
        }), $d79cc3a87842e2bb$var$c(this, "deleteProposal", async (e, t)=>{
            if (t) try {
                const s = this.client.proposal.get(e), i = this.client.core.eventClient.getEvent({
                    topic: s.pairingTopic
                });
                i?.setError((0, $cm4ZJ.EVENT_CLIENT_SESSION_ERRORS).proposal_expired);
            } catch  {}
            await Promise.all([
                this.client.proposal.delete(e, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.addToRecentlyDeleted(e, "proposal");
        }), $d79cc3a87842e2bb$var$c(this, "deletePendingSessionRequest", async (e, t, s = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, t),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.addToRecentlyDeleted(e, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), s && (this.sessionRequestQueue.state = $d79cc3a87842e2bb$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: e
            }));
        }), $d79cc3a87842e2bb$var$c(this, "deletePendingAuthRequest", async (e, t, s = !1)=>{
            await Promise.all([
                this.client.auth.requests.delete(e, t),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }), $d79cc3a87842e2bb$var$c(this, "setExpiry", async (e, t)=>{
            this.client.session.keys.includes(e) && (this.client.core.expirer.set(e, t), await this.client.session.update(e, {
                expiry: t
            }));
        }), $d79cc3a87842e2bb$var$c(this, "setProposal", async (e, t)=>{
            this.client.core.expirer.set(e, (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)), await this.client.proposal.set(e, t);
        }), $d79cc3a87842e2bb$var$c(this, "setAuthRequest", async (e, t)=>{
            const { request: s, pairingTopic: i, transportType: r = (0, $cm4ZJ.TRANSPORT_TYPES).relay } = t;
            this.client.core.expirer.set(e, s.expiryTimestamp), await this.client.auth.requests.set(e, {
                authPayload: s.authPayload,
                requester: s.requester,
                expiryTimestamp: s.expiryTimestamp,
                id: e,
                pairingTopic: i,
                verifyContext: s.verifyContext,
                transportType: r
            });
        }), $d79cc3a87842e2bb$var$c(this, "setPendingSessionRequest", async (e)=>{
            const { id: t, topic: s, params: i, verifyContext: r } = e, o = i.request.expiryTimestamp || (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            this.client.core.expirer.set(t, o), await this.client.pendingRequest.set(t, {
                id: t,
                topic: s,
                params: i,
                verifyContext: r
            });
        }), $d79cc3a87842e2bb$var$c(this, "sendRequest", async (e)=>{
            const { topic: t, method: s, params: i, expiry: r, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: l, appLink: p, tvf: h } = e, u = (0, $3G8ou.formatJsonRpcRequest)(s, i, a);
            let d;
            const w = !!p;
            try {
                const _ = w ? (0, $9jF5G.BASE64URL) : (0, $9jF5G.BASE64);
                d = await this.client.core.crypto.encode(t, u, {
                    encoding: _
                });
            } catch (_) {
                throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${t} failed`), _;
            }
            let m;
            if ($d79cc3a87842e2bb$export$63c37d8ae5931ad5.includes(s)) {
                const _ = (0, $9jF5G.hashMessage)(JSON.stringify(u)), g = (0, $9jF5G.hashMessage)(d);
                m = await this.client.core.verify.register({
                    id: g,
                    decryptedId: _
                });
            }
            const f = $d79cc3a87842e2bb$export$4edb1ca37014192d[s].req;
            if (f.attestation = m, r && (f.ttl = r), o && (f.id = o), this.client.core.history.set(t, u), w) {
                const _ = (0, $9jF5G.getLinkModeURL)(p, t, d);
                await $parcel$global.Linking.openURL(_, this.client.name);
            } else {
                const _ = $d79cc3a87842e2bb$export$4edb1ca37014192d[s].req;
                r && (_.ttl = r), o && (_.id = o), _.tvf = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, h), {
                    correlationId: u.id
                }), l ? (_.internal = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, _.internal), {
                    throwOnFailedPublish: !0
                }), await this.client.core.relayer.publish(t, d, _)) : this.client.core.relayer.publish(t, d, _).catch((g)=>this.client.logger.error(g));
            }
            return u.id;
        }), $d79cc3a87842e2bb$var$c(this, "sendResult", async (e)=>{
            const { id: t, topic: s, result: i, throwOnFailedPublish: r, encodeOpts: o, appLink: a } = e, l = (0, $3G8ou.formatJsonRpcResult)(t, i);
            let p;
            const h = a && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
            try {
                const w = h ? (0, $9jF5G.BASE64URL) : (0, $9jF5G.BASE64);
                p = await this.client.core.crypto.encode(s, l, $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, o || {}), {
                    encoding: w
                }));
            } catch (w) {
                throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${s} failed`), w;
            }
            let u, d;
            try {
                u = await this.client.core.history.get(s, t);
                const w = u.request;
                try {
                    this.shouldSetTVF(w.method, w.params) && (d = this.getTVFParams(t, w.params, i));
                } catch (m) {
                    this.client.logger.warn("sendResult() -> getTVFParams() failed", m);
                }
            } catch (w) {
                throw this.client.logger.error(`sendResult() -> history.get(${s}, ${t}) failed`), w;
            }
            if (h) {
                const w = (0, $9jF5G.getLinkModeURL)(a, s, p);
                await $parcel$global.Linking.openURL(w, this.client.name);
            } else {
                const w = u.request.method, m = $d79cc3a87842e2bb$export$4edb1ca37014192d[w].res;
                m.tvf = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, d), {
                    correlationId: t
                }), r ? (m.internal = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, m.internal), {
                    throwOnFailedPublish: !0
                }), await this.client.core.relayer.publish(s, p, m)) : this.client.core.relayer.publish(s, p, m).catch((f)=>this.client.logger.error(f));
            }
            await this.client.core.history.resolve(l);
        }), $d79cc3a87842e2bb$var$c(this, "sendError", async (e)=>{
            const { id: t, topic: s, error: i, encodeOpts: r, rpcOpts: o, appLink: a } = e, l = (0, $3G8ou.formatJsonRpcError)(t, i);
            let p;
            const h = a && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
            try {
                const d = h ? (0, $9jF5G.BASE64URL) : (0, $9jF5G.BASE64);
                p = await this.client.core.crypto.encode(s, l, $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, r || {}), {
                    encoding: d
                }));
            } catch (d) {
                throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${s} failed`), d;
            }
            let u;
            try {
                u = await this.client.core.history.get(s, t);
            } catch (d) {
                throw this.client.logger.error(`sendError() -> history.get(${s}, ${t}) failed`), d;
            }
            if (h) {
                const d = (0, $9jF5G.getLinkModeURL)(a, s, p);
                await $parcel$global.Linking.openURL(d, this.client.name);
            } else {
                const d = u.request.method, w = o || $d79cc3a87842e2bb$export$4edb1ca37014192d[d].res;
                this.client.core.relayer.publish(s, p, w);
            }
            await this.client.core.history.resolve(l);
        }), $d79cc3a87842e2bb$var$c(this, "cleanup", async ()=>{
            const e = [], t = [];
            this.client.session.getAll().forEach((s)=>{
                let i = !1;
                (0, $9jF5G.isExpired)(s.expiry) && (i = !0), this.client.core.crypto.keychain.has(s.topic) || (i = !0), i && e.push(s.topic);
            }), this.client.proposal.getAll().forEach((s)=>{
                (0, $9jF5G.isExpired)(s.expiryTimestamp) && t.push(s.id);
            }), await Promise.all([
                ...e.map((s)=>this.deleteSession({
                        topic: s
                    })),
                ...t.map((s)=>this.deleteProposal(s))
            ]);
        }), $d79cc3a87842e2bb$var$c(this, "onProviderMessageEvent", async (e)=>{
            !this.initialized || this.relayMessageCache.length > 0 ? this.relayMessageCache.push(e) : await this.onRelayMessage(e);
        }), $d79cc3a87842e2bb$var$c(this, "onRelayEventRequest", async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }), $d79cc3a87842e2bb$var$c(this, "processRequestsQueue", async ()=>{
            if (this.requestQueue.state === $d79cc3a87842e2bb$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $d79cc3a87842e2bb$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    await this.processRequest(e);
                } catch (t) {
                    this.client.logger.warn(t);
                }
            }
            this.requestQueue.state = $d79cc3a87842e2bb$export$8602b201748df21a.idle;
        }), $d79cc3a87842e2bb$var$c(this, "processRequest", async (e)=>{
            const { topic: t, payload: s, attestation: i, transportType: r, encryptedId: o } = e, a = s.method;
            if (!this.shouldIgnorePairingRequest({
                topic: t,
                requestMethod: a
            })) switch(a){
                case "wc_sessionPropose":
                    return await this.onSessionProposeRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: o
                    });
                case "wc_sessionSettle":
                    return await this.onSessionSettleRequest(t, s);
                case "wc_sessionUpdate":
                    return await this.onSessionUpdateRequest(t, s);
                case "wc_sessionExtend":
                    return await this.onSessionExtendRequest(t, s);
                case "wc_sessionPing":
                    return await this.onSessionPingRequest(t, s);
                case "wc_sessionDelete":
                    return await this.onSessionDeleteRequest(t, s);
                case "wc_sessionRequest":
                    return await this.onSessionRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: o,
                        transportType: r
                    });
                case "wc_sessionEvent":
                    return await this.onSessionEventRequest(t, s);
                case "wc_sessionAuthenticate":
                    return await this.onSessionAuthenticateRequest({
                        topic: t,
                        payload: s,
                        attestation: i,
                        encryptedId: o,
                        transportType: r
                    });
                default:
                    return this.client.logger.info(`Unsupported request method ${a}`);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onRelayEventResponse", async (e)=>{
            const { topic: t, payload: s, transportType: i } = e, r = (await this.client.core.history.get(t, s.id)).request.method;
            switch(r){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(t, s, i);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(t, s);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(t, s);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(t, s);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(t, s);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(t, s);
                case "wc_sessionAuthenticate":
                    return this.onSessionAuthenticateResponse(t, s);
                default:
                    return this.client.logger.info(`Unsupported response method ${r}`);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onRelayEventUnknownPayload", (e)=>{
            const { topic: t } = e, { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `Decoded payload on topic ${t} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(s);
        }), $d79cc3a87842e2bb$var$c(this, "shouldIgnorePairingRequest", (e)=>{
            const { topic: t, requestMethod: s } = e, i = this.expectedPairingMethodMap.get(t);
            return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
        }), $d79cc3a87842e2bb$var$c(this, "onSessionProposeRequest", async (e)=>{
            const { topic: t, payload: s, attestation: i, encryptedId: r } = e, { params: o, id: a } = s;
            try {
                const l = this.client.core.eventClient.getEvent({
                    topic: t
                });
                this.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), l?.setError((0, $cm4ZJ.EVENT_CLIENT_PAIRING_ERRORS).proposal_listener_not_found)), this.isValidConnect($d79cc3a87842e2bb$var$v({}, s.params));
                const p = o.expiryTimestamp || (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), h = $d79cc3a87842e2bb$var$v({
                    id: a,
                    pairingTopic: t,
                    expiryTimestamp: p
                }, o);
                await this.setProposal(a, h);
                const u = await this.getVerifyContext({
                    attestationId: i,
                    hash: (0, $9jF5G.hashMessage)(JSON.stringify(s)),
                    encryptedId: r,
                    metadata: h.proposer.metadata
                });
                l?.addTrace((0, $cm4ZJ.EVENT_CLIENT_PAIRING_TRACES).emit_session_proposal), this.client.events.emit("session_proposal", {
                    id: a,
                    params: h,
                    verifyContext: u
                });
            } catch (l) {
                await this.sendError({
                    id: a,
                    topic: t,
                    error: l,
                    rpcOpts: $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionPropose.autoReject
                }), this.client.logger.error(l);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionProposeResponse", async (e, t, s)=>{
            const { id: i } = t;
            if ((0, $5ZYqc.isJsonRpcResult)(t)) {
                const { result: r } = t;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: r
                });
                const o = this.client.proposal.get(i);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: o
                });
                const a = o.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: a
                });
                const l = r.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: l
                });
                const p = await this.client.core.crypto.generateSharedKey(a, l);
                this.pendingSessions.set(i, {
                    sessionTopic: p,
                    pairingTopic: e,
                    proposalId: i,
                    publicKey: a
                });
                const h = await this.client.core.relayer.subscribe(p, {
                    transportType: s
                });
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: h
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else if ((0, $5ZYqc.isJsonRpcError)(t)) {
                await this.client.proposal.delete(i, (0, $9jF5G.getSdkError)("USER_DISCONNECTED"));
                const r = (0, $9jF5G.engineEvent)("session_connect", i);
                if (this.events.listenerCount(r) === 0) throw new Error(`emitting ${r} without any listeners, 954`);
                this.events.emit(r, {
                    error: t.error
                });
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionSettleRequest", async (e, t)=>{
            const { id: s, params: i } = t;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: r, controller: o, expiry: a, namespaces: l, sessionProperties: p, scopedProperties: h, sessionConfig: u } = t.params, d = [
                    ...this.pendingSessions.values()
                ].find((f)=>f.sessionTopic === e);
                if (!d) return this.client.logger.error(`Pending session not found for topic ${e}`);
                const w = this.client.proposal.get(d.proposalId), m = $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v($d79cc3a87842e2bb$var$v($d79cc3a87842e2bb$var$v({
                    topic: e,
                    relay: r,
                    expiry: a,
                    namespaces: l,
                    acknowledged: !0,
                    pairingTopic: d.pairingTopic,
                    requiredNamespaces: w.requiredNamespaces,
                    optionalNamespaces: w.optionalNamespaces,
                    controller: o.publicKey,
                    self: {
                        publicKey: d.publicKey,
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, p && {
                    sessionProperties: p
                }), h && {
                    scopedProperties: h
                }), u && {
                    sessionConfig: u
                }), {
                    transportType: (0, $cm4ZJ.TRANSPORT_TYPES).relay
                });
                await this.client.session.set(m.topic, m), await this.setExpiry(m.topic, m.expiry), await this.client.core.pairing.updateMetadata({
                    topic: d.pairingTopic,
                    metadata: m.peer.metadata
                }), this.client.events.emit("session_connect", {
                    session: m
                }), this.events.emit((0, $9jF5G.engineEvent)("session_connect", d.proposalId), {
                    session: m
                }), this.pendingSessions.delete(d.proposalId), this.deleteProposal(d.proposalId, !1), this.cleanupDuplicatePairings(m), await this.sendResult({
                    id: t.id,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                });
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionSettleResponse", async (e, t)=>{
            const { id: s } = t;
            (0, $5ZYqc.isJsonRpcResult)(t) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $9jF5G.engineEvent)("session_approve", s), {})) : (0, $5ZYqc.isJsonRpcError)(t) && (await this.client.session.delete(e, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, $9jF5G.engineEvent)("session_approve", s), {
                error: t.error
            }));
        }), $d79cc3a87842e2bb$var$c(this, "onSessionUpdateRequest", async (e, t)=>{
            const { params: s, id: i } = t;
            try {
                const r = `${e}_session_update`, o = (0, $9jF5G.MemoryStore).get(r);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.warn(`Discarding out of sync request - ${i}`), this.sendError({
                        id: i,
                        topic: e,
                        error: (0, $9jF5G.getSdkError)("INVALID_UPDATE_REQUEST")
                    });
                    return;
                }
                this.isValidUpdate($d79cc3a87842e2bb$var$v({
                    topic: e
                }, s));
                try {
                    (0, $9jF5G.MemoryStore).set(r, i), await this.client.session.update(e, {
                        namespaces: s.namespaces
                    }), await this.sendResult({
                        id: i,
                        topic: e,
                        result: !0,
                        throwOnFailedPublish: !0
                    });
                } catch (a) {
                    throw (0, $9jF5G.MemoryStore).delete(r), a;
                }
                this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: s
                });
            } catch (r) {
                await this.sendError({
                    id: i,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isRequestOutOfSync", (e, t)=>t.toString().slice(0, -3) < e.toString().slice(0, -3)), $d79cc3a87842e2bb$var$c(this, "onSessionUpdateResponse", (e, t)=>{
            const { id: s } = t, i = (0, $9jF5G.engineEvent)("session_update", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $5ZYqc.isJsonRpcResult)(t) ? this.events.emit((0, $9jF5G.engineEvent)("session_update", s), {}) : (0, $5ZYqc.isJsonRpcError)(t) && this.events.emit((0, $9jF5G.engineEvent)("session_update", s), {
                error: t.error
            });
        }), $d79cc3a87842e2bb$var$c(this, "onSessionExtendRequest", async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $9jF5G.calcExpiry)($d79cc3a87842e2bb$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: s,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_extend", {
                    id: s,
                    topic: e
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: i
                }), this.client.logger.error(i);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionExtendResponse", (e, t)=>{
            const { id: s } = t, i = (0, $9jF5G.engineEvent)("session_extend", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $5ZYqc.isJsonRpcResult)(t) ? this.events.emit((0, $9jF5G.engineEvent)("session_extend", s), {}) : (0, $5ZYqc.isJsonRpcError)(t) && this.events.emit((0, $9jF5G.engineEvent)("session_extend", s), {
                error: t.error
            });
        }), $d79cc3a87842e2bb$var$c(this, "onSessionPingRequest", async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: s,
                    topic: e,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_ping", {
                    id: s,
                    topic: e
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: i
                }), this.client.logger.error(i);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionPingResponse", (e, t)=>{
            const { id: s } = t, i = (0, $9jF5G.engineEvent)("session_ping", s);
            setTimeout(()=>{
                if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners 2176`);
                (0, $5ZYqc.isJsonRpcResult)(t) ? this.events.emit((0, $9jF5G.engineEvent)("session_ping", s), {}) : (0, $5ZYqc.isJsonRpcError)(t) && this.events.emit((0, $9jF5G.engineEvent)("session_ping", s), {
                    error: t.error
                });
            }, 500);
        }), $d79cc3a87842e2bb$var$c(this, "onSessionDeleteRequest", async (e, t)=>{
            const { id: s } = t;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: t.params
                }), Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $cm4ZJ.RELAYER_EVENTS).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: e,
                                id: s
                            }));
                        });
                    }),
                    this.sendResult({
                        id: s,
                        topic: e,
                        result: !0,
                        throwOnFailedPublish: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: e,
                        error: (0, $9jF5G.getSdkError)("USER_DISCONNECTED")
                    })
                ]).catch((i)=>this.client.logger.error(i));
            } catch (i) {
                this.client.logger.error(i);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionRequest", async (e)=>{
            var t, s, i;
            const { topic: r, payload: o, attestation: a, encryptedId: l, transportType: p } = e, { id: h, params: u } = o;
            try {
                await this.isValidRequest($d79cc3a87842e2bb$var$v({
                    topic: r
                }, u));
                const d = this.client.session.get(r), w = await this.getVerifyContext({
                    attestationId: a,
                    hash: (0, $9jF5G.hashMessage)(JSON.stringify((0, $3G8ou.formatJsonRpcRequest)("wc_sessionRequest", u, h))),
                    encryptedId: l,
                    metadata: d.peer.metadata,
                    transportType: p
                }), m = {
                    id: h,
                    topic: r,
                    params: u,
                    verifyContext: w
                };
                await this.setPendingSessionRequest(m), p === (0, $cm4ZJ.TRANSPORT_TYPES).link_mode && (t = d.peer.metadata.redirect) != null && t.universal && this.client.core.addLinkModeSupportedApp((s = d.peer.metadata.redirect) == null ? void 0 : s.universal), (i = this.client.signConfig) != null && i.disableRequestQueue ? this.emitSessionRequest(m) : (this.addSessionRequestToSessionRequestQueue(m), this.processSessionRequestQueue());
            } catch (d) {
                await this.sendError({
                    id: h,
                    topic: r,
                    error: d
                }), this.client.logger.error(d);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionRequestResponse", (e, t)=>{
            const { id: s } = t, i = (0, $9jF5G.engineEvent)("session_request", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $5ZYqc.isJsonRpcResult)(t) ? this.events.emit((0, $9jF5G.engineEvent)("session_request", s), {
                result: t.result
            }) : (0, $5ZYqc.isJsonRpcError)(t) && this.events.emit((0, $9jF5G.engineEvent)("session_request", s), {
                error: t.error
            });
        }), $d79cc3a87842e2bb$var$c(this, "onSessionEventRequest", async (e, t)=>{
            const { id: s, params: i } = t;
            try {
                const r = `${e}_session_event_${i.event.name}`, o = (0, $9jF5G.MemoryStore).get(r);
                if (o && this.isRequestOutOfSync(o, s)) {
                    this.client.logger.info(`Discarding out of sync request - ${s}`);
                    return;
                }
                this.isValidEmit($d79cc3a87842e2bb$var$v({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: s,
                    topic: e,
                    params: i
                }), (0, $9jF5G.MemoryStore).set(r, s);
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: e,
                    error: r
                }), this.client.logger.error(r);
            }
        }), $d79cc3a87842e2bb$var$c(this, "onSessionAuthenticateResponse", (e, t)=>{
            const { id: s } = t;
            this.client.logger.trace({
                type: "method",
                method: "onSessionAuthenticateResponse",
                topic: e,
                payload: t
            }), (0, $5ZYqc.isJsonRpcResult)(t) ? this.events.emit((0, $9jF5G.engineEvent)("session_request", s), {
                result: t.result
            }) : (0, $5ZYqc.isJsonRpcError)(t) && this.events.emit((0, $9jF5G.engineEvent)("session_request", s), {
                error: t.error
            });
        }), $d79cc3a87842e2bb$var$c(this, "onSessionAuthenticateRequest", async (e)=>{
            var t;
            const { topic: s, payload: i, attestation: r, encryptedId: o, transportType: a } = e;
            try {
                const { requester: l, authPayload: p, expiryTimestamp: h } = i.params, u = await this.getVerifyContext({
                    attestationId: r,
                    hash: (0, $9jF5G.hashMessage)(JSON.stringify(i)),
                    encryptedId: o,
                    metadata: l.metadata,
                    transportType: a
                }), d = {
                    requester: l,
                    pairingTopic: s,
                    id: i.id,
                    authPayload: p,
                    verifyContext: u,
                    expiryTimestamp: h
                };
                await this.setAuthRequest(i.id, {
                    request: d,
                    pairingTopic: s,
                    transportType: a
                }), a === (0, $cm4ZJ.TRANSPORT_TYPES).link_mode && (t = l.metadata.redirect) != null && t.universal && this.client.core.addLinkModeSupportedApp(l.metadata.redirect.universal), this.client.events.emit("session_authenticate", {
                    topic: s,
                    params: i.params,
                    id: i.id,
                    verifyContext: u
                });
            } catch (l) {
                this.client.logger.error(l);
                const p = i.params.requester.publicKey, h = await this.client.core.crypto.generateKeyPair(), u = this.getAppLinkIfEnabled(i.params.requester.metadata, a), d = {
                    type: (0, $9jF5G.TYPE_1),
                    receiverPublicKey: p,
                    senderPublicKey: h
                };
                await this.sendError({
                    id: i.id,
                    topic: s,
                    error: l,
                    encodeOpts: d,
                    rpcOpts: $d79cc3a87842e2bb$export$4edb1ca37014192d.wc_sessionAuthenticate.autoReject,
                    appLink: u
                });
            }
        }), $d79cc3a87842e2bb$var$c(this, "addSessionRequestToSessionRequestQueue", (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }), $d79cc3a87842e2bb$var$c(this, "cleanupAfterResponse", (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $d79cc3a87842e2bb$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $2TjUJ.toMiliseconds)(this.requestQueueDelay));
        }), $d79cc3a87842e2bb$var$c(this, "cleanupPendingSentRequestsForTopic", ({ topic: e, error: t })=>{
            const s = this.client.core.history.pending;
            s.length > 0 && s.filter((i)=>i.topic === e && i.request.method === "wc_sessionRequest").forEach((i)=>{
                const r = i.request.id, o = (0, $9jF5G.engineEvent)("session_request", r);
                if (this.events.listenerCount(o) === 0) throw new Error(`emitting ${o} without any listeners`);
                this.events.emit((0, $9jF5G.engineEvent)("session_request", i.request.id), {
                    error: t
                });
            });
        }), $d79cc3a87842e2bb$var$c(this, "processSessionRequestQueue", ()=>{
            if (this.sessionRequestQueue.state === $d79cc3a87842e2bb$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $d79cc3a87842e2bb$export$8602b201748df21a.active, this.emitSessionRequest(e);
            } catch (t) {
                this.client.logger.error(t);
            }
        }), $d79cc3a87842e2bb$var$c(this, "emitSessionRequest", (e)=>{
            this.client.events.emit("session_request", e);
        }), $d79cc3a87842e2bb$var$c(this, "onPairingCreated", (e)=>{
            if (e.methods && this.expectedPairingMethodMap.set(e.topic, e.methods), e.active) return;
            const t = this.client.proposal.getAll().find((s)=>s.pairingTopic === e.topic);
            t && this.onSessionProposeRequest({
                topic: e.topic,
                payload: (0, $3G8ou.formatJsonRpcRequest)("wc_sessionPropose", $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({}, t), {
                    requiredNamespaces: t.requiredNamespaces,
                    optionalNamespaces: t.optionalNamespaces,
                    relays: t.relays,
                    proposer: t.proposer,
                    sessionProperties: t.sessionProperties,
                    scopedProperties: t.scopedProperties
                }), t.id)
            });
        }), $d79cc3a87842e2bb$var$c(this, "isValidConnect", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: l } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(l);
            }
            const { pairingTopic: t, requiredNamespaces: s, optionalNamespaces: i, sessionProperties: r, scopedProperties: o, relays: a } = e;
            if ((0, $9jF5G.isUndefined)(t) || await this.isValidPairingTopic(t), !(0, $9jF5G.isValidRelays)(a, !0)) {
                const { message: l } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `connect() relays: ${a}`);
                throw new Error(l);
            }
            if (!(0, $9jF5G.isUndefined)(s) && (0, $9jF5G.isValidObject)(s) !== 0 && this.validateNamespaces(s, "requiredNamespaces"), !(0, $9jF5G.isUndefined)(i) && (0, $9jF5G.isValidObject)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $9jF5G.isUndefined)(r) || this.validateSessionProps(r, "sessionProperties"), !(0, $9jF5G.isUndefined)(o)) {
                this.validateSessionProps(o, "scopedProperties");
                const l = Object.keys(s || {}).concat(Object.keys(i || {}));
                if (!Object.keys(o).every((p)=>l.includes(p))) throw new Error(`Scoped properties must be a subset of required/optional namespaces, received: ${JSON.stringify(o)}, required/optional namespaces: ${JSON.stringify(l)}`);
            }
        }), $d79cc3a87842e2bb$var$c(this, "validateNamespaces", (e, t)=>{
            const s = (0, $9jF5G.isValidRequiredNamespaces)(e, "connect()", t);
            if (s) throw new Error(s.message);
        }), $d79cc3a87842e2bb$var$c(this, "isValidApprove", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) throw new Error((0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: t, namespaces: s, relayProtocol: i, sessionProperties: r, scopedProperties: o } = e;
            this.checkRecentlyDeleted(t), await this.isValidProposalId(t);
            const a = this.client.proposal.get(t), l = (0, $9jF5G.isValidNamespaces)(s, "approve()");
            if (l) throw new Error(l.message);
            const p = (0, $9jF5G.isConformingNamespaces)(a.requiredNamespaces, s, "approve()");
            if (p) throw new Error(p.message);
            if (!(0, $9jF5G.isValidString)(i, !0)) {
                const { message: h } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            if ((0, $9jF5G.isUndefined)(r) || this.validateSessionProps(r, "sessionProperties"), !(0, $9jF5G.isUndefined)(o)) {
                this.validateSessionProps(o, "scopedProperties");
                const h = new Set(Object.keys(s));
                if (!Object.keys(o).every((u)=>h.has(u))) throw new Error(`Scoped properties must be a subset of approved namespaces, received: ${JSON.stringify(o)}, approved namespaces: ${Array.from(h).join(", ")}`);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isValidReject", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: i } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: t, reason: s } = e;
            if (this.checkRecentlyDeleted(t), await this.isValidProposalId(t), !(0, $9jF5G.isValidErrorReason)(s)) {
                const { message: i } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(s)}`);
                throw new Error(i);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isValidSessionSettleRequest", (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: l } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(l);
            }
            const { relay: t, controller: s, namespaces: i, expiry: r } = e;
            if (!(0, $9jF5G.isValidRelay)(t)) {
                const { message: l } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(l);
            }
            const o = (0, $9jF5G.isValidController)(s, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $9jF5G.isValidNamespaces)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $9jF5G.isExpired)(r)) {
                const { message: l } = (0, $9jF5G.getInternalError)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(l);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isValidUpdate", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: t, namespaces: s } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
            const i = this.client.session.get(t), r = (0, $9jF5G.isValidNamespaces)(s, "update()");
            if (r) throw new Error(r.message);
            const o = (0, $9jF5G.isConformingNamespaces)(i.requiredNamespaces, s, "update()");
            if (o) throw new Error(o.message);
        }), $d79cc3a87842e2bb$var$c(this, "isValidExtend", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
        }), $d79cc3a87842e2bb$var$c(this, "isValidRequest", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: t, request: s, chainId: i, expiry: r } = e;
            this.checkRecentlyDeleted(t), await this.isValidSessionTopic(t);
            const { namespaces: o } = this.client.session.get(t);
            if (!(0, $9jF5G.isValidNamespacesChainId)(o, i)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $9jF5G.isValidRequest)(s)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `request() ${JSON.stringify(s)}`);
                throw new Error(a);
            }
            if (!(0, $9jF5G.isValidNamespacesRequest)(o, i, s.method)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `request() method: ${s.method}`);
                throw new Error(a);
            }
            if (r && !(0, $9jF5G.isValidRequestExpiry)(r, $d79cc3a87842e2bb$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `request() expiry: ${r}. Expiry must be a number (in seconds) between ${$d79cc3a87842e2bb$export$409f0c0a13a1b7c6.min} and ${$d79cc3a87842e2bb$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isValidRespond", async (e)=>{
            var t;
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: r } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(r);
            }
            const { topic: s, response: i } = e;
            try {
                await this.isValidSessionTopic(s);
            } catch (r) {
                throw (t = e?.response) != null && t.id && this.cleanupAfterResponse(e), r;
            }
            if (!(0, $9jF5G.isValidResponse)(i)) {
                const { message: r } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(r);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isValidPing", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            await this.isValidSessionOrPairingTopic(t);
        }), $d79cc3a87842e2bb$var$c(this, "isValidEmit", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: o } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: t, event: s, chainId: i } = e;
            await this.isValidSessionTopic(t);
            const { namespaces: r } = this.client.session.get(t);
            if (!(0, $9jF5G.isValidNamespacesChainId)(r, i)) {
                const { message: o } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $9jF5G.isValidEvent)(s)) {
                const { message: o } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
            if (!(0, $9jF5G.isValidNamespacesEvent)(r, i, s.name)) {
                const { message: o } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isValidDisconnect", async (e)=>{
            if (!(0, $9jF5G.isValidParams)(e)) {
                const { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(s);
            }
            const { topic: t } = e;
            await this.isValidSessionOrPairingTopic(t);
        }), $d79cc3a87842e2bb$var$c(this, "isValidAuthenticate", (e)=>{
            const { chains: t, uri: s, domain: i, nonce: r } = e;
            if (!Array.isArray(t) || t.length === 0) throw new Error("chains is required and must be a non-empty array");
            if (!(0, $9jF5G.isValidString)(s, !1)) throw new Error("uri is required parameter");
            if (!(0, $9jF5G.isValidString)(i, !1)) throw new Error("domain is required parameter");
            if (!(0, $9jF5G.isValidString)(r, !1)) throw new Error("nonce is required parameter");
            if ([
                ...new Set(t.map((a)=>(0, $9jF5G.parseChainId)(a).namespace))
            ].length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
            const { namespace: o } = (0, $9jF5G.parseChainId)(t[0]);
            if (o !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
        }), $d79cc3a87842e2bb$var$c(this, "getVerifyContext", async (e)=>{
            const { attestationId: t, hash: s, encryptedId: i, metadata: r, transportType: o } = e, a = {
                verified: {
                    verifyUrl: r.verifyUrl || (0, $cm4ZJ.VERIFY_SERVER),
                    validation: "UNKNOWN",
                    origin: r.url || ""
                }
            };
            try {
                if (o === (0, $cm4ZJ.TRANSPORT_TYPES).link_mode) {
                    const p = this.getAppLinkIfEnabled(r, o);
                    return a.verified.validation = p && new URL(p).origin === new URL(r.url).origin ? "VALID" : "INVALID", a;
                }
                const l = await this.client.core.verify.resolve({
                    attestationId: t,
                    hash: s,
                    encryptedId: i,
                    verifyUrl: r.verifyUrl
                });
                l && (a.verified.origin = l.origin, a.verified.isScam = l.isScam, a.verified.validation = l.origin === new URL(r.url).origin ? "VALID" : "INVALID");
            } catch (l) {
                this.client.logger.warn(l);
            }
            return this.client.logger.debug(`Verify context: ${JSON.stringify(a)}`), a;
        }), $d79cc3a87842e2bb$var$c(this, "validateSessionProps", (e, t)=>{
            Object.values(e).forEach((s, i)=>{
                if (s == null) {
                    const { message: r } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `${t} must contain an existing value for each key. Received: ${s} for key ${Object.keys(e)[i]}`);
                    throw new Error(r);
                }
            });
        }), $d79cc3a87842e2bb$var$c(this, "getPendingAuthRequest", (e)=>{
            const t = this.client.auth.requests.get(e);
            return typeof t == "object" ? t : void 0;
        }), $d79cc3a87842e2bb$var$c(this, "addToRecentlyDeleted", (e, t)=>{
            if (this.recentlyDeletedMap.set(e, t), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
                let s = 0;
                const i = this.recentlyDeletedLimit / 2;
                for (const r of this.recentlyDeletedMap.keys()){
                    if (s++ >= i) break;
                    this.recentlyDeletedMap.delete(r);
                }
            }
        }), $d79cc3a87842e2bb$var$c(this, "checkRecentlyDeleted", (e)=>{
            const t = this.recentlyDeletedMap.get(e);
            if (t) {
                const { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `Record was recently deleted - ${t}: ${e}`);
                throw new Error(s);
            }
        }), $d79cc3a87842e2bb$var$c(this, "isLinkModeEnabled", (e, t)=>{
            var s, i, r, o, a, l, p, h, u;
            return !e || t !== (0, $cm4ZJ.TRANSPORT_TYPES).link_mode ? !1 : ((i = (s = this.client.metadata) == null ? void 0 : s.redirect) == null ? void 0 : i.linkMode) === !0 && ((o = (r = this.client.metadata) == null ? void 0 : r.redirect) == null ? void 0 : o.universal) !== void 0 && ((l = (a = this.client.metadata) == null ? void 0 : a.redirect) == null ? void 0 : l.universal) !== "" && ((p = e?.redirect) == null ? void 0 : p.universal) !== void 0 && ((h = e?.redirect) == null ? void 0 : h.universal) !== "" && ((u = e?.redirect) == null ? void 0 : u.linkMode) === !0 && this.client.core.linkModeSupportedApps.includes(e.redirect.universal) && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
        }), $d79cc3a87842e2bb$var$c(this, "getAppLinkIfEnabled", (e, t)=>{
            var s;
            return this.isLinkModeEnabled(e, t) ? (s = e?.redirect) == null ? void 0 : s.universal : void 0;
        }), $d79cc3a87842e2bb$var$c(this, "handleLinkModeMessage", ({ url: e })=>{
            if (!e || !e.includes("wc_ev") || !e.includes("topic")) return;
            const t = (0, $9jF5G.getSearchParamFromURL)(e, "topic") || "", s = decodeURIComponent((0, $9jF5G.getSearchParamFromURL)(e, "wc_ev") || ""), i = this.client.session.keys.includes(t);
            i && this.client.session.update(t, {
                transportType: (0, $cm4ZJ.TRANSPORT_TYPES).link_mode
            }), this.client.core.dispatchEnvelope({
                topic: t,
                message: s,
                sessionExists: i
            });
        }), $d79cc3a87842e2bb$var$c(this, "registerLinkModeListeners", async ()=>{
            var e;
            if ((0, $9jF5G.isTestRun)() || (0, $9jF5G.isReactNative)() && (e = this.client.metadata.redirect) != null && e.linkMode) {
                const t = $parcel$global == null ? void 0 : $parcel$global.Linking;
                if (typeof t < "u") {
                    t.addEventListener("url", this.handleLinkModeMessage, this.client.name);
                    const s = await t.getInitialURL();
                    s && setTimeout(()=>{
                        this.handleLinkModeMessage({
                            url: s
                        });
                    }, 50);
                }
            }
        }), $d79cc3a87842e2bb$var$c(this, "shouldSetTVF", (e, t)=>{
            if (!t || e !== "wc_sessionRequest") return !1;
            const { request: s } = t;
            return Object.keys($d79cc3a87842e2bb$export$a06a2a399442c35f).includes(s.method);
        }), $d79cc3a87842e2bb$var$c(this, "getTVFParams", (e, t, s)=>{
            var i, r;
            try {
                const o = t.request.method, a = this.extractTxHashesFromResult(o, s);
                return $d79cc3a87842e2bb$var$b($d79cc3a87842e2bb$var$v({
                    correlationId: e,
                    rpcMethods: [
                        o
                    ],
                    chainId: t.chainId
                }, this.isValidContractData(t.request.params) && {
                    contractAddresses: [
                        (r = (i = t.request.params) == null ? void 0 : i[0]) == null ? void 0 : r.to
                    ]
                }), {
                    txHashes: a
                });
            } catch (o) {
                this.client.logger.warn("Error getting TVF params", o);
            }
            return {};
        }), $d79cc3a87842e2bb$var$c(this, "isValidContractData", (e)=>{
            var t;
            if (!e) return !1;
            try {
                const s = e?.data || ((t = e?.[0]) == null ? void 0 : t.data);
                if (!s.startsWith("0x")) return !1;
                const i = s.slice(2);
                return /^[0-9a-fA-F]*$/.test(i) ? i.length % 2 === 0 : !1;
            } catch  {}
            return !1;
        }), $d79cc3a87842e2bb$var$c(this, "extractTxHashesFromResult", (e, t)=>{
            try {
                const s = $d79cc3a87842e2bb$export$a06a2a399442c35f[e];
                if (typeof t == "string") return [
                    t
                ];
                const i = t[s.key];
                if ((0, $9jF5G.isValidArray)(i)) return e === "solana_signAllTransactions" ? i.map((r)=>(0, $9jF5G.extractSolanaTransactionId)(r)) : i;
                if (typeof i == "string") return [
                    i
                ];
            } catch (s) {
                this.client.logger.warn("Error extracting tx hashes from result", s);
            }
            return [];
        });
    }
    async processPendingMessageEvents() {
        try {
            const n = this.client.session.keys, e = this.client.core.relayer.messages.getWithoutAck(n);
            for (const [t, s] of Object.entries(e))for (const i of s)try {
                await this.onProviderMessageEvent({
                    topic: t,
                    message: i,
                    publishedAt: Date.now()
                });
            } catch  {
                this.client.logger.warn(`Error processing pending message event for topic: ${t}, message: ${i}`);
            }
        } catch (n) {
            this.client.logger.warn("processPendingMessageEvents failed", n);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: n } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(n);
        }
    }
    async confirmOnlineStateOrThrow() {
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $cm4ZJ.RELAYER_EVENTS).message, (n)=>{
            this.onProviderMessageEvent(n);
        });
    }
    async onRelayMessage(n) {
        const { topic: e, message: t, attestation: s, transportType: i } = n, { publicKey: r } = this.client.auth.authKeys.keys.includes($d79cc3a87842e2bb$export$efef74cb455ac30f) ? this.client.auth.authKeys.get($d79cc3a87842e2bb$export$efef74cb455ac30f) : {
            responseTopic: void 0,
            publicKey: void 0
        };
        try {
            const o = await this.client.core.crypto.decode(e, t, {
                receiverPublicKey: r,
                encoding: i === (0, $cm4ZJ.TRANSPORT_TYPES).link_mode ? (0, $9jF5G.BASE64URL) : (0, $9jF5G.BASE64)
            });
            (0, $5ZYqc.isJsonRpcRequest)(o) ? (this.client.core.history.set(e, o), await this.onRelayEventRequest({
                topic: e,
                payload: o,
                attestation: s,
                transportType: i,
                encryptedId: (0, $9jF5G.hashMessage)(t)
            })) : (0, $5ZYqc.isJsonRpcResponse)(o) ? (await this.client.core.history.resolve(o), await this.onRelayEventResponse({
                topic: e,
                payload: o,
                transportType: i
            }), this.client.core.history.delete(e, o.id)) : await this.onRelayEventUnknownPayload({
                topic: e,
                payload: o,
                transportType: i
            }), await this.client.core.relayer.messages.ack(e, t);
        } catch (o) {
            this.client.logger.error(o);
        }
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $cm4ZJ.EXPIRER_EVENTS).expired, async (n)=>{
            const { topic: e, id: t } = (0, $9jF5G.parseExpirerTarget)(n.target);
            if (t && this.client.pendingRequest.keys.includes(t)) return await this.deletePendingSessionRequest(t, (0, $9jF5G.getInternalError)("EXPIRED"), !0);
            if (t && this.client.auth.requests.keys.includes(t)) return await this.deletePendingAuthRequest(t, (0, $9jF5G.getInternalError)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession({
                topic: e,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: e
            })) : t && (await this.deleteProposal(t, !0), this.client.events.emit("proposal_expire", {
                id: t
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $cm4ZJ.PAIRING_EVENTS).create, (n)=>this.onPairingCreated(n)), this.client.core.pairing.events.on((0, $cm4ZJ.PAIRING_EVENTS).delete, (n)=>{
            this.addToRecentlyDeleted(n.topic, "pairing");
        });
    }
    isValidPairingTopic(n) {
        if (!(0, $9jF5G.isValidString)(n, !1)) {
            const { message: e } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${n}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(n)) {
            const { message: e } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${n}`);
            throw new Error(e);
        }
        if ((0, $9jF5G.isExpired)(this.client.core.pairing.pairings.get(n).expiry)) {
            const { message: e } = (0, $9jF5G.getInternalError)("EXPIRED", `pairing topic: ${n}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(n) {
        if (!(0, $9jF5G.isValidString)(n, !1)) {
            const { message: e } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `session topic should be a string: ${n}`);
            throw new Error(e);
        }
        if (this.checkRecentlyDeleted(n), !this.client.session.keys.includes(n)) {
            const { message: e } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `session topic doesn't exist: ${n}`);
            throw new Error(e);
        }
        if ((0, $9jF5G.isExpired)(this.client.session.get(n).expiry)) {
            await this.deleteSession({
                topic: n
            });
            const { message: e } = (0, $9jF5G.getInternalError)("EXPIRED", `session topic: ${n}`);
            throw new Error(e);
        }
        if (!this.client.core.crypto.keychain.has(n)) {
            const { message: e } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${n}`);
            throw await this.deleteSession({
                topic: n
            }), new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(n) {
        if (this.checkRecentlyDeleted(n), this.client.session.keys.includes(n)) await this.isValidSessionTopic(n);
        else if (this.client.core.pairing.pairings.keys.includes(n)) this.isValidPairingTopic(n);
        else if ((0, $9jF5G.isValidString)(n, !1)) {
            const { message: e } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${n}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${n}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(n) {
        if (!(0, $9jF5G.isValidId)(n)) {
            const { message: e } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `proposal id should be a number: ${n}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(n)) {
            const { message: e } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `proposal id doesn't exist: ${n}`);
            throw new Error(e);
        }
        if ((0, $9jF5G.isExpired)(this.client.proposal.get(n).expiryTimestamp)) {
            await this.deleteProposal(n);
            const { message: e } = (0, $9jF5G.getInternalError)("EXPIRED", `proposal id: ${n}`);
            throw new Error(e);
        }
    }
}
class $d79cc3a87842e2bb$var$Ns extends (0, $cm4ZJ.Store) {
    constructor(n, e){
        super(n, e, $d79cc3a87842e2bb$export$ae6c7a4f7ed730a1, $d79cc3a87842e2bb$export$7fa6f9ee1e2cab96), this.core = n, this.logger = e;
    }
}
class $d79cc3a87842e2bb$var$St extends (0, $cm4ZJ.Store) {
    constructor(n, e){
        super(n, e, $d79cc3a87842e2bb$export$a069e98a8dfeec1e, $d79cc3a87842e2bb$export$7fa6f9ee1e2cab96), this.core = n, this.logger = e;
    }
}
class $d79cc3a87842e2bb$var$Os extends (0, $cm4ZJ.Store) {
    constructor(n, e){
        super(n, e, $d79cc3a87842e2bb$export$40b296af21bd38a4, $d79cc3a87842e2bb$export$7fa6f9ee1e2cab96, (t)=>t.id), this.core = n, this.logger = e;
    }
}
class $d79cc3a87842e2bb$var$bs extends (0, $cm4ZJ.Store) {
    constructor(n, e){
        super(n, e, $d79cc3a87842e2bb$export$ab815cb37981e7e0, $d79cc3a87842e2bb$export$323ba3ebb8028ed0, ()=>$d79cc3a87842e2bb$export$efef74cb455ac30f), this.core = n, this.logger = e;
    }
}
class $d79cc3a87842e2bb$var$As extends (0, $cm4ZJ.Store) {
    constructor(n, e){
        super(n, e, $d79cc3a87842e2bb$export$5d9af9e20f678626, $d79cc3a87842e2bb$export$323ba3ebb8028ed0), this.core = n, this.logger = e;
    }
}
class $d79cc3a87842e2bb$var$xs extends (0, $cm4ZJ.Store) {
    constructor(n, e){
        super(n, e, $d79cc3a87842e2bb$export$3643b3579d091159, $d79cc3a87842e2bb$export$323ba3ebb8028ed0, (t)=>t.id), this.core = n, this.logger = e;
    }
}
var $d79cc3a87842e2bb$var$Cs = Object.defineProperty, $d79cc3a87842e2bb$var$Vs = (S, n, e)=>n in S ? $d79cc3a87842e2bb$var$Cs(S, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : S[n] = e, $d79cc3a87842e2bb$var$Ge = (S, n, e)=>$d79cc3a87842e2bb$var$Vs(S, typeof n != "symbol" ? n + "" : n, e);
class $d79cc3a87842e2bb$var$Ds {
    constructor(n, e){
        this.core = n, this.logger = e, $d79cc3a87842e2bb$var$Ge(this, "authKeys"), $d79cc3a87842e2bb$var$Ge(this, "pairingTopics"), $d79cc3a87842e2bb$var$Ge(this, "requests"), this.authKeys = new $d79cc3a87842e2bb$var$bs(this.core, this.logger), this.pairingTopics = new $d79cc3a87842e2bb$var$As(this.core, this.logger), this.requests = new $d79cc3a87842e2bb$var$xs(this.core, this.logger);
    }
    async init() {
        await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
    }
}
var $d79cc3a87842e2bb$var$Ls = Object.defineProperty, $d79cc3a87842e2bb$var$ks = (S, n, e)=>n in S ? $d79cc3a87842e2bb$var$Ls(S, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : S[n] = e, $d79cc3a87842e2bb$var$E = (S, n, e)=>$d79cc3a87842e2bb$var$ks(S, typeof n != "symbol" ? n + "" : n, e);
class $d79cc3a87842e2bb$export$2e2bcd8739ae039 extends (0, $dgxYa.ISignClient) {
    constructor(n){
        super(n), $d79cc3a87842e2bb$var$E(this, "protocol", $d79cc3a87842e2bb$export$4fa962fc67384e02), $d79cc3a87842e2bb$var$E(this, "version", $d79cc3a87842e2bb$export$61085c48796ff049), $d79cc3a87842e2bb$var$E(this, "name", $d79cc3a87842e2bb$export$8dffb3242f2c5f72.name), $d79cc3a87842e2bb$var$E(this, "metadata"), $d79cc3a87842e2bb$var$E(this, "core"), $d79cc3a87842e2bb$var$E(this, "logger"), $d79cc3a87842e2bb$var$E(this, "events", new (0, $7hlqZ.EventEmitter)), $d79cc3a87842e2bb$var$E(this, "engine"), $d79cc3a87842e2bb$var$E(this, "session"), $d79cc3a87842e2bb$var$E(this, "proposal"), $d79cc3a87842e2bb$var$E(this, "pendingRequest"), $d79cc3a87842e2bb$var$E(this, "auth"), $d79cc3a87842e2bb$var$E(this, "signConfig"), $d79cc3a87842e2bb$var$E(this, "on", (t, s)=>this.events.on(t, s)), $d79cc3a87842e2bb$var$E(this, "once", (t, s)=>this.events.once(t, s)), $d79cc3a87842e2bb$var$E(this, "off", (t, s)=>this.events.off(t, s)), $d79cc3a87842e2bb$var$E(this, "removeListener", (t, s)=>this.events.removeListener(t, s)), $d79cc3a87842e2bb$var$E(this, "removeAllListeners", (t)=>this.events.removeAllListeners(t)), $d79cc3a87842e2bb$var$E(this, "connect", async (t)=>{
            try {
                return await this.engine.connect(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "pair", async (t)=>{
            try {
                return await this.engine.pair(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "approve", async (t)=>{
            try {
                return await this.engine.approve(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "reject", async (t)=>{
            try {
                return await this.engine.reject(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "update", async (t)=>{
            try {
                return await this.engine.update(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "extend", async (t)=>{
            try {
                return await this.engine.extend(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "request", async (t)=>{
            try {
                return await this.engine.request(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "respond", async (t)=>{
            try {
                return await this.engine.respond(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "ping", async (t)=>{
            try {
                return await this.engine.ping(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "emit", async (t)=>{
            try {
                return await this.engine.emit(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "disconnect", async (t)=>{
            try {
                return await this.engine.disconnect(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "find", (t)=>{
            try {
                return this.engine.find(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "getPendingSessionRequests", ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }), $d79cc3a87842e2bb$var$E(this, "authenticate", async (t, s)=>{
            try {
                return await this.engine.authenticate(t, s);
            } catch (i) {
                throw this.logger.error(i.message), i;
            }
        }), $d79cc3a87842e2bb$var$E(this, "formatAuthMessage", (t)=>{
            try {
                return this.engine.formatAuthMessage(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "approveSessionAuthenticate", async (t)=>{
            try {
                return await this.engine.approveSessionAuthenticate(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), $d79cc3a87842e2bb$var$E(this, "rejectSessionAuthenticate", async (t)=>{
            try {
                return await this.engine.rejectSessionAuthenticate(t);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }), this.name = n?.name || $d79cc3a87842e2bb$export$8dffb3242f2c5f72.name, this.metadata = (0, $9jF5G.populateAppMetadata)(n?.metadata), this.signConfig = n?.signConfig;
        const e = typeof n?.logger < "u" && typeof n?.logger != "string" ? n.logger : (0, (/*@__PURE__*/$parcel$interopDefault($jt6FO)))((0, $ksL7m.getDefaultLoggerOptions)({
            level: n?.logger || $d79cc3a87842e2bb$export$8dffb3242f2c5f72.logger
        }));
        this.core = n?.core || new (0, $cm4ZJ.Core)(n), this.logger = (0, $ksL7m.generateChildLogger)(e, this.name), this.session = new $d79cc3a87842e2bb$var$St(this.core, this.logger), this.proposal = new $d79cc3a87842e2bb$var$Ns(this.core, this.logger), this.pendingRequest = new $d79cc3a87842e2bb$var$Os(this.core, this.logger), this.engine = new $d79cc3a87842e2bb$var$Ps(this), this.auth = new $d79cc3a87842e2bb$var$Ds(this.core, this.logger);
    }
    static async init(n) {
        const e = new $d79cc3a87842e2bb$export$2e2bcd8739ae039(n);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.auth.init(), await this.engine.init(), this.logger.info("SignClient Initialization Success"), setTimeout(()=>{
                this.engine.processRelayMessageCache();
            }, (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_SECOND)));
        } catch (n) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(n.message), n;
        }
    }
}
const $d79cc3a87842e2bb$export$90b8cff65c105172 = $d79cc3a87842e2bb$var$St, $d79cc3a87842e2bb$export$bdf4ba258ec679dc = $d79cc3a87842e2bb$export$2e2bcd8739ae039;

});
parcelRegister("cm4ZJ", function(module, exports) {

$parcel$export(module.exports, "RELAYER_DEFAULT_PROTOCOL", function () { return $8feb69f0c9fb7ecf$export$822d0bd1635d5360; });
$parcel$export(module.exports, "RELAYER_EVENTS", function () { return $8feb69f0c9fb7ecf$export$d56245796e2837d; });
$parcel$export(module.exports, "TRANSPORT_TYPES", function () { return $8feb69f0c9fb7ecf$export$326e296bb8673773; });
$parcel$export(module.exports, "PAIRING_EVENTS", function () { return $8feb69f0c9fb7ecf$export$ca3c0b962acf7b75; });
$parcel$export(module.exports, "EXPIRER_EVENTS", function () { return $8feb69f0c9fb7ecf$export$9013719d9206b0c1; });
$parcel$export(module.exports, "VERIFY_SERVER", function () { return $8feb69f0c9fb7ecf$export$7e3b1a28ddecdbaa; });
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_TRACES", function () { return $8feb69f0c9fb7ecf$export$6736f9bb609b5d34; });
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_ERRORS", function () { return $8feb69f0c9fb7ecf$export$e1dc85b7b7495247; });
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_TRACES", function () { return $8feb69f0c9fb7ecf$export$16ed3f27a411eba0; });
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_ERRORS", function () { return $8feb69f0c9fb7ecf$export$bc50109885e83402; });
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_TRACES", function () { return $8feb69f0c9fb7ecf$export$6540f02663742dde; });
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_ERRORS", function () { return $8feb69f0c9fb7ecf$export$aca4f34441e6cd3a; });
$parcel$export(module.exports, "Store", function () { return $8feb69f0c9fb7ecf$export$390f32400eaf98c9; });
$parcel$export(module.exports, "Core", function () { return $8feb69f0c9fb7ecf$export$4143ab5b91744744; });

var $7hlqZ = parcelRequire("7hlqZ");

var $8VxUj = parcelRequire("8VxUj");

var $fROir = parcelRequire("fROir");

var $ksL7m = parcelRequire("ksL7m");
var $jt6FO = parcelRequire("jt6FO");

var $dgxYa = parcelRequire("dgxYa");

var $2TjUJ = parcelRequire("2TjUJ");

var $4yffS = parcelRequire("4yffS");

var $islmt = parcelRequire("islmt");

var $9jF5G = parcelRequire("9jF5G");
parcelRequire("8l48q");
var $BCGxC = parcelRequire("BCGxC");

var $01Dhm = parcelRequire("01Dhm");
parcelRequire("3olrm");
var $3G8ou = parcelRequire("3G8ou");
var $5ZYqc = parcelRequire("5ZYqc");

var $dcgNG = parcelRequire("dcgNG");

var $f4uqJ = parcelRequire("f4uqJ");

var $98IaM = parcelRequire("98IaM");
var $8feb69f0c9fb7ecf$require$Buffer = $98IaM.Buffer;

var $17tgv = parcelRequire("17tgv");
const $8feb69f0c9fb7ecf$export$51b1c900ac262bdf = "wc", $8feb69f0c9fb7ecf$export$f30bd3c8747cdfbe = 2, $8feb69f0c9fb7ecf$export$d47601f9de5ee22b = "core", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545 = `${$8feb69f0c9fb7ecf$export$51b1c900ac262bdf}@2:${$8feb69f0c9fb7ecf$export$d47601f9de5ee22b}:`, $8feb69f0c9fb7ecf$export$db0fdb6d486555c2 = {
    name: $8feb69f0c9fb7ecf$export$d47601f9de5ee22b,
    logger: "error"
}, $8feb69f0c9fb7ecf$export$ba920abfe854b85d = {
    database: ":memory:"
}, $8feb69f0c9fb7ecf$export$92a79f21481c803d = "crypto", $8feb69f0c9fb7ecf$export$3613aa6e652146e4 = "client_ed25519_seed", $8feb69f0c9fb7ecf$export$c4bc5e31a4d0ec78 = (0, $2TjUJ.ONE_DAY), $8feb69f0c9fb7ecf$export$9d7218f72e8dc49b = "keychain", $8feb69f0c9fb7ecf$export$34f82f4ba0c3d769 = "0.3", $8feb69f0c9fb7ecf$export$9662bbc7d10cf481 = "messages", $8feb69f0c9fb7ecf$export$19dfd1896412c038 = "0.3", $8feb69f0c9fb7ecf$export$8ddbe6611b67d926 = (0, $2TjUJ.SIX_HOURS), $8feb69f0c9fb7ecf$export$9d92662178f2abd1 = "publisher", $8feb69f0c9fb7ecf$export$822d0bd1635d5360 = "irn", $8feb69f0c9fb7ecf$export$5176ffa6778d6637 = "error", $8feb69f0c9fb7ecf$export$a68061e6c48f332a = "wss://relay.walletconnect.org", $8feb69f0c9fb7ecf$export$602d6e27611c3fcb = "relayer", $8feb69f0c9fb7ecf$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $8feb69f0c9fb7ecf$export$119b4645f6b233c8 = "_subscription", $8feb69f0c9fb7ecf$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $8feb69f0c9fb7ecf$export$11ccd39be2c57d6 = .1, $8feb69f0c9fb7ecf$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $8feb69f0c9fb7ecf$export$5f30917a6f8c9025 = "2.19.2", $8feb69f0c9fb7ecf$export$fb3eab7adf12329d = 1e4, $8feb69f0c9fb7ecf$export$326e296bb8673773 = {
    link_mode: "link_mode",
    relay: "relay"
}, $8feb69f0c9fb7ecf$export$5c65dd72e0f566ab = {
    inbound: "inbound",
    outbound: "outbound"
}, $8feb69f0c9fb7ecf$export$629a342182ba24b = "0.3", $8feb69f0c9fb7ecf$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $8feb69f0c9fb7ecf$export$1989eec3a412fb97 = "WALLETCONNECT_LINK_MODE_APPS", $8feb69f0c9fb7ecf$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $8feb69f0c9fb7ecf$export$9d35d0a6a3599be = (0, $2TjUJ.THIRTY_DAYS), $8feb69f0c9fb7ecf$export$9c3a96bb670cddb8 = "subscription", $8feb69f0c9fb7ecf$export$fb57e03bef4c4cea = "0.3", $8feb69f0c9fb7ecf$export$9a2ddbfe54f8af77 = (0, $2TjUJ.FIVE_SECONDS) * 1e3, $8feb69f0c9fb7ecf$export$390360ea476c6145 = "pairing", $8feb69f0c9fb7ecf$export$5593ec74b27d1b18 = "0.3", $8feb69f0c9fb7ecf$export$ee4b1978d0aedfad = (0, $2TjUJ.THIRTY_DAYS), $8feb69f0c9fb7ecf$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $2TjUJ.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $2TjUJ.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $2TjUJ.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $8feb69f0c9fb7ecf$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $8feb69f0c9fb7ecf$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $8feb69f0c9fb7ecf$export$160142c73cb99dc3 = "history", $8feb69f0c9fb7ecf$export$8eba9ce85616c607 = "0.3", $8feb69f0c9fb7ecf$export$4ddf883392bbc828 = "expirer", $8feb69f0c9fb7ecf$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $8feb69f0c9fb7ecf$export$717295846191925d = "0.3", $8feb69f0c9fb7ecf$export$3cfe73d6765db74 = (0, $2TjUJ.ONE_DAY), $8feb69f0c9fb7ecf$export$3b58f2450f2297e3 = "verify-api", $8feb69f0c9fb7ecf$var$Xs = "https://verify.walletconnect.com", $8feb69f0c9fb7ecf$var$Ht = "https://verify.walletconnect.org", $8feb69f0c9fb7ecf$export$7e3b1a28ddecdbaa = $8feb69f0c9fb7ecf$var$Ht, $8feb69f0c9fb7ecf$export$412739528655ee2f = `${$8feb69f0c9fb7ecf$export$7e3b1a28ddecdbaa}/v3`, $8feb69f0c9fb7ecf$export$be24df03c4baa778 = [
    $8feb69f0c9fb7ecf$var$Xs,
    $8feb69f0c9fb7ecf$var$Ht
], $8feb69f0c9fb7ecf$export$40c022d2cffe0adc = "echo", $8feb69f0c9fb7ecf$export$3c48c4faab79aab1 = "https://echo.walletconnect.com", $8feb69f0c9fb7ecf$export$2f94b15ed52f7de9 = "event-client", $8feb69f0c9fb7ecf$export$6736f9bb609b5d34 = {
    pairing_started: "pairing_started",
    pairing_uri_validation_success: "pairing_uri_validation_success",
    pairing_uri_not_expired: "pairing_uri_not_expired",
    store_new_pairing: "store_new_pairing",
    subscribing_pairing_topic: "subscribing_pairing_topic",
    subscribe_pairing_topic_success: "subscribe_pairing_topic_success",
    existing_pairing: "existing_pairing",
    pairing_not_expired: "pairing_not_expired",
    emit_inactive_pairing: "emit_inactive_pairing",
    emit_session_proposal: "emit_session_proposal",
    subscribing_to_pairing_topic: "subscribing_to_pairing_topic"
}, $8feb69f0c9fb7ecf$export$e1dc85b7b7495247 = {
    no_wss_connection: "no_wss_connection",
    no_internet_connection: "no_internet_connection",
    malformed_pairing_uri: "malformed_pairing_uri",
    active_pairing_already_exists: "active_pairing_already_exists",
    subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure",
    pairing_expired: "pairing_expired",
    proposal_expired: "proposal_expired",
    proposal_listener_not_found: "proposal_listener_not_found"
}, $8feb69f0c9fb7ecf$export$16ed3f27a411eba0 = {
    session_approve_started: "session_approve_started",
    proposal_not_expired: "proposal_not_expired",
    session_namespaces_validation_success: "session_namespaces_validation_success",
    create_session_topic: "create_session_topic",
    subscribing_session_topic: "subscribing_session_topic",
    subscribe_session_topic_success: "subscribe_session_topic_success",
    publishing_session_approve: "publishing_session_approve",
    session_approve_publish_success: "session_approve_publish_success",
    store_session: "store_session",
    publishing_session_settle: "publishing_session_settle",
    session_settle_publish_success: "session_settle_publish_success"
}, $8feb69f0c9fb7ecf$export$bc50109885e83402 = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    proposal_expired: "proposal_expired",
    subscribe_session_topic_failure: "subscribe_session_topic_failure",
    session_approve_publish_failure: "session_approve_publish_failure",
    session_settle_publish_failure: "session_settle_publish_failure",
    session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure",
    proposal_not_found: "proposal_not_found"
}, $8feb69f0c9fb7ecf$export$6540f02663742dde = {
    authenticated_session_approve_started: "authenticated_session_approve_started",
    authenticated_session_not_expired: "authenticated_session_not_expired",
    chains_caip2_compliant: "chains_caip2_compliant",
    chains_evm_compliant: "chains_evm_compliant",
    create_authenticated_session_topic: "create_authenticated_session_topic",
    cacaos_verified: "cacaos_verified",
    store_authenticated_session: "store_authenticated_session",
    subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic",
    subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success",
    publishing_authenticated_session_approve: "publishing_authenticated_session_approve",
    authenticated_session_approve_publish_success: "authenticated_session_approve_publish_success"
}, $8feb69f0c9fb7ecf$export$aca4f34441e6cd3a = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    missing_session_authenticate_request: "missing_session_authenticate_request",
    session_authenticate_request_expired: "session_authenticate_request_expired",
    chains_caip2_compliant_failure: "chains_caip2_compliant_failure",
    chains_evm_compliant_failure: "chains_evm_compliant_failure",
    invalid_cacao: "invalid_cacao",
    subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure",
    authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure",
    authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found"
}, $8feb69f0c9fb7ecf$export$c73857c3a3d16b1c = .1, $8feb69f0c9fb7ecf$export$e020229e09910965 = "event-client", $8feb69f0c9fb7ecf$export$79348045429687e2 = 86400, $8feb69f0c9fb7ecf$export$bb6a8925f3cb1ca = "https://pulse.walletconnect.org/batch";
function $8feb69f0c9fb7ecf$var$sr(r, e) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < r.length; s++){
        var n = r.charAt(s), o = n.charCodeAt(0);
        if (t[o] !== 255) throw new TypeError(n + " is ambiguous");
        t[o] = s;
    }
    var a = r.length, c = r.charAt(0), h = Math.log(a) / Math.log(256), l = Math.log(256) / Math.log(a);
    function d(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var b = 0, x = 0, I = 0, D = u.length; I !== D && u[I] === 0;)I++, b++;
        for(var j = (D - I) * l + 1 >>> 0, T = new Uint8Array(j); I !== D;){
            for(var q = u[I], J = 0, K = j - 1; (q !== 0 || J < x) && K !== -1; K--, J++)q += 256 * T[K] >>> 0, T[K] = q % a >>> 0, q = q / a >>> 0;
            if (q !== 0) throw new Error("Non-zero carry");
            x = J, I++;
        }
        for(var H = j - x; H !== j && T[H] === 0;)H++;
        for(var me = c.repeat(b); H < j; ++H)me += r.charAt(T[H]);
        return me;
    }
    function g(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var b = 0;
        if (u[b] !== " ") {
            for(var x = 0, I = 0; u[b] === c;)x++, b++;
            for(var D = (u.length - b) * h + 1 >>> 0, j = new Uint8Array(D); u[b];){
                var T = t[u.charCodeAt(b)];
                if (T === 255) return;
                for(var q = 0, J = D - 1; (T !== 0 || q < I) && J !== -1; J--, q++)T += a * j[J] >>> 0, j[J] = T % 256 >>> 0, T = T / 256 >>> 0;
                if (T !== 0) throw new Error("Non-zero carry");
                I = q, b++;
            }
            if (u[b] !== " ") {
                for(var K = D - I; K !== D && j[K] === 0;)K++;
                for(var H = new Uint8Array(x + (D - K)), me = x; K !== D;)H[me++] = j[K++];
                return H;
            }
        }
    }
    function _(u) {
        var b = g(u);
        if (b) return b;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: d,
        decodeUnsafe: g,
        decode: _
    };
}
var $8feb69f0c9fb7ecf$var$rr = $8feb69f0c9fb7ecf$var$sr, $8feb69f0c9fb7ecf$var$nr = $8feb69f0c9fb7ecf$var$rr;
const $8feb69f0c9fb7ecf$var$si = (r)=>{
    if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
    if (r instanceof ArrayBuffer) return new Uint8Array(r);
    if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $8feb69f0c9fb7ecf$var$or = (r)=>new TextEncoder().encode(r), $8feb69f0c9fb7ecf$var$ar = (r)=>new TextDecoder().decode(r);
class $8feb69f0c9fb7ecf$var$cr {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $8feb69f0c9fb7ecf$var$hr {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $8feb69f0c9fb7ecf$var$ri(this, e);
    }
}
class $8feb69f0c9fb7ecf$var$lr {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $8feb69f0c9fb7ecf$var$ri(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $8feb69f0c9fb7ecf$var$ri = (r, e)=>new $8feb69f0c9fb7ecf$var$lr({
        ...r.decoders || {
            [r.prefix]: r
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $8feb69f0c9fb7ecf$var$ur {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $8feb69f0c9fb7ecf$var$cr(e, t, i), this.decoder = new $8feb69f0c9fb7ecf$var$hr(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $8feb69f0c9fb7ecf$var$Ee = ({ name: r, prefix: e, encode: t, decode: i })=>new $8feb69f0c9fb7ecf$var$ur(r, e, t, i), $8feb69f0c9fb7ecf$var$de = ({ prefix: r, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $8feb69f0c9fb7ecf$var$nr(t, e);
    return $8feb69f0c9fb7ecf$var$Ee({
        prefix: r,
        name: e,
        encode: i,
        decode: (n)=>$8feb69f0c9fb7ecf$var$si(s(n))
    });
}, $8feb69f0c9fb7ecf$var$dr = (r, e, t, i)=>{
    const s = {};
    for(let l = 0; l < e.length; ++l)s[e[l]] = l;
    let n = r.length;
    for(; r[n - 1] === "=";)--n;
    const o = new Uint8Array(n * t / 8 | 0);
    let a = 0, c = 0, h = 0;
    for(let l = 0; l < n; ++l){
        const d = s[r[l]];
        if (d === void 0) throw new SyntaxError(`Non-${i} character`);
        c = c << t | d, a += t, a >= 8 && (a -= 8, o[h++] = 255 & c >> a);
    }
    if (a >= t || 255 & c << 8 - a) throw new SyntaxError("Unexpected end of data");
    return o;
}, $8feb69f0c9fb7ecf$var$gr = (r, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let n = "", o = 0, a = 0;
    for(let c = 0; c < r.length; ++c)for(a = a << 8 | r[c], o += 8; o > t;)o -= t, n += e[s & a >> o];
    if (o && (n += e[s & a << t - o]), i) for(; n.length * t & 7;)n += "=";
    return n;
}, $8feb69f0c9fb7ecf$var$P = ({ name: r, prefix: e, bitsPerChar: t, alphabet: i })=>$8feb69f0c9fb7ecf$var$Ee({
        prefix: e,
        name: r,
        encode (s) {
            return $8feb69f0c9fb7ecf$var$gr(s, i, t);
        },
        decode (s) {
            return $8feb69f0c9fb7ecf$var$dr(s, i, t, r);
        }
    }), $8feb69f0c9fb7ecf$var$pr = $8feb69f0c9fb7ecf$var$Ee({
    prefix: "\0",
    name: "identity",
    encode: (r)=>$8feb69f0c9fb7ecf$var$ar(r),
    decode: (r)=>$8feb69f0c9fb7ecf$var$or(r)
});
var $8feb69f0c9fb7ecf$var$yr = Object.freeze({
    __proto__: null,
    identity: $8feb69f0c9fb7ecf$var$pr
});
const $8feb69f0c9fb7ecf$var$br = $8feb69f0c9fb7ecf$var$P({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $8feb69f0c9fb7ecf$var$mr = Object.freeze({
    __proto__: null,
    base2: $8feb69f0c9fb7ecf$var$br
});
const $8feb69f0c9fb7ecf$var$fr = $8feb69f0c9fb7ecf$var$P({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $8feb69f0c9fb7ecf$var$Dr = Object.freeze({
    __proto__: null,
    base8: $8feb69f0c9fb7ecf$var$fr
});
const $8feb69f0c9fb7ecf$var$vr = $8feb69f0c9fb7ecf$var$de({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $8feb69f0c9fb7ecf$var$wr = Object.freeze({
    __proto__: null,
    base10: $8feb69f0c9fb7ecf$var$vr
});
const $8feb69f0c9fb7ecf$var$_r = $8feb69f0c9fb7ecf$var$P({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $8feb69f0c9fb7ecf$var$Er = $8feb69f0c9fb7ecf$var$P({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $8feb69f0c9fb7ecf$var$Ir = Object.freeze({
    __proto__: null,
    base16: $8feb69f0c9fb7ecf$var$_r,
    base16upper: $8feb69f0c9fb7ecf$var$Er
});
const $8feb69f0c9fb7ecf$var$Tr = $8feb69f0c9fb7ecf$var$P({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Cr = $8feb69f0c9fb7ecf$var$P({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Pr = $8feb69f0c9fb7ecf$var$P({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Sr = $8feb69f0c9fb7ecf$var$P({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Rr = $8feb69f0c9fb7ecf$var$P({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Or = $8feb69f0c9fb7ecf$var$P({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Ar = $8feb69f0c9fb7ecf$var$P({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$xr = $8feb69f0c9fb7ecf$var$P({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $8feb69f0c9fb7ecf$var$Nr = $8feb69f0c9fb7ecf$var$P({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $8feb69f0c9fb7ecf$var$$r = Object.freeze({
    __proto__: null,
    base32: $8feb69f0c9fb7ecf$var$Tr,
    base32upper: $8feb69f0c9fb7ecf$var$Cr,
    base32pad: $8feb69f0c9fb7ecf$var$Pr,
    base32padupper: $8feb69f0c9fb7ecf$var$Sr,
    base32hex: $8feb69f0c9fb7ecf$var$Rr,
    base32hexupper: $8feb69f0c9fb7ecf$var$Or,
    base32hexpad: $8feb69f0c9fb7ecf$var$Ar,
    base32hexpadupper: $8feb69f0c9fb7ecf$var$xr,
    base32z: $8feb69f0c9fb7ecf$var$Nr
});
const $8feb69f0c9fb7ecf$var$zr = $8feb69f0c9fb7ecf$var$de({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $8feb69f0c9fb7ecf$var$Lr = $8feb69f0c9fb7ecf$var$de({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $8feb69f0c9fb7ecf$var$kr = Object.freeze({
    __proto__: null,
    base36: $8feb69f0c9fb7ecf$var$zr,
    base36upper: $8feb69f0c9fb7ecf$var$Lr
});
const $8feb69f0c9fb7ecf$var$jr = $8feb69f0c9fb7ecf$var$de({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $8feb69f0c9fb7ecf$var$Ur = $8feb69f0c9fb7ecf$var$de({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $8feb69f0c9fb7ecf$var$Fr = Object.freeze({
    __proto__: null,
    base58btc: $8feb69f0c9fb7ecf$var$jr,
    base58flickr: $8feb69f0c9fb7ecf$var$Ur
});
const $8feb69f0c9fb7ecf$var$Mr = $8feb69f0c9fb7ecf$var$P({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $8feb69f0c9fb7ecf$var$Kr = $8feb69f0c9fb7ecf$var$P({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $8feb69f0c9fb7ecf$var$Br = $8feb69f0c9fb7ecf$var$P({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $8feb69f0c9fb7ecf$var$Vr = $8feb69f0c9fb7ecf$var$P({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $8feb69f0c9fb7ecf$var$qr = Object.freeze({
    __proto__: null,
    base64: $8feb69f0c9fb7ecf$var$Mr,
    base64pad: $8feb69f0c9fb7ecf$var$Kr,
    base64url: $8feb69f0c9fb7ecf$var$Br,
    base64urlpad: $8feb69f0c9fb7ecf$var$Vr
});
const $8feb69f0c9fb7ecf$var$ni = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $8feb69f0c9fb7ecf$var$Gr = $8feb69f0c9fb7ecf$var$ni.reduce((r, e, t)=>(r[t] = e, r), []), $8feb69f0c9fb7ecf$var$Wr = $8feb69f0c9fb7ecf$var$ni.reduce((r, e, t)=>(r[e.codePointAt(0)] = t, r), []);
function $8feb69f0c9fb7ecf$var$Hr(r) {
    return r.reduce((e, t)=>(e += $8feb69f0c9fb7ecf$var$Gr[t], e), "");
}
function $8feb69f0c9fb7ecf$var$Yr(r) {
    const e = [];
    for (const t of r){
        const i = $8feb69f0c9fb7ecf$var$Wr[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $8feb69f0c9fb7ecf$var$Jr = $8feb69f0c9fb7ecf$var$Ee({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $8feb69f0c9fb7ecf$var$Hr,
    decode: $8feb69f0c9fb7ecf$var$Yr
});
var $8feb69f0c9fb7ecf$var$Xr = Object.freeze({
    __proto__: null,
    base256emoji: $8feb69f0c9fb7ecf$var$Jr
}), $8feb69f0c9fb7ecf$var$Zr = $8feb69f0c9fb7ecf$var$ai, $8feb69f0c9fb7ecf$var$oi = 128, $8feb69f0c9fb7ecf$var$Qr = 127, $8feb69f0c9fb7ecf$var$en = ~$8feb69f0c9fb7ecf$var$Qr, $8feb69f0c9fb7ecf$var$tn = Math.pow(2, 31);
function $8feb69f0c9fb7ecf$var$ai(r, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; r >= $8feb69f0c9fb7ecf$var$tn;)e[t++] = r & 255 | $8feb69f0c9fb7ecf$var$oi, r /= 128;
    for(; r & $8feb69f0c9fb7ecf$var$en;)e[t++] = r & 255 | $8feb69f0c9fb7ecf$var$oi, r >>>= 7;
    return e[t] = r | 0, $8feb69f0c9fb7ecf$var$ai.bytes = t - i + 1, e;
}
var $8feb69f0c9fb7ecf$var$sn = $8feb69f0c9fb7ecf$var$Me, $8feb69f0c9fb7ecf$var$rn = 128, $8feb69f0c9fb7ecf$var$ci = 127;
function $8feb69f0c9fb7ecf$var$Me(r, i) {
    var t = 0, i = i || 0, s = 0, n = i, o, a = r.length;
    do {
        if (n >= a) throw $8feb69f0c9fb7ecf$var$Me.bytes = 0, new RangeError("Could not decode varint");
        o = r[n++], t += s < 28 ? (o & $8feb69f0c9fb7ecf$var$ci) << s : (o & $8feb69f0c9fb7ecf$var$ci) * Math.pow(2, s), s += 7;
    }while (o >= $8feb69f0c9fb7ecf$var$rn);
    return $8feb69f0c9fb7ecf$var$Me.bytes = n - i, t;
}
var $8feb69f0c9fb7ecf$var$nn = Math.pow(2, 7), $8feb69f0c9fb7ecf$var$on = Math.pow(2, 14), $8feb69f0c9fb7ecf$var$an = Math.pow(2, 21), $8feb69f0c9fb7ecf$var$cn = Math.pow(2, 28), $8feb69f0c9fb7ecf$var$hn = Math.pow(2, 35), $8feb69f0c9fb7ecf$var$ln = Math.pow(2, 42), $8feb69f0c9fb7ecf$var$un = Math.pow(2, 49), $8feb69f0c9fb7ecf$var$dn = Math.pow(2, 56), $8feb69f0c9fb7ecf$var$gn = Math.pow(2, 63), $8feb69f0c9fb7ecf$var$pn = function(r) {
    return r < $8feb69f0c9fb7ecf$var$nn ? 1 : r < $8feb69f0c9fb7ecf$var$on ? 2 : r < $8feb69f0c9fb7ecf$var$an ? 3 : r < $8feb69f0c9fb7ecf$var$cn ? 4 : r < $8feb69f0c9fb7ecf$var$hn ? 5 : r < $8feb69f0c9fb7ecf$var$ln ? 6 : r < $8feb69f0c9fb7ecf$var$un ? 7 : r < $8feb69f0c9fb7ecf$var$dn ? 8 : r < $8feb69f0c9fb7ecf$var$gn ? 9 : 10;
}, $8feb69f0c9fb7ecf$var$yn = {
    encode: $8feb69f0c9fb7ecf$var$Zr,
    decode: $8feb69f0c9fb7ecf$var$sn,
    encodingLength: $8feb69f0c9fb7ecf$var$pn
}, $8feb69f0c9fb7ecf$var$hi = $8feb69f0c9fb7ecf$var$yn;
const $8feb69f0c9fb7ecf$var$li = (r, e, t = 0)=>($8feb69f0c9fb7ecf$var$hi.encode(r, e, t), e), $8feb69f0c9fb7ecf$var$ui = (r)=>$8feb69f0c9fb7ecf$var$hi.encodingLength(r), $8feb69f0c9fb7ecf$var$Ke = (r, e)=>{
    const t = e.byteLength, i = $8feb69f0c9fb7ecf$var$ui(r), s = i + $8feb69f0c9fb7ecf$var$ui(t), n = new Uint8Array(s + t);
    return $8feb69f0c9fb7ecf$var$li(r, n, 0), $8feb69f0c9fb7ecf$var$li(t, n, i), n.set(e, s), new $8feb69f0c9fb7ecf$var$bn(r, t, e, n);
};
class $8feb69f0c9fb7ecf$var$bn {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $8feb69f0c9fb7ecf$var$di = ({ name: r, code: e, encode: t })=>new $8feb69f0c9fb7ecf$var$mn(r, e, t);
class $8feb69f0c9fb7ecf$var$mn {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $8feb69f0c9fb7ecf$var$Ke(this.code, t) : t.then((i)=>$8feb69f0c9fb7ecf$var$Ke(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $8feb69f0c9fb7ecf$var$gi = (r)=>async (e)=>new Uint8Array(await crypto.subtle.digest(r, e)), $8feb69f0c9fb7ecf$var$fn = $8feb69f0c9fb7ecf$var$di({
    name: "sha2-256",
    code: 18,
    encode: $8feb69f0c9fb7ecf$var$gi("SHA-256")
}), $8feb69f0c9fb7ecf$var$Dn = $8feb69f0c9fb7ecf$var$di({
    name: "sha2-512",
    code: 19,
    encode: $8feb69f0c9fb7ecf$var$gi("SHA-512")
});
var $8feb69f0c9fb7ecf$var$vn = Object.freeze({
    __proto__: null,
    sha256: $8feb69f0c9fb7ecf$var$fn,
    sha512: $8feb69f0c9fb7ecf$var$Dn
});
const $8feb69f0c9fb7ecf$var$pi = 0, $8feb69f0c9fb7ecf$var$wn = "identity", $8feb69f0c9fb7ecf$var$yi = $8feb69f0c9fb7ecf$var$si, $8feb69f0c9fb7ecf$var$_n = (r)=>$8feb69f0c9fb7ecf$var$Ke($8feb69f0c9fb7ecf$var$pi, $8feb69f0c9fb7ecf$var$yi(r)), $8feb69f0c9fb7ecf$var$En = {
    code: $8feb69f0c9fb7ecf$var$pi,
    name: $8feb69f0c9fb7ecf$var$wn,
    encode: $8feb69f0c9fb7ecf$var$yi,
    digest: $8feb69f0c9fb7ecf$var$_n
};
var $8feb69f0c9fb7ecf$var$In = Object.freeze({
    __proto__: null,
    identity: $8feb69f0c9fb7ecf$var$En
});
new TextEncoder, new TextDecoder;
const $8feb69f0c9fb7ecf$var$bi = {
    ...$8feb69f0c9fb7ecf$var$yr,
    ...$8feb69f0c9fb7ecf$var$mr,
    ...$8feb69f0c9fb7ecf$var$Dr,
    ...$8feb69f0c9fb7ecf$var$wr,
    ...$8feb69f0c9fb7ecf$var$Ir,
    ...$8feb69f0c9fb7ecf$var$$r,
    ...$8feb69f0c9fb7ecf$var$kr,
    ...$8feb69f0c9fb7ecf$var$Fr,
    ...$8feb69f0c9fb7ecf$var$qr,
    ...$8feb69f0c9fb7ecf$var$Xr
};
({
    ...$8feb69f0c9fb7ecf$var$vn,
    ...$8feb69f0c9fb7ecf$var$In
});
function $8feb69f0c9fb7ecf$var$Tn(r = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(r) : new Uint8Array(r);
}
function $8feb69f0c9fb7ecf$var$mi(r, e, t, i) {
    return {
        name: r,
        prefix: e,
        encoder: {
            name: r,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $8feb69f0c9fb7ecf$var$fi = $8feb69f0c9fb7ecf$var$mi("utf8", "u", (r)=>"u" + new TextDecoder("utf8").decode(r), (r)=>new TextEncoder().encode(r.substring(1))), $8feb69f0c9fb7ecf$var$Be = $8feb69f0c9fb7ecf$var$mi("ascii", "a", (r)=>{
    let e = "a";
    for(let t = 0; t < r.length; t++)e += String.fromCharCode(r[t]);
    return e;
}, (r)=>{
    r = r.substring(1);
    const e = $8feb69f0c9fb7ecf$var$Tn(r.length);
    for(let t = 0; t < r.length; t++)e[t] = r.charCodeAt(t);
    return e;
}), $8feb69f0c9fb7ecf$var$Cn = {
    utf8: $8feb69f0c9fb7ecf$var$fi,
    "utf-8": $8feb69f0c9fb7ecf$var$fi,
    hex: $8feb69f0c9fb7ecf$var$bi.base16,
    latin1: $8feb69f0c9fb7ecf$var$Be,
    ascii: $8feb69f0c9fb7ecf$var$Be,
    binary: $8feb69f0c9fb7ecf$var$Be,
    ...$8feb69f0c9fb7ecf$var$bi
};
function $8feb69f0c9fb7ecf$var$Pn(r, e = "utf8") {
    const t = $8feb69f0c9fb7ecf$var$Cn[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(r, "utf8") : t.decoder.decode(`${t.prefix}${r}`);
}
var $8feb69f0c9fb7ecf$var$Sn = Object.defineProperty, $8feb69f0c9fb7ecf$var$Rn = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Sn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$W = (r, e, t)=>$8feb69f0c9fb7ecf$var$Rn(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, $8feb69f0c9fb7ecf$var$W(this, "keychain", new Map), $8feb69f0c9fb7ecf$var$W(this, "name", $8feb69f0c9fb7ecf$export$9d7218f72e8dc49b), $8feb69f0c9fb7ecf$var$W(this, "version", $8feb69f0c9fb7ecf$export$34f82f4ba0c3d769), $8feb69f0c9fb7ecf$var$W(this, "initialized", !1), $8feb69f0c9fb7ecf$var$W(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$W(this, "init", async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }), $8feb69f0c9fb7ecf$var$W(this, "has", (i)=>(this.isInitialized(), this.keychain.has(i))), $8feb69f0c9fb7ecf$var$W(this, "set", async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }), $8feb69f0c9fb7ecf$var$W(this, "get", (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: n } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(n);
            }
            return s;
        }), $8feb69f0c9fb7ecf$var$W(this, "del", async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }), this.core = e, this.logger = (0, $ksL7m.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $9jF5G.mapToObj)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $9jF5G.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $8feb69f0c9fb7ecf$var$On = Object.defineProperty, $8feb69f0c9fb7ecf$var$An = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$On(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$S = (r, e, t)=>$8feb69f0c9fb7ecf$var$An(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, $8feb69f0c9fb7ecf$var$S(this, "name", $8feb69f0c9fb7ecf$export$92a79f21481c803d), $8feb69f0c9fb7ecf$var$S(this, "keychain"), $8feb69f0c9fb7ecf$var$S(this, "randomSessionIdentifier", (0, $9jF5G.generateRandomBytes32)()), $8feb69f0c9fb7ecf$var$S(this, "initialized", !1), $8feb69f0c9fb7ecf$var$S(this, "init", async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }), $8feb69f0c9fb7ecf$var$S(this, "hasKeys", (s)=>(this.isInitialized(), this.keychain.has(s))), $8feb69f0c9fb7ecf$var$S(this, "getClientId", async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), n = $islmt.generateKeyPair(s);
            return $islmt.encodeIss(n.publicKey);
        }), $8feb69f0c9fb7ecf$var$S(this, "generateKeyPair", ()=>{
            this.isInitialized();
            const s = (0, $9jF5G.generateKeyPair)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }), $8feb69f0c9fb7ecf$var$S(this, "signJWT", async (s)=>{
            this.isInitialized();
            const n = await this.getClientSeed(), o = $islmt.generateKeyPair(n), a = this.randomSessionIdentifier, c = $8feb69f0c9fb7ecf$export$c4bc5e31a4d0ec78;
            return await $islmt.signJWT(a, s, c, o);
        }), $8feb69f0c9fb7ecf$var$S(this, "generateSharedKey", (s, n, o)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), c = (0, $9jF5G.deriveSymKey)(a, n);
            return this.setSymKey(c, o);
        }), $8feb69f0c9fb7ecf$var$S(this, "setSymKey", async (s, n)=>{
            this.isInitialized();
            const o = n || (0, $9jF5G.hashKey)(s);
            return await this.keychain.set(o, s), o;
        }), $8feb69f0c9fb7ecf$var$S(this, "deleteKeyPair", async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }), $8feb69f0c9fb7ecf$var$S(this, "deleteSymKey", async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }), $8feb69f0c9fb7ecf$var$S(this, "encode", async (s, n, o)=>{
            this.isInitialized();
            const a = (0, $9jF5G.validateEncoding)(o), c = (0, $4yffS.safeJsonStringify)(n);
            if ((0, $9jF5G.isTypeTwoEnvelope)(a)) return (0, $9jF5G.encodeTypeTwoEnvelope)(c, o?.encoding);
            if ((0, $9jF5G.isTypeOneEnvelope)(a)) {
                const g = a.senderPublicKey, _ = a.receiverPublicKey;
                s = await this.generateSharedKey(g, _);
            }
            const h = this.getSymKey(s), { type: l, senderPublicKey: d } = a;
            return (0, $9jF5G.encrypt)({
                type: l,
                symKey: h,
                message: c,
                senderPublicKey: d,
                encoding: o?.encoding
            });
        }), $8feb69f0c9fb7ecf$var$S(this, "decode", async (s, n, o)=>{
            this.isInitialized();
            const a = (0, $9jF5G.validateDecoding)(n, o);
            if ((0, $9jF5G.isTypeTwoEnvelope)(a)) {
                const c = (0, $9jF5G.decodeTypeTwoEnvelope)(n, o?.encoding);
                return (0, $4yffS.safeJsonParse)(c);
            }
            if ((0, $9jF5G.isTypeOneEnvelope)(a)) {
                const c = a.receiverPublicKey, h = a.senderPublicKey;
                s = await this.generateSharedKey(c, h);
            }
            try {
                const c = this.getSymKey(s), h = (0, $9jF5G.decrypt)({
                    symKey: c,
                    encoded: n,
                    encoding: o?.encoding
                });
                return (0, $4yffS.safeJsonParse)(h);
            } catch (c) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(c);
            }
        }), $8feb69f0c9fb7ecf$var$S(this, "getPayloadType", (s, n = (0, $9jF5G.BASE64))=>{
            const o = (0, $9jF5G.deserialize)({
                encoded: s,
                encoding: n
            });
            return (0, $9jF5G.decodeTypeByte)(o.type);
        }), $8feb69f0c9fb7ecf$var$S(this, "getPayloadSenderPublicKey", (s, n = (0, $9jF5G.BASE64))=>{
            const o = (0, $9jF5G.deserialize)({
                encoded: s,
                encoding: n
            });
            return o.senderPublicKey ? (0, $BCGxC.toString)(o.senderPublicKey, (0, $9jF5G.BASE16)) : void 0;
        }), this.core = e, this.logger = (0, $ksL7m.generateChildLogger)(t, this.name), this.keychain = i || new $8feb69f0c9fb7ecf$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($8feb69f0c9fb7ecf$export$3613aa6e652146e4);
        } catch  {
            e = (0, $9jF5G.generateRandomBytes32)(), await this.keychain.set($8feb69f0c9fb7ecf$export$3613aa6e652146e4, e);
        }
        return $8feb69f0c9fb7ecf$var$Pn(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $8feb69f0c9fb7ecf$var$xn = Object.defineProperty, $8feb69f0c9fb7ecf$var$Nn = Object.defineProperties, $8feb69f0c9fb7ecf$var$$n = Object.getOwnPropertyDescriptors, $8feb69f0c9fb7ecf$var$wi = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$zn = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$Ln = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$Ve = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$xn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$kn = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$zn.call(e, t) && $8feb69f0c9fb7ecf$var$Ve(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$wi) for (var t of $8feb69f0c9fb7ecf$var$wi(e))$8feb69f0c9fb7ecf$var$Ln.call(e, t) && $8feb69f0c9fb7ecf$var$Ve(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$jn = (r, e)=>$8feb69f0c9fb7ecf$var$Nn(r, $8feb69f0c9fb7ecf$var$$n(e)), $8feb69f0c9fb7ecf$var$k = (r, e, t)=>$8feb69f0c9fb7ecf$var$Ve(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$4a2542d0790ac2fd extends (0, $dgxYa.IMessageTracker) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, $8feb69f0c9fb7ecf$var$k(this, "messages", new Map), $8feb69f0c9fb7ecf$var$k(this, "messagesWithoutClientAck", new Map), $8feb69f0c9fb7ecf$var$k(this, "name", $8feb69f0c9fb7ecf$export$9662bbc7d10cf481), $8feb69f0c9fb7ecf$var$k(this, "version", $8feb69f0c9fb7ecf$export$19dfd1896412c038), $8feb69f0c9fb7ecf$var$k(this, "initialized", !1), $8feb69f0c9fb7ecf$var$k(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$k(this, "init", async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i);
                    const s = await this.getRelayerMessagesWithoutClientAck();
                    typeof s < "u" && (this.messagesWithoutClientAck = s), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }), $8feb69f0c9fb7ecf$var$k(this, "set", async (i, s, n)=>{
            this.isInitialized();
            const o = (0, $9jF5G.hashMessage)(s);
            let a = this.messages.get(i);
            if (typeof a > "u" && (a = {}), typeof a[o] < "u") return o;
            if (a[o] = s, this.messages.set(i, a), n === $8feb69f0c9fb7ecf$export$5c65dd72e0f566ab.inbound) {
                const c = this.messagesWithoutClientAck.get(i) || {};
                this.messagesWithoutClientAck.set(i, $8feb69f0c9fb7ecf$var$jn($8feb69f0c9fb7ecf$var$kn({}, c), {
                    [o]: s
                }));
            }
            return await this.persist(), o;
        }), $8feb69f0c9fb7ecf$var$k(this, "get", (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }), $8feb69f0c9fb7ecf$var$k(this, "getWithoutAck", (i)=>{
            this.isInitialized();
            const s = {};
            for (const n of i){
                const o = this.messagesWithoutClientAck.get(n) || {};
                s[n] = Object.values(o);
            }
            return s;
        }), $8feb69f0c9fb7ecf$var$k(this, "has", (i, s)=>{
            this.isInitialized();
            const n = this.get(i), o = (0, $9jF5G.hashMessage)(s);
            return typeof n[o] < "u";
        }), $8feb69f0c9fb7ecf$var$k(this, "ack", async (i, s)=>{
            this.isInitialized();
            const n = this.messagesWithoutClientAck.get(i);
            if (typeof n > "u") return;
            const o = (0, $9jF5G.hashMessage)(s);
            delete n[o], Object.keys(n).length === 0 ? this.messagesWithoutClientAck.delete(i) : this.messagesWithoutClientAck.set(i, n), await this.persist();
        }), $8feb69f0c9fb7ecf$var$k(this, "del", async (i)=>{
            this.isInitialized(), this.messages.delete(i), this.messagesWithoutClientAck.delete(i), await this.persist();
        }), this.logger = (0, $ksL7m.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get storageKeyWithoutClientAck() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name + "_withoutClientAck";
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $9jF5G.mapToObj)(e));
    }
    async setRelayerMessagesWithoutClientAck(e) {
        await this.core.storage.setItem(this.storageKeyWithoutClientAck, (0, $9jF5G.mapToObj)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $9jF5G.objToMap)(e) : void 0;
    }
    async getRelayerMessagesWithoutClientAck() {
        const e = await this.core.storage.getItem(this.storageKeyWithoutClientAck);
        return typeof e < "u" ? (0, $9jF5G.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages), await this.setRelayerMessagesWithoutClientAck(this.messagesWithoutClientAck);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $8feb69f0c9fb7ecf$var$Un = Object.defineProperty, $8feb69f0c9fb7ecf$var$Fn = Object.defineProperties, $8feb69f0c9fb7ecf$var$Mn = Object.getOwnPropertyDescriptors, $8feb69f0c9fb7ecf$var$Ei = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$Kn = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$Bn = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$qe = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Un(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$Ie = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$Kn.call(e, t) && $8feb69f0c9fb7ecf$var$qe(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$Ei) for (var t of $8feb69f0c9fb7ecf$var$Ei(e))$8feb69f0c9fb7ecf$var$Bn.call(e, t) && $8feb69f0c9fb7ecf$var$qe(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$Ge = (r, e)=>$8feb69f0c9fb7ecf$var$Fn(r, $8feb69f0c9fb7ecf$var$Mn(e)), $8feb69f0c9fb7ecf$var$V = (r, e, t)=>$8feb69f0c9fb7ecf$var$qe(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$var$Vn extends (0, $dgxYa.IPublisher) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, $8feb69f0c9fb7ecf$var$V(this, "events", new (0, $7hlqZ.EventEmitter)), $8feb69f0c9fb7ecf$var$V(this, "name", $8feb69f0c9fb7ecf$export$9d92662178f2abd1), $8feb69f0c9fb7ecf$var$V(this, "queue", new Map), $8feb69f0c9fb7ecf$var$V(this, "publishTimeout", (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_MINUTE))), $8feb69f0c9fb7ecf$var$V(this, "initialPublishTimeout", (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_SECOND) * 15)), $8feb69f0c9fb7ecf$var$V(this, "needsTransportRestart", !1), $8feb69f0c9fb7ecf$var$V(this, "publish", async (i, s, n)=>{
            var o;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: n
                }
            });
            const a = n?.ttl || $8feb69f0c9fb7ecf$export$8ddbe6611b67d926, c = (0, $9jF5G.getRelayProtocolName)(n), h = n?.prompt || !1, l = n?.tag || 0, d = n?.id || (0, $3G8ou.getBigIntRpcId)().toString(), g = {
                topic: i,
                message: s,
                opts: {
                    ttl: a,
                    relay: c,
                    prompt: h,
                    tag: l,
                    id: d,
                    attestation: n?.attestation,
                    tvf: n?.tvf
                }
            }, _ = `Failed to publish payload, please try again. id:${d} tag:${l}`;
            try {
                const u = new Promise(async (b)=>{
                    const x = ({ id: D })=>{
                        g.opts.id === D && (this.removeRequestFromQueue(D), this.relayer.events.removeListener($8feb69f0c9fb7ecf$export$d56245796e2837d.publish, x), b(g));
                    };
                    this.relayer.events.on($8feb69f0c9fb7ecf$export$d56245796e2837d.publish, x);
                    const I = (0, $9jF5G.createExpiringPromise)(new Promise((D, j)=>{
                        this.rpcPublish({
                            topic: i,
                            message: s,
                            ttl: a,
                            prompt: h,
                            tag: l,
                            id: d,
                            attestation: n?.attestation,
                            tvf: n?.tvf
                        }).then(D).catch((T)=>{
                            this.logger.warn(T, T?.message), j(T);
                        });
                    }), this.initialPublishTimeout, `Failed initial publish, retrying.... id:${d} tag:${l}`);
                    try {
                        await I, this.events.removeListener($8feb69f0c9fb7ecf$export$d56245796e2837d.publish, x);
                    } catch (D) {
                        this.queue.set(d, $8feb69f0c9fb7ecf$var$Ge($8feb69f0c9fb7ecf$var$Ie({}, g), {
                            attempt: 1
                        })), this.logger.warn(D, D?.message);
                    }
                });
                this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        id: d,
                        topic: i,
                        message: s,
                        opts: n
                    }
                }), await (0, $9jF5G.createExpiringPromise)(u, this.publishTimeout, _);
            } catch (u) {
                if (this.logger.debug("Failed to Publish Payload"), this.logger.error(u), (o = n?.internal) != null && o.throwOnFailedPublish) throw u;
            } finally{
                this.queue.delete(d);
            }
        }), $8feb69f0c9fb7ecf$var$V(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $8feb69f0c9fb7ecf$var$V(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $8feb69f0c9fb7ecf$var$V(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $8feb69f0c9fb7ecf$var$V(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), this.relayer = e, this.logger = (0, $ksL7m.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    async rpcPublish(e) {
        var t, i, s, n;
        const { topic: o, message: a, ttl: c = $8feb69f0c9fb7ecf$export$8ddbe6611b67d926, prompt: h, tag: l, id: d, attestation: g, tvf: _ } = e, u = {
            method: (0, $9jF5G.getRelayProtocolApi)((0, $9jF5G.getRelayProtocolName)().protocol).publish,
            params: $8feb69f0c9fb7ecf$var$Ie({
                topic: o,
                message: a,
                ttl: c,
                prompt: h,
                tag: l,
                attestation: g
            }, _),
            id: d
        };
        (0, $9jF5G.isUndefined)((t = u.params) == null ? void 0 : t.prompt) && ((i = u.params) == null || delete i.prompt), (0, $9jF5G.isUndefined)((s = u.params) == null ? void 0 : s.tag) && ((n = u.params) == null || delete n.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: u
        });
        const b = await this.relayer.request(u);
        return this.relayer.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.publish, e), this.logger.debug("Successfully Published Payload"), b;
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e, t)=>{
            const i = e.attempt + 1;
            this.queue.set(t, $8feb69f0c9fb7ecf$var$Ge($8feb69f0c9fb7ecf$var$Ie({}, e), {
                attempt: i
            }));
            const { topic: s, message: n, opts: o, attestation: a } = e;
            this.logger.warn({}, `Publisher: queue->publishing: ${e.opts.id}, tag: ${e.opts.tag}, attempt: ${i}`), await this.rpcPublish($8feb69f0c9fb7ecf$var$Ge($8feb69f0c9fb7ecf$var$Ie({}, e), {
                topic: s,
                message: n,
                ttl: o.ttl,
                prompt: o.prompt,
                tag: o.tag,
                id: o.id,
                attestation: a,
                tvf: o.tvf
            })), this.logger.warn({}, `Publisher: queue->published: ${e.opts.id}`);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $8VxUj.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($8feb69f0c9fb7ecf$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
var $8feb69f0c9fb7ecf$var$qn = Object.defineProperty, $8feb69f0c9fb7ecf$var$Gn = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$qn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$re = (r, e, t)=>$8feb69f0c9fb7ecf$var$Gn(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$var$Wn {
    constructor(){
        $8feb69f0c9fb7ecf$var$re(this, "map", new Map), $8feb69f0c9fb7ecf$var$re(this, "set", (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }), $8feb69f0c9fb7ecf$var$re(this, "get", (e)=>this.map.get(e) || []), $8feb69f0c9fb7ecf$var$re(this, "exists", (e, t)=>this.get(e).includes(t)), $8feb69f0c9fb7ecf$var$re(this, "delete", (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((n)=>n !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }), $8feb69f0c9fb7ecf$var$re(this, "clear", ()=>{
            this.map.clear();
        });
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $8feb69f0c9fb7ecf$var$Hn = Object.defineProperty, $8feb69f0c9fb7ecf$var$Yn = Object.defineProperties, $8feb69f0c9fb7ecf$var$Jn = Object.getOwnPropertyDescriptors, $8feb69f0c9fb7ecf$var$Ii = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$Xn = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$Zn = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$We = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Hn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$ge = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$Xn.call(e, t) && $8feb69f0c9fb7ecf$var$We(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$Ii) for (var t of $8feb69f0c9fb7ecf$var$Ii(e))$8feb69f0c9fb7ecf$var$Zn.call(e, t) && $8feb69f0c9fb7ecf$var$We(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$He = (r, e)=>$8feb69f0c9fb7ecf$var$Yn(r, $8feb69f0c9fb7ecf$var$Jn(e)), $8feb69f0c9fb7ecf$var$f = (r, e, t)=>$8feb69f0c9fb7ecf$var$We(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$60959659b2c22881 extends (0, $dgxYa.ISubscriber) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, $8feb69f0c9fb7ecf$var$f(this, "subscriptions", new Map), $8feb69f0c9fb7ecf$var$f(this, "topicMap", new $8feb69f0c9fb7ecf$var$Wn), $8feb69f0c9fb7ecf$var$f(this, "events", new (0, $7hlqZ.EventEmitter)), $8feb69f0c9fb7ecf$var$f(this, "name", $8feb69f0c9fb7ecf$export$9c3a96bb670cddb8), $8feb69f0c9fb7ecf$var$f(this, "version", $8feb69f0c9fb7ecf$export$fb57e03bef4c4cea), $8feb69f0c9fb7ecf$var$f(this, "pending", new Map), $8feb69f0c9fb7ecf$var$f(this, "cached", []), $8feb69f0c9fb7ecf$var$f(this, "initialized", !1), $8feb69f0c9fb7ecf$var$f(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$f(this, "subscribeTimeout", (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_MINUTE))), $8feb69f0c9fb7ecf$var$f(this, "initialSubscribeTimeout", (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_SECOND) * 15)), $8feb69f0c9fb7ecf$var$f(this, "clientId"), $8feb69f0c9fb7ecf$var$f(this, "batchSubscribeTopicsLimit", 500), $8feb69f0c9fb7ecf$var$f(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), await this.restore()), this.initialized = !0;
        }), $8feb69f0c9fb7ecf$var$f(this, "subscribe", async (i, s)=>{
            this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const n = (0, $9jF5G.getRelayProtocolName)(s), o = {
                    topic: i,
                    relay: n,
                    transportType: s?.transportType
                };
                this.pending.set(i, o);
                const a = await this.rpcSubscribe(i, n, s);
                return typeof a == "string" && (this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                })), a;
            } catch (n) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
            }
        }), $8feb69f0c9fb7ecf$var$f(this, "unsubscribe", async (i, s)=>{
            this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }), $8feb69f0c9fb7ecf$var$f(this, "isSubscribed", (i)=>new Promise((s)=>{
                s(this.topicMap.topics.includes(i));
            })), $8feb69f0c9fb7ecf$var$f(this, "isKnownTopic", (i)=>new Promise((s)=>{
                s(this.topicMap.topics.includes(i) || this.pending.has(i) || this.cached.some((n)=>n.topic === i));
            })), $8feb69f0c9fb7ecf$var$f(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $8feb69f0c9fb7ecf$var$f(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $8feb69f0c9fb7ecf$var$f(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $8feb69f0c9fb7ecf$var$f(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), $8feb69f0c9fb7ecf$var$f(this, "start", async ()=>{
            await this.onConnect();
        }), $8feb69f0c9fb7ecf$var$f(this, "stop", async ()=>{
            await this.onDisconnect();
        }), $8feb69f0c9fb7ecf$var$f(this, "restart", async ()=>{
            await this.restore(), await this.onRestart();
        }), $8feb69f0c9fb7ecf$var$f(this, "checkPending", async ()=>{
            if (this.pending.size === 0 && (!this.initialized || !this.relayer.connected)) return;
            const i = [];
            this.pending.forEach((s)=>{
                i.push(s);
            }), await this.batchSubscribe(i);
        }), $8feb69f0c9fb7ecf$var$f(this, "registerEventListeners", ()=>{
            this.relayer.core.heartbeat.on((0, $8VxUj.HEARTBEAT_EVENTS).pulse, async ()=>{
                await this.checkPending();
            }), this.events.on($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, async (i)=>{
                const s = $8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created;
                this.logger.info(`Emitting ${s}`), this.logger.debug({
                    type: "event",
                    event: s,
                    data: i
                }), await this.persist();
            }), this.events.on($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.deleted, async (i)=>{
                const s = $8feb69f0c9fb7ecf$export$24ff3e54e94ef413.deleted;
                this.logger.info(`Emitting ${s}`), this.logger.debug({
                    type: "event",
                    event: s,
                    data: i
                }), await this.persist();
            });
        }), this.relayer = e, this.logger = (0, $ksL7m.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    get hasAnyTopics() {
        return this.topicMap.topics.length > 0 || this.pending.size > 0 || this.cached.length > 0 || this.subscriptions.size > 0;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    reset() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $9jF5G.getRelayProtocolName)(i);
            await this.restartToComplete({
                topic: e,
                id: t,
                relay: s
            }), await this.rpcUnsubscribe(e, t, s);
            const n = (0, $9jF5G.getSdkError)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t, i) {
        var s;
        (!i || i?.transportType === $8feb69f0c9fb7ecf$export$326e296bb8673773.relay) && await this.restartToComplete({
            topic: e,
            id: e,
            relay: t
        });
        const n = {
            method: (0, $9jF5G.getRelayProtocolApi)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: n
        });
        const o = (s = i?.internal) == null ? void 0 : s.throwOnFailedPublish;
        try {
            const a = await this.getSubscriptionId(e);
            if (i?.transportType === $8feb69f0c9fb7ecf$export$326e296bb8673773.link_mode) return setTimeout(()=>{
                (this.relayer.connected || this.relayer.connecting) && this.relayer.request(n).catch((l)=>this.logger.warn(l));
            }, (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_SECOND))), a;
            const c = new Promise(async (l)=>{
                const d = (g)=>{
                    g.topic === e && (this.events.removeListener($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, d), l(g.id));
                };
                this.events.on($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, d);
                try {
                    const g = await (0, $9jF5G.createExpiringPromise)(new Promise((_, u)=>{
                        this.relayer.request(n).catch((b)=>{
                            this.logger.warn(b, b?.message), u(b);
                        }).then(_);
                    }), this.initialSubscribeTimeout, `Subscribing to ${e} failed, please try again`);
                    this.events.removeListener($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, d), l(g);
                } catch  {}
            }), h = await (0, $9jF5G.createExpiringPromise)(c, this.subscribeTimeout, `Subscribing to ${e} failed, please try again`);
            if (!h && o) throw new Error(`Subscribing to ${e} failed, please try again`);
            return h ? a : null;
        } catch (a) {
            if (this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.connection_stalled), o) throw a;
        }
        return null;
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $9jF5G.getRelayProtocolApi)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $9jF5G.createExpiringPromise)(new Promise((s)=>{
                this.relayer.request(i).catch((n)=>this.logger.warn(n)).then(s);
            }), this.subscribeTimeout, "rpcBatchSubscribe failed, please try again");
        } catch  {
            this.relayer.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.connection_stalled);
        }
    }
    async rpcBatchFetchMessages(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $9jF5G.getRelayProtocolApi)(t.protocol).batchFetchMessages,
            params: {
                topics: e.map((n)=>n.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        let s;
        try {
            s = await await (0, $9jF5G.createExpiringPromise)(new Promise((n, o)=>{
                this.relayer.request(i).catch((a)=>{
                    this.logger.warn(a), o(a);
                }).then(n);
            }), this.subscribeTimeout, "rpcBatchFetchMessages failed, please try again");
        } catch  {
            this.relayer.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.connection_stalled);
        }
        return s;
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $9jF5G.getRelayProtocolApi)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $8feb69f0c9fb7ecf$var$He($8feb69f0c9fb7ecf$var$ge({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $8feb69f0c9fb7ecf$var$ge({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t);
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $8feb69f0c9fb7ecf$var$ge({}, t)), this.topicMap.set(t.topic, e), this.events.emit($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.deleted, $8feb69f0c9fb7ecf$var$He($8feb69f0c9fb7ecf$var$ge({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.sync);
    }
    async onRestart() {
        if (this.cached.length) {
            const e = [
                ...this.cached
            ], t = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let i = 0; i < t; i++){
                const s = e.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(s);
            }
        }
        this.events.emit($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $9jF5G.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        e.length && (await this.rpcBatchSubscribe(e), this.onBatchSubscribe(await Promise.all(e.map(async (t)=>$8feb69f0c9fb7ecf$var$He($8feb69f0c9fb7ecf$var$ge({}, t), {
                id: await this.getSubscriptionId(t.topic)
            })))));
    }
    async batchFetchMessages(e) {
        if (!e.length) return;
        this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
        const t = await this.rpcBatchFetchMessages(e);
        t && t.messages && (await (0, $9jF5G.sleep)((0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_SECOND))), await this.relayer.handleBatchMessageEvents(t.messages));
    }
    async onConnect() {
        await this.restart(), this.reset();
    }
    onDisconnect() {
        this.onDisable();
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete(e) {
        !this.relayer.connected && !this.relayer.connecting && (this.cached.push(e), await this.relayer.transportOpen());
    }
    async getClientId() {
        return this.clientId || (this.clientId = await this.relayer.core.crypto.getClientId()), this.clientId;
    }
    async getSubscriptionId(e) {
        return (0, $9jF5G.hashMessage)(e + await this.getClientId());
    }
}
var $8feb69f0c9fb7ecf$var$Qn = Object.defineProperty, $8feb69f0c9fb7ecf$var$Ci = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$eo = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$to = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$Ye = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Qn(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$Pi = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$eo.call(e, t) && $8feb69f0c9fb7ecf$var$Ye(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$Ci) for (var t of $8feb69f0c9fb7ecf$var$Ci(e))$8feb69f0c9fb7ecf$var$to.call(e, t) && $8feb69f0c9fb7ecf$var$Ye(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$y = (r, e, t)=>$8feb69f0c9fb7ecf$var$Ye(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$70e73aa29a3d4407 extends (0, $dgxYa.IRelayer) {
    constructor(e){
        super(e), $8feb69f0c9fb7ecf$var$y(this, "protocol", "wc"), $8feb69f0c9fb7ecf$var$y(this, "version", 2), $8feb69f0c9fb7ecf$var$y(this, "core"), $8feb69f0c9fb7ecf$var$y(this, "logger"), $8feb69f0c9fb7ecf$var$y(this, "events", new (0, $7hlqZ.EventEmitter)), $8feb69f0c9fb7ecf$var$y(this, "provider"), $8feb69f0c9fb7ecf$var$y(this, "messages"), $8feb69f0c9fb7ecf$var$y(this, "subscriber"), $8feb69f0c9fb7ecf$var$y(this, "publisher"), $8feb69f0c9fb7ecf$var$y(this, "name", $8feb69f0c9fb7ecf$export$602d6e27611c3fcb), $8feb69f0c9fb7ecf$var$y(this, "transportExplicitlyClosed", !1), $8feb69f0c9fb7ecf$var$y(this, "initialized", !1), $8feb69f0c9fb7ecf$var$y(this, "connectionAttemptInProgress", !1), $8feb69f0c9fb7ecf$var$y(this, "relayUrl"), $8feb69f0c9fb7ecf$var$y(this, "projectId"), $8feb69f0c9fb7ecf$var$y(this, "packageName"), $8feb69f0c9fb7ecf$var$y(this, "bundleId"), $8feb69f0c9fb7ecf$var$y(this, "hasExperiencedNetworkDisruption", !1), $8feb69f0c9fb7ecf$var$y(this, "pingTimeout"), $8feb69f0c9fb7ecf$var$y(this, "heartBeatTimeout", (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.THIRTY_SECONDS) + (0, $2TjUJ.FIVE_SECONDS))), $8feb69f0c9fb7ecf$var$y(this, "reconnectTimeout"), $8feb69f0c9fb7ecf$var$y(this, "connectPromise"), $8feb69f0c9fb7ecf$var$y(this, "reconnectInProgress", !1), $8feb69f0c9fb7ecf$var$y(this, "requestsInFlight", []), $8feb69f0c9fb7ecf$var$y(this, "connectTimeout", (0, $2TjUJ.toMiliseconds)((0, $2TjUJ.ONE_SECOND) * 15)), $8feb69f0c9fb7ecf$var$y(this, "request", async (t)=>{
            var i, s;
            this.logger.debug("Publishing Request Payload");
            const n = t.id || (0, $3G8ou.getBigIntRpcId)().toString();
            await this.toEstablishConnection();
            try {
                this.logger.trace({
                    id: n,
                    method: t.method,
                    topic: (i = t.params) == null ? void 0 : i.topic
                }, "relayer.request - publishing...");
                const o = `${n}:${((s = t.params) == null ? void 0 : s.tag) || ""}`;
                this.requestsInFlight.push(o);
                const a = await this.provider.request(t);
                return this.requestsInFlight = this.requestsInFlight.filter((c)=>c !== o), a;
            } catch (o) {
                throw this.logger.debug(`Failed to Publish Request: ${n}`), o;
            }
        }), $8feb69f0c9fb7ecf$var$y(this, "resetPingTimeout", ()=>{
            (0, $9jF5G.isNode)() && (clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
                var t, i, s, n;
                try {
                    this.logger.debug({}, "pingTimeout: Connection stalled, terminating..."), (n = (s = (i = (t = this.provider) == null ? void 0 : t.connection) == null ? void 0 : i.socket) == null ? void 0 : s.terminate) == null || n.call(s);
                } catch (o) {
                    this.logger.warn(o, o?.message);
                }
            }, this.heartBeatTimeout));
        }), $8feb69f0c9fb7ecf$var$y(this, "onPayloadHandler", (t)=>{
            this.onProviderPayload(t), this.resetPingTimeout();
        }), $8feb69f0c9fb7ecf$var$y(this, "onConnectHandler", ()=>{
            this.logger.warn({}, "Relayer connected \uD83D\uDEDC"), this.startPingTimeout(), this.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.connect);
        }), $8feb69f0c9fb7ecf$var$y(this, "onDisconnectHandler", ()=>{
            this.logger.warn({}, "Relayer disconnected \uD83D\uDED1"), this.requestsInFlight = [], this.onProviderDisconnect();
        }), $8feb69f0c9fb7ecf$var$y(this, "onProviderErrorHandler", (t)=>{
            this.logger.fatal(`Fatal socket error: ${t.message}`), this.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.error, t), this.logger.fatal("Fatal socket error received, closing transport"), this.transportClose();
        }), $8feb69f0c9fb7ecf$var$y(this, "registerProviderListeners", ()=>{
            this.provider.on($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }), this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $ksL7m.generateChildLogger)(e.logger, this.name) : (0, (/*@__PURE__*/$parcel$interopDefault($jt6FO)))((0, $ksL7m.getDefaultLoggerOptions)({
            level: e.logger || $8feb69f0c9fb7ecf$export$5176ffa6778d6637
        })), this.messages = new $8feb69f0c9fb7ecf$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $8feb69f0c9fb7ecf$export$60959659b2c22881(this, this.logger), this.publisher = new $8feb69f0c9fb7ecf$var$Vn(this, this.logger), this.relayUrl = e?.relayUrl || $8feb69f0c9fb7ecf$export$a68061e6c48f332a, this.projectId = e.projectId, (0, $9jF5G.isAndroid)() ? this.packageName = (0, $9jF5G.getAppId)() : (0, $9jF5G.isIos)() && (this.bundleId = (0, $9jF5G.getAppId)()), this.provider = {};
    }
    async init() {
        if (this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]), this.initialized = !0, this.subscriber.hasAnyTopics) try {
            await this.transportOpen();
        } catch (e) {
            this.logger.warn(e, e?.message);
        }
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get connected() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 1 || !1;
    }
    get connecting() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 0 || this.connectPromise !== void 0 || !1;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now(),
            transportType: $8feb69f0c9fb7ecf$export$326e296bb8673773.relay
        }, $8feb69f0c9fb7ecf$export$5c65dd72e0f566ab.outbound);
    }
    async subscribe(e, t) {
        var i, s, n;
        this.isInitialized(), (!(t != null && t.transportType) || t?.transportType === "relay") && await this.toEstablishConnection();
        const o = typeof ((i = t?.internal) == null ? void 0 : i.throwOnFailedPublish) > "u" ? !0 : (s = t?.internal) == null ? void 0 : s.throwOnFailedPublish;
        let a = ((n = this.subscriber.topicMap.get(e)) == null ? void 0 : n[0]) || "", c;
        const h = (l)=>{
            l.topic === e && (this.subscriber.off($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, h), c());
        };
        return await Promise.all([
            new Promise((l)=>{
                c = l, this.subscriber.on($8feb69f0c9fb7ecf$export$24ff3e54e94ef413.created, h);
            }),
            new Promise(async (l, d)=>{
                a = await this.subscriber.subscribe(e, $8feb69f0c9fb7ecf$var$Pi({
                    internal: {
                        throwOnFailedPublish: o
                    }
                }, t)).catch((g)=>{
                    o && d(g);
                }) || a, l();
            })
        ]), a;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportDisconnect() {
        this.provider.disconnect && (this.hasExperiencedNetworkDisruption || this.connected) ? await (0, $9jF5G.createExpiringPromise)(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.onProviderDisconnect();
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, await this.transportDisconnect();
    }
    async transportOpen(e) {
        if (!this.subscriber.hasAnyTopics) {
            this.logger.warn("Starting WS connection skipped because the client has no topics to work with.");
            return;
        }
        if (this.connectPromise ? (this.logger.debug({}, "Waiting for existing connection attempt to resolve..."), await this.connectPromise, this.logger.debug({}, "Existing connection attempt resolved")) : (this.connectPromise = new Promise(async (t, i)=>{
            await this.connect(e).then(t).catch(i).finally(()=>{
                this.connectPromise = void 0;
            });
        }), await this.connectPromise), !this.connected) throw new Error(`Couldn't establish socket connection to the relay server: ${this.relayUrl}`);
    }
    async restartTransport(e) {
        this.logger.debug({}, "Restarting transport..."), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $9jF5G.isOnline)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    async handleBatchMessageEvents(e) {
        if (e?.length === 0) {
            this.logger.trace("Batch message events is empty. Ignoring...");
            return;
        }
        const t = e.sort((i, s)=>i.publishedAt - s.publishedAt);
        this.logger.debug(`Batch of ${t.length} message events sorted`);
        for (const i of t)try {
            await this.onMessageEvent(i);
        } catch (s) {
            this.logger.warn(s, "Error while processing batch message event: " + s?.message);
        }
        this.logger.trace(`Batch of ${t.length} message events processed`);
    }
    async onLinkMessageEvent(e, t) {
        const { topic: i } = e;
        if (!t.sessionExists) {
            const s = (0, $9jF5G.calcExpiry)((0, $2TjUJ.FIVE_MINUTES)), n = {
                topic: i,
                expiry: s,
                relay: {
                    protocol: "irn"
                },
                active: !1
            };
            await this.core.pairing.pairings.set(i, n);
        }
        this.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.message, e), await this.recordMessageEvent(e, $8feb69f0c9fb7ecf$export$5c65dd72e0f566ab.inbound);
    }
    async connect(e) {
        await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
        let t = 1;
        for(; t < 6;){
            try {
                if (this.transportExplicitlyClosed) break;
                this.logger.debug({}, `Connecting to ${this.relayUrl}, attempt: ${t}...`), await this.createProvider(), await new Promise(async (i, s)=>{
                    const n = ()=>{
                        s(new Error("Connection interrupted while trying to subscribe"));
                    };
                    this.provider.once($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.disconnect, n), await (0, $9jF5G.createExpiringPromise)(new Promise((o, a)=>{
                        this.provider.connect().then(o).catch(a);
                    }), this.connectTimeout, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((o)=>{
                        s(o);
                    }).finally(()=>{
                        this.provider.off($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.disconnect, n), clearTimeout(this.reconnectTimeout);
                    }), await new Promise(async (o, a)=>{
                        const c = ()=>{
                            a(new Error("Connection interrupted while trying to subscribe"));
                        };
                        this.provider.once($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.disconnect, c), await this.subscriber.start().then(o).catch(a).finally(()=>{
                            this.provider.off($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.disconnect, c);
                        });
                    }), this.hasExperiencedNetworkDisruption = !1, i();
                });
            } catch (i) {
                await this.subscriber.stop();
                const s = i;
                this.logger.warn({}, s.message), this.hasExperiencedNetworkDisruption = !0;
            } finally{
                this.connectionAttemptInProgress = !1;
            }
            if (this.connected) {
                this.logger.debug({}, `Connected to ${this.relayUrl} successfully on attempt: ${t}`);
                break;
            }
            await new Promise((i)=>setTimeout(i, (0, $2TjUJ.toMiliseconds)(t * 1))), t++;
        }
    }
    startPingTimeout() {
        var e, t, i, s, n;
        if ((0, $9jF5G.isNode)()) try {
            (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((n = (s = (i = this.provider) == null ? void 0 : i.connection) == null ? void 0 : s.socket) == null || n.on("ping", ()=>{
                this.resetPingTimeout();
            })), this.resetPingTimeout();
        } catch (o) {
            this.logger.warn(o, o?.message);
        }
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $01Dhm.JsonRpcProvider)(new (0, $dcgNG.default)((0, $9jF5G.formatRelayRpcUrl)({
            sdkVersion: $8feb69f0c9fb7ecf$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId,
            packageName: this.packageName
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e, t) {
        const { topic: i, message: s } = e;
        await this.messages.set(i, s, t);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.warn(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isKnownTopic(t)) return this.logger.warn(`Ignoring message for unknown topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.warn(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $5ZYqc.isJsonRpcRequest)(e)) {
            if (!e.method.endsWith($8feb69f0c9fb7ecf$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: n, attestation: o } = t.data, a = {
                topic: i,
                message: s,
                publishedAt: n,
                transportType: $8feb69f0c9fb7ecf$export$326e296bb8673773.relay,
                attestation: o
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($8feb69f0c9fb7ecf$var$Pi({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $5ZYqc.isJsonRpcResponse)(e) && this.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (await this.recordMessageEvent(e, $8feb69f0c9fb7ecf$export$5c65dd72e0f566ab.inbound), this.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.message, e));
    }
    async acknowledgePayload(e) {
        const t = (0, $3G8ou.formatJsonRpcResult)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($8feb69f0c9fb7ecf$export$58062acf2f31ddf8.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
    }
    async registerEventListeners() {
        let e = await (0, $9jF5G.isOnline)();
        (0, $9jF5G.subscribeToNetworkChange)(async (t)=>{
            e !== t && (e = t, t ? await this.transportOpen().catch((i)=>this.logger.error(i, i?.message)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
        });
    }
    async onProviderDisconnect() {
        clearTimeout(this.pingTimeout), this.events.emit($8feb69f0c9fb7ecf$export$d56245796e2837d.disconnect), this.connectionAttemptInProgress = !1, !this.reconnectInProgress && (this.reconnectInProgress = !0, await this.subscriber.stop(), this.subscriber.hasAnyTopics && (this.transportExplicitlyClosed || (this.reconnectTimeout = setTimeout(async ()=>{
            await this.transportOpen().catch((e)=>this.logger.error(e, e?.message)), this.reconnectTimeout = void 0, this.reconnectInProgress = !1;
        }, (0, $2TjUJ.toMiliseconds)($8feb69f0c9fb7ecf$export$11ccd39be2c57d6)))));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        await this.confirmOnlineStateOrThrow(), !this.connected && await this.connect();
    }
}
function $8feb69f0c9fb7ecf$var$io() {}
function $8feb69f0c9fb7ecf$var$Ri(r) {
    if (!r || typeof r != "object") return !1;
    const e = Object.getPrototypeOf(r);
    return e === null || e === Object.prototype || Object.getPrototypeOf(e) === null ? Object.prototype.toString.call(r) === "[object Object]" : !1;
}
function $8feb69f0c9fb7ecf$var$Oi(r) {
    return Object.getOwnPropertySymbols(r).filter((e)=>Object.prototype.propertyIsEnumerable.call(r, e));
}
function $8feb69f0c9fb7ecf$var$Ai(r) {
    return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
}
const $8feb69f0c9fb7ecf$var$so = "[object RegExp]", $8feb69f0c9fb7ecf$var$ro = "[object String]", $8feb69f0c9fb7ecf$var$no = "[object Number]", $8feb69f0c9fb7ecf$var$oo = "[object Boolean]", $8feb69f0c9fb7ecf$var$xi = "[object Arguments]", $8feb69f0c9fb7ecf$var$ao = "[object Symbol]", $8feb69f0c9fb7ecf$var$co = "[object Date]", $8feb69f0c9fb7ecf$var$ho = "[object Map]", $8feb69f0c9fb7ecf$var$lo = "[object Set]", $8feb69f0c9fb7ecf$var$uo = "[object Array]", $8feb69f0c9fb7ecf$var$go = "[object Function]", $8feb69f0c9fb7ecf$var$po = "[object ArrayBuffer]", $8feb69f0c9fb7ecf$var$Je = "[object Object]", $8feb69f0c9fb7ecf$var$yo = "[object Error]", $8feb69f0c9fb7ecf$var$bo = "[object DataView]", $8feb69f0c9fb7ecf$var$mo = "[object Uint8Array]", $8feb69f0c9fb7ecf$var$fo = "[object Uint8ClampedArray]", $8feb69f0c9fb7ecf$var$Do = "[object Uint16Array]", $8feb69f0c9fb7ecf$var$vo = "[object Uint32Array]", $8feb69f0c9fb7ecf$var$wo = "[object BigUint64Array]", $8feb69f0c9fb7ecf$var$_o = "[object Int8Array]", $8feb69f0c9fb7ecf$var$Eo = "[object Int16Array]", $8feb69f0c9fb7ecf$var$Io = "[object Int32Array]", $8feb69f0c9fb7ecf$var$To = "[object BigInt64Array]", $8feb69f0c9fb7ecf$var$Co = "[object Float32Array]", $8feb69f0c9fb7ecf$var$Po = "[object Float64Array]";
function $8feb69f0c9fb7ecf$var$So(r, e) {
    return r === e || Number.isNaN(r) && Number.isNaN(e);
}
function $8feb69f0c9fb7ecf$var$Ro(r, e, t) {
    return $8feb69f0c9fb7ecf$var$pe(r, e, void 0, void 0, void 0, void 0, t);
}
function $8feb69f0c9fb7ecf$var$pe(r, e, t, i, s, n, o) {
    const a = o(r, e, t, i, s, n);
    if (a !== void 0) return a;
    if (typeof r == typeof e) switch(typeof r){
        case "bigint":
        case "string":
        case "boolean":
        case "symbol":
        case "undefined":
            return r === e;
        case "number":
            return r === e || Object.is(r, e);
        case "function":
            return r === e;
        case "object":
            return $8feb69f0c9fb7ecf$var$ye(r, e, n, o);
    }
    return $8feb69f0c9fb7ecf$var$ye(r, e, n, o);
}
function $8feb69f0c9fb7ecf$var$ye(r, e, t, i) {
    if (Object.is(r, e)) return !0;
    let s = $8feb69f0c9fb7ecf$var$Ai(r), n = $8feb69f0c9fb7ecf$var$Ai(e);
    if (s === $8feb69f0c9fb7ecf$var$xi && (s = $8feb69f0c9fb7ecf$var$Je), n === $8feb69f0c9fb7ecf$var$xi && (n = $8feb69f0c9fb7ecf$var$Je), s !== n) return !1;
    switch(s){
        case $8feb69f0c9fb7ecf$var$ro:
            return r.toString() === e.toString();
        case $8feb69f0c9fb7ecf$var$no:
            {
                const c = r.valueOf(), h = e.valueOf();
                return $8feb69f0c9fb7ecf$var$So(c, h);
            }
        case $8feb69f0c9fb7ecf$var$oo:
        case $8feb69f0c9fb7ecf$var$co:
        case $8feb69f0c9fb7ecf$var$ao:
            return Object.is(r.valueOf(), e.valueOf());
        case $8feb69f0c9fb7ecf$var$so:
            return r.source === e.source && r.flags === e.flags;
        case $8feb69f0c9fb7ecf$var$go:
            return r === e;
    }
    t = t ?? new Map;
    const o = t.get(r), a = t.get(e);
    if (o != null && a != null) return o === e;
    t.set(r, e), t.set(e, r);
    try {
        switch(s){
            case $8feb69f0c9fb7ecf$var$ho:
                if (r.size !== e.size) return !1;
                for (const [c, h] of r.entries())if (!e.has(c) || !$8feb69f0c9fb7ecf$var$pe(h, e.get(c), c, r, e, t, i)) return !1;
                return !0;
            case $8feb69f0c9fb7ecf$var$lo:
                {
                    if (r.size !== e.size) return !1;
                    const c = Array.from(r.values()), h = Array.from(e.values());
                    for(let l = 0; l < c.length; l++){
                        const d = c[l], g = h.findIndex((_)=>$8feb69f0c9fb7ecf$var$pe(d, _, void 0, r, e, t, i));
                        if (g === -1) return !1;
                        h.splice(g, 1);
                    }
                    return !0;
                }
            case $8feb69f0c9fb7ecf$var$uo:
            case $8feb69f0c9fb7ecf$var$mo:
            case $8feb69f0c9fb7ecf$var$fo:
            case $8feb69f0c9fb7ecf$var$Do:
            case $8feb69f0c9fb7ecf$var$vo:
            case $8feb69f0c9fb7ecf$var$wo:
            case $8feb69f0c9fb7ecf$var$_o:
            case $8feb69f0c9fb7ecf$var$Eo:
            case $8feb69f0c9fb7ecf$var$Io:
            case $8feb69f0c9fb7ecf$var$To:
            case $8feb69f0c9fb7ecf$var$Co:
            case $8feb69f0c9fb7ecf$var$Po:
                if (typeof $8feb69f0c9fb7ecf$require$Buffer < "u" && $8feb69f0c9fb7ecf$require$Buffer.isBuffer(r) !== $8feb69f0c9fb7ecf$require$Buffer.isBuffer(e) || r.length !== e.length) return !1;
                for(let c = 0; c < r.length; c++)if (!$8feb69f0c9fb7ecf$var$pe(r[c], e[c], c, r, e, t, i)) return !1;
                return !0;
            case $8feb69f0c9fb7ecf$var$po:
                return r.byteLength !== e.byteLength ? !1 : $8feb69f0c9fb7ecf$var$ye(new Uint8Array(r), new Uint8Array(e), t, i);
            case $8feb69f0c9fb7ecf$var$bo:
                return r.byteLength !== e.byteLength || r.byteOffset !== e.byteOffset ? !1 : $8feb69f0c9fb7ecf$var$ye(new Uint8Array(r), new Uint8Array(e), t, i);
            case $8feb69f0c9fb7ecf$var$yo:
                return r.name === e.name && r.message === e.message;
            case $8feb69f0c9fb7ecf$var$Je:
                {
                    if (!($8feb69f0c9fb7ecf$var$ye(r.constructor, e.constructor, t, i) || $8feb69f0c9fb7ecf$var$Ri(r) && $8feb69f0c9fb7ecf$var$Ri(e))) return !1;
                    const h = [
                        ...Object.keys(r),
                        ...$8feb69f0c9fb7ecf$var$Oi(r)
                    ], l = [
                        ...Object.keys(e),
                        ...$8feb69f0c9fb7ecf$var$Oi(e)
                    ];
                    if (h.length !== l.length) return !1;
                    for(let d = 0; d < h.length; d++){
                        const g = h[d], _ = r[g];
                        if (!Object.hasOwn(e, g)) return !1;
                        const u = e[g];
                        if (!$8feb69f0c9fb7ecf$var$pe(_, u, g, r, e, t, i)) return !1;
                    }
                    return !0;
                }
            default:
                return !1;
        }
    } finally{
        t.delete(r), t.delete(e);
    }
}
function $8feb69f0c9fb7ecf$var$Oo(r, e) {
    return $8feb69f0c9fb7ecf$var$Ro(r, e, $8feb69f0c9fb7ecf$var$io);
}
var $8feb69f0c9fb7ecf$var$Ao = Object.defineProperty, $8feb69f0c9fb7ecf$var$Ni = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$xo = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$No = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$Xe = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Ao(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$$i = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$xo.call(e, t) && $8feb69f0c9fb7ecf$var$Xe(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$Ni) for (var t of $8feb69f0c9fb7ecf$var$Ni(e))$8feb69f0c9fb7ecf$var$No.call(e, t) && $8feb69f0c9fb7ecf$var$Xe(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$z = (r, e, t)=>$8feb69f0c9fb7ecf$var$Xe(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$390f32400eaf98c9 extends (0, $dgxYa.IStore) {
    constructor(e, t, i, s = $8feb69f0c9fb7ecf$export$f258d29ae5e3d545, n){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, $8feb69f0c9fb7ecf$var$z(this, "map", new Map), $8feb69f0c9fb7ecf$var$z(this, "version", $8feb69f0c9fb7ecf$export$629a342182ba24b), $8feb69f0c9fb7ecf$var$z(this, "cached", []), $8feb69f0c9fb7ecf$var$z(this, "initialized", !1), $8feb69f0c9fb7ecf$var$z(this, "getKey"), $8feb69f0c9fb7ecf$var$z(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$z(this, "recentlyDeleted", []), $8feb69f0c9fb7ecf$var$z(this, "recentlyDeletedLimit", 200), $8feb69f0c9fb7ecf$var$z(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o)=>{
                this.getKey && o !== null && !(0, $9jF5G.isUndefined)(o) ? this.map.set(this.getKey(o), o) : (0, $9jF5G.isProposalStruct)(o) ? this.map.set(o.id, o) : (0, $9jF5G.isSessionStruct)(o) && this.map.set(o.topic, o);
            }), this.cached = [], this.initialized = !0);
        }), $8feb69f0c9fb7ecf$var$z(this, "set", async (o, a)=>{
            this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: o,
                value: a
            }), this.map.set(o, a), await this.persist());
        }), $8feb69f0c9fb7ecf$var$z(this, "get", (o)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: o
            }), this.getData(o))), $8feb69f0c9fb7ecf$var$z(this, "getAll", (o)=>(this.isInitialized(), o ? this.values.filter((a)=>Object.keys(o).every((c)=>$8feb69f0c9fb7ecf$var$Oo(a[c], o[c]))) : this.values)), $8feb69f0c9fb7ecf$var$z(this, "update", async (o, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: o,
                update: a
            });
            const c = $8feb69f0c9fb7ecf$var$$i($8feb69f0c9fb7ecf$var$$i({}, this.getData(o)), a);
            this.map.set(o, c), await this.persist();
        }), $8feb69f0c9fb7ecf$var$z(this, "delete", async (o, a)=>{
            this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: o,
                reason: a
            }), this.map.delete(o), this.addToRecentlyDeleted(o), await this.persist());
        }), this.logger = (0, $ksL7m.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = n;
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    addToRecentlyDeleted(e) {
        this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            if (this.recentlyDeleted.includes(e)) {
                const { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
                throw this.logger.error(s), new Error(s);
            }
            const { message: i } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $9jF5G.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $8feb69f0c9fb7ecf$var$$o = Object.defineProperty, $8feb69f0c9fb7ecf$var$zo = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$$o(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$p = (r, e, t)=>$8feb69f0c9fb7ecf$var$zo(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, $8feb69f0c9fb7ecf$var$p(this, "name", $8feb69f0c9fb7ecf$export$390360ea476c6145), $8feb69f0c9fb7ecf$var$p(this, "version", $8feb69f0c9fb7ecf$export$5593ec74b27d1b18), $8feb69f0c9fb7ecf$var$p(this, "events", new (0, (/*@__PURE__*/$parcel$interopDefault($7hlqZ)))), $8feb69f0c9fb7ecf$var$p(this, "pairings"), $8feb69f0c9fb7ecf$var$p(this, "initialized", !1), $8feb69f0c9fb7ecf$var$p(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$p(this, "ignoredPayloadTypes", [
            (0, $9jF5G.TYPE_1)
        ]), $8feb69f0c9fb7ecf$var$p(this, "registeredMethods", []), $8feb69f0c9fb7ecf$var$p(this, "init", async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }), $8feb69f0c9fb7ecf$var$p(this, "register", ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }), $8feb69f0c9fb7ecf$var$p(this, "create", async (i)=>{
            this.isInitialized();
            const s = (0, $9jF5G.generateRandomBytes32)(), n = await this.core.crypto.setSymKey(s), o = (0, $9jF5G.calcExpiry)((0, $2TjUJ.FIVE_MINUTES)), a = {
                protocol: $8feb69f0c9fb7ecf$export$822d0bd1635d5360
            }, c = {
                topic: n,
                expiry: o,
                relay: a,
                active: !1,
                methods: i?.methods
            }, h = (0, $9jF5G.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: n,
                symKey: s,
                relay: a,
                expiryTimestamp: o,
                methods: i?.methods
            });
            return this.events.emit($8feb69f0c9fb7ecf$export$ca3c0b962acf7b75.create, c), this.core.expirer.set(n, o), await this.pairings.set(n, c), await this.core.relayer.subscribe(n, {
                transportType: i?.transportType
            }), {
                topic: n,
                uri: h
            };
        }), $8feb69f0c9fb7ecf$var$p(this, "pair", async (i)=>{
            this.isInitialized();
            const s = this.core.eventClient.createEvent({
                properties: {
                    topic: i?.uri,
                    trace: [
                        $8feb69f0c9fb7ecf$export$6736f9bb609b5d34.pairing_started
                    ]
                }
            });
            this.isValidPair(i, s);
            const { topic: n, symKey: o, relay: a, expiryTimestamp: c, methods: h } = (0, $9jF5G.parseUri)(i.uri);
            s.props.properties.topic = n, s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.pairing_uri_validation_success), s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.pairing_uri_not_expired);
            let l;
            if (this.pairings.keys.includes(n)) {
                if (l = this.pairings.get(n), s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.existing_pairing), l.active) throw s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.active_pairing_already_exists), new Error(`Pairing already exists: ${n}. Please try again with a new connection URI.`);
                s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.pairing_not_expired);
            }
            const d = c || (0, $9jF5G.calcExpiry)((0, $2TjUJ.FIVE_MINUTES)), g = {
                topic: n,
                relay: a,
                expiry: d,
                active: !1,
                methods: h
            };
            this.core.expirer.set(n, d), await this.pairings.set(n, g), s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.store_new_pairing), i.activatePairing && await this.activate({
                topic: n
            }), this.events.emit($8feb69f0c9fb7ecf$export$ca3c0b962acf7b75.create, g), s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.emit_inactive_pairing), this.core.crypto.keychain.has(n) || await this.core.crypto.setSymKey(o, n), s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.subscribing_pairing_topic);
            try {
                await this.core.relayer.confirmOnlineStateOrThrow();
            } catch  {
                s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.no_internet_connection);
            }
            try {
                await this.core.relayer.subscribe(n, {
                    relay: a
                });
            } catch (_) {
                throw s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.subscribe_pairing_topic_failure), _;
            }
            return s.addTrace($8feb69f0c9fb7ecf$export$6736f9bb609b5d34.subscribe_pairing_topic_success), g;
        }), $8feb69f0c9fb7ecf$var$p(this, "activate", async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $9jF5G.calcExpiry)((0, $2TjUJ.FIVE_MINUTES));
            this.core.expirer.set(i, s), await this.pairings.update(i, {
                active: !0,
                expiry: s
            });
        }), $8feb69f0c9fb7ecf$var$p(this, "ping", async (i)=>{
            this.isInitialized(), await this.isValidPing(i), this.logger.warn("ping() is deprecated and will be removed in the next major release.");
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: o, resolve: a, reject: c } = (0, $9jF5G.createDelayedPromise)();
                this.events.once((0, $9jF5G.engineEvent)("pairing_ping", n), ({ error: h })=>{
                    h ? c(h) : a();
                }), await o();
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "updateExpiry", async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }), $8feb69f0c9fb7ecf$var$p(this, "updateMetadata", async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }), $8feb69f0c9fb7ecf$var$p(this, "getPairings", ()=>(this.isInitialized(), this.pairings.values)), $8feb69f0c9fb7ecf$var$p(this, "disconnect", async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $9jF5G.getSdkError)("USER_DISCONNECTED")), await this.deletePairing(s));
        }), $8feb69f0c9fb7ecf$var$p(this, "formatUriFromPairing", (i)=>{
            this.isInitialized();
            const { topic: s, relay: n, expiry: o, methods: a } = i, c = this.core.crypto.keychain.get(s);
            return (0, $9jF5G.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: c,
                relay: n,
                expiryTimestamp: o,
                methods: a
            });
        }), $8feb69f0c9fb7ecf$var$p(this, "sendRequest", async (i, s, n)=>{
            const o = (0, $3G8ou.formatJsonRpcRequest)(s, n), a = await this.core.crypto.encode(i, o), c = $8feb69f0c9fb7ecf$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, o), this.core.relayer.publish(i, a, c), o.id;
        }), $8feb69f0c9fb7ecf$var$p(this, "sendResult", async (i, s, n)=>{
            const o = (0, $3G8ou.formatJsonRpcResult)(i, n), a = await this.core.crypto.encode(s, o), c = (await this.core.history.get(s, i)).request.method, h = $8feb69f0c9fb7ecf$export$d94d6986a8185883[c].res;
            await this.core.relayer.publish(s, a, h), await this.core.history.resolve(o);
        }), $8feb69f0c9fb7ecf$var$p(this, "sendError", async (i, s, n)=>{
            const o = (0, $3G8ou.formatJsonRpcError)(i, n), a = await this.core.crypto.encode(s, o), c = (await this.core.history.get(s, i)).request.method, h = $8feb69f0c9fb7ecf$export$d94d6986a8185883[c] ? $8feb69f0c9fb7ecf$export$d94d6986a8185883[c].res : $8feb69f0c9fb7ecf$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, h), await this.core.history.resolve(o);
        }), $8feb69f0c9fb7ecf$var$p(this, "deletePairing", async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $9jF5G.getSdkError)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }), $8feb69f0c9fb7ecf$var$p(this, "cleanup", async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $9jF5G.isExpired)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }), $8feb69f0c9fb7ecf$var$p(this, "onRelayEventRequest", async (i)=>{
            const { topic: s, payload: n } = i;
            switch(n.method){
                case "wc_pairingPing":
                    return await this.onPairingPingRequest(s, n);
                case "wc_pairingDelete":
                    return await this.onPairingDeleteRequest(s, n);
                default:
                    return await this.onUnknownRpcMethodRequest(s, n);
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "onRelayEventResponse", async (i)=>{
            const { topic: s, payload: n } = i, o = (await this.core.history.get(s, n.id)).request.method;
            switch(o){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, n);
                default:
                    return this.onUnknownRpcMethodResponse(o);
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "onPairingPingRequest", async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(n, i, !0), this.events.emit($8feb69f0c9fb7ecf$export$ca3c0b962acf7b75.ping, {
                    id: n,
                    topic: i
                });
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "onPairingPingResponse", (i, s)=>{
            const { id: n } = s;
            setTimeout(()=>{
                (0, $5ZYqc.isJsonRpcResult)(s) ? this.events.emit((0, $9jF5G.engineEvent)("pairing_ping", n), {}) : (0, $5ZYqc.isJsonRpcError)(s) && this.events.emit((0, $9jF5G.engineEvent)("pairing_ping", n), {
                    error: s.error
                });
            }, 500);
        }), $8feb69f0c9fb7ecf$var$p(this, "onPairingDeleteRequest", async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($8feb69f0c9fb7ecf$export$ca3c0b962acf7b75.delete, {
                    id: n,
                    topic: i
                });
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "onUnknownRpcMethodRequest", async (i, s)=>{
            const { id: n, method: o } = s;
            try {
                if (this.registeredMethods.includes(o)) return;
                const a = (0, $9jF5G.getSdkError)("WC_METHOD_UNSUPPORTED", o);
                await this.sendError(n, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "onUnknownRpcMethodResponse", (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $9jF5G.getSdkError)("WC_METHOD_UNSUPPORTED", i));
        }), $8feb69f0c9fb7ecf$var$p(this, "isValidPair", (i, s)=>{
            var n;
            if (!(0, $9jF5G.isValidParams)(i)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(0, $9jF5G.isValidUrl)(i.uri)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            const o = (0, $9jF5G.parseUri)(i?.uri);
            if (!((n = o?.relay) != null && n.protocol)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(o != null && o.symKey)) {
                const { message: a } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (o != null && o.expiryTimestamp && (0, $2TjUJ.toMiliseconds)(o?.expiryTimestamp) < Date.now()) {
                s.setError($8feb69f0c9fb7ecf$export$e1dc85b7b7495247.pairing_expired);
                const { message: a } = (0, $9jF5G.getInternalError)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(a);
            }
        }), $8feb69f0c9fb7ecf$var$p(this, "isValidPing", async (i)=>{
            if (!(0, $9jF5G.isValidParams)(i)) {
                const { message: n } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }), $8feb69f0c9fb7ecf$var$p(this, "isValidDisconnect", async (i)=>{
            if (!(0, $9jF5G.isValidParams)(i)) {
                const { message: n } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }), $8feb69f0c9fb7ecf$var$p(this, "isValidPairingTopic", async (i)=>{
            if (!(0, $9jF5G.isValidString)(i, !1)) {
                const { message: s } = (0, $9jF5G.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $9jF5G.isExpired)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $9jF5G.getInternalError)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }), this.core = e, this.logger = (0, $ksL7m.generateChildLogger)(t, this.name), this.pairings = new $8feb69f0c9fb7ecf$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($8feb69f0c9fb7ecf$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i, transportType: s } = e;
            if (this.pairings.keys.includes(t) && s !== $8feb69f0c9fb7ecf$export$326e296bb8673773.link_mode && !this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) try {
                const n = await this.core.crypto.decode(t, i);
                (0, $5ZYqc.isJsonRpcRequest)(n) ? (this.core.history.set(t, n), await this.onRelayEventRequest({
                    topic: t,
                    payload: n
                })) : (0, $5ZYqc.isJsonRpcResponse)(n) && (await this.core.history.resolve(n), await this.onRelayEventResponse({
                    topic: t,
                    payload: n
                }), this.core.history.delete(t, n.id)), await this.core.relayer.messages.ack(t, i);
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($8feb69f0c9fb7ecf$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $9jF5G.parseExpirerTarget)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($8feb69f0c9fb7ecf$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
var $8feb69f0c9fb7ecf$var$Lo = Object.defineProperty, $8feb69f0c9fb7ecf$var$ko = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Lo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$R = (r, e, t)=>$8feb69f0c9fb7ecf$var$ko(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$eeb4f10f25d479cb extends (0, $dgxYa.IJsonRpcHistory) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, $8feb69f0c9fb7ecf$var$R(this, "records", new Map), $8feb69f0c9fb7ecf$var$R(this, "events", new (0, $7hlqZ.EventEmitter)), $8feb69f0c9fb7ecf$var$R(this, "name", $8feb69f0c9fb7ecf$export$160142c73cb99dc3), $8feb69f0c9fb7ecf$var$R(this, "version", $8feb69f0c9fb7ecf$export$8eba9ce85616c607), $8feb69f0c9fb7ecf$var$R(this, "cached", []), $8feb69f0c9fb7ecf$var$R(this, "initialized", !1), $8feb69f0c9fb7ecf$var$R(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$R(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }), $8feb69f0c9fb7ecf$var$R(this, "set", (i, s, n)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: n
            }), this.records.has(s.id)) return;
            const o = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: n,
                expiry: (0, $9jF5G.calcExpiry)((0, $2TjUJ.THIRTY_DAYS))
            };
            this.records.set(o.id, o), this.persist(), this.events.emit($8feb69f0c9fb7ecf$export$a682338b5ffca937.created, o);
        }), $8feb69f0c9fb7ecf$var$R(this, "resolve", async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $5ZYqc.isJsonRpcError)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.persist(), this.events.emit($8feb69f0c9fb7ecf$export$a682338b5ffca937.updated, s));
        }), $8feb69f0c9fb7ecf$var$R(this, "get", async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s))), $8feb69f0c9fb7ecf$var$R(this, "delete", (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((n)=>{
                if (n.topic === i) {
                    if (typeof s < "u" && n.id !== s) return;
                    this.records.delete(n.id), this.events.emit($8feb69f0c9fb7ecf$export$a682338b5ffca937.deleted, n);
                }
            }), this.persist();
        }), $8feb69f0c9fb7ecf$var$R(this, "exists", async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1)), $8feb69f0c9fb7ecf$var$R(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $8feb69f0c9fb7ecf$var$R(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $8feb69f0c9fb7ecf$var$R(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $8feb69f0c9fb7ecf$var$R(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), this.logger = (0, $ksL7m.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $3G8ou.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($8feb69f0c9fb7ecf$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $9jF5G.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($8feb69f0c9fb7ecf$export$a682338b5ffca937.created, (e)=>{
            const t = $8feb69f0c9fb7ecf$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($8feb69f0c9fb7ecf$export$a682338b5ffca937.updated, (e)=>{
            const t = $8feb69f0c9fb7ecf$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($8feb69f0c9fb7ecf$export$a682338b5ffca937.deleted, (e)=>{
            const t = $8feb69f0c9fb7ecf$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.core.heartbeat.on((0, $8VxUj.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.isInitialized();
            let e = !1;
            this.records.forEach((t)=>{
                (0, $2TjUJ.toMiliseconds)(t.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${t.id}`), this.records.delete(t.id), this.events.emit($8feb69f0c9fb7ecf$export$a682338b5ffca937.deleted, t, !1), e = !0);
            }), e && this.persist();
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $8feb69f0c9fb7ecf$var$jo = Object.defineProperty, $8feb69f0c9fb7ecf$var$Uo = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$jo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$A = (r, e, t)=>$8feb69f0c9fb7ecf$var$Uo(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$e76805ce609031cb extends (0, $dgxYa.IExpirer) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, $8feb69f0c9fb7ecf$var$A(this, "expirations", new Map), $8feb69f0c9fb7ecf$var$A(this, "events", new (0, $7hlqZ.EventEmitter)), $8feb69f0c9fb7ecf$var$A(this, "name", $8feb69f0c9fb7ecf$export$4ddf883392bbc828), $8feb69f0c9fb7ecf$var$A(this, "version", $8feb69f0c9fb7ecf$export$717295846191925d), $8feb69f0c9fb7ecf$var$A(this, "cached", []), $8feb69f0c9fb7ecf$var$A(this, "initialized", !1), $8feb69f0c9fb7ecf$var$A(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$A(this, "init", async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }), $8feb69f0c9fb7ecf$var$A(this, "has", (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }), $8feb69f0c9fb7ecf$var$A(this, "set", (i, s)=>{
            this.isInitialized();
            const n = this.formatTarget(i), o = {
                target: n,
                expiry: s
            };
            this.expirations.set(n, o), this.checkExpiry(n, o), this.events.emit($8feb69f0c9fb7ecf$export$9013719d9206b0c1.created, {
                target: n,
                expiration: o
            });
        }), $8feb69f0c9fb7ecf$var$A(this, "get", (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }), $8feb69f0c9fb7ecf$var$A(this, "del", (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), n = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($8feb69f0c9fb7ecf$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: n
                });
            }
        }), $8feb69f0c9fb7ecf$var$A(this, "on", (i, s)=>{
            this.events.on(i, s);
        }), $8feb69f0c9fb7ecf$var$A(this, "once", (i, s)=>{
            this.events.once(i, s);
        }), $8feb69f0c9fb7ecf$var$A(this, "off", (i, s)=>{
            this.events.off(i, s);
        }), $8feb69f0c9fb7ecf$var$A(this, "removeListener", (i, s)=>{
            this.events.removeListener(i, s);
        }), this.logger = (0, $ksL7m.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $9jF5G.formatTopicTarget)(e);
        if (typeof e == "number") return (0, $9jF5G.formatIdTarget)(e);
        const { message: t } = (0, $9jF5G.getInternalError)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($8feb69f0c9fb7ecf$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $9jF5G.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $9jF5G.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.warn(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $2TjUJ.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($8feb69f0c9fb7ecf$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $8VxUj.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($8feb69f0c9fb7ecf$export$9013719d9206b0c1.created, (e)=>{
            const t = $8feb69f0c9fb7ecf$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($8feb69f0c9fb7ecf$export$9013719d9206b0c1.expired, (e)=>{
            const t = $8feb69f0c9fb7ecf$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($8feb69f0c9fb7ecf$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $8feb69f0c9fb7ecf$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $9jF5G.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $8feb69f0c9fb7ecf$var$Fo = Object.defineProperty, $8feb69f0c9fb7ecf$var$Mo = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Fo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$w = (r, e, t)=>$8feb69f0c9fb7ecf$var$Mo(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$91a8e56769aeb334 extends (0, $dgxYa.IVerify) {
    constructor(e, t, i){
        super(e, t, i), this.core = e, this.logger = t, this.store = i, $8feb69f0c9fb7ecf$var$w(this, "name", $8feb69f0c9fb7ecf$export$3b58f2450f2297e3), $8feb69f0c9fb7ecf$var$w(this, "abortController"), $8feb69f0c9fb7ecf$var$w(this, "isDevEnv"), $8feb69f0c9fb7ecf$var$w(this, "verifyUrlV3", $8feb69f0c9fb7ecf$export$412739528655ee2f), $8feb69f0c9fb7ecf$var$w(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$w(this, "version", $8feb69f0c9fb7ecf$export$f30bd3c8747cdfbe), $8feb69f0c9fb7ecf$var$w(this, "publicKey"), $8feb69f0c9fb7ecf$var$w(this, "fetchPromise"), $8feb69f0c9fb7ecf$var$w(this, "init", async ()=>{
            var s;
            this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && (0, $2TjUJ.toMiliseconds)((s = this.publicKey) == null ? void 0 : s.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()));
        }), $8feb69f0c9fb7ecf$var$w(this, "register", async (s)=>{
            if (!(0, $9jF5G.isBrowser)() || this.isDevEnv) return;
            const n = window.location.origin, { id: o, decryptedId: a } = s, c = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${n}&id=${o}&decryptedId=${a}`;
            try {
                const h = (0, $f4uqJ.getDocument)(), l = this.startAbortTimer((0, $2TjUJ.ONE_SECOND) * 5), d = await new Promise((g, _)=>{
                    const u = ()=>{
                        window.removeEventListener("message", x), h.body.removeChild(b), _("attestation aborted");
                    };
                    this.abortController.signal.addEventListener("abort", u);
                    const b = h.createElement("iframe");
                    b.src = c, b.style.display = "none", b.addEventListener("error", u, {
                        signal: this.abortController.signal
                    });
                    const x = (I)=>{
                        if (I.data && typeof I.data == "string") try {
                            const D = JSON.parse(I.data);
                            if (D.type === "verify_attestation") {
                                if ((0, $islmt.decodeJWT)(D.attestation).payload.id !== o) return;
                                clearInterval(l), h.body.removeChild(b), this.abortController.signal.removeEventListener("abort", u), window.removeEventListener("message", x), g(D.attestation === null ? "" : D.attestation);
                            }
                        } catch (D) {
                            this.logger.warn(D);
                        }
                    };
                    h.body.appendChild(b), window.addEventListener("message", x, {
                        signal: this.abortController.signal
                    });
                });
                return this.logger.debug("jwt attestation", d), d;
            } catch (h) {
                this.logger.warn(h);
            }
            return "";
        }), $8feb69f0c9fb7ecf$var$w(this, "resolve", async (s)=>{
            if (this.isDevEnv) return "";
            const { attestationId: n, hash: o, encryptedId: a } = s;
            if (n === "") {
                this.logger.debug("resolve: attestationId is empty, skipping");
                return;
            }
            if (n) {
                if ((0, $islmt.decodeJWT)(n).payload.id !== a) return;
                const h = await this.isValidJwtAttestation(n);
                if (h) {
                    if (!h.isVerified) {
                        this.logger.warn("resolve: jwt attestation: origin url not verified");
                        return;
                    }
                    return h;
                }
            }
            if (!o) return;
            const c = this.getVerifyUrl(s?.verifyUrl);
            return this.fetchAttestation(o, c);
        }), $8feb69f0c9fb7ecf$var$w(this, "fetchAttestation", async (s, n)=>{
            this.logger.debug(`resolving attestation: ${s} from url: ${n}`);
            const o = this.startAbortTimer((0, $2TjUJ.ONE_SECOND) * 5), a = await fetch(`${n}/attestation/${s}?v2Supported=true`, {
                signal: this.abortController.signal
            });
            return clearTimeout(o), a.status === 200 ? await a.json() : void 0;
        }), $8feb69f0c9fb7ecf$var$w(this, "getVerifyUrl", (s)=>{
            let n = s || $8feb69f0c9fb7ecf$export$7e3b1a28ddecdbaa;
            return $8feb69f0c9fb7ecf$export$be24df03c4baa778.includes(n) || (this.logger.info(`verify url: ${n}, not included in trusted list, assigning default: ${$8feb69f0c9fb7ecf$export$7e3b1a28ddecdbaa}`), n = $8feb69f0c9fb7ecf$export$7e3b1a28ddecdbaa), n;
        }), $8feb69f0c9fb7ecf$var$w(this, "fetchPublicKey", async ()=>{
            try {
                this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
                const s = this.startAbortTimer((0, $2TjUJ.FIVE_SECONDS)), n = await fetch(`${this.verifyUrlV3}/public-key`, {
                    signal: this.abortController.signal
                });
                return clearTimeout(s), await n.json();
            } catch (s) {
                this.logger.warn(s);
            }
        }), $8feb69f0c9fb7ecf$var$w(this, "persistPublicKey", async (s)=>{
            this.logger.debug("persisting public key to local storage", s), await this.store.setItem(this.storeKey, s), this.publicKey = s;
        }), $8feb69f0c9fb7ecf$var$w(this, "removePublicKey", async ()=>{
            this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
        }), $8feb69f0c9fb7ecf$var$w(this, "isValidJwtAttestation", async (s)=>{
            const n = await this.getPublicKey();
            try {
                if (n) return this.validateAttestation(s, n);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
            const o = await this.fetchAndPersistPublicKey();
            try {
                if (o) return this.validateAttestation(s, o);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
        }), $8feb69f0c9fb7ecf$var$w(this, "getPublicKey", async ()=>this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey()), $8feb69f0c9fb7ecf$var$w(this, "fetchAndPersistPublicKey", async ()=>{
            if (this.fetchPromise) return await this.fetchPromise, this.publicKey;
            this.fetchPromise = new Promise(async (n)=>{
                const o = await this.fetchPublicKey();
                o && (await this.persistPublicKey(o), n(o));
            });
            const s = await this.fetchPromise;
            return this.fetchPromise = void 0, s;
        }), $8feb69f0c9fb7ecf$var$w(this, "validateAttestation", (s, n)=>{
            const o = (0, $9jF5G.verifyP256Jwt)(s, n.publicKey), a = {
                hasExpired: (0, $2TjUJ.toMiliseconds)(o.exp) < Date.now(),
                payload: o
            };
            if (a.hasExpired) throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
            return {
                origin: a.payload.origin,
                isScam: a.payload.isScam,
                isVerified: a.payload.isVerified
            };
        }), this.logger = (0, $ksL7m.generateChildLogger)(t, this.name), this.abortController = new AbortController, this.isDevEnv = (0, $9jF5G.isTestRun)(), this.init();
    }
    get storeKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $2TjUJ.toMiliseconds)(e));
    }
}
var $8feb69f0c9fb7ecf$var$Ko = Object.defineProperty, $8feb69f0c9fb7ecf$var$Bo = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Ko(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$Fi = (r, e, t)=>$8feb69f0c9fb7ecf$var$Bo(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$c393c48c5b0cf59a extends (0, $dgxYa.IEchoClient) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, $8feb69f0c9fb7ecf$var$Fi(this, "context", $8feb69f0c9fb7ecf$export$40c022d2cffe0adc), $8feb69f0c9fb7ecf$var$Fi(this, "registerDeviceToken", async (i)=>{
            const { clientId: s, token: n, notificationType: o, enableEncrypted: a = !1 } = i, c = `${$8feb69f0c9fb7ecf$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await fetch(c, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: o,
                    token: n,
                    always_raw: a
                })
            });
        }), this.logger = (0, $ksL7m.generateChildLogger)(t, this.context);
    }
}
var $8feb69f0c9fb7ecf$var$Vo = Object.defineProperty, $8feb69f0c9fb7ecf$var$Ki = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$qo = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$Go = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$Ze = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Vo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$be = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$qo.call(e, t) && $8feb69f0c9fb7ecf$var$Ze(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$Ki) for (var t of $8feb69f0c9fb7ecf$var$Ki(e))$8feb69f0c9fb7ecf$var$Go.call(e, t) && $8feb69f0c9fb7ecf$var$Ze(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$E = (r, e, t)=>$8feb69f0c9fb7ecf$var$Ze(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$f4a30e909fe70796 extends (0, $dgxYa.IEventClient) {
    constructor(e, t, i = !0){
        super(e, t, i), this.core = e, this.logger = t, $8feb69f0c9fb7ecf$var$E(this, "context", $8feb69f0c9fb7ecf$export$e020229e09910965), $8feb69f0c9fb7ecf$var$E(this, "storagePrefix", $8feb69f0c9fb7ecf$export$f258d29ae5e3d545), $8feb69f0c9fb7ecf$var$E(this, "storageVersion", $8feb69f0c9fb7ecf$export$c73857c3a3d16b1c), $8feb69f0c9fb7ecf$var$E(this, "events", new Map), $8feb69f0c9fb7ecf$var$E(this, "shouldPersist", !1), $8feb69f0c9fb7ecf$var$E(this, "init", async ()=>{
            if (!(0, $9jF5G.isTestRun)()) try {
                const s = {
                    eventId: (0, $9jF5G.uuidv4)(),
                    timestamp: Date.now(),
                    domain: this.getAppDomain(),
                    props: {
                        event: "INIT",
                        type: "",
                        properties: {
                            client_id: await this.core.crypto.getClientId(),
                            user_agent: (0, $9jF5G.formatUA)(this.core.relayer.protocol, this.core.relayer.version, $8feb69f0c9fb7ecf$export$5f30917a6f8c9025)
                        }
                    }
                };
                await this.sendEvent([
                    s
                ]);
            } catch (s) {
                this.logger.warn(s);
            }
        }), $8feb69f0c9fb7ecf$var$E(this, "createEvent", (s)=>{
            const { event: n = "ERROR", type: o = "", properties: { topic: a, trace: c } } = s, h = (0, $9jF5G.uuidv4)(), l = this.core.projectId || "", d = Date.now(), g = $8feb69f0c9fb7ecf$var$be({
                eventId: h,
                timestamp: d,
                props: {
                    event: n,
                    type: o,
                    properties: {
                        topic: a,
                        trace: c
                    }
                },
                bundleId: l,
                domain: this.getAppDomain()
            }, this.setMethods(h));
            return this.telemetryEnabled && (this.events.set(h, g), this.shouldPersist = !0), g;
        }), $8feb69f0c9fb7ecf$var$E(this, "getEvent", (s)=>{
            const { eventId: n, topic: o } = s;
            if (n) return this.events.get(n);
            const a = Array.from(this.events.values()).find((c)=>c.props.properties.topic === o);
            if (a) return $8feb69f0c9fb7ecf$var$be($8feb69f0c9fb7ecf$var$be({}, a), this.setMethods(a.eventId));
        }), $8feb69f0c9fb7ecf$var$E(this, "deleteEvent", (s)=>{
            const { eventId: n } = s;
            this.events.delete(n), this.shouldPersist = !0;
        }), $8feb69f0c9fb7ecf$var$E(this, "setEventListeners", ()=>{
            this.core.heartbeat.on((0, $8VxUj.HEARTBEAT_EVENTS).pulse, async ()=>{
                this.shouldPersist && await this.persist(), this.events.forEach((s)=>{
                    (0, $2TjUJ.fromMiliseconds)(Date.now()) - (0, $2TjUJ.fromMiliseconds)(s.timestamp) > $8feb69f0c9fb7ecf$export$79348045429687e2 && (this.events.delete(s.eventId), this.shouldPersist = !0);
                });
            });
        }), $8feb69f0c9fb7ecf$var$E(this, "setMethods", (s)=>({
                addTrace: (n)=>this.addTrace(s, n),
                setError: (n)=>this.setError(s, n)
            })), $8feb69f0c9fb7ecf$var$E(this, "addTrace", (s, n)=>{
            const o = this.events.get(s);
            o && (o.props.properties.trace.push(n), this.events.set(s, o), this.shouldPersist = !0);
        }), $8feb69f0c9fb7ecf$var$E(this, "setError", (s, n)=>{
            const o = this.events.get(s);
            o && (o.props.type = n, o.timestamp = Date.now(), this.events.set(s, o), this.shouldPersist = !0);
        }), $8feb69f0c9fb7ecf$var$E(this, "persist", async ()=>{
            await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
        }), $8feb69f0c9fb7ecf$var$E(this, "restore", async ()=>{
            try {
                const s = await this.core.storage.getItem(this.storageKey) || [];
                if (!s.length) return;
                s.forEach((n)=>{
                    this.events.set(n.eventId, $8feb69f0c9fb7ecf$var$be($8feb69f0c9fb7ecf$var$be({}, n), this.setMethods(n.eventId)));
                });
            } catch (s) {
                this.logger.warn(s);
            }
        }), $8feb69f0c9fb7ecf$var$E(this, "submit", async ()=>{
            if (!this.telemetryEnabled || this.events.size === 0) return;
            const s = [];
            for (const [n, o] of this.events)o.props.type && s.push(o);
            if (s.length !== 0) try {
                if ((await this.sendEvent(s)).ok) for (const n of s)this.events.delete(n.eventId), this.shouldPersist = !0;
            } catch (n) {
                this.logger.warn(n);
            }
        }), $8feb69f0c9fb7ecf$var$E(this, "sendEvent", async (s)=>{
            const n = this.getAppDomain() ? "" : "&sp=desktop";
            return await fetch(`${$8feb69f0c9fb7ecf$export$bb6a8925f3cb1ca}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${$8feb69f0c9fb7ecf$export$5f30917a6f8c9025}${n}`, {
                method: "POST",
                body: JSON.stringify(s)
            });
        }), $8feb69f0c9fb7ecf$var$E(this, "getAppDomain", ()=>(0, $9jF5G.getAppMetadata)().url), this.logger = (0, $ksL7m.generateChildLogger)(t, this.context), this.telemetryEnabled = i, i ? this.restore().then(async ()=>{
            await this.submit(), this.setEventListeners();
        }) : this.persist();
    }
    get storageKey() {
        return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
    }
}
var $8feb69f0c9fb7ecf$var$Wo = Object.defineProperty, $8feb69f0c9fb7ecf$var$Vi = Object.getOwnPropertySymbols, $8feb69f0c9fb7ecf$var$Ho = Object.prototype.hasOwnProperty, $8feb69f0c9fb7ecf$var$Yo = Object.prototype.propertyIsEnumerable, $8feb69f0c9fb7ecf$var$Qe = (r, e, t)=>e in r ? $8feb69f0c9fb7ecf$var$Wo(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8feb69f0c9fb7ecf$var$qi = (r, e)=>{
    for(var t in e || (e = {}))$8feb69f0c9fb7ecf$var$Ho.call(e, t) && $8feb69f0c9fb7ecf$var$Qe(r, t, e[t]);
    if ($8feb69f0c9fb7ecf$var$Vi) for (var t of $8feb69f0c9fb7ecf$var$Vi(e))$8feb69f0c9fb7ecf$var$Yo.call(e, t) && $8feb69f0c9fb7ecf$var$Qe(r, t, e[t]);
    return r;
}, $8feb69f0c9fb7ecf$var$v = (r, e, t)=>$8feb69f0c9fb7ecf$var$Qe(r, typeof e != "symbol" ? e + "" : e, t);
class $8feb69f0c9fb7ecf$export$2e2bcd8739ae039 extends (0, $dgxYa.ICore) {
    constructor(e){
        var t;
        super(e), $8feb69f0c9fb7ecf$var$v(this, "protocol", $8feb69f0c9fb7ecf$export$51b1c900ac262bdf), $8feb69f0c9fb7ecf$var$v(this, "version", $8feb69f0c9fb7ecf$export$f30bd3c8747cdfbe), $8feb69f0c9fb7ecf$var$v(this, "name", $8feb69f0c9fb7ecf$export$d47601f9de5ee22b), $8feb69f0c9fb7ecf$var$v(this, "relayUrl"), $8feb69f0c9fb7ecf$var$v(this, "projectId"), $8feb69f0c9fb7ecf$var$v(this, "customStoragePrefix"), $8feb69f0c9fb7ecf$var$v(this, "events", new (0, $7hlqZ.EventEmitter)), $8feb69f0c9fb7ecf$var$v(this, "logger"), $8feb69f0c9fb7ecf$var$v(this, "heartbeat"), $8feb69f0c9fb7ecf$var$v(this, "relayer"), $8feb69f0c9fb7ecf$var$v(this, "crypto"), $8feb69f0c9fb7ecf$var$v(this, "storage"), $8feb69f0c9fb7ecf$var$v(this, "history"), $8feb69f0c9fb7ecf$var$v(this, "expirer"), $8feb69f0c9fb7ecf$var$v(this, "pairing"), $8feb69f0c9fb7ecf$var$v(this, "verify"), $8feb69f0c9fb7ecf$var$v(this, "echoClient"), $8feb69f0c9fb7ecf$var$v(this, "linkModeSupportedApps"), $8feb69f0c9fb7ecf$var$v(this, "eventClient"), $8feb69f0c9fb7ecf$var$v(this, "initialized", !1), $8feb69f0c9fb7ecf$var$v(this, "logChunkController"), $8feb69f0c9fb7ecf$var$v(this, "on", (a, c)=>this.events.on(a, c)), $8feb69f0c9fb7ecf$var$v(this, "once", (a, c)=>this.events.once(a, c)), $8feb69f0c9fb7ecf$var$v(this, "off", (a, c)=>this.events.off(a, c)), $8feb69f0c9fb7ecf$var$v(this, "removeListener", (a, c)=>this.events.removeListener(a, c)), $8feb69f0c9fb7ecf$var$v(this, "dispatchEnvelope", ({ topic: a, message: c, sessionExists: h })=>{
            if (!a || !c) return;
            const l = {
                topic: a,
                message: c,
                publishedAt: Date.now(),
                transportType: $8feb69f0c9fb7ecf$export$326e296bb8673773.link_mode
            };
            this.relayer.onLinkMessageEvent(l, {
                sessionExists: h
            });
        });
        const i = this.getGlobalCore(e?.customStoragePrefix);
        if (i) try {
            return this.customStoragePrefix = i.customStoragePrefix, this.logger = i.logger, this.heartbeat = i.heartbeat, this.crypto = i.crypto, this.history = i.history, this.expirer = i.expirer, this.storage = i.storage, this.relayer = i.relayer, this.pairing = i.pairing, this.verify = i.verify, this.echoClient = i.echoClient, this.linkModeSupportedApps = i.linkModeSupportedApps, this.eventClient = i.eventClient, this.initialized = i.initialized, this.logChunkController = i.logChunkController, i;
        } catch (a) {
            console.warn("Failed to copy global core", a);
        }
        this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $8feb69f0c9fb7ecf$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const s = (0, $ksL7m.getDefaultLoggerOptions)({
            level: typeof e?.logger == "string" && e.logger ? e.logger : $8feb69f0c9fb7ecf$export$db0fdb6d486555c2.logger,
            name: $8feb69f0c9fb7ecf$export$d47601f9de5ee22b
        }), { logger: n, chunkLoggerController: o } = (0, $ksL7m.generatePlatformLogger)({
            opts: s,
            maxSizeInBytes: e?.maxLogBlobSizeInBytes,
            loggerOverride: e?.logger
        });
        this.logChunkController = o, (t = this.logChunkController) != null && t.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async ()=>{
            var a, c;
            (a = this.logChunkController) != null && a.downloadLogsBlobInBrowser && ((c = this.logChunkController) == null || c.downloadLogsBlobInBrowser({
                clientId: await this.crypto.getClientId()
            }));
        }), this.logger = (0, $ksL7m.generateChildLogger)(n, this.name), this.heartbeat = new (0, $8VxUj.HeartBeat), this.crypto = new $8feb69f0c9fb7ecf$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $8feb69f0c9fb7ecf$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $8feb69f0c9fb7ecf$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $fROir.default)($8feb69f0c9fb7ecf$var$qi($8feb69f0c9fb7ecf$var$qi({}, $8feb69f0c9fb7ecf$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $8feb69f0c9fb7ecf$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $8feb69f0c9fb7ecf$export$3370ee24730992a3(this, this.logger), this.verify = new $8feb69f0c9fb7ecf$export$91a8e56769aeb334(this, this.logger, this.storage), this.echoClient = new $8feb69f0c9fb7ecf$export$c393c48c5b0cf59a(this.projectId || "", this.logger), this.linkModeSupportedApps = [], this.eventClient = new $8feb69f0c9fb7ecf$export$f4a30e909fe70796(this, this.logger, e?.telemetryEnabled), this.setGlobalCore(this);
    }
    static async init(e) {
        const t = new $8feb69f0c9fb7ecf$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($8feb69f0c9fb7ecf$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $ksL7m.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async getLogsBlob() {
        var e;
        return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({
            clientId: await this.crypto.getClientId()
        });
    }
    async addLinkModeSupportedApp(e) {
        this.linkModeSupportedApps.includes(e) || (this.linkModeSupportedApps.push(e), await this.storage.setItem($8feb69f0c9fb7ecf$export$1989eec3a412fb97, this.linkModeSupportedApps));
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.linkModeSupportedApps = await this.storage.getItem($8feb69f0c9fb7ecf$export$1989eec3a412fb97) || [], this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
    getGlobalCore(e = "") {
        try {
            if (this.isGlobalCoreDisabled()) return;
            const t = `_walletConnectCore_${e}`, i = `${t}_count`;
            return globalThis[i] = (globalThis[i] || 0) + 1, globalThis[i] > 1 && console.warn(`WalletConnect Core is already initialized. This is probably a mistake and can lead to unexpected behavior. Init() was called ${globalThis[i]} times.`), globalThis[t];
        } catch (t) {
            console.warn("Failed to get global WalletConnect core", t);
            return;
        }
    }
    setGlobalCore(e) {
        var t;
        try {
            if (this.isGlobalCoreDisabled()) return;
            const i = `_walletConnectCore_${((t = e.opts) == null ? void 0 : t.customStoragePrefix) || ""}`;
            globalThis[i] = e;
        } catch (i) {
            console.warn("Failed to set global WalletConnect core", i);
        }
    }
    isGlobalCoreDisabled() {
        try {
            return typeof $17tgv < "u" && false;
        } catch  {
            return !0;
        }
    }
}
const $8feb69f0c9fb7ecf$export$4143ab5b91744744 = $8feb69f0c9fb7ecf$export$2e2bcd8739ae039;

});
parcelRegister("8VxUj", function(module, exports) {

$parcel$export(module.exports, "HEARTBEAT_EVENTS", function () { return $67fdf2db2a291d84$export$f3340c1af6bee4b5; });
$parcel$export(module.exports, "HeartBeat", function () { return $67fdf2db2a291d84$export$996c9b2cd7645b55; });

var $7hlqZ = parcelRequire("7hlqZ");

var $2TjUJ = parcelRequire("2TjUJ");
parcelRequire("bb4ll");
var $hoQRu = parcelRequire("hoQRu");
class $67fdf2db2a291d84$export$d31d5212998928bd extends (0, $hoQRu.IEvents) {
    constructor(e){
        super();
    }
}
const $67fdf2db2a291d84$export$31c453b5fe09788d = (0, $2TjUJ.FIVE_SECONDS), $67fdf2db2a291d84$export$f3340c1af6bee4b5 = {
    pulse: "heartbeat_pulse"
};
class $67fdf2db2a291d84$export$996c9b2cd7645b55 extends $67fdf2db2a291d84$export$d31d5212998928bd {
    constructor(e){
        super(e), this.events = new (0, $7hlqZ.EventEmitter), this.interval = $67fdf2db2a291d84$export$31c453b5fe09788d, this.interval = e?.interval || $67fdf2db2a291d84$export$31c453b5fe09788d;
    }
    static async init(e) {
        const t = new $67fdf2db2a291d84$export$996c9b2cd7645b55(e);
        return await t.init(), t;
    }
    async init() {
        await this.initialize();
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async initialize() {
        this.intervalRef = setInterval(()=>this.pulse(), (0, $2TjUJ.toMiliseconds)(this.interval));
    }
    pulse() {
        this.events.emit($67fdf2db2a291d84$export$f3340c1af6bee4b5.pulse);
    }
}

});
parcelRegister("bb4ll", function(module, exports) {
$parcel$export(module.exports, "IEvents", function () { return (parcelRequire("hoQRu")).IEvents; });
parcelRequire("hoQRu");

});
parcelRegister("hoQRu", function(module, exports) {

$parcel$export(module.exports, "IEvents", function () { return $caadaeceb39254b2$export$ab429ec7e240e546; });
class $caadaeceb39254b2$export$ab429ec7e240e546 {
}

});



parcelRegister("fROir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d2d216761300d5$export$8536778e426ddf92; });

var $3DHry = parcelRequire("3DHry");

var $gX2rI = parcelRequire("gX2rI");

var $4yffS = parcelRequire("4yffS");
function $b8d2d216761300d5$var$C(i) {
    return i;
}
const $b8d2d216761300d5$var$x = "idb-keyval";
var $b8d2d216761300d5$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $gX2rI.createStore)(i.dbName, i.storeName)), {
        name: $b8d2d216761300d5$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $gX2rI.get)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $gX2rI.get)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $gX2rI.set)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $gX2rI.del)(e(s), n);
        },
        getKeys () {
            return (0, $gX2rI.keys)(n);
        },
        clear () {
            return (0, $gX2rI.clear)(n);
        }
    };
};
const $b8d2d216761300d5$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $b8d2d216761300d5$var$E = "keyvaluestorage";
class $b8d2d216761300d5$var$_ {
    constructor(){
        this.indexedDb = (0, $3DHry.createStorage)({
            driver: $b8d2d216761300d5$var$z({
                dbName: $b8d2d216761300d5$var$D,
                storeName: $b8d2d216761300d5$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $4yffS.safeJsonStringify)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $b8d2d216761300d5$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $b8d2d216761300d5$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $b8d2d216761300d5$var$l < "u" && $b8d2d216761300d5$var$l.localStorage ? $b8d2d216761300d5$var$c.exports = $b8d2d216761300d5$var$l.localStorage : typeof window < "u" && window.localStorage ? $b8d2d216761300d5$var$c.exports = window.localStorage : $b8d2d216761300d5$var$c.exports = new t;
})();
function $b8d2d216761300d5$var$k(i) {
    var t;
    return [
        i[0],
        (0, $4yffS.safeJsonParse)((t = i[1]) != null ? t : "")
    ];
}
class $b8d2d216761300d5$var$K {
    constructor(){
        this.localStorage = $b8d2d216761300d5$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($b8d2d216761300d5$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $4yffS.safeJsonParse)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $4yffS.safeJsonStringify)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $b8d2d216761300d5$var$N = "wc_storage_version", $b8d2d216761300d5$var$y = 1, $b8d2d216761300d5$var$O = async (i, t, e)=>{
    const n = $b8d2d216761300d5$var$N, s = await t.getItem(n);
    if (s && s >= $b8d2d216761300d5$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $b8d2d216761300d5$var$y), e(t), $b8d2d216761300d5$var$j(i, m);
}, $b8d2d216761300d5$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $b8d2d216761300d5$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $b8d2d216761300d5$var$K;
        this.storage = t;
        try {
            const e = new $b8d2d216761300d5$var$_;
            $b8d2d216761300d5$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}

});
parcelRegister("3DHry", function(module, exports) {

$parcel$export(module.exports, "createStorage", function () { return $1281cd619e21a8a7$export$d184a47a971dd4b9; });

var $1W6DK = parcelRequire("1W6DK");

var $iNmGh = parcelRequire("iNmGh");
function $1281cd619e21a8a7$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $1281cd619e21a8a7$var$DRIVER_NAME = "memory";
const $1281cd619e21a8a7$var$memory = $1281cd619e21a8a7$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $1281cd619e21a8a7$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $1281cd619e21a8a7$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $1281cd619e21a8a7$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $iNmGh.a)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $1281cd619e21a8a7$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $iNmGh.a)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $iNmGh.b)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $iNmGh.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $1W6DK.default)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $iNmGh.b)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $iNmGh.j)(batch.base, item.key),
                            value: (0, $1W6DK.default)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $iNmGh.b)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $1W6DK.default)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $iNmGh.b)(driver.getItemRaw, relativeKey, opts);
            return (0, $iNmGh.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $iNmGh.d)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $iNmGh.b)(driver.setItem, relativeKey, (0, $iNmGh.s)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) return (0, $iNmGh.b)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $iNmGh.s)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $iNmGh.b)(batch.driver.setItem, item.relativeKey, (0, $iNmGh.s)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $iNmGh.b)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $iNmGh.b)(driver.setItem, relativeKey, (0, $iNmGh.c)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $iNmGh.b)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $iNmGh.b)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $iNmGh.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $iNmGh.b)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $iNmGh.b)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $1W6DK.default)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $iNmGh.n)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $iNmGh.b)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $iNmGh.a)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $iNmGh.n)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $iNmGh.b)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$1281cd619e21a8a7$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $iNmGh.n)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($1281cd619e21a8a7$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $iNmGh.n)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $1281cd619e21a8a7$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $iNmGh.a)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $iNmGh.a)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $1281cd619e21a8a7$export$b8801ea43165ed7d(storage, base) {
    base = (0, $iNmGh.n)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $1281cd619e21a8a7$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $iNmGh.n)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $1281cd619e21a8a7$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $1281cd619e21a8a7$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $iNmGh.b)(driver.dispose);
}
const $1281cd619e21a8a7$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};

});
parcelRegister("1W6DK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3a0494cde366823$export$2e2bcd8739ae039; });
const $b3a0494cde366823$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $b3a0494cde366823$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $b3a0494cde366823$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $b3a0494cde366823$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $b3a0494cde366823$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $b3a0494cde366823$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $b3a0494cde366823$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.endsWith('"') && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$b3a0494cde366823$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($b3a0494cde366823$var$suspectProtoRx.test(value) || $b3a0494cde366823$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $b3a0494cde366823$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $b3a0494cde366823$export$4b2a7c187ff4b28c(value, options = {}) {
    return $b3a0494cde366823$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}

});

parcelRegister("iNmGh", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $43dbe2aa7b7ebec5$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "s", function () { return $43dbe2aa7b7ebec5$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $43dbe2aa7b7ebec5$export$db3b6bfb95261072; });
$parcel$export(module.exports, "d", function () { return $43dbe2aa7b7ebec5$export$4368d992c4eafac0; });
$parcel$export(module.exports, "n", function () { return $43dbe2aa7b7ebec5$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "a", function () { return $43dbe2aa7b7ebec5$export$407448d2b89b1813; });
$parcel$export(module.exports, "j", function () { return $43dbe2aa7b7ebec5$export$35e795649ee09318; });

var $98IaM = parcelRequire("98IaM");
var $43dbe2aa7b7ebec5$require$Buffer = $98IaM.Buffer;
function $43dbe2aa7b7ebec5$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $43dbe2aa7b7ebec5$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $43dbe2aa7b7ebec5$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $43dbe2aa7b7ebec5$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $43dbe2aa7b7ebec5$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $43dbe2aa7b7ebec5$export$2408f22a0fab9ae5(value) {
    if ($43dbe2aa7b7ebec5$var$isPrimitive(value)) return String(value);
    if ($43dbe2aa7b7ebec5$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $43dbe2aa7b7ebec5$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $43dbe2aa7b7ebec5$var$checkBufferSupport() {}
const $43dbe2aa7b7ebec5$var$BASE64_PREFIX = "base64:";
function $43dbe2aa7b7ebec5$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $43dbe2aa7b7ebec5$var$checkBufferSupport();
    const base64 = $43dbe2aa7b7ebec5$require$Buffer.from(value).toString("base64");
    return $43dbe2aa7b7ebec5$var$BASE64_PREFIX + base64;
}
function $43dbe2aa7b7ebec5$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($43dbe2aa7b7ebec5$var$BASE64_PREFIX)) return value;
    $43dbe2aa7b7ebec5$var$checkBufferSupport();
    return $43dbe2aa7b7ebec5$require$Buffer.from(value.slice($43dbe2aa7b7ebec5$var$BASE64_PREFIX.length), "base64");
}
const $43dbe2aa7b7ebec5$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $43dbe2aa7b7ebec5$export$ffb5f4729a158638(storage, base) {
    base = $43dbe2aa7b7ebec5$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $43dbe2aa7b7ebec5$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $43dbe2aa7b7ebec5$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $43dbe2aa7b7ebec5$export$35e795649ee09318(...keys) {
    return $43dbe2aa7b7ebec5$export$407448d2b89b1813(keys.join(":"));
}
function $43dbe2aa7b7ebec5$export$7ccc53e8f1e7dfc5(base) {
    base = $43dbe2aa7b7ebec5$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}

});


parcelRegister("gX2rI", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $c5740dc3cad916c8$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "get", function () { return $c5740dc3cad916c8$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $c5740dc3cad916c8$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "del", function () { return $c5740dc3cad916c8$export$1d2f21e549771e67; });
$parcel$export(module.exports, "clear", function () { return $c5740dc3cad916c8$export$42ffd38884aecdac; });
$parcel$export(module.exports, "keys", function () { return $c5740dc3cad916c8$export$ed97f33186d4b816; });
function $c5740dc3cad916c8$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $c5740dc3cad916c8$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $c5740dc3cad916c8$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $c5740dc3cad916c8$var$defaultGetStoreFunc;
function $c5740dc3cad916c8$var$defaultGetStore() {
    if (!$c5740dc3cad916c8$var$defaultGetStoreFunc) $c5740dc3cad916c8$var$defaultGetStoreFunc = $c5740dc3cad916c8$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $c5740dc3cad916c8$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$3988ae62b71be9a3(key, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readonly", (store)=>$c5740dc3cad916c8$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$adaa4cf7ef1b65be(key, value, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.put(value, key);
        return $c5740dc3cad916c8$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$daa0a5170277c7a8(entries, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $c5740dc3cad916c8$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$5df405cccea42673(keys, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readonly", (store)=>Promise.all(keys.map((key)=>$c5740dc3cad916c8$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$722fbec263ad908a(key, updater, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($c5740dc3cad916c8$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$1d2f21e549771e67(key, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.delete(key);
        return $c5740dc3cad916c8$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$c8aa84257229cac8(keys, customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $c5740dc3cad916c8$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$42ffd38884aecdac(customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.clear();
        return $c5740dc3cad916c8$export$b327150396135fe7(store.transaction);
    });
}
function $c5740dc3cad916c8$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $c5740dc3cad916c8$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$ed97f33186d4b816(customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $c5740dc3cad916c8$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $c5740dc3cad916c8$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$68c286be0e7e55b7(customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $c5740dc3cad916c8$export$b327150396135fe7(store.getAll());
        const items = [];
        return $c5740dc3cad916c8$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $c5740dc3cad916c8$export$3e9f948b41964866(customStore = $c5740dc3cad916c8$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $c5740dc3cad916c8$export$b327150396135fe7(store.getAllKeys()),
            $c5740dc3cad916c8$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore("readonly", (store)=>$c5740dc3cad916c8$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});


parcelRegister("ksL7m", function(module, exports) {

$parcel$export(module.exports, "getDefaultLoggerOptions", function () { return $ee5af8cb46531848$export$bad2475df51c8ecc; });
$parcel$export(module.exports, "getLoggerContext", function () { return $ee5af8cb46531848$export$a283a9a0054a3c25; });
$parcel$export(module.exports, "generateChildLogger", function () { return $ee5af8cb46531848$export$4929e0372308a636; });
$parcel$export(module.exports, "generatePlatformLogger", function () { return $ee5af8cb46531848$export$15eba7fb5aaf9303; });
$parcel$export(module.exports, "pino", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jt6FO")))); });

var $jt6FO = parcelRequire("jt6FO");

var $4yffS = parcelRequire("4yffS");
const $ee5af8cb46531848$export$341ee22b43fe3f8e = {
    level: "info"
}, $ee5af8cb46531848$export$fdd446d41f74bf3a = "custom_context", $ee5af8cb46531848$export$64bef9d49cc9288f = 1024000;
class $ee5af8cb46531848$var$O {
    constructor(e){
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    get value() {
        return this.nodeValue;
    }
    get size() {
        return this.sizeInBytes;
    }
}
class $ee5af8cb46531848$var$d {
    constructor(e){
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    append(e) {
        const t = new $ee5af8cb46531848$var$O(e);
        if (t.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${t.size}`);
        for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
        this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
    shift() {
        if (!this.head) return;
        const e = this.head;
        this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
    toArray() {
        const e = [];
        let t = this.head;
        for(; t !== null;)e.push(t.value), t = t.next;
        return e;
    }
    get length() {
        return this.lengthInNodes;
    }
    get size() {
        return this.sizeInBytes;
    }
    toOrderedArray() {
        return Array.from(this);
    }
    [Symbol.iterator]() {
        let e = this.head;
        return {
            next: ()=>{
                if (!e) return {
                    done: !0,
                    value: null
                };
                const t = e.value;
                return e = e.next, {
                    done: !1,
                    value: t
                };
            }
        };
    }
}
class $ee5af8cb46531848$var$L {
    constructor(e, t = $ee5af8cb46531848$export$64bef9d49cc9288f){
        this.level = e ?? "error", this.levelValue = (0, $jt6FO.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new $ee5af8cb46531848$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    forwardToConsole(e, t) {
        t === (0, $jt6FO.levels).values.error ? console.error(e) : t === (0, $jt6FO.levels).values.warn ? console.warn(e) : t === (0, $jt6FO.levels).values.debug ? console.debug(e) : t === (0, $jt6FO.levels).values.trace ? console.trace(e) : console.log(e);
    }
    appendToLogs(e) {
        this.logs.append((0, $4yffS.safeJsonStringify)({
            timestamp: new Date().toISOString(),
            log: e
        }));
        const t = typeof e == "string" ? JSON.parse(e).level : e.level;
        t >= this.levelValue && this.forwardToConsole(e, t);
    }
    getLogs() {
        return this.logs;
    }
    clearLogs() {
        this.logs = new $ee5af8cb46531848$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    getLogArray() {
        return Array.from(this.logs);
    }
    logsToBlob(e) {
        const t = this.getLogArray();
        return t.push((0, $4yffS.safeJsonStringify)({
            extraMetadata: e
        })), new Blob(t, {
            type: "application/json"
        });
    }
}
class $ee5af8cb46531848$var$m {
    constructor(e, t = $ee5af8cb46531848$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $ee5af8cb46531848$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
    downloadLogsBlobInBrowser(e) {
        const t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
        o.href = t, o.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
}
class $ee5af8cb46531848$var$B {
    constructor(e, t = $ee5af8cb46531848$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $ee5af8cb46531848$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
}
var $ee5af8cb46531848$var$x = Object.defineProperty, $ee5af8cb46531848$var$S = Object.defineProperties, $ee5af8cb46531848$var$_ = Object.getOwnPropertyDescriptors, $ee5af8cb46531848$var$p = Object.getOwnPropertySymbols, $ee5af8cb46531848$var$T = Object.prototype.hasOwnProperty, $ee5af8cb46531848$var$z = Object.prototype.propertyIsEnumerable, $ee5af8cb46531848$var$f = (r, e, t)=>e in r ? $ee5af8cb46531848$var$x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $ee5af8cb46531848$var$i = (r, e)=>{
    for(var t in e || (e = {}))$ee5af8cb46531848$var$T.call(e, t) && $ee5af8cb46531848$var$f(r, t, e[t]);
    if ($ee5af8cb46531848$var$p) for (var t of $ee5af8cb46531848$var$p(e))$ee5af8cb46531848$var$z.call(e, t) && $ee5af8cb46531848$var$f(r, t, e[t]);
    return r;
}, $ee5af8cb46531848$var$g = (r, e)=>$ee5af8cb46531848$var$S(r, $ee5af8cb46531848$var$_(e));
function $ee5af8cb46531848$export$bad2475df51c8ecc(r) {
    return $ee5af8cb46531848$var$g($ee5af8cb46531848$var$i({}, r), {
        level: r?.level || $ee5af8cb46531848$export$341ee22b43fe3f8e.level
    });
}
function $ee5af8cb46531848$export$e8faae0482d84e9e(r, e = $ee5af8cb46531848$export$fdd446d41f74bf3a) {
    return r[e] || "";
}
function $ee5af8cb46531848$export$758f352b7265b00e(r, e, t = $ee5af8cb46531848$export$fdd446d41f74bf3a) {
    return r[t] = e, r;
}
function $ee5af8cb46531848$export$a283a9a0054a3c25(r, e = $ee5af8cb46531848$export$fdd446d41f74bf3a) {
    let t = "";
    return typeof r.bindings > "u" ? t = $ee5af8cb46531848$export$e8faae0482d84e9e(r, e) : t = r.bindings().context || "", t;
}
function $ee5af8cb46531848$export$307261146df20465(r, e, t = $ee5af8cb46531848$export$fdd446d41f74bf3a) {
    const o = $ee5af8cb46531848$export$a283a9a0054a3c25(r, t);
    return o.trim() ? `${o}/${e}` : e;
}
function $ee5af8cb46531848$export$4929e0372308a636(r, e, t = $ee5af8cb46531848$export$fdd446d41f74bf3a) {
    const o = $ee5af8cb46531848$export$307261146df20465(r, e, t), a = r.child({
        context: o
    });
    return $ee5af8cb46531848$export$758f352b7265b00e(a, o, t);
}
function $ee5af8cb46531848$export$2ca1453636a43a7(r) {
    var e, t;
    const o = new $ee5af8cb46531848$var$m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($jt6FO)))($ee5af8cb46531848$var$g($ee5af8cb46531848$var$i({}, r.opts), {
            level: "trace",
            browser: $ee5af8cb46531848$var$g($ee5af8cb46531848$var$i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: (a)=>o.write(a)
            })
        })),
        chunkLoggerController: o
    };
}
function $ee5af8cb46531848$export$495ac2973e46cb97(r) {
    var e;
    const t = new $ee5af8cb46531848$var$B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($jt6FO)))($ee5af8cb46531848$var$g($ee5af8cb46531848$var$i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function $ee5af8cb46531848$export$15eba7fb5aaf9303(r) {
    return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : typeof window < "u" ? $ee5af8cb46531848$export$2ca1453636a43a7(r) : $ee5af8cb46531848$export$495ac2973e46cb97(r);
}

});
parcelRegister("jt6FO", function(module, exports) {
"use strict";

var $joxH7 = parcelRequire("joxH7");
module.exports = $e2c5e6f5e01af750$var$pino;
const $e2c5e6f5e01af750$var$_console = $e2c5e6f5e01af750$var$pfGlobalThisOrFallback().console || {};
const $e2c5e6f5e01af750$var$stdSerializers = {
    mapHttpRequest: $e2c5e6f5e01af750$var$mock,
    mapHttpResponse: $e2c5e6f5e01af750$var$mock,
    wrapRequestSerializer: $e2c5e6f5e01af750$var$passthrough,
    wrapResponseSerializer: $e2c5e6f5e01af750$var$passthrough,
    wrapErrorSerializer: $e2c5e6f5e01af750$var$passthrough,
    req: $e2c5e6f5e01af750$var$mock,
    res: $e2c5e6f5e01af750$var$mock,
    err: $e2c5e6f5e01af750$var$asErrValue
};
function $e2c5e6f5e01af750$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $e2c5e6f5e01af750$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $e2c5e6f5e01af750$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $e2c5e6f5e01af750$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $e2c5e6f5e01af750$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $e2c5e6f5e01af750$var$getTimeFunction(opts)
    };
    logger.levels = $e2c5e6f5e01af750$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $e2c5e6f5e01af750$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $e2c5e6f5e01af750$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $e2c5e6f5e01af750$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $e2c5e6f5e01af750$var$set(setOpts, logger, "fatal", "error");
        $e2c5e6f5e01af750$var$set(setOpts, logger, "warn", "error");
        $e2c5e6f5e01af750$var$set(setOpts, logger, "info", "log");
        $e2c5e6f5e01af750$var$set(setOpts, logger, "debug", "log");
        $e2c5e6f5e01af750$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $e2c5e6f5e01af750$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $e2c5e6f5e01af750$var$bind(parent, bindings, "error");
            this.fatal = $e2c5e6f5e01af750$var$bind(parent, bindings, "fatal");
            this.warn = $e2c5e6f5e01af750$var$bind(parent, bindings, "warn");
            this.info = $e2c5e6f5e01af750$var$bind(parent, bindings, "info");
            this.debug = $e2c5e6f5e01af750$var$bind(parent, bindings, "debug");
            this.trace = $e2c5e6f5e01af750$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $e2c5e6f5e01af750$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$e2c5e6f5e01af750$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$e2c5e6f5e01af750$var$pino.stdSerializers = $e2c5e6f5e01af750$var$stdSerializers;
$e2c5e6f5e01af750$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $e2c5e6f5e01af750$var$nullTime,
    epochTime: $e2c5e6f5e01af750$var$epochTime,
    unixTime: $e2c5e6f5e01af750$var$unixTime,
    isoTime: $e2c5e6f5e01af750$var$isoTime
});
function $e2c5e6f5e01af750$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $e2c5e6f5e01af750$var$noop : proto[level] ? proto[level] : $e2c5e6f5e01af750$var$_console[level] || $e2c5e6f5e01af750$var$_console[fallback] || $e2c5e6f5e01af750$var$noop;
    $e2c5e6f5e01af750$var$wrap(opts, logger, level);
}
function $e2c5e6f5e01af750$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $e2c5e6f5e01af750$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $e2c5e6f5e01af750$var$_console ? $e2c5e6f5e01af750$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $e2c5e6f5e01af750$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $e2c5e6f5e01af750$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $e2c5e6f5e01af750$var$pino.levels.values[transmitLevel];
                const methodValue = $e2c5e6f5e01af750$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $e2c5e6f5e01af750$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $e2c5e6f5e01af750$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $e2c5e6f5e01af750$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $e2c5e6f5e01af750$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $e2c5e6f5e01af750$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $joxH7(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $joxH7(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $e2c5e6f5e01af750$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $e2c5e6f5e01af750$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $e2c5e6f5e01af750$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $e2c5e6f5e01af750$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $e2c5e6f5e01af750$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $e2c5e6f5e01af750$var$createLogEventShape(bindings);
}
function $e2c5e6f5e01af750$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $e2c5e6f5e01af750$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $e2c5e6f5e01af750$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $e2c5e6f5e01af750$var$nullTime;
    return $e2c5e6f5e01af750$var$epochTime;
}
function $e2c5e6f5e01af750$var$mock() {
    return {};
}
function $e2c5e6f5e01af750$var$passthrough(a) {
    return a;
}
function $e2c5e6f5e01af750$var$noop() {}
function $e2c5e6f5e01af750$var$nullTime() {
    return false;
}
function $e2c5e6f5e01af750$var$epochTime() {
    return Date.now();
}
function $e2c5e6f5e01af750$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $e2c5e6f5e01af750$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $e2c5e6f5e01af750$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("joxH7", function(module, exports) {
"use strict";
function $e1ea653ea4ba1e4f$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $e1ea653ea4ba1e4f$var$format;
function $e1ea653ea4ba1e4f$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $e1ea653ea4ba1e4f$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});



parcelRegister("dgxYa", function(module, exports) {

$parcel$export(module.exports, "ICore", function () { return $9a871e9a19e4749e$export$ed533416df113881; });
$parcel$export(module.exports, "IJsonRpcHistory", function () { return $9a871e9a19e4749e$export$45b2c2643615b67; });
$parcel$export(module.exports, "IMessageTracker", function () { return $9a871e9a19e4749e$export$e67570fe0a885c47; });
$parcel$export(module.exports, "IPublisher", function () { return $9a871e9a19e4749e$export$3b0872bbd7e675a2; });
$parcel$export(module.exports, "IRelayer", function () { return $9a871e9a19e4749e$export$9a0f755fd4f79434; });
$parcel$export(module.exports, "IStore", function () { return $9a871e9a19e4749e$export$a7f17ba6c54777e7; });
$parcel$export(module.exports, "ISubscriber", function () { return $9a871e9a19e4749e$export$300eed987e764b57; });
$parcel$export(module.exports, "IExpirer", function () { return $9a871e9a19e4749e$export$41aaa3c39f6f2861; });
$parcel$export(module.exports, "IVerify", function () { return $9a871e9a19e4749e$export$873b0b865d85ddb6; });
$parcel$export(module.exports, "IEchoClient", function () { return $9a871e9a19e4749e$export$7db533fb638f979d; });
$parcel$export(module.exports, "IEventClient", function () { return $9a871e9a19e4749e$export$4264a8ec567679e5; });
$parcel$export(module.exports, "ISignClient", function () { return $9a871e9a19e4749e$export$2ebcf6eeacedad44; });
$parcel$export(module.exports, "IEngine", function () { return $9a871e9a19e4749e$export$87df43c730effa30; });
parcelRequire("bb4ll");
var $hoQRu = parcelRequire("hoQRu");

var $7hlqZ = parcelRequire("7hlqZ");
var $9a871e9a19e4749e$var$a = Object.defineProperty, $9a871e9a19e4749e$var$u = (e, s, r)=>s in e ? $9a871e9a19e4749e$var$a(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $9a871e9a19e4749e$var$c = (e, s, r)=>$9a871e9a19e4749e$var$u(e, typeof s != "symbol" ? s + "" : s, r);
class $9a871e9a19e4749e$export$ed533416df113881 extends (0, $hoQRu.IEvents) {
    constructor(s){
        super(), this.opts = s, $9a871e9a19e4749e$var$c(this, "protocol", "wc"), $9a871e9a19e4749e$var$c(this, "version", 2);
    }
}
class $9a871e9a19e4749e$export$a4e7e56f03915894 {
    constructor(s, r, t){
        this.core = s, this.logger = r;
    }
}
var $9a871e9a19e4749e$var$p = Object.defineProperty, $9a871e9a19e4749e$var$b = (e, s, r)=>s in e ? $9a871e9a19e4749e$var$p(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $9a871e9a19e4749e$var$v = (e, s, r)=>$9a871e9a19e4749e$var$b(e, typeof s != "symbol" ? s + "" : s, r);
class $9a871e9a19e4749e$export$45b2c2643615b67 extends (0, $hoQRu.IEvents) {
    constructor(s, r){
        super(), this.core = s, this.logger = r, $9a871e9a19e4749e$var$v(this, "records", new Map);
    }
}
class $9a871e9a19e4749e$export$e67570fe0a885c47 {
    constructor(s, r){
        this.logger = s, this.core = r;
    }
}
class $9a871e9a19e4749e$export$3b0872bbd7e675a2 extends (0, $hoQRu.IEvents) {
    constructor(s, r){
        super(), this.relayer = s, this.logger = r;
    }
}
class $9a871e9a19e4749e$export$9a0f755fd4f79434 extends (0, $hoQRu.IEvents) {
    constructor(s){
        super();
    }
}
class $9a871e9a19e4749e$export$a7f17ba6c54777e7 {
    constructor(s, r, t, q){
        this.core = s, this.logger = r, this.name = t;
    }
}
var $9a871e9a19e4749e$var$E = Object.defineProperty, $9a871e9a19e4749e$var$x = (e, s, r)=>s in e ? $9a871e9a19e4749e$var$E(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $9a871e9a19e4749e$var$w = (e, s, r)=>$9a871e9a19e4749e$var$x(e, typeof s != "symbol" ? s + "" : s, r);
class $9a871e9a19e4749e$export$5746ea6dad01660a {
    constructor(){
        $9a871e9a19e4749e$var$w(this, "map", new Map);
    }
}
class $9a871e9a19e4749e$export$300eed987e764b57 extends (0, $hoQRu.IEvents) {
    constructor(s, r){
        super(), this.relayer = s, this.logger = r;
    }
}
class $9a871e9a19e4749e$export$be56d986c75c3691 {
    constructor(s, r){
        this.core = s, this.logger = r;
    }
}
class $9a871e9a19e4749e$export$41aaa3c39f6f2861 extends (0, $hoQRu.IEvents) {
    constructor(s, r){
        super(), this.core = s, this.logger = r;
    }
}
class $9a871e9a19e4749e$export$d6c2d698ffb743f1 {
    constructor(s, r){
        this.logger = s, this.core = r;
    }
}
class $9a871e9a19e4749e$export$873b0b865d85ddb6 {
    constructor(s, r, t){
        this.core = s, this.logger = r, this.store = t;
    }
}
class $9a871e9a19e4749e$export$7db533fb638f979d {
    constructor(s, r){
        this.projectId = s, this.logger = r;
    }
}
class $9a871e9a19e4749e$export$4264a8ec567679e5 {
    constructor(s, r, t){
        this.core = s, this.logger = r, this.telemetryEnabled = t;
    }
}
var $9a871e9a19e4749e$var$T = Object.defineProperty, $9a871e9a19e4749e$var$k = (e, s, r)=>s in e ? $9a871e9a19e4749e$var$T(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[s] = r, $9a871e9a19e4749e$var$i = (e, s, r)=>$9a871e9a19e4749e$var$k(e, typeof s != "symbol" ? s + "" : s, r);
class $9a871e9a19e4749e$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($7hlqZ))) {
    constructor(){
        super();
    }
}
class $9a871e9a19e4749e$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, $9a871e9a19e4749e$var$i(this, "protocol", "wc"), $9a871e9a19e4749e$var$i(this, "version", 2);
    }
}
class $9a871e9a19e4749e$export$623dd0f793f15643 extends (0, $7hlqZ.EventEmitter) {
    constructor(){
        super();
    }
}
class $9a871e9a19e4749e$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}

});

parcelRegister("01Dhm", function(module, exports) {

$parcel$export(module.exports, "JsonRpcProvider", function () { return $004e9017080f07dd$export$da28308012bf6748; });

var $7hlqZ = parcelRequire("7hlqZ");
parcelRequire("3olrm");
var $3G8ou = parcelRequire("3G8ou");
var $5ahto = parcelRequire("5ahto");
var $5ZYqc = parcelRequire("5ZYqc");
class $004e9017080f07dd$export$da28308012bf6748 extends (0, $5ahto.IJsonRpcProvider) {
    constructor(t){
        super(t), this.events = new (0, $7hlqZ.EventEmitter), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(t), this.connection.connected && this.registerEventListeners();
    }
    async connect(t = this.connection) {
        await this.open(t);
    }
    async disconnect() {
        await this.close();
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async request(t, e) {
        return this.requestStrict((0, $3G8ou.formatJsonRpcRequest)(t.method, t.params || [], t.id || (0, $3G8ou.getBigIntRpcId)().toString()), e);
    }
    async requestStrict(t, e) {
        return new Promise(async (i, s)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (n) {
                s(n);
            }
            this.events.on(`${t.id}`, (n)=>{
                (0, $5ZYqc.isJsonRpcError)(n) ? s(n.error) : i(n.result);
            });
            try {
                await this.connection.send(t, e);
            } catch (n) {
                s(n);
            }
        });
    }
    setConnection(t = this.connection) {
        return t;
    }
    onPayload(t) {
        this.events.emit("payload", t), (0, $5ZYqc.isJsonRpcResponse)(t) ? this.events.emit(`${t.id}`, t) : this.events.emit("message", {
            type: t.method,
            data: t.params
        });
    }
    onClose(t) {
        t && t.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${t.code} ${t.reason ? `(${t.reason})` : ""}`)), this.events.emit("disconnect");
    }
    async open(t = this.connection) {
        this.connection === t && this.connection.connected || (this.connection.connected && this.close(), typeof t == "string" && (await this.connection.open(t), t = this.connection), this.connection = this.setConnection(t), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        this.hasRegisteredEventListeners || (this.connection.on("payload", (t)=>this.onPayload(t)), this.connection.on("close", (t)=>this.onClose(t)), this.connection.on("error", (t)=>this.events.emit("error", t)), this.connection.on("register_error", (t)=>this.onClose()), this.hasRegisteredEventListeners = !0);
    }
}

});
parcelRegister("3olrm", function(module, exports) {
$parcel$export(module.exports, "parseConnectionError", function () { return (parcelRequire("4HsQx")).parseConnectionError; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return (parcelRequire("xiXqh")).formatJsonRpcError; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return (parcelRequire("xiXqh")).formatJsonRpcRequest; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return (parcelRequire("xiXqh")).formatJsonRpcResult; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return (parcelRequire("xiXqh")).getBigIntRpcId; });
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("xiXqh")).IJsonRpcProvider; });
$parcel$export(module.exports, "isHttpUrl", function () { return (parcelRequire("xiXqh")).isHttpUrl; });
$parcel$export(module.exports, "isJsonRpcError", function () { return (parcelRequire("xiXqh")).isJsonRpcError; });
$parcel$export(module.exports, "isJsonRpcRequest", function () { return (parcelRequire("xiXqh")).isJsonRpcRequest; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return (parcelRequire("xiXqh")).isJsonRpcResponse; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return (parcelRequire("xiXqh")).isJsonRpcResult; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return (parcelRequire("xiXqh")).isLocalhostUrl; });
$parcel$export(module.exports, "isReactNative", function () { return (parcelRequire("xiXqh")).isReactNative; });
$parcel$export(module.exports, "isWsUrl", function () { return (parcelRequire("xiXqh")).isWsUrl; });
$parcel$export(module.exports, "parseConnectionError", function () { return (parcelRequire("xiXqh")).parseConnectionError; });
$parcel$export(module.exports, "payloadId", function () { return (parcelRequire("xiXqh")).payloadId; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return (parcelRequire("3G8ou")).formatJsonRpcError; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return (parcelRequire("3G8ou")).formatJsonRpcRequest; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return (parcelRequire("3G8ou")).formatJsonRpcResult; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return (parcelRequire("3G8ou")).getBigIntRpcId; });
$parcel$export(module.exports, "payloadId", function () { return (parcelRequire("3G8ou")).payloadId; });
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("5ahto")).IJsonRpcProvider; });
$parcel$export(module.exports, "isHttpUrl", function () { return (parcelRequire("8xEQC")).isHttpUrl; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return (parcelRequire("8xEQC")).isLocalhostUrl; });
$parcel$export(module.exports, "isWsUrl", function () { return (parcelRequire("8xEQC")).isWsUrl; });
$parcel$export(module.exports, "isJsonRpcError", function () { return (parcelRequire("5ZYqc")).isJsonRpcError; });
$parcel$export(module.exports, "isJsonRpcRequest", function () { return (parcelRequire("5ZYqc")).isJsonRpcRequest; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return (parcelRequire("5ZYqc")).isJsonRpcResponse; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return (parcelRequire("5ZYqc")).isJsonRpcResult; });
parcelRequire("5Vdqj");
parcelRequire("4HsQx");
parcelRequire("7WLGj");
parcelRequire("3G8ou");
parcelRequire("gwJ2f");
parcelRequire("jLZUS");
parcelRequire("8xEQC");
parcelRequire("5ZYqc");

});
parcelRegister("5Vdqj", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_ERROR", function () { return $44fcb03d8eb9661e$export$f6e3abf3038d348f; });
$parcel$export(module.exports, "SERVER_ERROR", function () { return $44fcb03d8eb9661e$export$125ebd30471ac25c; });
$parcel$export(module.exports, "RESERVED_ERROR_CODES", function () { return $44fcb03d8eb9661e$export$af84821b5448ca78; });
$parcel$export(module.exports, "SERVER_ERROR_CODE_RANGE", function () { return $44fcb03d8eb9661e$export$fff5b44b15c75f69; });
$parcel$export(module.exports, "STANDARD_ERROR_MAP", function () { return $44fcb03d8eb9661e$export$cca5387ab287e1ae; });
$parcel$export(module.exports, "DEFAULT_ERROR", function () { return $44fcb03d8eb9661e$export$d166979eca925bce; });
const $44fcb03d8eb9661e$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $44fcb03d8eb9661e$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $44fcb03d8eb9661e$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $44fcb03d8eb9661e$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $44fcb03d8eb9661e$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $44fcb03d8eb9661e$export$125ebd30471ac25c = "SERVER_ERROR";
const $44fcb03d8eb9661e$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $44fcb03d8eb9661e$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $44fcb03d8eb9661e$export$cca5387ab287e1ae = {
    [$44fcb03d8eb9661e$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$44fcb03d8eb9661e$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$44fcb03d8eb9661e$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$44fcb03d8eb9661e$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$44fcb03d8eb9661e$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$44fcb03d8eb9661e$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $44fcb03d8eb9661e$export$d166979eca925bce = $44fcb03d8eb9661e$export$125ebd30471ac25c;

});

parcelRegister("4HsQx", function(module, exports) {

$parcel$export(module.exports, "isReservedErrorCode", function () { return $36c18ddfc15ddb4a$export$2ae0ec6393ab16c3; });
$parcel$export(module.exports, "getError", function () { return $36c18ddfc15ddb4a$export$e1599abf47b5b568; });
$parcel$export(module.exports, "getErrorByCode", function () { return $36c18ddfc15ddb4a$export$60a3bac005957e12; });
$parcel$export(module.exports, "parseConnectionError", function () { return $36c18ddfc15ddb4a$export$f555d7d8f922e407; });

var $5Vdqj = parcelRequire("5Vdqj");
function $36c18ddfc15ddb4a$export$e463129eb4bc487f(code) {
    return code <= (0, $5Vdqj.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, $5Vdqj.SERVER_ERROR_CODE_RANGE)[1];
}
function $36c18ddfc15ddb4a$export$2ae0ec6393ab16c3(code) {
    return (0, $5Vdqj.RESERVED_ERROR_CODES).includes(code);
}
function $36c18ddfc15ddb4a$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $36c18ddfc15ddb4a$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $5Vdqj.STANDARD_ERROR_MAP)).includes(type)) return (0, $5Vdqj.STANDARD_ERROR_MAP)[0, $5Vdqj.DEFAULT_ERROR];
    return (0, $5Vdqj.STANDARD_ERROR_MAP)[type];
}
function $36c18ddfc15ddb4a$export$60a3bac005957e12(code) {
    const match = Object.values((0, $5Vdqj.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, $5Vdqj.STANDARD_ERROR_MAP)[0, $5Vdqj.DEFAULT_ERROR];
    return match;
}
function $36c18ddfc15ddb4a$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$36c18ddfc15ddb4a$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($36c18ddfc15ddb4a$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $36c18ddfc15ddb4a$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $5Vdqj.STANDARD_ERROR_MAP)[0, $5Vdqj.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $36c18ddfc15ddb4a$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

});

parcelRegister("7WLGj", function(module, exports) {

var $xiXqh = parcelRequire("xiXqh");
const $5c92efba691b1b07$export$d1694901a048d7c8 = (0, $xiXqh.isNode);
$parcel$exportWildcard(module.exports, $xiXqh);

});
parcelRegister("xiXqh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gK1CZ = parcelRequire("gK1CZ");

$gK1CZ.__exportStar((parcelRequire("5UVZf")), module.exports);

$gK1CZ.__exportStar((parcelRequire("3kLU4")), module.exports);

});
parcelRegister("gK1CZ", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $c3023477dc4a0532$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c3023477dc4a0532$var$extendStatics = function(d, b) {
    $c3023477dc4a0532$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c3023477dc4a0532$var$extendStatics(d, b);
};
function $c3023477dc4a0532$export$a8ba968b8961cb8a(d, b) {
    $c3023477dc4a0532$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c3023477dc4a0532$export$18ce0697a983be9b = function() {
    $c3023477dc4a0532$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3023477dc4a0532$export$18ce0697a983be9b.apply(this, arguments);
};
function $c3023477dc4a0532$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c3023477dc4a0532$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c3023477dc4a0532$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c3023477dc4a0532$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c3023477dc4a0532$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c3023477dc4a0532$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c3023477dc4a0532$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c3023477dc4a0532$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c3023477dc4a0532$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c3023477dc4a0532$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c3023477dc4a0532$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c3023477dc4a0532$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c3023477dc4a0532$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c3023477dc4a0532$export$10c90e4f7922046c(v) {
    return this instanceof $c3023477dc4a0532$export$10c90e4f7922046c ? (this.v = v, this) : new $c3023477dc4a0532$export$10c90e4f7922046c(v);
}
function $c3023477dc4a0532$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c3023477dc4a0532$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c3023477dc4a0532$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c3023477dc4a0532$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c3023477dc4a0532$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c3023477dc4a0532$export$19a8beecd37a4c45 === "function" ? $c3023477dc4a0532$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c3023477dc4a0532$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c3023477dc4a0532$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c3023477dc4a0532$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c3023477dc4a0532$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c3023477dc4a0532$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("5UVZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $44ef29b2f5bae98c$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $44ef29b2f5bae98c$var$getBrowerCrypto;
function $44ef29b2f5bae98c$var$getSubtleCrypto() {
    const browserCrypto = $44ef29b2f5bae98c$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $44ef29b2f5bae98c$var$getSubtleCrypto;
function $44ef29b2f5bae98c$var$isBrowserCryptoAvailable() {
    return !!$44ef29b2f5bae98c$var$getBrowerCrypto() && !!$44ef29b2f5bae98c$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $44ef29b2f5bae98c$var$isBrowserCryptoAvailable;

});

parcelRegister("3kLU4", function(module, exports) {

var $17tgv = parcelRequire("17tgv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $26d865f29061dbcc$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $26d865f29061dbcc$var$isReactNative;
function $26d865f29061dbcc$var$isNode() {
    return typeof $17tgv !== "undefined" && typeof $17tgv.versions !== "undefined" && typeof $17tgv.versions.node !== "undefined";
}
module.exports.isNode = $26d865f29061dbcc$var$isNode;
function $26d865f29061dbcc$var$isBrowser() {
    return !$26d865f29061dbcc$var$isReactNative() && !$26d865f29061dbcc$var$isNode();
}
module.exports.isBrowser = $26d865f29061dbcc$var$isBrowser;

});



parcelRegister("3G8ou", function(module, exports) {

$parcel$export(module.exports, "payloadId", function () { return $2adbce360e9c1535$export$2f5364a5d4b80251; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return $2adbce360e9c1535$export$799a3db5df197877; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return $2adbce360e9c1535$export$11d081ebb32d4398; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return $2adbce360e9c1535$export$478fdea01c2a3198; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return $2adbce360e9c1535$export$9f7302ae26c3f77; });

var $4HsQx = parcelRequire("4HsQx");

var $5Vdqj = parcelRequire("5Vdqj");
function $2adbce360e9c1535$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $2adbce360e9c1535$export$799a3db5df197877(entropy = 6) {
    return BigInt($2adbce360e9c1535$export$2f5364a5d4b80251(entropy));
}
function $2adbce360e9c1535$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $2adbce360e9c1535$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $2adbce360e9c1535$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $2adbce360e9c1535$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $2adbce360e9c1535$export$5201d50a34753d71(error, data)
    };
}
function $2adbce360e9c1535$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $4HsQx.getError)((0, $5Vdqj.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $4HsQx.getError)((0, $5Vdqj.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $4HsQx.isReservedErrorCode)(error.code)) error = (0, $4HsQx.getErrorByCode)(error.code);
    return error;
}

});

parcelRegister("gwJ2f", function(module, exports) {
function $c082918f769789cf$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $c082918f769789cf$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $c082918f769789cf$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $c082918f769789cf$export$8e8b9bea55b56df2(route) {
    if ($c082918f769789cf$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $c082918f769789cf$export$2d48faaafcc8fbdc(route) {
    return !$c082918f769789cf$export$c7e2040809cad2c4(route) && $c082918f769789cf$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $c082918f769789cf$export$be298a4710fab756(route) {
    return !$c082918f769789cf$export$c7e2040809cad2c4(route) && $c082918f769789cf$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}

});

parcelRegister("jLZUS", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("5ahto")).IJsonRpcProvider; });
parcelRequire("5ahto");

});
parcelRegister("5ahto", function(module, exports) {

$parcel$export(module.exports, "IJsonRpcProvider", function () { return $3c2b70b438e93e92$export$46957420a688a16d; });
class $3c2b70b438e93e92$export$ab429ec7e240e546 {
}
class $3c2b70b438e93e92$export$77d426dd89724fbe extends $3c2b70b438e93e92$export$ab429ec7e240e546 {
    constructor(c){
        super();
    }
}
class $3c2b70b438e93e92$export$cb916a2eed49af33 extends $3c2b70b438e93e92$export$ab429ec7e240e546 {
    constructor(){
        super();
    }
}
class $3c2b70b438e93e92$export$46957420a688a16d extends $3c2b70b438e93e92$export$cb916a2eed49af33 {
    constructor(c){
        super();
    }
}

});


parcelRegister("8xEQC", function(module, exports) {

$parcel$export(module.exports, "isHttpUrl", function () { return $638117466bc23d23$export$206c3129b8bb1b4f; });
$parcel$export(module.exports, "isWsUrl", function () { return $638117466bc23d23$export$4e4463e75eccf20c; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return $638117466bc23d23$export$8eb4a0a481601f29; });
const $638117466bc23d23$var$HTTP_REGEX = "^https?:";
const $638117466bc23d23$var$WS_REGEX = "^wss?:";
function $638117466bc23d23$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $638117466bc23d23$var$matchRegexProtocol(url, regex) {
    const protocol = $638117466bc23d23$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $638117466bc23d23$export$206c3129b8bb1b4f(url) {
    return $638117466bc23d23$var$matchRegexProtocol(url, $638117466bc23d23$var$HTTP_REGEX);
}
function $638117466bc23d23$export$4e4463e75eccf20c(url) {
    return $638117466bc23d23$var$matchRegexProtocol(url, $638117466bc23d23$var$WS_REGEX);
}
function $638117466bc23d23$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

});

parcelRegister("5ZYqc", function(module, exports) {

$parcel$export(module.exports, "isJsonRpcRequest", function () { return $45e184bb23f6402f$export$f6e4034abe07d2a5; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return $45e184bb23f6402f$export$308ba927de2bcbe8; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return $45e184bb23f6402f$export$cb3d3b20e3223d77; });
$parcel$export(module.exports, "isJsonRpcError", function () { return $45e184bb23f6402f$export$5662a1047b4d1d15; });
function $45e184bb23f6402f$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $45e184bb23f6402f$export$f6e4034abe07d2a5(payload) {
    return $45e184bb23f6402f$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $45e184bb23f6402f$export$308ba927de2bcbe8(payload) {
    return $45e184bb23f6402f$export$bf3617e9fafa893f(payload) && ($45e184bb23f6402f$export$cb3d3b20e3223d77(payload) || $45e184bb23f6402f$export$5662a1047b4d1d15(payload));
}
function $45e184bb23f6402f$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $45e184bb23f6402f$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $45e184bb23f6402f$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}

});



parcelRegister("dcgNG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99b96d8b17ed208c$export$ea0df116fa892998; });

var $7hlqZ = parcelRequire("7hlqZ");

var $4yffS = parcelRequire("4yffS");
parcelRequire("3olrm");
var $3G8ou = parcelRequire("3G8ou");
var $8xEQC = parcelRequire("8xEQC");
var $xiXqh = parcelRequire("xiXqh");
var $4HsQx = parcelRequire("4HsQx");

const $99b96d8b17ed208c$var$v = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("gwQVC")), $99b96d8b17ed208c$var$w = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $99b96d8b17ed208c$var$d = (r)=>r.split("?")[0], $99b96d8b17ed208c$var$h = 10, $99b96d8b17ed208c$var$b = $99b96d8b17ed208c$var$v();
class $99b96d8b17ed208c$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $7hlqZ.EventEmitter), this.registering = !1, !(0, $8xEQC.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $4yffS.safeJsonStringify)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $8xEQC.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, s)=>{
                this.events.once("register_error", (o)=>{
                    this.resetMaxListeners(), s(o);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return s(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const s = (0, $xiXqh.isReactNative)() ? void 0 : {
                rejectUnauthorized: !(0, $8xEQC.isLocalhostUrl)(e)
            }, o = new $99b96d8b17ed208c$var$b(e, [], s);
            $99b96d8b17ed208c$var$w() ? o.onerror = (i)=>{
                const a = i;
                n(this.emitError(a.error));
            } : o.on("error", (i)=>{
                n(this.emitError(i));
            }), o.onopen = ()=>{
                this.onOpen(o), t(o);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $4yffS.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), s = n.message || n.toString(), o = (0, $3G8ou.formatJsonRpcError)(e, s);
        this.events.emit("payload", o);
    }
    parseError(e, t = this.url) {
        return (0, $4HsQx.parseConnectionError)(e, $99b96d8b17ed208c$var$d(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $99b96d8b17ed208c$var$h && this.events.setMaxListeners($99b96d8b17ed208c$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$99b96d8b17ed208c$var$d(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}

});
parcelRegister("gwQVC", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});




parcelRegister("katVf", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", function () { return $eaebf3ccca5d3ab6$export$13c1f9cf8a283575; });
$parcel$export(module.exports, "default", function () { return $eaebf3ccca5d3ab6$export$13c1f9cf8a283575; });

var $7hlqZ = parcelRequire("7hlqZ");

var $lSoH6 = parcelRequire("lSoH6");

var $4yffS = parcelRequire("4yffS");
parcelRequire("3olrm");
var $3G8ou = parcelRequire("3G8ou");
var $8xEQC = parcelRequire("8xEQC");
var $4HsQx = parcelRequire("4HsQx");
var $eaebf3ccca5d3ab6$var$P = Object.defineProperty, $eaebf3ccca5d3ab6$var$w = Object.defineProperties, $eaebf3ccca5d3ab6$var$E = Object.getOwnPropertyDescriptors, $eaebf3ccca5d3ab6$var$c = Object.getOwnPropertySymbols, $eaebf3ccca5d3ab6$var$L = Object.prototype.hasOwnProperty, $eaebf3ccca5d3ab6$var$O = Object.prototype.propertyIsEnumerable, $eaebf3ccca5d3ab6$var$l = (r, t, e)=>t in r ? $eaebf3ccca5d3ab6$var$P(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e, $eaebf3ccca5d3ab6$var$p = (r, t)=>{
    for(var e in t || (t = {}))$eaebf3ccca5d3ab6$var$L.call(t, e) && $eaebf3ccca5d3ab6$var$l(r, e, t[e]);
    if ($eaebf3ccca5d3ab6$var$c) for (var e of $eaebf3ccca5d3ab6$var$c(t))$eaebf3ccca5d3ab6$var$O.call(t, e) && $eaebf3ccca5d3ab6$var$l(r, e, t[e]);
    return r;
}, $eaebf3ccca5d3ab6$var$v = (r, t)=>$eaebf3ccca5d3ab6$var$w(r, $eaebf3ccca5d3ab6$var$E(t));
const $eaebf3ccca5d3ab6$var$j = {
    Accept: "application/json",
    "Content-Type": "application/json"
}, $eaebf3ccca5d3ab6$var$T = "POST", $eaebf3ccca5d3ab6$var$d = {
    headers: $eaebf3ccca5d3ab6$var$j,
    method: $eaebf3ccca5d3ab6$var$T
}, $eaebf3ccca5d3ab6$var$g = 10;
class $eaebf3ccca5d3ab6$export$13c1f9cf8a283575 {
    constructor(t, e = !1){
        if (this.url = t, this.disableProviderPing = e, this.events = new (0, $7hlqZ.EventEmitter), this.isAvailable = !1, this.registering = !1, !(0, $8xEQC.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        this.url = t, this.disableProviderPing = e;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async open(t = this.url) {
        await this.register(t);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(t) {
        this.isAvailable || await this.register();
        try {
            const e = (0, $4yffS.safeJsonStringify)(t), s = await (await (0, (/*@__PURE__*/$parcel$interopDefault($lSoH6)))(this.url, $eaebf3ccca5d3ab6$var$v($eaebf3ccca5d3ab6$var$p({}, $eaebf3ccca5d3ab6$var$d), {
                body: e
            }))).json();
            this.onPayload({
                data: s
            });
        } catch (e) {
            this.onError(t.id, e);
        }
    }
    async register(t = this.url) {
        if (!(0, $8xEQC.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        if (this.registering) {
            const e = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= e || this.events.listenerCount("open") >= e) && this.events.setMaxListeners(e + 1), new Promise((s, i)=>{
                this.events.once("register_error", (n)=>{
                    this.resetMaxListeners(), i(n);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.isAvailable > "u") return i(new Error("HTTP connection is missing or invalid"));
                    s();
                });
            });
        }
        this.url = t, this.registering = !0;
        try {
            if (!this.disableProviderPing) {
                const e = (0, $4yffS.safeJsonStringify)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($lSoH6)))(t, $eaebf3ccca5d3ab6$var$v($eaebf3ccca5d3ab6$var$p({}, $eaebf3ccca5d3ab6$var$d), {
                    body: e
                }));
            }
            this.onOpen();
        } catch (e) {
            const s = this.parseError(e);
            throw this.events.emit("register_error", s), this.onClose(), s;
        }
    }
    onOpen() {
        this.isAvailable = !0, this.registering = !1, this.events.emit("open");
    }
    onClose() {
        this.isAvailable = !1, this.registering = !1, this.events.emit("close");
    }
    onPayload(t) {
        if (typeof t.data > "u") return;
        const e = typeof t.data == "string" ? (0, $4yffS.safeJsonParse)(t.data) : t.data;
        this.events.emit("payload", e);
    }
    onError(t, e) {
        const s = this.parseError(e), i = s.message || s.toString(), n = (0, $3G8ou.formatJsonRpcError)(t, i);
        this.events.emit("payload", n);
    }
    parseError(t, e = this.url) {
        return (0, $4HsQx.parseConnectionError)(t, e, "HTTP");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $eaebf3ccca5d3ab6$var$g && this.events.setMaxListeners($eaebf3ccca5d3ab6$var$g);
    }
}

});
parcelRegister("lSoH6", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== "undefined" && globalThis1 || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== "undefined" && $parcel$global || {};
        var support = {
            searchParams: "URLSearchParams" in g,
            iterable: "Symbol" in g && "iterator" in Symbol,
            blob: "FileReader" in g && "Blob" in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in g,
            arrayBuffer: "ArrayBuffer" in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : "utf-8";
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = "";
                } else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error("could not read as ArrayBuffer");
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "CONNECT",
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "PATCH",
            "POST",
            "PUT",
            "TRACE"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ("AbortController" in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn("Response " + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ""
            });
            response.ok = false;
            response.status = 0;
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request timed out"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("19vcb", function(module, exports) {

var $8atpW = parcelRequire("8atpW");
module.exports = $8atpW("fah7H").then(()=>parcelRequire("jS1SF"));

});



//# sourceMappingURL=index.es.5ea190e0.js.map
